export default `# This MVPS HOSTS file is a free download from:            #
# http://winhelp2002.mvps.org/hosts.htm                    #
#                                                          #
# Notes: The Operating System does not read the "#" symbol #
# or anything after the # symbol on the same line          #
#                                                          #
# This *must* be the first line: 127.0.0.1     localhost   #
#                                                          #
#**********************************************************#
# ---------------- Updated: May-03-2020 ------------------ #
#**********************************************************#
#                                                          #
# Disclaimer: this file is free to use for personal use    #
# only. Furthermore it is NOT permitted to copy any of the #
# contents or host on any other site without permission or #
# meeting the full criteria of the below license terms.    #
#                                                          #
# This work is licensed under the Creative Commons         #
# Attribution-NonCommercial-ShareAlike License.            #
# https://creativecommons.org/licenses/by-nc-sa/4.0/       #
#                                                          #
# License info for commercial purposes contact Winhelp2002 #

127.0.0.1 localhost

::1 localhost #[IPv6]

# [Start of entries generated by MVPS HOSTS]
#
# [Misc A - Z]
0.0.0.0 fr.a2dfp.net
0.0.0.0 mfr.a2dfp.net
0.0.0.0 ad.a8.net
0.0.0.0 asy.a8ww.net
0.0.0.0 static.a-ads.com
0.0.0.0 abcstats.com
0.0.0.0 track.acclaimnetwork.com
0.0.0.0 csh.actiondesk.com
0.0.0.0 ads.activepower.net
0.0.0.0 app.activetrail.com
0.0.0.0 traffic.acwebconnecting.com
0.0.0.0 office.ad1.ru
0.0.0.0 cms.ad2click.nl
0.0.0.0 ad2games.com
0.0.0.0 content.ad20.net
0.0.0.0 core.ad20.net
0.0.0.0 banner.ad.nu
0.0.0.0 adadvisor.net
0.0.0.0 wad.adbasket.net
0.0.0.0 www.adchimp.com
0.0.0.0 adcomplete.com
0.0.0.0 www.adcomplete.com
0.0.0.0 adcore.ru
0.0.0.0 pixel.adcrowd.com
0.0.0.0 ct1.addthis.com
0.0.0.0 static.uk.addynamo.com
0.0.0.0 adexc.net
0.0.0.0 static.adfclick1.com
0.0.0.0 c.adfirmative.com
0.0.0.0 www.adfirmative.com
0.0.0.0 adfocus.ru
0.0.0.0 server.adformdsp.net
0.0.0.0 adforce.ru
0.0.0.0 ads.adfox.ru
0.0.0.0 gazeta.adfox.ru
0.0.0.0 s.adframesrc.com
0.0.0.0 media.adfrontiers.com
0.0.0.0 www.adgitize.com
0.0.0.0 www.ad-groups.com #[Ban Man Pro Banner Code]
0.0.0.0 adgrx.com
0.0.0.0 adhall.com
0.0.0.0 pool.adhese.be
0.0.0.0 adhitzads.com
0.0.0.0 ads.static.adhood.com
0.0.0.0 app.pubserver.adhood.com
0.0.0.0 app.winwords.adhood.com
0.0.0.0 ssl3.adhost.com
0.0.0.0 www2.adhost.com
0.0.0.0 adfarm1.adition.com
0.0.0.0 imagesrv.adition.com
0.0.0.0 ad.adition.net
0.0.0.0 hosting.adjug.com
0.0.0.0 tracking.adjug.com
0.0.0.0 aj.adjungle.com
0.0.0.0 adserver-e7.com
0.0.0.0 adsearch.adkontekst.pl
0.0.0.0 stat.adlabs.ru
0.0.0.0 d.tds.adlabs.ru
0.0.0.0 publicidad.adlead.com
0.0.0.0 rc.de.adlink.net #[Tracking.Cookie]
0.0.0.0 tr.de.adlink.net
0.0.0.0 n.admagnet.net
0.0.0.0 bridge.ame.admarketplace.net #[Spamdexing]
0.0.0.0 bridge.lga1.admarketplace.net
0.0.0.0 bridge.sf.admarketplace.net
0.0.0.0 bridge.sfo1.admarketplace.net
0.0.0.0 a1.admaster.net
0.0.0.0 img.admaster.net
0.0.0.0 admedia.com
0.0.0.0 w.admedia.com
0.0.0.0 apps.admission.net #[Spotlight Ads]
0.0.0.0 appcache.admission.net
0.0.0.0 dt.admission.net
0.0.0.0 view.admission.net
0.0.0.0 ad.admitad.com
0.0.0.0 cdn.admitad.com
0.0.0.0 www.ad.admitad.com
0.0.0.0 cdn.admixer.net
0.0.0.0 run.admost.com
0.0.0.0 assets3.admulti.com
0.0.0.0 go.admulti.com
0.0.0.0 s.admulti.com
0.0.0.0 ads.adnet.am
0.0.0.0 ad.adnet.biz #[Tracking.Cookie]
0.0.0.0 adnet.com.ua
0.0.0.0 www.ad-net.co.uk
0.0.0.0 srv.adngin.com
0.0.0.0 ad.adnow.com
0.0.0.0 speednetwork14.adk2.co
0.0.0.0 cdn.oas-c17.adnxs.com
0.0.0.0 tt11.adobe.com
0.0.0.0 ace.adoftheyear.com
0.0.0.0 adperium.com
0.0.0.0 www.adperium.com
0.0.0.0 img.adplan-ds.com
0.0.0.0 res.adplus.co.id
0.0.0.0 ab.adpro.com.ua
0.0.0.0 adroll.com
0.0.0.0 n.ads1-adnow.com
0.0.0.0 n.ads2-adnow.com
0.0.0.0 n.ads3-adnow.com
0.0.0.0 vu.adschoom.com
0.0.0.0 core1.adservingfactory.com
0.0.0.0 content.adservingfactory.com
0.0.0.0 track.adservingfactory.com
0.0.0.0 mg.adskeeper.co.uk
0.0.0.0 map2.adsniper.ru
0.0.0.0 f-nod2.adsniper.ru
0.0.0.0 content.adspynet.com
0.0.0.0 engine.adspynet.com
0.0.0.0 ads.adsready.com
0.0.0.0 ads.adsurve.com
0.0.0.0 www.adsurve.com
0.0.0.0 cntr.adrime.com
0.0.0.0 images.adrime.com #[Adsolutions]
0.0.0.0 ad.adriver.ru
0.0.0.0 content.adriver.ru
0.0.0.0 ssp.adriver.ru
0.0.0.0 r.adrolays.de
0.0.0.0 www.adrotate.net
0.0.0.0 adrunnr.com
0.0.0.0 v2.adsbookie.com
0.0.0.0 fusion.adtoma.com
0.0.0.0 track.adtraction.com
0.0.0.0 core.adunity.com
0.0.0.0 ddnk.advertur.ru
0.0.0.0 js.adscale.de
0.0.0.0 ih.adscale.de
0.0.0.0 adscendmedia.com
0.0.0.0 adserver-voice-online.co.uk
0.0.0.0 adsfac.net #[Facilitate Tracking Code]
0.0.0.0 adsgangsta.com
0.0.0.0 adsfac.eu
0.0.0.0 ad.ad-srv.net
0.0.0.0 www.adshot.de
0.0.0.0 f-nod1.adsniper.ru
0.0.0.0 sync2.adsniper.ru
0.0.0.0 cdn6.adspirit.de
0.0.0.0 www.adspace.be
0.0.0.0 ads.adsponse.de
0.0.0.0 static.ads-twitter.com
0.0.0.0 ads.adtiger.de
0.0.0.0 www.adtiger.de
0.0.0.0 ad.adtoma.com
0.0.0.0 rek.adtotal.pl
0.0.0.0 adtdp.com
0.0.0.0 www.adtrade.net
0.0.0.0 adtradr.com
0.0.0.0 ads.adtube.de
0.0.0.0 www.adultcommercial.net
0.0.0.0 adultmoneymakers.com
0.0.0.0 tracking.adultsense.com
0.0.0.0 www.adult-tracker.de
0.0.0.0 ad.aduserver.com
0.0.0.0 advaction.ru
0.0.0.0 euroad1.advantage.as
0.0.0.0 mf.advantage.as
0.0.0.0 mfad1.advantage.as
0.0.0.0 adve.net
0.0.0.0 www.advertlets.com
0.0.0.0 ads.advertise.net
0.0.0.0 ad.adverticum.net
0.0.0.0 img.adverticum.net
0.0.0.0 imgs.adverticum.net
0.0.0.0 www.advertising365.com
0.0.0.0 ad.advertstream.com
0.0.0.0 images.adviews.de
0.0.0.0 www.adviews.de
0.0.0.0 chart.advinion.com
0.0.0.0 advizi.ru
0.0.0.0 events.adwidecenter.com
0.0.0.0 www.adwidecenter.com
0.0.0.0 serve.adworldmedia.com
0.0.0.0 ad.adworx.at
0.0.0.0 www.ad-z.de
0.0.0.0 show.adzpower.com
0.0.0.0 ads.afa.net
0.0.0.0 affbeat.com
0.0.0.0 affiliate.affdirect.com
0.0.0.0 sttc.affiliate.hu
0.0.0.0 tr.affiliate.hu
0.0.0.0 ads.affiliateclub.com
0.0.0.0 affiliategroove.com
0.0.0.0 banners.affiliatefuture.com
0.0.0.0 js.affiliatelounge.com
0.0.0.0 record.affiliatelounge.com
0.0.0.0 web1.affiliatelounge.com
0.0.0.0 banners.affilimatch.de
0.0.0.0 ad.afilo.pl
0.0.0.0 adserwer.afilo.pl
0.0.0.0 ads.afraccess.com
0.0.0.0 ads.aftonbladet.se
0.0.0.0 stats.agent.co.il
0.0.0.0 stats.agentinteractive.com
0.0.0.0 w.ahalogy.com
0.0.0.0 ac.ajur.info #[WebBug]
0.0.0.0 openx.ajur.info
0.0.0.0 adlik2.akavita.com
0.0.0.0 spotxchange-a.akamaihd.net
0.0.0.0 ads.allaccess.com.ph
0.0.0.0 adcontent2.allaccess.com.ph
0.0.0.0 adservice.aliexpress.com
0.0.0.0 bokee.allyes.com
0.0.0.0 eastmoney.allyes.com
0.0.0.0 sroomafp.allyes.com
0.0.0.0 tom.allyes.com
0.0.0.0 yeskyafp.allyes.com
0.0.0.0 eas.almamedia.fi
0.0.0.0 ad.altervista.org
0.0.0.0 pqwaker.altervista.org
0.0.0.0 altmedia101.com
0.0.0.0 adtools2.amakings.com
0.0.0.0 ad.amgdgt.com
0.0.0.0 10394-127.ampxchange.com #[Spamdexing]
0.0.0.0 10394-4254.ampxchange.com
0.0.0.0 10394-2468.ampxchange.com
0.0.0.0 vfdeprod.amobee.com
0.0.0.0 widgets.amung.us
0.0.0.0 whos.amung.us #[WebBug]
0.0.0.0 analytics.analytics-egain.com
0.0.0.0 cloud-us.analytics-egain.com
0.0.0.0 www.anastasiasaffiliate.com
0.0.0.0 advert.ananzi.co.za
0.0.0.0 advert2.ananzi.co.za
0.0.0.0 box.anchorfree.net
0.0.0.0 rpt.anchorfree.net
0.0.0.0 www.anticlown.com
0.0.0.0 antventure.com
0.0.0.0 webtracker.apicasystem.com
0.0.0.0 junior.apk.net
0.0.0.0 openx.apollo.lv
0.0.0.0 five.partner.archive-it.org
0.0.0.0 ads.ask.com
0.0.0.0 stats.asp24.pl
0.0.0.0 ads.aspalliance.com
0.0.0.0 www.astalavista.us
0.0.0.0 atemda.com
0.0.0.0 logw349.ati-host.net
# 0.0.0.0 rules.atgsvcs.com #[affects banking]
0.0.0.0 p.ato.mx
0.0.0.0 s.ato.mx
0.0.0.0 ads.auctionads.com
0.0.0.0 ad.auditude.com
0.0.0.0 ads.auctioncity.co.nz
0.0.0.0 d.audienceiq.com
0.0.0.0 ads.autoscout24.com
0.0.0.0 ads.autotrader.com
0.0.0.0 adserving.autotrader.com
0.0.0.0 profiling.avandor.com
0.0.0.0 avantlink.com
0.0.0.0 www.avantlink.com
0.0.0.0 ias.avidmedia.net
0.0.0.0 rev.avsforum.com
0.0.0.0 ads.avusa.co.za
0.0.0.0 analytics.aweber.com
# 0.0.0.0 clicks.aweber.com #[affects newsletters]
0.0.0.0 www.azmsoft.com
# [B]
0.0.0.0 ads.badische-zeitung.de
0.0.0.0 banerator.net
0.0.0.0 www.banner-exchange.nl
0.0.0.0 www.bannerexchange.co.nz
0.0.0.0 banners.host.bannerflow.com
0.0.0.0 tracker.bannerflow.com
0.0.0.0 images.host.bannerflow.com
0.0.0.0 scripts.host.bannerflow.com
0.0.0.0 www.bannermanagement.nl
0.0.0.0 www.banner-rotation.com
0.0.0.0 match.basebanner.com
0.0.0.0 ad.batanga.com
0.0.0.0 ad.bauerverlag.de
0.0.0.0 go.arbopl.bbelements.com
0.0.0.0 bbcdn.go.arbopl.bbelements.com
0.0.0.0 go.eu.bbelements.com
0.0.0.0 api.bttrack.com
0.0.0.0 t.bbtrack.net
0.0.0.0 ad.beepworld.de
0.0.0.0 ads.be2hand.com
0.0.0.0 app.beanstalkdata.com
0.0.0.0 www.beead.co.uk
0.0.0.0 tracker.beezup.com
0.0.0.0 autocontext.begun.ru
0.0.0.0 promo.begun.ru
0.0.0.0 referal.begun.ru
0.0.0.0 www.belstat.be
0.0.0.0 www.belstat.com
0.0.0.0 www.belstat.nl
0.0.0.0 pagestat.mmi.bemobile.ua
0.0.0.0 serving.bepolite.eu
0.0.0.0 webtrends.besite.be
0.0.0.0 imstore.bet365affiliates.com
0.0.0.0 oddbanner.bet-at-home.com
0.0.0.0 banners.betcris.com
0.0.0.0 ads.betfair.com
0.0.0.0 banner.betfred.com
0.0.0.0 ad.beritasatumedia.com
0.0.0.0 www.bettertextads.com
0.0.0.0 ads.bgfree.com
0.0.0.0 banners.bgmaps.com
0.0.0.0 bgtop100.com
0.0.0.0 ads.bgtop.net
0.0.0.0 bgwebads.com
0.0.0.0 adsby.bidtheatre.com
0.0.0.0 bighop.com
0.0.0.0 api.bigmobileads.com
0.0.0.0 banex.bikers-engine.com
0.0.0.0 view.binlayer.com
0.0.0.0 ads.biscom.net
0.0.0.0 dc.bizjournals.com
0.0.0.0 ads2.blastro.com
0.0.0.0 ads3.blastro.com
0.0.0.0 blekko.com
0.0.0.0 ads.blizzard.com
0.0.0.0 ads.blog.com
0.0.0.0 www.blogcatalog.com
0.0.0.0 blogcounter.com
0.0.0.0 track.blogcounter.de
0.0.0.0 www.blogcounter.de
0.0.0.0 ads.blogdrive.com
0.0.0.0 ads.blogherads.com
0.0.0.0 pixel.blog.hu
0.0.0.0 pcbutts1-therealtruth.blogspot.com
0.0.0.0 ads.blogtalkradio.com
0.0.0.0 adserver.bloodhorse.com
0.0.0.0 stats.bluebillywig.com
0.0.0.0 watershed.bm23.com
0.0.0.0 t.bmmetrix.com
0.0.0.0 www.bmmetrix.com #[WebBug][Tracking.Cookie]
0.0.0.0 ads.boardtracker.com
0.0.0.0 ranks.boardtracker.com
0.0.0.0 ads.boerse-express.com
0.0.0.0 reklama.botevgrad.com
0.0.0.0 www.box.bg
0.0.0.0 tracker.brainsins.com
0.0.0.0 ads.brandeins.de
0.0.0.0 stats.break.com
0.0.0.0 bans.bride.ru
0.0.0.0 ads.bridgetrack.com
0.0.0.0 cc.bridgetrack.com
0.0.0.0 citi.bridgetrack.com #[Tracking.Cookie]
0.0.0.0 goku.brightcove.com #[WebBug]
0.0.0.0 www.browser-statistik.de
0.0.0.0 ads.bsplayer.com
0.0.0.0 statistik.bundestag.de #[Piwik.Analytics]
0.0.0.0 ivitrine.buscape.com
0.0.0.0 ads.businessclick.com
0.0.0.0 ads.businessclick.pl
0.0.0.0 buylicensekey.com
0.0.0.0 assets.buysellads.com
0.0.0.0 cdn.buysellads.com
0.0.0.0 traffic.buyservices.com
0.0.0.0 txads.buzzcity.com
0.0.0.0 www.buzzclick.com
0.0.0.0 adnetwork.buzzlogic.com
0.0.0.0 tr.buzzlogic.com
0.0.0.0 byet.org
0.0.0.0 blog.byethost.com
# [C]
0.0.0.0 145-ct.c3tag.com
0.0.0.0 298-ct.c3tag.com
0.0.0.0 687-ct.c3tag.com
0.0.0.0 755-ct.c3tag.com
0.0.0.0 ads.calgarystampede.com
0.0.0.0 www.cambodiaoutsourcing.com
0.0.0.0 openx.camelmedia.net
0.0.0.0 stats.canalblog.com
0.0.0.0 ad.caradisiac.com
0.0.0.0 cdn.carbonads.com
0.0.0.0 srv.carbonads.net
0.0.0.0 ads.cars.com
0.0.0.0 banner.casinodelrio.com
0.0.0.0 www.casinotropez.com #[Tracking.Cookie]
0.0.0.0 tracking.cdiscount.com #[WebBug]
0.0.0.0 cn.ecritel.bench.cedexis.com
0.0.0.0 radar.cedexis.com
0.0.0.0 c.cfjump.com
0.0.0.0 t.cfjump.com
0.0.0.0 count.channeladvisor.com
0.0.0.0 adsapi.chartbeat.com
# 0.0.0.0 st.chatango.com #[affects chat]
0.0.0.0 code.checkstat.nl
0.0.0.0 www.checkstat.nl
0.0.0.0 ads.china.com
0.0.0.0 v5.chinoc.net
0.0.0.0 ckstatic.com
0.0.0.0 clevernt.com
0.0.0.0 are.clevernt.com
0.0.0.0 cdn.clic2pub.com
0.0.0.0 crv.clickad.pl
0.0.0.0 publishers.clickbooth.com #[directleads.com]
0.0.0.0 j.clickdensity.com
0.0.0.0 r.clickdensity.com
0.0.0.0 delivery.clickonometrics.pl
0.0.0.0 static.clickonometrics.pl
0.0.0.0 tracktrue.clicktrue.biz
0.0.0.0 www.clickvalidator.net
0.0.0.0 www.is1.clixgalore.com
0.0.0.0 www.clixgalore.com
0.0.0.0 www.clickhouse.com
0.0.0.0 banners.clips4sale.com
0.0.0.0 adserver.clix.pt
0.0.0.0 ad.cmfu.com
0.0.0.0 openx.cnews.ru
0.0.0.0 c.cnstats.ru
0.0.0.0 www.cnstats.com
0.0.0.0 www.co2stats.com
0.0.0.0 traffic.prod.cobaltgroup.com
0.0.0.0 ads.comperia.pl
0.0.0.0 pixel.condenastdigital.com
0.0.0.0 ads.consumeraffairs.com
0.0.0.0 ads.contactmusic.com #[AdvertPro]
0.0.0.0 ads.contextweb.com
0.0.0.0 ds.contextweb.com
0.0.0.0 www.contaxe.com
0.0.0.0 www.conversionruler.com
0.0.0.0 pings.conviva.com
0.0.0.0 ad.cooks.com
0.0.0.0 ad2.cooks.com
0.0.0.0 banners.copyscape.com
0.0.0.0 data.de.coremetrics.com
0.0.0.0 www.count24.de
0.0.0.0 www.countit.ch
0.0.0.0 www.counter-gratis.com #[Tracking.Cookie]
0.0.0.0 cdn.dmpcounter.com
0.0.0.0 connectionzone.com
0.0.0.0 banner.coza.com
0.0.0.0 www.cpays.com
0.0.0.0 www.cpmterra.com
0.0.0.0 ads.cpxcenter.com
0.0.0.0 cdn.cpxinteractive.com
0.0.0.0 static.crakbanner.com
0.0.0.0 sh.creativcdn.net
0.0.0.0 adverts.creativemark.co.uk
0.0.0.0 ads.crisppremium.com
0.0.0.0 stg.widget.crowdignite.com
0.0.0.0 ads.crossworxs.eu
0.0.0.0 i.ctnsnet.com
0.0.0.0 ads.milliyet.cubecdn.net
# 0.0.0.0 cdn.cxense.com #[affects dagsavisen.no]
0.0.0.0 www.cybereps.com
0.0.0.0 cybertown.ru
# [D]
0.0.0.0 count.daem0n.com
0.0.0.0 t.dailymail.co.uk
0.0.0.0 rta.dailymail.co.uk
0.0.0.0 ted.dailymail.co.uk
0.0.0.0 www.dataforce.net #[Spamdexing]
0.0.0.0 tag.datariver.ru
0.0.0.0 mb.datingadzone.com
0.0.0.0 daylogs.com
0.0.0.0 advertising.dclux.com
0.0.0.0 tracking.dc-storm.com
0.0.0.0 de17a.com
0.0.0.0 connect.decknetwork.net
0.0.0.0 adocean.delfi.lv
0.0.0.0 fast.gannett.demdex.net
0.0.0.0 ads.dennisnet.co.uk
0.0.0.0 deostr.com
0.0.0.0 adcast.deviantart.com
0.0.0.0 www.dia-traffic.com
0.0.0.0 counter.dieit.de
0.0.0.0 openx.diena.lv
0.0.0.0 ads.digitalalchemy.tv
0.0.0.0 ads.digitalpoint.com
0.0.0.0 geo.digitalpoint.com
0.0.0.0 tag.digitaltarget.ru
0.0.0.0 vstats.digitaltrends.com
0.0.0.0 st.directadvert.ru
0.0.0.0 www.directadvert.ru
0.0.0.0 www.direct-stats.com
0.0.0.0 glitter.services.disqus.com
0.0.0.0 disqusads.com
0.0.0.0 return.domainnamesales.com #[Parking.Service]
0.0.0.0 publishers.domainadvertising.com
0.0.0.0 return.bs.domainnamesales.com
0.0.0.0 ad.donanimhaber.com
0.0.0.0 adv.dontcrack.com
0.0.0.0 ad2.bal.dotandad.com
0.0.0.0 script.dotmetrics.net
0.0.0.0 test-script.dotmetrics.net
0.0.0.0 ads.dotomi.com
0.0.0.0 iad-login.dotomi.com
0.0.0.0 ads.double.net
0.0.0.0 ad03.doubleadx.com
0.0.0.0 marketing.doubleclickindustries.com
0.0.0.0 imgn.dt00.net
0.0.0.0 tracking.dsmmadvantage.com
0.0.0.0 tracking.dtiserv2.com
0.0.0.0 track.dvdbox.com
0.0.0.0 www.dwin1.com
0.0.0.0 ads.dynamic-media.org
# [E]
0.0.0.0 ad.eanalyzer.de
0.0.0.0 cdn.earnify.com
0.0.0.0 ay.eastmoney.com
0.0.0.0 cdn.easy-ads.com
0.0.0.0 www.easy-dating.org
0.0.0.0 ads.eccentrix.com
0.0.0.0 c.ecliks.com
0.0.0.0 webstats.eco.de #[Piwik.Analytics]
0.0.0.0 ad.ecplaza.net
0.0.0.0 ads.ecrush.com #[AdvertPro]
0.0.0.0 ads.bridgetrack.com.edgesuite.net
0.0.0.0 images.edgeads.org
0.0.0.0 servedby.edgeads.org
0.0.0.0 ads.edipresse.pl
0.0.0.0 track.effiliation.com
0.0.0.0 pk-cdn.effectivemeasure.net
0.0.0.0 th-cdn.effectivemeasure.net
0.0.0.0 eisenstein.dk #[tracking.ping]
0.0.0.0 global.ekmpinpoint.com
0.0.0.0 ads.elmaz.com
0.0.0.0 ads.elitetrader.com
0.0.0.0 www.ellads.com
0.0.0.0 s1415903351.t.eloqua.com
0.0.0.0 email-reflex.com
0.0.0.0 cdn3.emediate.eu
0.0.0.0 cdn6.emediate.eu
0.0.0.0 cdn8.emediate.eu
0.0.0.0 eas5.emediate.eu
0.0.0.0 ism6.emediate.eu
0.0.0.0 dotnet.endai.com
0.0.0.0 trk.enecto.com
0.0.0.0 openx.engagedmediamags.com
0.0.0.0 adsrv.ads.eniro.com
0.0.0.0 publicidad.entelchile.net
0.0.0.0 sa.entireweb.com
0.0.0.0 entk.net
0.0.0.0 e-marketing.entelchile.net #[RealMedia]
0.0.0.0 ads.e-planning.net
0.0.0.0 epmads.com
0.0.0.0 code.etracker.com
0.0.0.0 www.etracker.de
0.0.0.0 ads.ere.net
0.0.0.0 ads.ersamedia.ch
0.0.0.0 it.erosadv.com
0.0.0.0 adserver.euronics.de
0.0.0.0 geoads.eurorevenue.com
0.0.0.0 www.euros4click.de
0.0.0.0 pixel.everesttech.net
0.0.0.0 pixel-user-1039.everesttech.net
0.0.0.0 venetian.evyy.net
0.0.0.0 advert.exaccess.ru
0.0.0.0 dynamic.exaccess.ru
0.0.0.0 static.exaccess.ru
0.0.0.0 www.exchangead.com
0.0.0.0 ads.expekt.com
0.0.0.0 www.experclick.com #[Tracking.Cookie]
0.0.0.0 expo-max.com
0.0.0.0 expired-targeted.com
0.0.0.0 resources.eyereturn.com
0.0.0.0 advertising.ezanga.com
0.0.0.0 1278725189.pub.ezanga.com
# [F]
0.0.0.0 st.fanatics.com
0.0.0.0 a.farlex.com
0.0.0.0 fashion-tube.be #[Win32/InstallMonetizer.AN]
0.0.0.0 fastonlineusers.com
0.0.0.0 counter.fateback.com
0.0.0.0 counter1.fc2.com
0.0.0.0 error.fc2.com
0.0.0.0 tracking.fccinteractive.com
0.0.0.0 as.featurelink.com
0.0.0.0 feedjit.com
0.0.0.0 log.feedjit.com
0.0.0.0 banners.ffsbg.com
0.0.0.0 ads.fiat-bg.org
0.0.0.0 adboost.finalid.com
0.0.0.0 tracker.financialcontent.com
0.0.0.0 banner.finn.no
0.0.0.0 s01.flagcounter.com
0.0.0.0 s02.flagcounter.com
0.0.0.0 s03.flagcounter.com
0.0.0.0 s04.flagcounter.com
0.0.0.0 s06.flagcounter.com
0.0.0.0 s07.flagcounter.com
0.0.0.0 s08.flagcounter.com
0.0.0.0 s09.flagcounter.com
0.0.0.0 s11.flagcounter.com
0.0.0.0 2.s09.flagcounter.com
0.0.0.0 s10.flagcounter.com
0.0.0.0 banners.flingguru.com
0.0.0.0 c.flx1.com
0.0.0.0 www.fncash.com
0.0.0.0 ads.focus-news.net
0.0.0.0 rnews.focus-news.net
0.0.0.0 controller.foreseeresults.com
0.0.0.0 forvideo.at
0.0.0.0 www.fpcclicks.com
0.0.0.0 ad.freecity.de
0.0.0.0 ads05.freecity.de
0.0.0.0 freegeoip.net
0.0.0.0 static.freeskreen.com
0.0.0.0 www.free-toplisten.at
0.0.0.0 banners.freett.com
0.0.0.0 count.freett.com
0.0.0.0 counters.freewebs.com
0.0.0.0 nx.frosmo.com
0.0.0.0 tr1.frosmo.com
0.0.0.0 frtyb.com
0.0.0.0 ads.fuelo.net
0.0.0.0 ads.fulltiltpoker.com
0.0.0.0 banners.fulltiltpoker.com
0.0.0.0 www.funtopliste.de
0.0.0.0 www.fusestats.com
0.0.0.0 fwbntw.com
0.0.0.0 ads5.fxdepo.com
0.0.0.0 adserving.fyi-marketing.com
# [G]
0.0.0.0 errdoc.gabia.net
0.0.0.0 adserver.gadu-gadu.pl
0.0.0.0 adsm.gameforge.de
0.0.0.0 tracking.gameforge.de
0.0.0.0 ingameads.gameloft.com
0.0.0.0 ads.garga.biz
0.0.0.0 track.gawker.com #[WebBug]
0.0.0.0 ad.gazeta.pl
0.0.0.0 adp.gazeta.pl
0.0.0.0 adv.gazeta.pl
0.0.0.0 analytics.gazeta.pl
0.0.0.0 mklik.gazeta.pl
0.0.0.0 geoip-db.com
0.0.0.0 www.geoplugin.net
0.0.0.0 adv.gepime.com
0.0.0.0 cloud.getpopunder.com
0.0.0.0 getrank.net
0.0.0.0 getrockerbox.com
0.0.0.0 www.getsmart.com
0.0.0.0 www17-orig.glam.com
0.0.0.0 promotools.globalmailer.com
0.0.0.0 promotools3.globalmailer.com
0.0.0.0 promotools4.globalmailer.com
0.0.0.0 ads.globo.com
0.0.0.0 ads.img.globo.com
0.0.0.0 gmads.net
0.0.0.0 at.gmads.net
0.0.0.0 dk.gmads.net
0.0.0.0 es.gmads.net
0.0.0.0 pl.gmads.net
0.0.0.0 c.gmtrack.com
0.0.0.0 affiliate.gmtracker.com
0.0.0.0 go777site.com
0.0.0.0 adserver2.goals365.com
0.0.0.0 counter.goingup.com
0.0.0.0 js-at.goldbach.com
0.0.0.0 goldbach-targeting.ch
0.0.0.0 c.go-mpulse.net
0.0.0.0 engine.goodadvert.ru
0.0.0.0 files.goodadvert.ru
0.0.0.0 googlus.com
0.0.0.0 ads.gorillavid.in
0.0.0.0 adtools.gossipkings.com
0.0.0.0 webcounter.goweb.de
0.0.0.0 reed-cw.grapeshot.co.uk
0.0.0.0 adv.gratuito.st
0.0.0.0 grmtech.net
0.0.0.0 de.grmtech.net
0.0.0.0 www.grmtech.net
0.0.0.0 tracker.gtarcade.com
0.0.0.0 ads.gumgum.com
0.0.0.0 c.gumgum.com
0.0.0.0 cdn.gumgum.com
# 0.0.0.0 www.sdad.guru #[affects msn.com]
0.0.0.0 guruads.de
0.0.0.0 beacon.gutefrage.net
0.0.0.0 adhese.gva.be
# [H]
0.0.0.0 tags.h12-media.com
0.0.0.0 hapjes-maken.eu
0.0.0.0 adserver.hardwareanalysis.com
0.0.0.0 www.harmonyhollow.net
0.0.0.0 stats.berkman.harvard.edu #[Piwik.Analytics]
0.0.0.0 ads.haskovo.net
0.0.0.0 ad0.haynet.com
0.0.0.0 ad.hbv.de
0.0.0.0 adhese.hbvl.be
0.0.0.0 ads.hearstmags.com
0.0.0.0 ads.heias.com
0.0.0.0 helpingtrk.com
0.0.0.0 ads2.helpos.com
0.0.0.0 ads.hexun.com
0.0.0.0 hx.hexun.com
0.0.0.0 utrack.hexun.com
0.0.0.0 ads.highdefdigest.com
0.0.0.0 adserver.hispanoclick.com
0.0.0.0 c.hit.ua
0.0.0.0 hit-now.com
0.0.0.0 hitslog.com
0.0.0.0 www.hittracker.org
0.0.0.0 hitwastedgarden.com
0.0.0.0 hitwebcounter.com
0.0.0.0 images.hitwise.co.uk
0.0.0.0 hxtrack.holidayextras.co.uk
0.0.0.0 www.adserver.home.pl
0.0.0.0 counters.honesty.com
0.0.0.0 cgi.honesty.com
0.0.0.0 e1.static.hoptopboy.com
0.0.0.0 ox.hoosiertimes.com
0.0.0.0 ad.hosting.pl
0.0.0.0 stats.hosting24.com
0.0.0.0 error.hostinger.eu
0.0.0.0 ad2.hotels.com
0.0.0.0 www.hotranks.com
0.0.0.0 banner.hpmdnetwork.ru
0.0.0.0 hstpnetwork.com
0.0.0.0 hub.com.pl
0.0.0.0 js.hubspot.com
0.0.0.0 ads.hulu.com
0.0.0.0 ads.hurra.de
0.0.0.0 tracker.dev.hearst.nl
0.0.0.0 ads2000.hw.net
0.0.0.0 dserver.hw.net
0.0.0.0 www.hw-ad.de
0.0.0.0 www.hxtrack.com
0.0.0.0 www.hypertracker.com #[Tracking.Cookie]
# [I]
0.0.0.0 metric-agent.i10c.net
0.0.0.0 ads.iafrica.com
0.0.0.0 ev.ib-ibi.com
0.0.0.0 bbcdn-bbnaut.ibillboard.com
0.0.0.0 bbcdn-tag.ibillboard.com
0.0.0.0 hits.icdirect.com
0.0.0.0 www.icentric.net
0.0.0.0 tracker.icerocket.com
0.0.0.0 log.idg.no #[WebTrends]
0.0.0.0 adidm07.idmnet.pl
0.0.0.0 adidm.idmnet.pl
# 0.0.0.0 mpsnare.iesnare.com #[affects westernunion.com]
0.0.0.0 adsrv2.ihlassondakika.com
0.0.0.0 script.ioam.de
0.0.0.0 rc.bt.ilsemedia.nl
0.0.0.0 ads.imarketservices.com
0.0.0.0 ads.imeem.com
0.0.0.0 stats.immense.net #[Piwik.Analytics]
0.0.0.0 bbn.img.com.ua
0.0.0.0 ads.imguol.com
0.0.0.0 tracking.immobilienscout24.de
0.0.0.0 affiliate.imperiaonline.org
0.0.0.0 secure-dcr.imrworldwide.com
0.0.0.0 x.imwx.com #[content.pulse360.com]
0.0.0.0 adbox.inbox-online.com
0.0.0.0 optimize.indieclick.com
0.0.0.0 aff.indirdik.com
0.0.0.0 ads.indexinfo.org
0.0.0.0 inetlog.ru
0.0.0.0 servedby.informatm.com
0.0.0.0 pcbutts1.software.informer.com #[Unauthorized.Downloads]
0.0.0.0 stats.infomedia.net
0.0.0.0 bimonline.insites.be
0.0.0.0 rs.instantservice.com
0.0.0.0 ads.inviziads.com
0.0.0.0 www.imiclk.com
0.0.0.0 avp.innity.com
0.0.0.0 content.integral-marketing.com
0.0.0.0 cdn.interactivemedia.net
0.0.0.0 intermediads.com
0.0.0.0 pl-engine.intextad.net
0.0.0.0 slo-engine.intextad.net
0.0.0.0 s1.inviziads.com
0.0.0.0 api.ipinfodb.com
0.0.0.0 ads.ipowerweb.com
0.0.0.0 adserver.iprom.net
0.0.0.0 central.iprom.net
0.0.0.0 ipromsi.iprom.net
0.0.0.0 krater.iprom.net
0.0.0.0 tie.iprom.net
0.0.0.0 www.iranwebads.com
0.0.0.0 clicktracker.iscan.nl
0.0.0.0 ads.isoftmarketing.com
0.0.0.0 banman.isoftmarketing.com
0.0.0.0 isralink.net
0.0.0.0 ts.istrack.com
0.0.0.0 adshow.it168.com
0.0.0.0 stat.it168.com
0.0.0.0 itcompany.com
0.0.0.0 www.itcompany.com #[Riskware/PUP]
0.0.0.0 stats.itweb.co.za
0.0.0.0 link.ixs1.net #[WebBug]
# [J]
0.0.0.0 raahenseutu.jainos.fi
0.0.0.0 ad.jamba.de
0.0.0.0 ad.jamster.com
0.0.0.0 ad.janalta.com
0.0.0.0 adserver.janesguide.com
0.0.0.0 ads.jewcy.com
0.0.0.0 pagerank.jklir.net
0.0.0.0 ads.joemonster.org
0.0.0.0 site.johnlewis.com
0.0.0.0 www.jouwstats.nl
0.0.0.0 www.jscount.com
# 0.0.0.0 cdn.jsdelivr.net #[affects spireenergy.com]
0.0.0.0 jsonip.com
0.0.0.0 stats.jtvnw.net
0.0.0.0 ck.juicyads.com
0.0.0.0 js.juicyads.com
0.0.0.0 nl.ads.justpremium.com
0.0.0.0 tracking.justpremium.com
0.0.0.0 ads.justpremium.nl
0.0.0.0 justredirect24.com
0.0.0.0 ads.justrelevant.com
# [K]
0.0.0.0 k5zoom.com
0.0.0.0 ads.kaldata.com
0.0.0.0 events.kalooga.com
0.0.0.0 stats.kaltura.com
0.0.0.0 a.kickassunblock.net
0.0.0.0 banner.kiev.ua
0.0.0.0 adserve.kikizo.com
0.0.0.0 l.kavanga.ru
0.0.0.0 adsby.klikki.com
0.0.0.0 click.kmindex.ru
0.0.0.0 counter.kmindex.ru
0.0.0.0 counting.kmindex.ru
0.0.0.0 www.kmindex.ru
0.0.0.0 openx.kokoma.pl
0.0.0.0 images.kolmic.com
0.0.0.0 ads3.kompasads.com
0.0.0.0 ads4.kompasads.com
0.0.0.0 ads5.kompasads.com
0.0.0.0 ads6.kompasads.com
0.0.0.0 ads.kozmetika-bg.com
0.0.0.0 sitestat.kpn-is.nl
0.0.0.0 beacon.krxd.net
# [L]
0.0.0.0 layer-ad.org
0.0.0.0 ads.layer-ad.org
0.0.0.0 banner.lbs.km.ru
0.0.0.0 lead-123.com
0.0.0.0 secure.leadforensics.com
0.0.0.0 vlog.leadformix.com
0.0.0.0 tracking.lengow.com
0.0.0.0 engine.letsstat.nl
0.0.0.0 pfa.levexis.com
0.0.0.0 res.levexis.com
0.0.0.0 visitors.lexus-europe.com
0.0.0.0 ads.lfstmedia.com
0.0.0.0 lib4.libstat.com
0.0.0.0 lib6.libstat.com
0.0.0.0 logos.libstat.com
0.0.0.0 d.ligatus.com
0.0.0.0 ms.ligatus.com
0.0.0.0 www.lifeforminc.com
0.0.0.0 link.ru
0.0.0.0 link.link.ru
0.0.0.0 ads.linki.nl
0.0.0.0 www.linkads.de
0.0.0.0 linkbuddies.com
0.0.0.0 banners.linkbuddies.com
0.0.0.0 www.linkbuddies.com
0.0.0.0 www.linkconnector.com
0.0.0.0 px.ads.linkedin.com
0.0.0.0 content.linkoffers.net
0.0.0.0 track.linkoffers.net
0.0.0.0 ad.linkstorms.com
0.0.0.0 www.linkworth.com
0.0.0.0 ads.linuxfoundation.org
0.0.0.0 ads.listingware.com
0.0.0.0 s1.listrakbi.com
0.0.0.0 livecams.nl
0.0.0.0 click.adv.livedoor.com
0.0.0.0 counter2.blog.livedoor.com
0.0.0.0 image.adv.livedoor.com
0.0.0.0 js.livehelper.com
0.0.0.0 newbrowse.livehelper.com
0.0.0.0 pixels.livingsocial.com
0.0.0.0 stats.livingsocial.com
0.0.0.0 a.livesportmedia.eu
0.0.0.0 advert.livesportmedia.eu
0.0.0.0 ad.lkqd.net
0.0.0.0 omnituretrack.local.com
0.0.0.0 adserver.lonuncavisto.com
0.0.0.0 r.looksmart.com
0.0.0.0 banners.lottoelite.com
0.0.0.0 partner.loveplanet.ru
0.0.0.0 gwa.lphbs.com
0.0.0.0 gwb.lphbs.com
0.0.0.0 gwc.lphbs.com
0.0.0.0 gwd.lphbs.com
0.0.0.0 luxup.ru
0.0.0.0 is.luxup.ru
# [M]
0.0.0.0 m2k.ru
0.0.0.0 ad.m5prod.net
0.0.0.0 www3.macys.com #[WebBug.eluminate]
0.0.0.0 eu2.madsone.com
0.0.0.0 www.mainadv.com
0.0.0.0 ads.maleflixxx.tv
0.0.0.0 adv.mangoadv.com
0.0.0.0 anapixel.marca.com
0.0.0.0 pixelcounter.marca.com
0.0.0.0 pro.marinsm.com
0.0.0.0 t3.marinsm.com
0.0.0.0 tag.marinsm.com
0.0.0.0 app.mashero.com
0.0.0.0 mass-traffic.com
0.0.0.0 mastertarget.ru
0.0.0.0 ads.affiliates.match.com
0.0.0.0 pixel.mathtag.com
0.0.0.0 sync.mathtag.com
0.0.0.0 tags.mathtag.com
0.0.0.0 mbn.com.ua
0.0.0.0 ads.mcafee.com
0.0.0.0 directads.mcafee.com #[Tracking.Cookie]
0.0.0.0 mcmads.mediacapital.pt #[DoubleClick]
0.0.0.0 piwik.medienhaus.com
0.0.0.0 idpix.media6degrees.com #[WebBug]
0.0.0.0 webtrekk.mediaset.net
0.0.0.0 search.mediatarget.com
0.0.0.0 app.medyanetads.com
0.0.0.0 counter.megaindex.ru
0.0.0.0 banners.mellowads.com
0.0.0.0 openx.mercatormedia.com
0.0.0.0 www.messagetag.com #[Email tracker]
0.0.0.0 stat24.meta.ua
0.0.0.0 action.metaffiliation.com
0.0.0.0 tracking.metalyzer.com
0.0.0.0 www.metavertising.com
0.0.0.0 mdctrail.com
0.0.0.0 pubs.mgn.net #[Grolier Network]
0.0.0.0 ads.miarroba.com
0.0.0.0 counter.mirohost.net
0.0.0.0 mixmarket.biz
0.0.0.0 www.mktrack.com
0.0.0.0 www.mlclick.com
0.0.0.0 www.mmaaxx.com
0.0.0.0 mmptrack.com
0.0.0.0 gj.mmstat.com
0.0.0.0 ads.mnemosoft.com
0.0.0.0 px.moatads.com
0.0.0.0 tr.mobiadserv.com
0.0.0.0 ads.mobilemarketer.com
0.0.0.0 a.mobify.com
0.0.0.0 mola77.mobilenobo.com
0.0.0.0 ads.monetize-me.com
0.0.0.0 mein.monster.de
0.0.0.0 cookie.monster.com
0.0.0.0 www.mongoosemetrics.com
0.0.0.0 ib.mookie1.com
0.0.0.0 piwik.mortgageloan.com #[Piwik.Analytics]
0.0.0.0 webstats.motigo.com
0.0.0.0 m1.webstats.motigo.com
0.0.0.0 www1.mpnrs.com
0.0.0.0 msgtag.com #[Email tracker]
0.0.0.0 img.msgtag.com
0.0.0.0 www.msgtag.com
0.0.0.0 www.mycpvlife.com
0.0.0.0 get.mycounter.ua
0.0.0.0 scripts.mycounter.ua
0.0.0.0 get.mycounter.com.ua
0.0.0.0 scripts.mycounter.com.ua
0.0.0.0 mydati.com #[HotspotShield]
0.0.0.0 www.mylottoadserv.com
0.0.0.0 servad.mynet.com
0.0.0.0 www.myreferer.com
0.0.0.0 www.mystats.nl
0.0.0.0 www2.mystats.nl
# [N]
0.0.0.0 n214adserv.com
0.0.0.0 www3.nationalgeographic.com
0.0.0.0 ads.nationchannel.com
0.0.0.0 adssrv.nationmultimedia.com
0.0.0.0 labs.natpal.com
0.0.0.0 phpadsnew.new.natuurpark.nl
0.0.0.0 xml.nbcsearch.com
0.0.0.0 xml2.nbcsearch.com
0.0.0.0 ads.ncm.com
0.0.0.0 ndparking.com #[Parking Service]
0.0.0.0 www.ndparking.com
0.0.0.0 ad2.neodatagroup.com
0.0.0.0 adlev.neodatagroup.com
0.0.0.0 netclickstats.com
0.0.0.0 ads2.net-communities.co.uk
0.0.0.0 hits.netgeography.net
0.0.0.0 ad.netgoo.com
0.0.0.0 ads.ads.netlog.com
0.0.0.0 pool.ads.netlog.com #[adhese.com]
0.0.0.0 nl-moneyou.netmining.com
0.0.0.0 nl-saab.netmining.com
0.0.0.0 bkrntr.netmng.com
0.0.0.0 nan.netmng.com
0.0.0.0 com-quidco.netmng.com
0.0.0.0 rbk.netmng.com
0.0.0.0 www.netmaxx.com
0.0.0.0 ads.netrition.com
0.0.0.0 cl.netseer.com
0.0.0.0 evbeacon.networksolutions.com
0.0.0.0 www.newclick.com
0.0.0.0 ads.newsint.co.uk
0.0.0.0 e.nexac.com
0.0.0.0 f.nexac.com
0.0.0.0 p.nexac.com
0.0.0.0 r.nexac.com
0.0.0.0 turn.nexac.com
0.0.0.0 vte.nexteramedia.com
0.0.0.0 ngacm.com
0.0.0.0 ngastatic.com
0.0.0.0 ads.nordichardware.com
0.0.0.0 ads.novsport.com
0.0.0.0 www.nowstat.com
0.0.0.0 bam.nr-data.net
0.0.0.0 ntlligent.info #[Spamdexing]
0.0.0.0 ad.ntvmsnbc.com
0.0.0.0 ntweb.org
0.0.0.0 i.nuseek.com #[Parking Service]
0.0.0.0 www1.nuseek.com
0.0.0.0 www2.nuseek.com
0.0.0.0 www3.nuseek.com
0.0.0.0 nxtck.com
0.0.0.0 p.nxtck.com
0.0.0.0 ads.nyi.net
# [O]
0.0.0.0 observare.de
0.0.0.0 banner.oddcast.com
0.0.0.0 banner-a.oddcast.com
0.0.0.0 banner-d.oddcast.com
0.0.0.0 tracking.oe24.at
0.0.0.0 www18.officedepot.com #[WebBug.eluminate]
0.0.0.0 ads.ogdenpubs.com
0.0.0.0 ads.olx.com
0.0.0.0 logo.onlinewebstat.com
0.0.0.0 ads1.omdadget.com
0.0.0.0 track.omguk.com
0.0.0.0 www.on2url.com
0.0.0.0 tracking.onefeed.co.uk
0.0.0.0 ads.oneplace.com
0.0.0.0 stat.onestat.com
0.0.0.0 www.onestat.com #[Tracking.Cookie]
0.0.0.0 www.onestatfree.com
0.0.0.0 one.ru
0.0.0.0 stats0.one.ru
0.0.0.0 stats1.one.ru
0.0.0.0 stats2.one.ru
0.0.0.0 404.online.net
0.0.0.0 aa.online-metrix.net
0.0.0.0 h.online-metrix.net
0.0.0.0 adserver.online-tech.com
0.0.0.0 sayac.onlinewebstats.com
0.0.0.0 lifemediahouse1.onlinewelten.com
# 0.0.0.0 assets.onswipe.com #[affects mobile devices]
0.0.0.0 openstat.net
0.0.0.0 i.xx.openx.com
0.0.0.0 c1.openx.org
0.0.0.0 c3.openx.org
0.0.0.0 invitation.opinionbar.com
0.0.0.0 by.optimost.com
0.0.0.0 es.optimost.com
0.0.0.0 www.oreware.com
0.0.0.0 otclick-adv.ru
0.0.0.0 otracking.com
0.0.0.0 amplifypixel.outbrain.com
0.0.0.0 odb.outbrain.com
0.0.0.0 traffic.outbrain.com
0.0.0.0 pub.oxado.com
# [P]
0.0.0.0 www.pagerank10.co.uk
0.0.0.0 parkingcrew.net #[Parking.Service]
0.0.0.0 www.parkingcrew.net
0.0.0.0 paidstats.com
0.0.0.0 ad1.pamedia.com.au
0.0.0.0 img.parked.ru #[Parking Service]
0.0.0.0 park.parkingpanel.com
0.0.0.0 www.partner-ads.com
0.0.0.0 stats.partypoker.com #[WebBug]
0.0.0.0 stat.pchome.net
0.0.0.0 pcmightymax.net
0.0.0.0 www.pcmightymax.net
0.0.0.0 catrg.peer39.net
0.0.0.0 trg.peer39.net #[PrivacyChoice.Tracker]
0.0.0.0 pt.peerius.com
0.0.0.0 tag.perfectaudience.com
0.0.0.0 b1.perfb.com
0.0.0.0 stats.persgroep.be
0.0.0.0 stats.persgroep.nl
0.0.0.0 count.pcpop.com
0.0.0.0 pixel.pcworld.com #[WebBug]
0.0.0.0 viewer.peer39.com
0.0.0.0 banners.perfectgonzo.com
0.0.0.0 errors.perfectgonzo.com
0.0.0.0 ads.periodistadigital.com
0.0.0.0 ads.persgroep.net
0.0.0.0 pgssl.com
0.0.0.0 pub.pgssl.com
0.0.0.0 pharmacyrxone.com
0.0.0.0 ads.phillipsdata.us
0.0.0.0 ads.phillyadclub.com
0.0.0.0 ads.pimdesign.org
0.0.0.0 rum-collector.pingdom.net
0.0.0.0 rum-static.pingdom.net
0.0.0.0 ads.pinger.com
0.0.0.0 banners.pinnaclesports.com
0.0.0.0 www.pixazza.com
0.0.0.0 banner.play-asia.com
0.0.0.0 pei-ads.playboy.com #[RealMedia]
0.0.0.0 pu.plugrush.com
0.0.0.0 webstats.plus.net
0.0.0.0 pxl.pmsrvr.com #[WebBug]
# 0.0.0.0 po.st #[affects URL shortening]
0.0.0.0 ads.po-zdravidnes.com
0.0.0.0 piwik.pokerlistings.com #[Piwik.Analytics]
0.0.0.0 adserve.podaddies.com
0.0.0.0 www1.pollg.com
0.0.0.0 www.pollmonkey.com
0.0.0.0 c1.popads.net
0.0.0.0 c2.popads.net
0.0.0.0 out.popads.net
0.0.0.0 serve.popads.net
0.0.0.0 www.popadvert.com
0.0.0.0 world.popadscdn.net
0.0.0.0 popcounter.com
0.0.0.0 partners.popmatters.com
0.0.0.0 chezh1.popmarker.com
0.0.0.0 popuptraf.ru
0.0.0.0 www.popuptraf.ru
0.0.0.0 cdn.popwin.net
0.0.0.0 ht.pornhub.com
0.0.0.0 porntraff.com
0.0.0.0 inapi.posst.co
0.0.0.0 prstats.postrelease.com
0.0.0.0 www.predictad.com
0.0.0.0 promo.content.premiumpass.com
0.0.0.0 www.pr-free.de
0.0.0.0 ads.prisacom.com #[RealMedia]
0.0.0.0 top.proext.com
0.0.0.0 ad.profiwin.de
0.0.0.0 bn.profiwin.de
0.0.0.0 www.promobenef.com
0.0.0.0 track.promptfile.com
0.0.0.0 ads.prospect.org
0.0.0.0 tr.prospecteye.com
0.0.0.0 www.profitzone.com
0.0.0.0 www.promo.com.au
0.0.0.0 ads-kurir.providus.rs
0.0.0.0 servedby.proxena-adserver.com
0.0.0.0 sdc.prudential.com
0.0.0.0 static.pubdirecte.com
0.0.0.0 www.pubdirecte.com
0.0.0.0 tracking.publicidees.com
0.0.0.0 ads.pubmatic.com
0.0.0.0 bid.pubmatic.com
0.0.0.0 haso.pubmatic.com
0.0.0.0 showads.pubmatic.com
0.0.0.0 track.pubmatic.com
0.0.0.0 pl11074444.puhtml.com
0.0.0.0 pl12258511.puhtml.com
0.0.0.0 cgicounter.puretec.de
# [Q]
0.0.0.0 www.qbop.com
0.0.0.0 e1.cdn.qnsr.com
0.0.0.0 l1.cdn.qnsr.com #[WebBug]
0.0.0.0 qualityporn.biz
0.0.0.0 siteinterceptco1.qualtrics.com
0.0.0.0 tracking.quisma.com
0.0.0.0 adping.qq.com
0.0.0.0 adsrich.qq.com
# [R]
0.0.0.0 ads.racunalniske-novice.com
0.0.0.0 stats2.radiocompanion.com
0.0.0.0 s-bid.rmp.rakuten.com
0.0.0.0 s-imp.rmp.rakuten.com
0.0.0.0 www.ranking-charts.de
0.0.0.0 srv1.rapidstats.de
0.0.0.0 www.random-logic.com
0.0.0.0 ranking-hits.de
0.0.0.0 www.ranking-hits.de
0.0.0.0 counter.rapidcounter.com
0.0.0.0 www.rapidcounter.com
0.0.0.0 count.rbc.ru
0.0.0.0 ads.rcgroups.com
0.0.0.0 webstats.web.rcn.net
0.0.0.0 reactads.com
0.0.0.0 banners.realitycash.com
0.0.0.0 go.realvu.net
0.0.0.0 noah.reddion.com
0.0.0.0 ads.rediff.com
0.0.0.0 adworks.rediff.com
0.0.0.0 imadworks.rediff.com
0.0.0.0 redirectcpv.com
0.0.0.0 js.ua.redtram.com
0.0.0.0 n4p.ua.redtram.com
0.0.0.0 www.refer.ru
0.0.0.0 ads.register.com
0.0.0.0 ad.reklamport.com
0.0.0.0 adserver.reklamstore.com
0.0.0.0 reklamanet.net
0.0.0.0 banner.relcom.ru
0.0.0.0 cdn.reporo.net
0.0.0.0 republer.com
0.0.0.0 custom-wrs.api.responsys.net
0.0.0.0 banners.resultonline.com
0.0.0.0 retaraga.ru
0.0.0.0 revcontent.com
0.0.0.0 cdn.revcontent.com
0.0.0.0 labs-cdn.revcontent.com
0.0.0.0 www.revcontent.com
0.0.0.0 rem.rezonmedia.eu
0.0.0.0 p.rfihub.com
0.0.0.0 sync.rhythmxchange.com
0.0.0.0 richmedia247.com
0.0.0.0 overlay.ringtonematcher.com
0.0.0.0 ads.ripoffreport.com
0.0.0.0 db.riskwaters.com #[WebTrends]
0.0.0.0 count.rin.ru
0.0.0.0 mct.rkdms.com
0.0.0.0 ei.rlcdn.com
0.0.0.0 sr.rlcdn.com
0.0.0.0 ads.rnmd.net
0.0.0.0 ro2.biz
0.0.0.0 tex-sync.rockyou.net
0.0.0.0 ads.rohea.com
0.0.0.0 adcode.rontar.com
0.0.0.0 laurel.rovicorp.com
0.0.0.0 gbjfc.rsvpgenius.com
0.0.0.0 count.rtl.de
0.0.0.0 rtrgt2.com
0.0.0.0 ads.rtvslo.si
0.0.0.0 adserver.rtvutrechtreclame.nl
0.0.0.0 ads.rubiconproject.com
0.0.0.0 optimized-by.rubiconproject.com
0.0.0.0 pixel.rubiconproject.com #[WebBug]
0.0.0.0 pixel-us-east.rubiconproject.com
0.0.0.0 advert.runescape.com
# 0.0.0.0 runslin.com
0.0.0.0 banners.rushcommerce.com
0.0.0.0 rutrk.org
# [S]
0.0.0.0 www.s2d6.com
0.0.0.0 s4le.net
0.0.0.0 ads.sagabg.net
0.0.0.0 samtrack1.com
0.0.0.0 cdn-rtb.sape.ru
0.0.0.0 app.scanscout.com
0.0.0.0 dt.scanscout.com
0.0.0.0 media.scanscout.com
0.0.0.0 static.scanscout.com #[Video.adpresentation]
0.0.0.0 sat.scoutanalytics.com
0.0.0.0 scout.scoutanalytics.net
0.0.0.0 zsc.scmspain.com
0.0.0.0 a1.seadform.net
0.0.0.0 ad.searchhound.com
0.0.0.0 searchmagnified.com #[Parking.Service]
0.0.0.0 tracking.searchmarketing.com
0.0.0.0 geoip.securitetotale.com
0.0.0.0 advertising.seenews.com
0.0.0.0 live.sekindo.com
0.0.0.0 www.selfsurveys.com
0.0.0.0 www2.sellhealth.com
0.0.0.0 t.sellpoints.com
0.0.0.0 stir.semilo.com
0.0.0.0 ads.senddroid.com
0.0.0.0 sensic.net
0.0.0.0 ad.sensismediasmart.com.au
0.0.0.0 weblink.settrade.com
0.0.0.0 logs.sexy-parade.com
0.0.0.0 sdc.shawinc.com
0.0.0.0 adserve.shopzilla.com
0.0.0.0 dc.sify.com #[WebTrends]
0.0.0.0 sinuatemedia.com
0.0.0.0 goska.siol.net #[RealMedia]
0.0.0.0 advertpro.sitepoint.com
0.0.0.0 domainpark.sitelutions.com #[Parking Service]
0.0.0.0 www.sitestatslive.com
0.0.0.0 eon.tags.sitetagger.co.uk
0.0.0.0 www.sitetagger.co.uk
0.0.0.0 sixsigmatraffic.com
0.0.0.0 www.sixsigmatraffic.com
0.0.0.0 simplehitcounter.com
0.0.0.0 ads.sina.com
0.0.0.0 ads.sladur.com
0.0.0.0 ad.smaclick.com
0.0.0.0 c.smartclick.net
0.0.0.0 ads.smartshoppingads.de
0.0.0.0 www.smartlog.ru
0.0.0.0 i.smartwebads.com
0.0.0.0 n2.smartyads.com
0.0.0.0 eu1.snoobi.com
0.0.0.0 l.socialsexnetwork.net
0.0.0.0 a.softconsultgroup.com
0.0.0.0 ads.sol.no
0.0.0.0 apex.go.sonobi.com
0.0.0.0 sync.go.sonobi.com
0.0.0.0 ivox.socratos.net
0.0.0.0 analytic.spamfighter.com #[Omniture]
0.0.0.0 tags.spider-mails.com
0.0.0.0 dp2.specificclick.net
0.0.0.0 www.speedcount.de
0.0.0.0 www.splem.net
0.0.0.0 www.sponsorads.de
0.0.0.0 bms.sportal.ru
# 0.0.0.0 spclient.wg.spotify.com #[affects mobile app]
0.0.0.0 spotsniper.ru
0.0.0.0 js.spotx.tv
0.0.0.0 search.spotxchange.com
0.0.0.0 www.speedcounter.net
0.0.0.0 speediest.net
0.0.0.0 counter.spylog.com
0.0.0.0 www.spywareit.com
0.0.0.0 js.stroeermediabrands.de
0.0.0.0 ads.stackoverflow.com
0.0.0.0 anchor.stailamedia.com
0.0.0.0 adn.static-files.com
0.0.0.0 pixel.staticworld.net
0.0.0.0 ads.stardoll.com
0.0.0.0 www.start-page.org
0.0.0.0 statistik-gallup.net
0.0.0.0 js.stats.de
0.0.0.0 www.statsector.hu
0.0.0.0 www.steamtraffic.com
0.0.0.0 analytics.strangeloopnetworks.com
0.0.0.0 straightresults.com
0.0.0.0 go.straightresults.com
0.0.0.0 webservices.sub2tech.com
0.0.0.0 ads.sun.com
0.0.0.0 ads.sup.com
0.0.0.0 cnt.sup.com
0.0.0.0 clix.superclix.de
0.0.0.0 www.superclix.de
0.0.0.0 www.surveynetworks.com
0.0.0.0 my.surveypopups.com
0.0.0.0 analytics.sutterhealth.org
0.0.0.0 adtag.sympatico.ca
0.0.0.0 www.system4.nl
0.0.0.0 tracking.synthasite.net
# [T]
0.0.0.0 c.t4ft.de
0.0.0.0 nr.taboola.com
0.0.0.0 www.t-analytics.com
0.0.0.0 www.tag4arm.com #[Piwik.Analytics]
0.0.0.0 ads.tahono.com
0.0.0.0 files.tailsweep.com
0.0.0.0 script.tailsweep.com
0.0.0.0 b100.takru.com
0.0.0.0 b120.takru.com
0.0.0.0 b130.takru.com
0.0.0.0 b140.takru.com
0.0.0.0 b180.takru.com
0.0.0.0 banners.takru.com
0.0.0.0 talkaxis.com
0.0.0.0 tapestry.tapad.com
0.0.0.0 dev.targetpoint.com
0.0.0.0 srs.targetpoint.com
0.0.0.0 traffic.tcmagnet.com
0.0.0.0 ads.tele.net
0.0.0.0 adserver.tele.net
0.0.0.0 sdc.tele.net
0.0.0.0 c2.tentaculos.net
0.0.0.0 dy.testnet.nl
0.0.0.0 textad.net
0.0.0.0 ads.tdcanadatrust.com
0.0.0.0 market2.the-adult-company.com
0.0.0.0 media.the-adult-company.com
0.0.0.0 dmp.theadex.com
0.0.0.0 j.theadsnet.com
0.0.0.0 pixel.theagency.com
0.0.0.0 scripts.the-group.net
0.0.0.0 analytics.theknot.com
0.0.0.0 ads.themoneytizer.com
0.0.0.0 analytics.thenest.com
0.0.0.0 pei-ads.thesmokingjacket.com
0.0.0.0 webstats.thesoul-publishing.com
0.0.0.0 www.thesocialsexnetwork.com
0.0.0.0 www.thickcash.com
0.0.0.0 www.tinbuadserv.com
0.0.0.0 www.tinka.ru
0.0.0.0 tns-counter.ru
0.0.0.0 kz.tns-counter.ru
0.0.0.0 www.tns-counter.ru
0.0.0.0 ad.tom.com
0.0.0.0 banner.tonygpoker.com
0.0.0.0 www.topblogging.com
0.0.0.0 hit.topc.org
0.0.0.0 topeuro.biz
0.0.0.0 counter.topphoto.ru
0.0.0.0 stats.topofblogs.com
0.0.0.0 www.top-rank.pl
0.0.0.0 www.topsites24.net
0.0.0.0 www.topsiteguide.com
0.0.0.0 ads.topwam.com
0.0.0.0 cdn.total-media.net
0.0.0.0 winappcenter.total-secure.info
0.0.0.0 ams.toxity.biz
0.0.0.0 www.tr100.net
0.0.0.0 ad.track.us.org
0.0.0.0 trackaffpix.com
0.0.0.0 cdnegc.trafficfactory.biz
0.0.0.0 www.trackbacksecure.com
0.0.0.0 t.trackedlink.net
0.0.0.0 usage.trackjs.com
0.0.0.0 api.trackuity.com
0.0.0.0 ads.tradeads.eu
0.0.0.0 tm.tradetracker.net
0.0.0.0 cdn1ht.traffichaus.com
0.0.0.0 www.trafficresults.com
0.0.0.0 t.trafmag.com
0.0.0.0 dm.travelocity.com
0.0.0.0 ad.triplemind.com
0.0.0.0 engine.trklnks.com
0.0.0.0 www.track2cash.com
0.0.0.0 trackdiscovery.net
0.0.0.0 ads.trademe.co.nz
0.0.0.0 www.trafficcenter.de
0.0.0.0 ads.traderonline.com #[RealMedia]
0.0.0.0 www.trafficbeamer.com
0.0.0.0 www.trafficbeamer.nl
0.0.0.0 delivery.trafficbroker.com
0.0.0.0 www.trafficzap.com
0.0.0.0 www.traktrafficflow.com
0.0.0.0 media.travelzoo.com
0.0.0.0 media2.travelzoo.com
0.0.0.0 advert.travlang.com
0.0.0.0 cdna.tremormedia.com
0.0.0.0 objects.tremormedia.com #[adserver.adtechus.com]
0.0.0.0 www.trendcounter.com
0.0.0.0 ads.tripican.com
# 0.0.0.0 s1.trrsf.com #[affects terra.com]
# 0.0.0.0 s2.trrsf.com #[affects terra.com]
0.0.0.0 hits3.truehits.net
0.0.0.0 tracker.truehits.net
0.0.0.0 origin-tracking.trulia.com
0.0.0.0 analytics.trutv.com
0.0.0.0 tds.tuberl.com
0.0.0.0 ht.tube8.com
0.0.0.0 adclient1.tucows.com
0.0.0.0 counts.tucows.com
0.0.0.0 google.tucows.com
0.0.0.0 d.turn.com
0.0.0.0 presentation-atl1.turn.com
0.0.0.0 ad.tv2.no #[RealMedia]
0.0.0.0 adserver.tvcatchup.com
0.0.0.0 p.tvpixel.com
0.0.0.0 ads.twitter.com
# 0.0.0.0 analytics.twitter.com #[affects Twitter Dashboard]
0.0.0.0 twittercounter.com
0.0.0.0 et.twyn.com
0.0.0.0 tracknet.twyn.com
0.0.0.0 tx2.ru
# [U]
0.0.0.0 a.ucoz.net
0.0.0.0 s212.ucoz.net
0.0.0.0 credity.ucoz.ru
0.0.0.0 ucounter.ucoz.net
0.0.0.0 udmserve.net
0.0.0.0 mediamgr.ugo.com
0.0.0.0 creativos.ads.uigc.net
0.0.0.0 adclient.uimserv.net
0.0.0.0 adimg.uimserv.net
0.0.0.0 pixelbox.uimserv.net
0.0.0.0 www.ukbanners.com
0.0.0.0 ukrbanner.net
0.0.0.0 tracking.ukwm.co.uk
0.0.0.0 www.ultimatetopsites.com
# 0.0.0.0 tags.api.umbel.com #[affects polygon.com]
0.0.0.0 undertonenetworks.com #[zedo.com]
0.0.0.0 www.undertonenetworks.com
0.0.0.0 adserving.unibet.com
0.0.0.0 www.unicast.com
0.0.0.0 ads.univision.com
0.0.0.0 web.unltd.info
0.0.0.0 update-java.kit.net
0.0.0.0 www.update-java.kit.net
0.0.0.0 www.upsellit.com
0.0.0.0 c.uarating.com
0.0.0.0 usabilitytesten.nl
0.0.0.0 usachoice.net
0.0.0.0 data.nal.usda.gov #[Universal Federated Analytics]
0.0.0.0 analytics.usdm.net
0.0.0.0 tag.userreport.com
0.0.0.0 www.usenetjunction.com
0.0.0.0 ads.urlfan.com
0.0.0.0 uroffer.link
0.0.0.0 ads.usercash.com
0.0.0.0 www.utarget.co.uk #[utarget Ad code]
0.0.0.0 rotabanner.utro.ru
0.0.0.0 rotabanner100.utro.ru
0.0.0.0 rotabanner234.utro.ru
0.0.0.0 rotabanner468.utro.ru
# [V]
0.0.0.0 tracking.vacationsmadeeasy.com
0.0.0.0 ads.vador.com
0.0.0.0 feed.validclick.com
0.0.0.0 ad.jp.ap.valuecommerce.com #[WebBug]
0.0.0.0 ads.vclick.vn
0.0.0.0 vclicks.net
0.0.0.0 counters.vendio.com
0.0.0.0 cdsusa.veinteractive.com
0.0.0.0 config1.veinteractive.com
0.0.0.0 drs2.veinteractive.com
0.0.0.0 c.velaro.com
0.0.0.0 v.velaro.com
0.0.0.0 ab.vendemore.com
0.0.0.0 profiling.veoxa.com
0.0.0.0 vu.veoxa.com
0.0.0.0 spinbox.versiontracker.com
0.0.0.0 p.vibrant.co
0.0.0.0 advice-ads-cdn.vice.com
0.0.0.0 geoip-lookup.vice.com
0.0.0.0 vice-ads-cdn.vice.com
# 0.0.0.0 vice-web-statics-cdn.vice.com #[affects vice.com]
0.0.0.0 chappel.videogamer.com
0.0.0.0 ads.videohub.tv
0.0.0.0 adserver.virginmedia.com
0.0.0.0 pilmedia.ads.visionweb.no
0.0.0.0 sniff.visistat.com
0.0.0.0 code.visitor-track.com
0.0.0.0 www.visitor-track.com #[WebBug]
0.0.0.0 www.visitortracklog.com
0.0.0.0 optimized.by.vitalads.net
0.0.0.0 optimized-by.vitalads.net
0.0.0.0 www.vjsoft.net
0.0.0.0 ads.vkushti.tv
0.0.0.0 www.v-links.net
0.0.0.0 livetracker.voanews.eu
0.0.0.0 optimize-stats.voxmedia.com
0.0.0.0 ads.vporn.com
0.0.0.0 vq918450.com
0.0.0.0 www.vstats.net
# [W]
0.0.0.0 ads.w3hoster.de
0.0.0.0 beacon.walmart.ca
0.0.0.0 beacon.walmart.com
0.0.0.0 beacon.affil.walmart.com
0.0.0.0 ad.wanderlist.com
# 0.0.0.0 tracking.waterfrontmedia.com #[affects MayoClinic]
0.0.0.0 delivery.way2traffic.com
0.0.0.0 ads.weather.ca
0.0.0.0 btn.counter.weather.ca
0.0.0.0 pub.weatherbug.com #[RealMedia]
0.0.0.0 ads.web1tv.de
0.0.0.0 data.webads.co.nz
0.0.0.0 tr.webantenna.info
0.0.0.0 banners.webcams.com
0.0.0.0 www.web-chart.de
0.0.0.0 webcounter.be
0.0.0.0 diapi.webgains.com
0.0.0.0 webgozar.com
0.0.0.0 webhits.de
0.0.0.0 www.webhits.de
0.0.0.0 ads.webkinz.com
0.0.0.0 ads2.weblogssl.com
0.0.0.0 counter.web-marketolog.ru
0.0.0.0 banners.webmasterplan.com #[WebBug]
0.0.0.0 ebayrelevancead.webmasterplan.com
0.0.0.0 partners.webmasterplan.com
0.0.0.0 secure.webresint.com
0.0.0.0 www.website-hit-counters.com
0.0.0.0 www.webtistic.com
0.0.0.0 ads.whitelabelpros.com
0.0.0.0 wikia-ads.wikia.com
0.0.0.0 a.wikia-beacon.com
0.0.0.0 sdc8prod1.wiley.com #[WebTrends]
0.0.0.0 cacheserve.williamhill.com
0.0.0.0 serve.williamhill.com
0.0.0.0 banner-server.winecountry.com
0.0.0.0 ads.wineenthusiast.com
0.0.0.0 win-spy.com
0.0.0.0 www.win-spy.com #[Spyware.WinSpy]
0.0.0.0 api.wipmania.com #[affects WorldIP]
0.0.0.0 stats.wired.com
0.0.0.0 ctsde01.wiredminds.de
# 0.0.0.0 f.wishabi.net #[affects walmart.ca]
0.0.0.0 helper-stats.wondershare.com
0.0.0.0 phpadsnew.wn.com
0.0.0.0 clicktrack.wnu.com
0.0.0.0 tracker.wordstream.com
0.0.0.0 w00tpublishers.wootmedia.net
0.0.0.0 links.worldbannerexchange.com
0.0.0.0 ads.worldstarhiphop.com
0.0.0.0 wtsdc.worldnow.com #[WebTrends]
0.0.0.0 ads.worthplaying.com
0.0.0.0 beacon.thred.woven.com
0.0.0.0 pixel.wp.com
0.0.0.0 stats.wp.com
0.0.0.0 ad.wsod.com
0.0.0.0 admedia.wsod.com
0.0.0.0 wtvertnet.com
0.0.0.0 www.wysistat.com
# [X]
0.0.0.0 engine.xclaimwords.net
0.0.0.0 hr-engine.xclaimwords.net
0.0.0.0 ad.xe.gr
0.0.0.0 148.xg4ken.com
0.0.0.0 506.xg4ken.com
0.0.0.0 531.xg4ken.com
0.0.0.0 www.xl-rank.com
0.0.0.0 adserver.xpanama.net
0.0.0.0 ssl.xplosion.de
0.0.0.0 ad.xrea.com
0.0.0.0 xtainment.net
0.0.0.0 ht.xtube.com
0.0.0.0 ads.xtra.co.nz
0.0.0.0 track.xtrasize.nl
0.0.0.0 ads.xtargeting.com
0.0.0.0 www.xxxbannerswap.com
0.0.0.0 www.xyztraffic.com
# [Y]
0.0.0.0 advertpro.ya.com
0.0.0.0 quad.yadro.ru
0.0.0.0 ad2.yam.com
0.0.0.0 ads.yam.com
0.0.0.0 yatrk.xyz
0.0.0.0 ybex.com
0.0.0.0 ads.yeshanews.com
0.0.0.0 ad.yieldlab.net
0.0.0.0 probe.yieldlab.net
0.0.0.0 counter.yesky.com
0.0.0.0 yieldbuild.com
0.0.0.0 hook.yieldbuild.com
0.0.0.0 payload.yieldbuild.com
0.0.0.0 yllix.com
0.0.0.0 urchin.lstat.youku.com
0.0.0.0 go.youlamedia.com
0.0.0.0 www.yourhitstats.com
0.0.0.0 ad.yourmedia.com
0.0.0.0 ad1.yourmedia.com
0.0.0.0 pc2.yumenetworks.com
# [Z]
0.0.0.0 ad.zanox.com
0.0.0.0 static.zanox.com
0.0.0.0 zanox-affiliate.de
0.0.0.0 www.zanox-affiliate.de
0.0.0.0 www.zapunited.com
0.0.0.0 zbest.in
0.0.0.0 analytics.zdbb.net
0.0.0.0 banners.zbs.ru
0.0.0.0 ea.zebestof.com
0.0.0.0 ads.zeusclicks.com
0.0.0.0 apibeta.zeti.com
0.0.0.0 in.zog.link
0.0.0.0 in3.zog.link
# [Misc]
0.0.0.0 www.1-1ads.com
0.0.0.0 1bg.net
0.0.0.0 100webads.com
0.0.0.0 www.123banners.com
0.0.0.0 123go.com
0.0.0.0 ns1.123go.net
0.0.0.0 123stat.com
0.0.0.0 123-tracker.com
0.0.0.0 banners.2lipslive.com
0.0.0.0 ads.24.com
0.0.0.0 stats.24.com
0.0.0.0 counter.24log.com
0.0.0.0 pixel.33across.com
0.0.0.0 imgad1.3conline.com
0.0.0.0 imgad2.3conline.com
0.0.0.0 imgad3.3conline.com
0.0.0.0 ads.3sfmedia.com
0.0.0.0 guannan.3322.net
0.0.0.0 ads.4tube.com
0.0.0.0 cdn1.adspace.4tube.com
0.0.0.0 adserver.4clicks.org
0.0.0.0 r.4at1.com
0.0.0.0 static.4chan-ads.org
0.0.0.0 banners.4d5.net
0.0.0.0 epomads2.4shared.com
0.0.0.0 4ur.click
0.0.0.0 www.777tool.com
# [1&1 Internet][AS8560][195.20.243.0 - 195.20.255.255]
0.0.0.0 madclient.uimserv.net
# [1&1 Internet][AS8560][212.227.36.0 - 212.227.60.255]
0.0.0.0 tools.ad-net.co.uk
# [1&1 Internet][AS8560][217.160.128.0 - 217.160.143.255]
0.0.0.0 am-display.com
0.0.0.0 statistik.polizei-beratung.de #[Piwik.Analytics]
# [1&1 Internet][AS8560][217.72.192.0 - 217.72.204.255]
0.0.0.0 advertising.ingame.de
0.0.0.0 uim.tifbs.net
0.0.0.0 fips.uimserv.net
0.0.0.0 uidbox.uimserv.net
# [1&1 Internet][AS8560][74.208.0.0 - 74.208.191.255]
0.0.0.0 ads.emqus.com
0.0.0.0 server.siteamplifier.net
0.0.0.0 ww1.tongji123.com
0.0.0.0 ww2.tongji123.com
0.0.0.0 ww3.tongji123.com
0.0.0.0 ww4.tongji123.com
# [1&1 Internet][AS8560][82.165.192.0 - 82.165.199.255]
0.0.0.0 www.countok.de
# [1&1 Internet][AS8560][87.106.16.0 - 87.106.31.255]
0.0.0.0 www.adranking.de
0.0.0.0 adsrv.advanced-television.tv
0.0.0.0 www.andyhoppe.com
0.0.0.0 www.free-counters.net
0.0.0.0 analytics.gameforge.de
0.0.0.0 delivery.ads.gfsrv.net
0.0.0.0 media.ads.gfsrv.net
0.0.0.0 www.gratis-counter-gratis.de
0.0.0.0 media.hauptbruch.de
0.0.0.0 www.ranking-counter.de
0.0.0.0 www.rankmaschine.de
0.0.0.0 a.trkme.net
# [1-800-hosting][AS33210][69.41.160.0 - 69.41.191.255]
0.0.0.0 www.ineedhits.com
0.0.0.0 track.lativio.com
# [7Search.com Networks][EMERgency 24 Inc][208.237.254.0 - 208.237.254.255]
0.0.0.0 7search.com #[Adware.7FaSSt]
0.0.0.0 conversion.7search.com
0.0.0.0 ia1.7search.com
0.0.0.0 img.7search.com
0.0.0.0 meta.7search.com
0.0.0.0 www.7search.com #[Spyware.SevenSearch]
0.0.0.0 77search.com
0.0.0.0 www.7metasearch.com
0.0.0.0 www.a1fax.com
0.0.0.0 advertisingagent.com
0.0.0.0 ajokeaday.com
0.0.0.0 bannersxchange.com
0.0.0.0 www.bannersxchange.com
0.0.0.0 bestsearch.com
0.0.0.0 www.bestsearch.com
0.0.0.0 www.buscamundo.com
0.0.0.0 internetsecurity.com
0.0.0.0 www.internetsecurity.com
0.0.0.0 www.payperranking.com
0.0.0.0 www.pay-per-search.com
0.0.0.0 paypertext.com
0.0.0.0 predictivesearch.com
0.0.0.0 seal.ranking.com
0.0.0.0 www.ranking.com
0.0.0.0 tracking.roispy.com
0.0.0.0 www.roispy.com
0.0.0.0 tracking.spiderbait.com
0.0.0.0 www.spiderbait.com
0.0.0.0 www.textadvertising.com
0.0.0.0 www.thetop10.com
0.0.0.0 trustgauge.com
0.0.0.0 www.trustgauge.com
0.0.0.0 seal.validatedsite.com
0.0.0.0 www.validatedsite.com
0.0.0.0 www.watch24.com
# [A1COLO.com][AS30266][216.17.96.0 - 216.17.111.255]
0.0.0.0 ztrack.net
# [Abacus America / Codero][AS10316][216.55.128.0 - 216.55.191.255]
0.0.0.0 phpadsnew.abac.com
# [Abovenet][AS6461][204.45.0.0 - 204.45.255.255]
0.0.0.0 hitslap.com
# [Abovenet][AS6461][208.185.115.0 - 208.185.115.255]
0.0.0.0 fast.cbsi.demdex.net
# [Abovenet / Everyone.net][AS30627][209.249.170.0 - 209.249.170.255]
0.0.0.0 chewbacca.cybereps.com
0.0.0.0 ds.cybereps.com
0.0.0.0 images.cybereps.com
0.0.0.0 yoda.cybereps.com
# [Abovenet / Coloquest][AS6461][209.249.220.0 - 209.249.223.255]
0.0.0.0 secure.cardtransaction.com
# [Abovenet][216.200.0.0 - 216.200.255.255]
0.0.0.0 spin.spinbox.net
# [Abovenet / Hyperbanner][AS6461][216.200.199.0 - 216.200.199.255]
0.0.0.0 ads.bidvertiser.com
0.0.0.0 bdv.bidvertiser.com
0.0.0.0 srv.bidvertiser.com
0.0.0.0 www.bidvertiser.com
# [Abovenet][AS17025][23.104.0.0 - 23.111.255.255]
0.0.0.0 img.revcontent.com
# [Abovenet][AS6461][64.124.0.0 - 64.125.255.255]
# [Abovenet][AS6461][94.31.2.32 - 94.31.2.63]
# [Abovenet][AS17025][94.31.29.0 - 94.31.29.255]
0.0.0.0 cdn.adpacks.com
0.0.0.0 cdn.trackjs.com
# [About Inc][AS22780][207.241.144.0 - 207.241.159.255]
0.0.0.0 clicks.about.com
0.0.0.0 home.about.com
0.0.0.0 images.about.com
# [Accretive / Flying Crocodile][AS11608][207.246.128.0 - 207.246.159.255]
0.0.0.0 2001positions.com
0.0.0.0 ifa.empflixlive.com
0.0.0.0 static.ifa.empflixlive.com
0.0.0.0 www.flyingcroc.com
0.0.0.0 ifa.hardsexmate.com
0.0.0.0 ifa.maxpornlive.com
0.0.0.0 clicktraq.mtree.com
0.0.0.0 counter.mtree.com
0.0.0.0 dyntraq.mtree.com
0.0.0.0 mtree.com
0.0.0.0 mt1.mtree.com
0.0.0.0 mt2.mtree.com
0.0.0.0 mt4.mtree.com #[xxxtoolbar.com]
0.0.0.0 mt10.mtree.com
0.0.0.0 mt11.mtree.com
0.0.0.0 mt12.mtree.com
0.0.0.0 mt15.mtree.com
0.0.0.0 mt32.mtree.com
0.0.0.0 mt34.mtree.com #[Google.Diagnostic]
0.0.0.0 mt35.mtree.com
0.0.0.0 mt37.mtree.com
0.0.0.0 mt55.mtree.com #[Troj/Istbar-BL]
0.0.0.0 mt58.mtree.com
0.0.0.0 mt83.mtree.com
0.0.0.0 mt94.mtree.com
0.0.0.0 mt103.mtree.com
0.0.0.0 mt113.mtree.com
0.0.0.0 mt124.mtree.com
0.0.0.0 mt127.mtree.com
0.0.0.0 porn.mtree.com #[Dialer.Moneytree]
0.0.0.0 psy.mtree.com
0.0.0.0 ss.mtree.com
0.0.0.0 the.mtree.com
0.0.0.0 wm.mtree.com
0.0.0.0 xbs.mtree.com #[Troj/NSUpdate-A]
0.0.0.0 xbs.pao.mtree.com #[TROJ_DYFUCA.X]
0.0.0.0 xbs.sea.mtree.com #[MoneyTree Dialer]
0.0.0.0 www.mtree.com
0.0.0.0 dyn.naiadsystems.com
0.0.0.0 www.naiadsystems.com
0.0.0.0 cdn.nsimg.net
0.0.0.0 banners.outster.com #[Tracking.Cookie]
0.0.0.0 c1.outster.com
0.0.0.0 c2.outster.com
0.0.0.0 c3.outster.com
0.0.0.0 clit50.outster.com
0.0.0.0 clit120.outster.com
0.0.0.0 links.outster.com
0.0.0.0 refer1.outster.com
0.0.0.0 refer20.outster.com
0.0.0.0 refer25.outster.com
0.0.0.0 refer46.outster.com
0.0.0.0 refer85.outster.com
0.0.0.0 refer100.outster.com
0.0.0.0 refer102.outster.com
0.0.0.0 rr1.outster.com
0.0.0.0 start.outster.com
0.0.0.0 stats.outster.com
0.0.0.0 cgi.sexlist.com #[Tracking.Cookie]
0.0.0.0 cgi1.sexlist.com
0.0.0.0 enter.sexlist.com
0.0.0.0 images.sexlist.com
0.0.0.0 links.sexlist.com
0.0.0.0 lobby.sexlist.com
0.0.0.0 vis.sexlist.com
0.0.0.0 vis5.sexlist.com
0.0.0.0 xit.sexlist.com
0.0.0.0 sextracker.com
0.0.0.0 the.sextracker.com
0.0.0.0 adserver.sextracker.com
0.0.0.0 banners.sextracker.com
0.0.0.0 counter1.sextracker.com
0.0.0.0 clit.sextracker.com
0.0.0.0 clit1.sextracker.com #[Tracking.Cookie]
0.0.0.0 clit2.sextracker.com
0.0.0.0 clit3.sextracker.com
0.0.0.0 clit4.sextracker.com
0.0.0.0 clit5.sextracker.com
0.0.0.0 clit6.sextracker.com
0.0.0.0 clit7.sextracker.com
0.0.0.0 clit8.sextracker.com
0.0.0.0 clit9.sextracker.com
0.0.0.0 clit10.sextracker.com
0.0.0.0 clit11.sextracker.com
0.0.0.0 clit12.sextracker.com
0.0.0.0 clit13.sextracker.com
0.0.0.0 clit14.sextracker.com
0.0.0.0 clit15.sextracker.com
0.0.0.0 clit16.sextracker.com
0.0.0.0 elite.sextracker.com
0.0.0.0 graphics1.sextracker.com
0.0.0.0 graphics2.sextracker.com
0.0.0.0 hosting.sextracker.com
0.0.0.0 links.sextracker.com
0.0.0.0 mau.sextracker.com
0.0.0.0 moneytree.sextracker.com
0.0.0.0 ranks.sextracker.com
0.0.0.0 search.sextracker.com
0.0.0.0 start.sextracker.com
0.0.0.0 stats.sextracker.com
0.0.0.0 stx.sextracker.com
0.0.0.0 stx0.sextracker.com
0.0.0.0 stx1.sextracker.com
0.0.0.0 stx2.sextracker.com
0.0.0.0 stx3.sextracker.com
0.0.0.0 stx4.sextracker.com
0.0.0.0 stx5.sextracker.com
0.0.0.0 stx6.sextracker.com
0.0.0.0 stx7.sextracker.com
0.0.0.0 stx8.sextracker.com
0.0.0.0 stx9.sextracker.com
0.0.0.0 stx10.sextracker.com
0.0.0.0 stx11.sextracker.com
0.0.0.0 stx12.sextracker.com
0.0.0.0 stx13.sextracker.com
0.0.0.0 stx14.sextracker.com
0.0.0.0 stx15.sextracker.com
0.0.0.0 stxbans.sextracker.com
0.0.0.0 webmasters.sextracker.com
0.0.0.0 stx.banners.sextracker.com
0.0.0.0 wm.banners.sextracker.com
0.0.0.0 www.sextracker.com
0.0.0.0 ads.sexspaces.com
0.0.0.0 ifa.slutloadlive.com
0.0.0.0 static.ifa.slutloadlive.com
0.0.0.0 static.gfx.streamen.com
0.0.0.0 www.streamen.com
0.0.0.0 streamate.com
0.0.0.0 static.gfx.streamate.com
0.0.0.0 teen.streamate.com
0.0.0.0 www.streamate.com
0.0.0.0 ifa.streamateaccess.com
0.0.0.0 www.streamatelive.com
0.0.0.0 www.thesexcinema.com
0.0.0.0 ifa.tnaflixlive.com
0.0.0.0 c1.xxxcounter.com
0.0.0.0 c2.xxxcounter.com
0.0.0.0 c3.xxxcounter.com
0.0.0.0 free.xxxcounter.com
0.0.0.0 grafix.xxxcounter.com
0.0.0.0 links.xxxcounter.com
0.0.0.0 rr1.xxxcounter.com
0.0.0.0 start.xxxcounter.com
# [Accretive / Flying Crocodile][216.127.32.0 - 216.127.63.255]
0.0.0.0 ifa.camads.net
0.0.0.0 ifa.keezlive.com
0.0.0.0 ifa.pornhublive.com
0.0.0.0 aphrodite.porntrack.com
0.0.0.0 stats1.porntrack.com
0.0.0.0 stats3.porntrack.com
0.0.0.0 www.seehits.com
0.0.0.0 as.sexad.net
0.0.0.0 counter2.sextracker.com
0.0.0.0 counter3.sextracker.com #[Tracking.Cookie]
0.0.0.0 counter4.sextracker.com
0.0.0.0 counter5.sextracker.com
0.0.0.0 counter6.sextracker.com
0.0.0.0 counter7.sextracker.com
0.0.0.0 counter8.sextracker.com
0.0.0.0 counter9.sextracker.com
0.0.0.0 counter10.sextracker.com
0.0.0.0 counter11.sextracker.com
0.0.0.0 counter12.sextracker.com
0.0.0.0 counter13.sextracker.com
0.0.0.0 counter14.sextracker.com
0.0.0.0 counter15.sextracker.com
0.0.0.0 counter16.sextracker.com
0.0.0.0 adserver.spankaway.com
0.0.0.0 adserver.spctl.com
0.0.0.0 asian.streamate.com
0.0.0.0 broadcaster.streamate.com
0.0.0.0 ebony.streamate.com
0.0.0.0 ifa.tube8live.com
0.0.0.0 webmaster.worldsex.com
0.0.0.0 ifa.xhamstercams.com
0.0.0.0 ifa.yobtcams.com
0.0.0.0 static.ifa.yobtcams.com
0.0.0.0 ifa.youjizzlive.com
0.0.0.0 ifa.youpornmate.com
# [A C Nielsen][AS16477][138.108.0.0 - 138.108.255.255]
0.0.0.0 secure-cert.imrworldwide.com
0.0.0.0 secure-drm.imrworldwide.com
0.0.0.0 secure-gl.imrworldwide.com
# [Add Software][AS42652][212.43.69.128 - 212.43.69.159]
0.0.0.0 ssl-vg03.met.vgwort.de
# [Adhost Internet Advertising][AS11274][67.212.128.0 - 67.212.143.255]
0.0.0.0 affinity.go2jump.org
# [ADNC][AS6130][209.112.240.0 - 209.112.255.255]
0.0.0.0 ads.digitalmedianet.com
0.0.0.0 adserver.digitalmedianet.com
# [ADNC][AS6130][67.207.208.0 - 67.207.223.255]
0.0.0.0 metrics.impactengine.com
# [AdOcean]
0.0.0.0 ad.adocean.pl
0.0.0.0 aripaee.adocean.pl
0.0.0.0 b92rs.adocean.pl
0.0.0.0 bg.adocean.pl
0.0.0.0 bggde.adocean.pl
0.0.0.0 bggde-new.adocean.pl
0.0.0.0 blitzbg.adocean.pl
0.0.0.0 by.adocean.pl
0.0.0.0 cz.adocean.pl
0.0.0.0 delfiee.adocean.pl
0.0.0.0 delfilv.adocean.pl
0.0.0.0 digital4ro.adocean.pl
0.0.0.0 edipresse.adocean.pl
0.0.0.0 ee.adocean.pl
0.0.0.0 eegde.adocean.pl
0.0.0.0 hr.adocean.pl
0.0.0.0 hrgde.adocean.pl
0.0.0.0 hugde.adocean.pl
0.0.0.0 ilgde.adocean.pl
0.0.0.0 indexhu.adocean.pl
0.0.0.0 investorbg.adocean.pl
0.0.0.0 keepaneyemk.adocean.pl
0.0.0.0 lrytaslt.adocean.pl
0.0.0.0 ltgde.adocean.pl
0.0.0.0 lt.adocean.pl
0.0.0.0 lv.adocean.pl
0.0.0.0 my.adocean.pl
0.0.0.0 myao.adocean.pl
0.0.0.0 pracuj.adocean.pl
0.0.0.0 protvmd.adocean.pl
0.0.0.0 ringierro.adocean.pl
0.0.0.0 ringierrs.adocean.pl
0.0.0.0 ro.adocean.pl
0.0.0.0 ro1ro.adocean.pl
0.0.0.0 rogde.adocean.pl
0.0.0.0 rs.adocean.pl
0.0.0.0 rsgde.adocean.pl
0.0.0.0 s1.sk.adocean.pl
0.0.0.0 s1.cz.adocean.pl
0.0.0.0 s1.czgde.adocean.pl
0.0.0.0 s1.edipresse.adocean.pl
0.0.0.0 s1.my.adocean.pl
0.0.0.0 s1.myao.adocean.pl
0.0.0.0 s1.pracuj.adocean.pl
0.0.0.0 s1.skgde.adocean.pl
0.0.0.0 sk.adocean.pl
0.0.0.0 si.adocean.pl
0.0.0.0 sportalbg.adocean.pl
0.0.0.0 thinkdigitalro.adocean.pl
0.0.0.0 trgde.adocean.pl
0.0.0.0 tvn.adocean.pl
0.0.0.0 tvn2.adocean.pl
0.0.0.0 ua.adocean.pl
0.0.0.0 vbbg.adocean.pl
0.0.0.0 webgroundbg.adocean.pl
# [AdOrigin Corp][AS19271][209.34.255.0 - 209.34.255.255]
0.0.0.0 www.adorigin.com
# [Adsolutions][Webads Europe][80.79.200.0 - 80.79.200.63]
0.0.0.0 storage.adsolutions.nl
0.0.0.0 telgids.adsolutions.nl
0.0.0.0 adserver.webads.nl
0.0.0.0 adserver.webads.co.uk
# [Advancedhosters][AS39572][192.243.48.0 - 192.243.63.255]
0.0.0.0 st-n.ads1-adnow.com
0.0.0.0 b.zog.link
# [Advancedhosters-net][AS39572][213.174.136.0 - 213.174.139.255]
0.0.0.0 st.adnow.com
0.0.0.0 st.ad.adnow.com
0.0.0.0 st.n.ads2-adnow.com
0.0.0.0 alfatraffic.com
0.0.0.0 www.antaraimedia.com
0.0.0.0 abc.doublegear.com
0.0.0.0 ads.fulldls.com
0.0.0.0 www.glxgroup.com
0.0.0.0 ad.iloveinterracial.com
0.0.0.0 st.ad.smaclick.com
0.0.0.0 teens24h.com
# [Advancedhosters][AS39572][46.229.160.128 - 46.229.160.191]
0.0.0.0 cd-ads.com
0.0.0.0 delivery.hornyspots.com
# [Advancedhosters / LeaseWeb][AS39572][88.208.0.0 - 88.208.11.255]
0.0.0.0 pkpojhc.com
0.0.0.0 st-n.ads2-adnow.com
0.0.0.0 st.pc.adonweb.ru
0.0.0.0 st.pay-click.ru
0.0.0.0 rb-net.com
0.0.0.0 rotator.trafficstars.com
0.0.0.0 ads.xhamster.com
0.0.0.0 m2.xhamster.com
0.0.0.0 partners.xhamster.com
# [AdvertPro][Renegade Internet]
0.0.0.0 aalbc.advertserve.com
0.0.0.0 cdn.advertserve.com
0.0.0.0 circuit.advertserve.com
0.0.0.0 divavillage.advertserve.com
0.0.0.0 hometheaterreview.advertserve.com
0.0.0.0 imagevenue.advertserve.com
0.0.0.0 pridesource.advertserve.com
0.0.0.0 projectorreviews.advertserve.com
0.0.0.0 tradearabia.advertserve.com
0.0.0.0 www.advertserve.com
# [Adverserve Pa][AS33890][77.72.164.0 - 77.72.164.31]
# 0.0.0.0 static.kleinezeitung.at
0.0.0.0 static.styria-digital.com
# [Advida Media][AS25180][83.244.139.32 - 83.244.139.63]
0.0.0.0 adstats.adviva.net
0.0.0.0 smp.adviva.net
# [Advida Media][AS25180][83.244.207.32 - 83.244.207.63]
0.0.0.0 afe2.specificclick.net
# [Advida Media][83.245.41.80 - 83.245.41.95]
0.0.0.0 ads.adviva.net #[Tracking.Cookie]
0.0.0.0 de.ads.adviva.net
# [AdWorld Media Corp]
0.0.0.0 cluster.adultadworld.com
0.0.0.0 cluster3.adultadworld.com
0.0.0.0 hippo.adultadworld.com
0.0.0.0 newt1.adultadworld.com
0.0.0.0 textads.adultadworld.com #[AdEngage]
0.0.0.0 tigershark.adultadworld.com
0.0.0.0 cluster.adworldmedia.com
0.0.0.0 www.adworldmedia.com
# [Agavacompany][AS39561][89.108.72.0 - 89.108.72.255]
0.0.0.0 err.agava.ru
# [Agora][AS8535][80.252.3.0 - 80.252.3.63]
0.0.0.0 static.adtaily.com
0.0.0.0 ad.glossymedia.pl
# [AiNET][AS6405][205.134.160.0 - 205.134.191.255]
0.0.0.0 bantam.ai.net
0.0.0.0 fiona.ai.net
# [Akamai][AS20940][104.64.0.0 - 104.127.255.255]
0.0.0.0 tag.aticdn.net
0.0.0.0 a.bf-ad.net
0.0.0.0 ssum.casalemedia.com
0.0.0.0 ade.clmbtech.com
0.0.0.0 fast.timeinc.demdex.net
# 0.0.0.0 dap.digitalgov.gov #[Universal Federated Analytics]
0.0.0.0 cdn-akamai.mookie1.com
0.0.0.0 ac.realvu.net
0.0.0.0 cdn.taboola.com
0.0.0.0 c.webtrends.com
# [Akamai][AS20940][125.56.128.0 - 125.56.255.255]
# [Akamai][AS20940][172.224.0.0 - 172.239.255.255]
0.0.0.0 tracking.admarketplace.net
0.0.0.0 static.ampxchange.com
0.0.0.0 p.bm23.com
# 0.0.0.0 cdn.tt.omtrdc.net #[affects Verizon]
# [Akamai][AS20940][173.222.0.0 - 173.223.255.255]
0.0.0.0 ads.pictela.net
0.0.0.0 tag.researchnow.com #[Web Bug]
0.0.0.0 b.thanksearch.com
0.0.0.0 e.thanksearch.com
# [Akamai / NTT][AS2914][AS26769][184.24.0.0 - 184.31.255.255]
0.0.0.0 www.77tracking.com
0.0.0.0 ak1s.abmr.net
0.0.0.0 cdn.betrad.com
0.0.0.0 c.betrad.com
0.0.0.0 ads.static.blip.tv
0.0.0.0 fast.ecs.demdex.net
0.0.0.0 fast.ford.demdex.net
0.0.0.0 fast.td.demdex.net
0.0.0.0 ma156-r.analytics.edgekey.net
0.0.0.0 79423.analytics.edgekey.net
0.0.0.0 my-cdn.effectivemeasure.net
0.0.0.0 cdn.fastclick.net
0.0.0.0 m1.fwmrm.net
0.0.0.0 js.indexww.com
0.0.0.0 a01.korrelate.net
0.0.0.0 a02.korrelate.net
0.0.0.0 plugin.mediavoice.com
0.0.0.0 vastx.moatads.com
0.0.0.0 geo.nbcsports.com
0.0.0.0 cdn.optimatic.com
0.0.0.0 c1.rfihub.net
0.0.0.0 ad.sitemaji.com
0.0.0.0 ads.yldmgrimg.net
0.0.0.0 e1.zedo.com
0.0.0.0 e2.zedo.com
0.0.0.0 z1.zedo.com
# [Akamai][AS20940][184.50.0.0 - 184.51.255.255]
0.0.0.0 redir.adap.tv
0.0.0.0 delivery-s3.adswizz.com
0.0.0.0 fast.fairfaxau.demdex.net
0.0.0.0 fast.philly.demdex.net
0.0.0.0 tiads.instyle.com
0.0.0.0 tracker.marinsm.com
# [Akamai][AS20940][184.84.0.0 - 184.87.255.255]
0.0.0.0 iocdn.coremetrics.com
0.0.0.0 update.hiconversion.com
0.0.0.0 secure.img-cdn.mediaplex.com
0.0.0.0 by.essl.optimost.com
0.0.0.0 ak.quantcast.com
0.0.0.0 widget.quantcast.com
# [Akamai][AS21342][193.108.88.0 - 193.108.95.255]
# [Akamai][AS3257][2.16.88.0 - 2.19.191.255]
0.0.0.0 mediaserver.bwinpartypartners.com
0.0.0.0 www.everestjs.net
# 0.0.0.0 cdn.optimizely.com #[affects sigfig.com/ 2go.com]
0.0.0.0 video.unrulymedia.com
0.0.0.0 cdn.static.zdbb.net
# [Akamai][AS20940][204.245.128.0 - 204.245.191.255]
# [Akamai][AS33659][23.0.0.0 - 23.67.255.255]
0.0.0.0 b.6sc.co #[WebBug]
0.0.0.0 ad131m.adk2.co
0.0.0.0 adsrvmedia.adk2.co
0.0.0.0 adtgs.adk2.co
0.0.0.0 cdn.adk2.co
0.0.0.0 matomy.adk2.co
0.0.0.0 ad-media.xe.gr
# 0.0.0.0 assets.adobedtm.com #[affects landsend.com]
0.0.0.0 www.adobetag.com #[SiteCatalyst Link Tracking]
0.0.0.0 a.adready.com
0.0.0.0 www.adreadytractions.com
0.0.0.0 assets1.adroll.com
0.0.0.0 cdn.adsrvmedia.net
0.0.0.0 content.adtegrity.net
0.0.0.0 content.aimatch.com
0.0.0.0 cdn2sitescout-a.akamaihd.net
0.0.0.0 static.adziff.com
0.0.0.0 cdn2.adsdk.com
0.0.0.0 cdn.atomex.net
0.0.0.0 cdn.atwola.com
0.0.0.0 akamai.t.axf8.net
0.0.0.0 content.bannerconnect.net
0.0.0.0 cdn.bidvertiser.com
0.0.0.0 as-sec.casalemedia.com
0.0.0.0 ip.casalemedia.com
0.0.0.0 ads.cdnslate.com
0.0.0.0 cc.chango.com
# 0.0.0.0 ad-js.chip.de #[affects images]
0.0.0.0 cdnssl.clicktale.net
0.0.0.0 cdn1.clkoffers.com
0.0.0.0 cdn1.clkrev.com
0.0.0.0 img.en25.com
0.0.0.0 tiads.essence.com
0.0.0.0 tiads.ew.com
0.0.0.0 promo.freshdirect.com
# 0.0.0.0 cdns.gigya.com #[affects IHeartRadio]
0.0.0.0 tiads.health.com
0.0.0.0 js.hs-analytics.net #[HubSpot Analytics Tracking Code]
0.0.0.0 s-static.innovid.com
0.0.0.0 service.maxymiser.net
# 0.0.0.0 s2.mdpcdn.com #[affects bhg.com]
0.0.0.0 cdn.mediavoice.com
0.0.0.0 d-track.send.microadinc.com
0.0.0.0 mnet-ad.net
# 0.0.0.0 cdn.mxpnl.com #[affects optimum.com]
0.0.0.0 adcache.nymag.com
0.0.0.0 cdn.polmontventures.com
0.0.0.0 a.postrelease.com
0.0.0.0 www.geolocation.performgroup.com
0.0.0.0 abo.prismamediadigital.com
0.0.0.0 image5.pubmatic.com
0.0.0.0 aboutads.quantcast.com
0.0.0.0 adv.r7.com
0.0.0.0 p0.raasnet.com
0.0.0.0 pr.realvu.net
0.0.0.0 us.rewardearners.com
0.0.0.0 c2.rfihub.net
0.0.0.0 ced.sascdn.com
0.0.0.0 rsc.scmspain.com
0.0.0.0 m.servebom.com
0.0.0.0 secure-ds.serving-sys.com
0.0.0.0 download.cdn.sharelive.net #[Win32/Toolbar.SearchSuite]
# 0.0.0.0 tiads.time.com #[affects Time.com]
0.0.0.0 cdn.unityads.unity3d.com
# 0.0.0.0 cdn.vidible.tv #[affects Aol]
0.0.0.0 sb.voicefive.com
0.0.0.0 content.womensforum.com
# [Akamai][AS16625][23.72.0.0 - 23.79.255.255]
0.0.0.0 dsum-sec.casalemedia.com
# [Akamai][AS20940][69.192.0.0 - 69.192.255.255]
0.0.0.0 s7.addthis.com #[affects whitehouse.gov/garmin.com]
0.0.0.0 s9.addthis.com
0.0.0.0 ssltracking.esearchvision.com
0.0.0.0 ads.undertone.com
0.0.0.0 ads.vegas.com
# [Akamai][AS31377][72.246.0.0 - 72.247.255.255]
0.0.0.0 aka.accortech.com
0.0.0.0 cdn.ad4game.com
0.0.0.0 c03.adsummos.net
0.0.0.0 supersonicads-a.akamaihd.net
0.0.0.0 dyn-beacon.akamaized.net
0.0.0.0 e35fbf.t.axf8.net
0.0.0.0 www.bkrtx.com
0.0.0.0 i.l.cnn.net #[WebBug]
0.0.0.0 cdn.demdex.net
0.0.0.0 fast.bostonglobe.demdex.net
0.0.0.0 fast.nbcu.demdex.net
0.0.0.0 fast.nbcots.demdex.net
0.0.0.0 fast.nrjgroup.demdex.net
0.0.0.0 omnikool.discovery.com #[RealMedia]
0.0.0.0 cdn.doubleverify.com
0.0.0.0 79423.analytics.edgesuite.net
0.0.0.0 ma156-r.analytics.edgesuite.net #[AkamaiPlayerAnalytics]
0.0.0.0 a.giantrealm.com
0.0.0.0 www30a5.glam.com
0.0.0.0 hs.interpolls.com
0.0.0.0 cdn.krxd.net
0.0.0.0 rt.liftdna.com
0.0.0.0 a.ligatus.com
0.0.0.0 sr2.liveperson.net
0.0.0.0 contextual.media.net
0.0.0.0 gallys.nastydollars.com
0.0.0.0 traktr.news.com.au
0.0.0.0 ad.policeone.com
0.0.0.0 graphics.pop6.com
0.0.0.0 ads.pro-market.net #[Tracking.Cookie]
# 0.0.0.0  media.richrelevance.com #[affects Walmart.ca]
0.0.0.0 a.rmgserving.com
# 0.0.0.0  imagesak.secureserver.net #[affects GoDaddy]
0.0.0.0 track.sitetag.us
0.0.0.0 cdn1.smartadserver.com
0.0.0.0 anon.doubleclick.speedera.net
0.0.0.0 fms2.eyewonder.speedera.net
0.0.0.0 d.thanksearch.com
0.0.0.0 tribalfusion.speedera.net
0.0.0.0 ad2.turn.com
0.0.0.0 media-0.vpptechnologies.com
0.0.0.0 c14.zedo.com
# [Akamai][AS16625][95.101.240.0 - 95.101.255.255]
0.0.0.0 static.atgsvcs.com
# [Akamai][AS20940][AS12989][96.16.0.0 - 96.17.255.255]
0.0.0.0 a.adroll.com
0.0.0.0 aa.connextra.com
0.0.0.0 bb.connextra.com
0.0.0.0 cc.connextra.com
0.0.0.0 dd.connextra.com
0.0.0.0 ee.connextra.com
0.0.0.0 ff.connextra.com
0.0.0.0 tmscdn.coremetrics.com
0.0.0.0 metrics.ctvdigital.net
0.0.0.0 adinterax.cnet.com.edgesuite.net
0.0.0.0 c6.edgesuite.net #[RealMedia]
0.0.0.0 citi.bridgetrack.com.edgesuite.net
0.0.0.0 content.yieldmanager.edgesuite.net
0.0.0.0 fastclick.com.edgesuite.net
0.0.0.0 akatracking.esearchvision.com
0.0.0.0 cdn.springboard.gorillanation.com
0.0.0.0 cdn.triggertag.gorillanation.com
0.0.0.0 static.inviziads.com
0.0.0.0 banner.missingkids.com
0.0.0.0 b.monetate.net
0.0.0.0 tracking.olx.com
0.0.0.0 i.cdn.openx.com
0.0.0.0 cdn.optmd.com
0.0.0.0 l1.qsstats.com
0.0.0.0 ds.serving-sys.com #[Tracking.Cookie]
0.0.0.0 ds-ll.serving-sys.com
0.0.0.0 akamai.smartadserver.com
0.0.0.0 graphics.streamray.com
0.0.0.0 cdn.turn.com
# [Akamai][AS20940][96.6.0.0 - 96.7.255.255]
0.0.0.0 download.cdn.torchbrowser.com #[Win32/TorchMedia]
# [Alchemy / Tagworld][AS7296][208.76.216.0 - 208.76.219.255]
0.0.0.0 ad.flux.com
0.0.0.0 t.flux.com #[WebBug]
# [Alchemy][AS7296][209.132.240.0/21]
0.0.0.0 c.channeltraffic.net
# [Alibaba][AS37963][115.124.16.0 - 115.124.31.255]
0.0.0.0 cnzz.mmstat.com
# [Alibaba][AS37963][119.42.224.0 - 119.42.239.255]
0.0.0.0 acookie.alimama.com
0.0.0.0 hz.mmstat.com
0.0.0.0 log.mmstat.com
0.0.0.0 pcookie.taobao.com
# [Alibaba][AS37963][140.205.248.253]
0.0.0.0 ac.mmstat.com
0.0.0.0 gm.mmstat.com
# [Amazon.com][AS14618][13.32.0.0 - 13.35.255.255]
0.0.0.0 sjs.bizographics.com
0.0.0.0 intljs.rmtag.com
# [Amazon.com][AS14618][107.20.0.0 - 107.23.255.255]
0.0.0.0 ad.360yield.com
0.0.0.0 fw.adsafeprotected.com
0.0.0.0 s.arclk.net
0.0.0.0 l.betrad.com
0.0.0.0 pixel.captora.com
0.0.0.0 statstracker.celebrity-gossip.net
0.0.0.0 tracking.clickmeter.com
0.0.0.0 www.clickmeter.com
0.0.0.0 script.crsspxl.com
0.0.0.0 tag.crsspxl.com
0.0.0.0 cam.demdex.net
0.0.0.0 dpm.demdex.net
0.0.0.0 everydayhealth.demdex.net
0.0.0.0 fairfaxau.demdex.net
0.0.0.0 gm.demdex.net
0.0.0.0 nfl.demdex.net
0.0.0.0 philly.demdex.net
0.0.0.0 postmedia.demdex.net
0.0.0.0 swa.demdex.net
0.0.0.0 torontostar.demdex.net
0.0.0.0 toyota.demdex.net
0.0.0.0 ads.domainoptions.net
0.0.0.0 parkcloud.dynadot.com #[Parking Service]
0.0.0.0 st.dynamicyield.com
0.0.0.0 ads.ehealthcaresolutions.com
0.0.0.0 track.eyeviewads.com
0.0.0.0 click.gospect.com
0.0.0.0 a.idio.co
0.0.0.0 dts.innovid.com
0.0.0.0 bootstrap.livefyre.com
0.0.0.0 stream1.livefyre.com
0.0.0.0 heapanalytics.com
0.0.0.0 track.hubspot.com #[WebBug]
0.0.0.0 geo.jetpackdigital.com
0.0.0.0 trk.kissmetrics.com
0.0.0.0 services.krxd.net #[Geo.Webbug]
0.0.0.0 api.lanistaads.com
0.0.0.0 lc.livefyre.com
0.0.0.0 logs.loggly.com #[WebBug]
0.0.0.0 cmi.netseer.com
0.0.0.0 h.nexac.com
0.0.0.0 tracking.optimatic.com
0.0.0.0 log3.optimizely.com
0.0.0.0 config.parsely.com
0.0.0.0 log.pinion.gg
0.0.0.0 motd.pinion.gg #[Game Adverts]
0.0.0.0 wiki.pinion.gg
0.0.0.0 www.pinion.gg
0.0.0.0 statdb.pressflex.com
0.0.0.0 js4.ringrevenue.com
0.0.0.0 json4.ringrevenue.com
0.0.0.0 rc.rlcdn.com
0.0.0.0 counter.scribblelive.com
0.0.0.0 d.shareaholic.com
0.0.0.0 s.shopify.com
0.0.0.0 pix.silverpush.co
0.0.0.0 ads.skinected.com
0.0.0.0 ads.supplyframe.com
# 0.0.0.0 analytics.supplyframe.com #[affects findchips.com]
0.0.0.0 images.ads.supplyframe.com
0.0.0.0 b.t.tailtarget.com
0.0.0.0 ws.tapjoyads.com
0.0.0.0 21750.tctm.co
0.0.0.0 ads.tracking202.com
0.0.0.0 rtd.tubemogul.com
0.0.0.0 w.usabilla.com
0.0.0.0 pixel.watch
0.0.0.0 tracking.websitealive.com
0.0.0.0 pixel.yabidos.com
0.0.0.0 download.ytdownloader.com
0.0.0.0 www.ytdownloader.com
# [Amazon.com][AS14618][143.204.0.0 - 143.204.255.255]
0.0.0.0 static.trackedweb.net
# [Amazon.com][AS14618][174.129.0.0 - 174.129.255.255]
0.0.0.0 engine.4chan-ads.org
0.0.0.0 ads20.adcolony.com
0.0.0.0 insight.adsrvr.org
0.0.0.0 askads.ask.com
0.0.0.0 server1.beaconpush.com
0.0.0.0 ads.chango.com
0.0.0.0 adunit.chango.com
0.0.0.0 ping.chartbeat.net
0.0.0.0 admonkey.dapper.net
0.0.0.0 b.ensighten.com
# 0.0.0.0 nexus.ensighten.com #[affects Subaru / Staples]
0.0.0.0 cs.exitmonitor.com
0.0.0.0 g2.gumgum.com
0.0.0.0 stack9.collect.igodigital.com
0.0.0.0 pixel.invitemedia.com
0.0.0.0 clicks.izea.com
0.0.0.0 ads.mobclix.com
0.0.0.0 s.mobclix.com
0.0.0.0 indium.openx.net
0.0.0.0 tracking.percentmobile.com
0.0.0.0 display.provenpixel.com
0.0.0.0 ads.reddit.com
0.0.0.0 www.reelcentric.com
0.0.0.0 rivasearchpage.com
0.0.0.0 tap.rubiconproject.com
0.0.0.0 l.sharethis.com
0.0.0.0 smaato.net
0.0.0.0 socialspark.com
0.0.0.0 req.tidaltv.com
0.0.0.0 static.tracking202.com
0.0.0.0 p1.tcr21.tynt.com
# 0.0.0.0 redirect.viglink.com #[affects disqus.com]
0.0.0.0 www.w3counter.com
0.0.0.0 ots.optimize.webtrends.com
0.0.0.0 b.wishabi.com
0.0.0.0 track.yieldsoftware.com
0.0.0.0 stats.zmags.com
# [Amazon.com][AS38895][175.41.128.0 - 175.41.159.255]
# [Amazon.com][AS16509][176.32.96.0 - 176.32.103.255]
0.0.0.0 cdn.adbooth.net
0.0.0.0 rcm.amazon.com
0.0.0.0 alexa-sitestats.s3.amazonaws.com
0.0.0.0 fls-na.amazon-adsystem.com
0.0.0.0 rcm-eu.amazon-adsystem.com
0.0.0.0 ws-eu.amazon-adsystem.com
0.0.0.0 wms-eu.amazon-adsystem.com
0.0.0.0 wms-na.amazon-adsystem.com
0.0.0.0 ws-na.amazon-adsystem.com
# [Amazon.com][AS16509][176.34.184.0 - 176.34.191.255]
0.0.0.0 chuknu.sokrati.com
# [Amazon.com][AS16509][176.34.232.0 - 176.34.239.255]
0.0.0.0 adsradios.adswizz.com
0.0.0.0 exchange.adswizz.com
0.0.0.0 synchrobox.adswizz.com
0.0.0.0 dni.agcdn.com
0.0.0.0 static-shareaholic.s3.amazonaws.com
0.0.0.0 pixelservice.apphb.com
0.0.0.0 tracker.leadenhancer.com
0.0.0.0 t13.intelliad.de
0.0.0.0 t23.intelliad.de
0.0.0.0 morehitserver.com
0.0.0.0 track.shop2market.com
0.0.0.0 ad.sxp.smartclip.net
0.0.0.0 tracker.vinsight.de
0.0.0.0 r.yieldkit.com
0.0.0.0 srv.uk.znaptag.com
# [Amazon.com][AS16509][177.71.190.213]
0.0.0.0 dm.demdex.net
# [Amazon.com][AS16509][178.236.0.0 - 178.236.7.255]
0.0.0.0 aax-eu.amazon-adsystem.com
0.0.0.0 ir-de.amazon-adsystem.com
0.0.0.0 ir-uk.amazon-adsystem.com
# [Amazon.com][AS16509][184.169.128.0 - 184.169.255.255]
0.0.0.0 abandonment.saas.seewhy.com
# [Amazon.com][AS14618][184.72.0.0 - 184.73.255.255]
0.0.0.0 www.adtaily.com
0.0.0.0 analytics.bleacherreport.com
0.0.0.0 s.btstatic.com
0.0.0.0 a.company-target.com
0.0.0.0 twc.demdex.net
0.0.0.0 marthastewart.demdex.net
0.0.0.0 hits.epochstats.com
0.0.0.0 js.geoads.com
0.0.0.0 a.goember.com
0.0.0.0 adsx.greystripe.com
0.0.0.0 s.innovid.com
0.0.0.0 www.intellisuggest.com
0.0.0.0 ads.investingchannel.com
0.0.0.0 o1.inviziads.com
0.0.0.0 create.leadid.com
0.0.0.0 metrics-api.librato.com
0.0.0.0 media-match.com
0.0.0.0 pixel.newscred.com
0.0.0.0 r.openx.net
0.0.0.0 pixel.realtor.com
0.0.0.0 howler.shareaholic.com
0.0.0.0 seg.sharethis.com
0.0.0.0 cdn.spectate.com
0.0.0.0 track.securedvisit.com
0.0.0.0 api.stathat.com
# 0.0.0.0 id.trove.com #[prevents registration]
0.0.0.0 rtb.tubemogul.com
0.0.0.0 api.viglink.com
0.0.0.0 www.webspectator.com
# [Amazon.com][AS14618][204.236.128.0 - 204.236.255.255]
0.0.0.0 cdn.beaconpush.com
0.0.0.0 fedex.demdex.net
0.0.0.0 tags.deployads.com
0.0.0.0 track.keywordstrategy.org
0.0.0.0 a.klaviyo.com
# [Amazon.com][AS38895][204.246.160.0 - 204.246.191.255]
0.0.0.0 cdn.boomtrain.com
0.0.0.0 js.coinisrsdelivery.com
0.0.0.0 s.idio.co
0.0.0.0 cdn.yb0t.com
# [Amazon.com][AS16509][205.251.192.0 - 205.251.255.255]
0.0.0.0 delivery-cdn-cf.adswizz.com
0.0.0.0 matchbin-assets.s3.amazonaws.com
0.0.0.0 springclick-ads.s3.amazonaws.com
0.0.0.0 d1zatounuylvwg.cloudfront.net
0.0.0.0 d26b395fwzu5fz.cloudfront.net
0.0.0.0 dc8xl0ndzn2cb.cloudfront.net #[Snowplow analytics]
0.0.0.0 gernewt.info
0.0.0.0 ads.goodreads.com
0.0.0.0 cdn-gl.imrworldwide.com
0.0.0.0 lionstracking.com
0.0.0.0 t.mdn2015x3.com
0.0.0.0 asset.pagefair.net
# 0.0.0.0 widget-cdn.rpxnow.com #[affects amc.com]
0.0.0.0 secureredirect101.com
0.0.0.0 trkmydomain.com
# [Amazon.com][AS16509][207.171.160.0 - 207.171.191.255]
0.0.0.0 s.206solutions.com
0.0.0.0 aax.amazon-adsystem.com
0.0.0.0 aax-us-east.amazon-adsystem.com
0.0.0.0 admarvel.s3.amazonaws.com
0.0.0.0 htmlads.s3.amazonaws.com
0.0.0.0 mondoads.s3.amazonaws.com
0.0.0.0 vml1.s3.amazonaws.com
0.0.0.0 files.bannersnack.com
0.0.0.0 tags.hypeads.org
# [Amazon.com][AS16509][216.137.32.0 - 216.137.63.255]
0.0.0.0 cdn.adk2.com
0.0.0.0 cache.adnet-media.net
0.0.0.0 ads.advertisespace.com
0.0.0.0 static.adzerk.net
0.0.0.0 adflash.affairsclub.com
0.0.0.0 c.amazon-adsystem.com
0.0.0.0 cdn.brcdn.com
0.0.0.0 c.greystripe.com
0.0.0.0 cdn.komoona.com
0.0.0.0 content.mkt922.com
0.0.0.0 t.neodatagroup.com
0.0.0.0 static.parsely.com
0.0.0.0 cdn.udmserve.net
0.0.0.0 a1.vdna-assets.com
# [Amazon.com][AS16509][13.32.0.0 - 13.35.255.255]
0.0.0.0 connatix.com
0.0.0.0 ads-d.viber.com
# [Amazon.com][AS14618][23.20.0.0 - 23.23.255.255]
0.0.0.0 ads.ad-center.com
0.0.0.0 static.adk2.com
0.0.0.0 async01.admantx.com
0.0.0.0 data.adsrvr.org
0.0.0.0 avidtrak.com
0.0.0.0 x.bidswitch.net
0.0.0.0 metrics.brightcove.com
0.0.0.0 eue.collect-opnet.com
0.0.0.0 static.etracker.com
0.0.0.0 go.goroost.com
0.0.0.0 nova.collect.igodigital.com
0.0.0.0 api.iris.tv
0.0.0.0 pixel.keywee.co
0.0.0.0 dc.ads.linkedin.com
0.0.0.0 us-east-1.dc.ads.linkedin.com
0.0.0.0 ads.mopub.com
0.0.0.0 papi.mynativeplatform.com
0.0.0.0 t.pswec.com
0.0.0.0 img.pulsemgr.com
0.0.0.0 siteintercept.qualtrics.com
0.0.0.0 adserv.roundrockmedia.com
0.0.0.0 load.scanscout.com
0.0.0.0 receive.inplay.scanscout.com
0.0.0.0 www.sendori.com
0.0.0.0 analytics.shareaholic.com
0.0.0.0 cm.shareaholic.com
0.0.0.0 s.thebrighttag.com
0.0.0.0 thelocalsearchnetwork.com
0.0.0.0 analytics.tout.com
0.0.0.0 stage.traffiliate.com
0.0.0.0 ads.tunein.com
0.0.0.0 services.webspectator.com
0.0.0.0 cdn.vdopia.com
# [Amazon.com][AS14618][34.192.0.0 - 34.255.255.255]
0.0.0.0 mcafee-home.7eer.net
0.0.0.0 blobar.org
0.0.0.0 api.circularhub.com
0.0.0.0 mscom.demdex.net
0.0.0.0 schwab.demdex.net
0.0.0.0 timeinc.demdex.net
0.0.0.0 www.onesafe-software.com #[ScamFraudAlert.Antispyware]
0.0.0.0 geo.qualaroo.com
0.0.0.0 collect.tealiumiq.com
0.0.0.0 collect-us-east-1.tealiumiq.com #[WebBug]
0.0.0.0 tracking.revimedia.com
0.0.0.0 n.targetctracker.com
0.0.0.0 trackcmp.net
0.0.0.0 log.quora.com
0.0.0.0 ads.viber.com
0.0.0.0 ads.aws.viber.com
0.0.0.0 videe.tv
0.0.0.0 pm.w55c.net
0.0.0.0 www.whizstats.com
# [Amazon.com][AS39111][35.152.0.0 - 35.183.255.255]
0.0.0.0 www.currentupdateconcepts.com #[Riskware/PUP]
0.0.0.0 ssp.videostat.com
# [Amazon.com][AS39111][46.137.0.0 - 46.137.127.255]
0.0.0.0 code2.adtlgc.com
0.0.0.0 l.linkpulse.com
0.0.0.0 s248.meetrics.net
0.0.0.0 s282.meetrics.net
0.0.0.0 counter.personyze.com
0.0.0.0 abp.smartadcheck.de
0.0.0.0 js.smartredirect.de
0.0.0.0 qa.stats.webs.com
0.0.0.0 prod-js.aws.y-track.com
# [Amazon.com][AS39111][46.51.128.0 - 46.51.191.255]
0.0.0.0 dcinfos.abtasty.com
0.0.0.0 go.affec.tv
0.0.0.0 www.smartredirect.de
# [Amazon.com][AS16509][50.112.0.0 - 50.112.255.255]
0.0.0.0 api.amplitude.com
0.0.0.0 idsync.rlcdn.com
# [Amazon.com][AS14618][50.16.0.0 - 50.19.255.255]
0.0.0.0 web-t.9gag.com #[Piwik.Analytics]
0.0.0.0 www.adotube.com
0.0.0.0 pixel.adsafeprotected.com
0.0.0.0 match.adsrvr.org
0.0.0.0 api.adsymptotic.com
0.0.0.0 ads.adual.net
0.0.0.0 engine2.adzerk.net
0.0.0.0 vpc.altitude-arena.com
0.0.0.0 data.apn.co.nz
0.0.0.0 tracking.badgeville.com
0.0.0.0 barilliance.net
0.0.0.0 www.barilliance.net
0.0.0.0 srv.clickfuse.com
0.0.0.0 com.com
# 0.0.0.0 api.demandbase.com #[affects Ringcentral]
0.0.0.0 adobe.demdex.net
0.0.0.0 condenast.demdex.net
0.0.0.0 fairfax.demdex.net
0.0.0.0 mtvn.demdex.net
0.0.0.0 a.dpmsrv.com #[WebBug]
0.0.0.0 px.dynamicyield.com
0.0.0.0 beacon.examiner.com
0.0.0.0 gonzogrape.gumgum.com
0.0.0.0 ads.havenhomemedia.com
0.0.0.0 analytics.hgcdn.net
0.0.0.0 stack7.collect.igodigital.com
0.0.0.0 a.imonomy.com
0.0.0.0 rtr.innovid.com
0.0.0.0 www.jetpackdigital.com
0.0.0.0 c.jsrdn.com
0.0.0.0 i.kissmetrics.com
0.0.0.0 a.komoona.com
0.0.0.0 ad.leadboltads.net
0.0.0.0 ads.lucidmedia.com
0.0.0.0 tags.mediaforge.com
0.0.0.0 engine.nectarads.com
0.0.0.0 ox-d.newstogram.com
0.0.0.0 script.opentracker.net
0.0.0.0 server1.opentracker.net
0.0.0.0 server10.opentracker.net
0.0.0.0 log.optimizely.com #[WebBug]
0.0.0.0 3459571470.log.optimizely.com
0.0.0.0 ntracking.optimatic.com
0.0.0.0 stats.pagefair.com
0.0.0.0 ads.pe.com
0.0.0.0 adserve.postrelease.com
0.0.0.0 lt.retargeter.com
0.0.0.0 collect.rewardstyle.com
0.0.0.0 reporting.singlefeed.com
0.0.0.0 go.sonobi.com
0.0.0.0 search34.info.com
0.0.0.0 sync.search.spotxchange.com
0.0.0.0 js.srcsmrtgs.com
0.0.0.0 cdn.targetfuel.com
0.0.0.0 e.targetfuel.com
0.0.0.0 i.trkjmp.com
# 0.0.0.0 idvisitor.washingtonpost.com #[affects login]
0.0.0.0 analytics.wishabi.ca
0.0.0.0 track.written.com
0.0.0.0 www.wtp101.com
0.0.0.0 zdbb.net
# [Amazon.com][AS14618][52.0.0.0 - 52.31.255.255]
0.0.0.0 datacollect3.abtasty.com
0.0.0.0 datacollect6.abtasty.com
0.0.0.0 ad.ad-arata.com
0.0.0.0 www.addwish.com
0.0.0.0 adsys.adk2x.com
0.0.0.0 s.admathhd.com
0.0.0.0 www.adnigma.com
0.0.0.0 a.adtpix.com
0.0.0.0 adrazzi.com
0.0.0.0 api.adrtx.net
0.0.0.0 cdn.adrtx.net
0.0.0.0 track.afcpatrk.com
0.0.0.0 jump.aragontrack.com
0.0.0.0 ad.atdmt.com
0.0.0.0 stats.bannersnack.com
0.0.0.0 api.boomtrain.com
0.0.0.0 events.boomtrain.com
0.0.0.0 promo.clicnscores.com
0.0.0.0 adserverc.cliipa.com
0.0.0.0 capture.condenastdigital.com
0.0.0.0 aexp.demdex.net
0.0.0.0 nbcu.demdex.net
0.0.0.0 nbcots.demdex.net
0.0.0.0 fastdownload10.com
0.0.0.0 track.freemmo2017.com
0.0.0.0 www.giftfunnew.com #[Riskware/PUP]
0.0.0.0 inceptionads.go2cloud.org
0.0.0.0 beacon.gu-web.net
0.0.0.0 dmp.gravity4.com
0.0.0.0 imads.integral-marketing.com
0.0.0.0 k.intellitxt.com
0.0.0.0 us.ads.justpremium.com
0.0.0.0 us.tracking.justpremium.com
0.0.0.0 jwpltx.com
0.0.0.0 i.n.jwpltx.com
0.0.0.0 analytics.kaltura.com
0.0.0.0 beacon.livefyre.com
0.0.0.0 logs-01.loggly.com
0.0.0.0 js.matheranalytics.com
0.0.0.0 www.mftracking.com
0.0.0.0 metrics-collector.onscroll.com
0.0.0.0 api.petametrics.com
0.0.0.0 www.ranchapptag.com #[Riskware/PUP]
0.0.0.0 widget.realo.be
0.0.0.0 r.remarketingpixel.com
0.0.0.0 fastlane-adv.rubiconproject.com
0.0.0.0 pixel.mtrcs.samba.tv
0.0.0.0 tracker.samplicio.us
0.0.0.0 recommender.scarabresearch.com
0.0.0.0 track.scrillaspace.com
0.0.0.0 count-server.sharethis.com
0.0.0.0 track.spots.im
0.0.0.0 init.supersonicads.com
0.0.0.0 rv-gateway.supersonicads.com
0.0.0.0 s.tagsrvcs.com
0.0.0.0 d.t.tailtarget.com
0.0.0.0 www.trackingclick.net
0.0.0.0 m6dqx-ad3hl.ads.tremorhub.com
0.0.0.0 track.ultragaming.biz
0.0.0.0 www.updatesoftwaresend.com
0.0.0.0 onlgc.voluumtrk.com
0.0.0.0 click.uamtrk.com
0.0.0.0 www.vaultsappsbyte.com #[Riskware/PUP]
0.0.0.0 dckappa.widespace.com
0.0.0.0 engine.widespace.com
0.0.0.0 inscreen.widespace.com
0.0.0.0 zeroredirect1.com
0.0.0.0 zs1.zeroredirect1.com
0.0.0.0 t.zqtk.net
# [Amazon.com][AS14618][52.32.0.0 - 52.79.255.255]
0.0.0.0 trk.ablogica.com
0.0.0.0 pool.admedo.com
0.0.0.0 rudy.adsnative.com
0.0.0.0 www.applicationsdeliveryupdate.com #[Win32/InstallCore]
0.0.0.0 www.bestfactorydelivery.com #[Win32/InstallCore]
0.0.0.0 www.centralsignnew.com #[Riskware/PUP]
0.0.0.0 ads.chargeads.com
0.0.0.0 www.chucklefunhead.com #[Riskware/PUP]
0.0.0.0 ing-district.clicktale.net
0.0.0.0 infinityid.condenastdigital.com
0.0.0.0 dmg.demdex.net
0.0.0.0 c.f5mtrack.com
0.0.0.0 fastnclick.com
0.0.0.0 afftracking.justanswer.com
0.0.0.0 track.leadin.com
0.0.0.0 mantodea.mantisadnetwork.com
0.0.0.0 sync.monarchads.com
0.0.0.0 dk-gmtdmp.mookie1.com
0.0.0.0 us-gmtdmp.mookie1.com
0.0.0.0 ar.mytrack.pro
0.0.0.0 us.pixel.newscgp.com
0.0.0.0 www.quickbitsdownloads.com #[Riskware/PUP]
0.0.0.0 is-gateway.supersonicads.com
0.0.0.0 go.tracksz.co
0.0.0.0 p4dt2-scyd6.ads.tremorhub.com
0.0.0.0 slckg-2p3vy.ads.tremorhub.com
0.0.0.0 dc.widespace.com
# [Amazon.com][AS14618][52.84.0.0 - 52.95.255.255]
0.0.0.0 ad-delivery.net
0.0.0.0 cdn.adikteev.com
0.0.0.0 cdn.adsafeprotected.com
0.0.0.0 iau.adsiduous.com
0.0.0.0 s.amazon-adsystem.com
0.0.0.0 fls-eu.amazon-adsystem.com
0.0.0.0 creatives.ancoraplatform.com
0.0.0.0 track.adthrive.com
0.0.0.0 cdn.accelerator.arsdev.net
0.0.0.0 d1v9u0bgi1uimx.cloudfront.net
0.0.0.0 d169bbxks24g2u.cloudfront.net
0.0.0.0 d2c8v52ll5s99u.cloudfront.net #[comscore][affects arstechnica/wired/vogue/vanity fair]
0.0.0.0 d2cgumzzqhgmdu.cloudfront.net
0.0.0.0 d24n15hnbwhuhn.cloudfront.net
0.0.0.0 d2tgfbvjf3q6hn.cloudfront.net
0.0.0.0 dz2fz0bgyq9tn.cloudfront.net
0.0.0.0 cdn.cquotient.com
0.0.0.0 rscdn.cxense.com
0.0.0.0 www.hotdogsandads.com
0.0.0.0 htl.bid
0.0.0.0 contentz.mkt61.net
0.0.0.0 tracker.nbcuas.com
0.0.0.0 cdn.permutive.com
0.0.0.0 dove.saymedia.com
0.0.0.0 go.searchlock.com
0.0.0.0 r.skimresources.com
0.0.0.0 siniature.com
0.0.0.0 static.site24x7rum.com
0.0.0.0 outcome.supersonicads.com
0.0.0.0 adserver.tappsgames.com
0.0.0.0 core.videoegg.com
# [Amazon.com][AS14618][54.144.0.0 - 54.159.255.255]
0.0.0.0 t.adk2.com
0.0.0.0 www.bitspresentdownload.com #[Riskware/PUP]
0.0.0.0 www.bundlerepositorycontent.com #[Riskware/PUP]
0.0.0.0 www.megagiftcity.com #[Riskware/PUP]
0.0.0.0 cdn.opensubcontent.com #[Win32/InstallCore.ACZ]
0.0.0.0 vid-io.springserve.net
0.0.0.0 collector-195.tvsquared.com #[Piwik.Analytics]
# [Amazon.com][AS14618][54.160.0.0 - 54.175.255.255]
0.0.0.0 t.acxiom-online.com
0.0.0.0 api.addnow.com
0.0.0.0 tag.apxlv.com
0.0.0.0 ads.deliverimp.com
0.0.0.0 charter.demdex.net
0.0.0.0 freecharge.demdex.net
0.0.0.0 iyogi.demdex.net
0.0.0.0 scripps.demdex.net
0.0.0.0 widgets.kiosked.com
0.0.0.0 tracking.listhub.net
0.0.0.0 apx.moatads.com
0.0.0.0 notify.nuviad.com
0.0.0.0 stats.pckeeper.software
0.0.0.0 track.prizeglobal.net
0.0.0.0 trax.prostrax.com
0.0.0.0 trends.revcontent.com
0.0.0.0 beacon.sojern.com
0.0.0.0 vid.springserve.com
0.0.0.0 vid-io-dub.springserve.com
0.0.0.0 srv.stackadapt.com
0.0.0.0 tar.tradedoubler.com
0.0.0.0 partners.tremorhub.com
0.0.0.0 collector-1054.tvsquared.com
0.0.0.0 admediator.unityads.unity3d.com
# 0.0.0.0 wurfl.io #[affects Google]
0.0.0.0 app.yieldify.com
0.0.0.0 ads.yieldmo.com
# [Amazon.com][AS16509][54.176.0.0 - 54.191.255.255]
0.0.0.0 www.cloudtracked.com
0.0.0.0 za-ssl.effectivemeasure.net
0.0.0.0 tracker.freecharge.in
0.0.0.0 ads.servebom.com
0.0.0.0 neo.go.sonobi.com
0.0.0.0 match.xg4ken.com
# [Amazon.com][AS16509][54.192.0.0 - 54.207.255.255]
0.0.0.0 admtpmp127.adsk2.co
0.0.0.0 adplexmedia.adk2.co
0.0.0.0 ad.adsrvr.org
0.0.0.0 ad.ad-stir.com
0.0.0.0 ads.adthrive.com
0.0.0.0 cdn.adtradr.com
0.0.0.0 ssp.anyclip-media.com
0.0.0.0 cdn.appdynamics.com
0.0.0.0 promotions.betfred.com
0.0.0.0 cdn.blueconic.net
0.0.0.0 tag.bounceexchange.com
0.0.0.0 d1jikhx1ssl81z.cloudfront.net
0.0.0.0 d1lxhc4jvstzrp.cloudfront.net
0.0.0.0 d1xfq2052q7thw.cloudfront.net
0.0.0.0 d1z2jf7jlzjs58.cloudfront.net
# 0.0.0.0 d2gatte9o95jao.cloudfront.net #[affects urbandictionary.com]
0.0.0.0 d2zah9y47r7bi2.cloudfront.net
0.0.0.0 d3qxwzhswv93jk.cloudfront.net
0.0.0.0 script.crazyegg.com
0.0.0.0 d.dc121677.com
0.0.0.0 me-ssl.effectivemeasure.net
0.0.0.0 gscounters.eu1.gigya.com
0.0.0.0 seccdn-gl.imrworldwide.com
0.0.0.0 resources.kiosked.com
0.0.0.0 cdn.listrakbi.com
# 0.0.0.0 www.livefyre.com #[affects startribune.com]
0.0.0.0 t.mdn2015x2.com
0.0.0.0 ads.mic.com
0.0.0.0 dbg52463.moatads.com
0.0.0.0 files.native.ad
0.0.0.0 ps.ns-cdn.com
0.0.0.0 ap.octopuspop.com
0.0.0.0 tags.onscroll.com
0.0.0.0 analytics.ooyala.com
0.0.0.0 match.rundsp.com
0.0.0.0 tag.mtrcs.samba.tv
0.0.0.0 cdn.scarabresearch.com
0.0.0.0 code.adsales.snidigital.com
0.0.0.0 ua.supersonicads.com
0.0.0.0 sumome.com
0.0.0.0 load.sumome.com
0.0.0.0 s.uadx.com
0.0.0.0 w.visualdna.com
0.0.0.0 wfpscripts.webspectator.com
0.0.0.0 cdn.yldbt.com
0.0.0.0 saxp.zedo.com
0.0.0.0 2664.tm.zedo.com
0.0.0.0 3211.tm.zedo.com
0.0.0.0 srv-us.znaptag.com
# [Amazon.com][AS16509][54.208.0.0 - 54.221.255.255]
0.0.0.0 tracking.affiliates.de
0.0.0.0 arena.altitude-arena.com
0.0.0.0 ca.altitude-arena.com
0.0.0.0 pstats.blogworks.com
0.0.0.0 click.clktraker.com
0.0.0.0 api.content-ad.net
0.0.0.0 ads.creative-serving.com
0.0.0.0 bostonglobe.demdex.net
0.0.0.0 ford.demdex.net
0.0.0.0 swisscom.demdex.net
0.0.0.0 bob.dmpxs.com
0.0.0.0 www.dntx.com
0.0.0.0 nz-ssl.effectivemeasure.net
0.0.0.0 s.effectivemeasure.net
0.0.0.0 j.flxpxl.com
0.0.0.0 matcher.idtargeting.com
0.0.0.0 ccs.infospace.com
0.0.0.0 www.i.matheranalytics.com #[WebBug]
0.0.0.0 stats.mezzobit.com
0.0.0.0 analytics.cnd-motionmedia.de
0.0.0.0 redirect.com
0.0.0.0 www.storygize.net #[WebBug]
0.0.0.0 d.tailtarget.com
0.0.0.0 j.traffichunt.com
0.0.0.0 eng.trkcnv.com
0.0.0.0 uadx.com
0.0.0.0 analytics.upworthy.com
0.0.0.0 rumds.wpdigital.net
0.0.0.0 i.yldbt.com
0.0.0.0 z2.zedo.com
# 0.0.0.0 segment-data.zqtk.net #[affects wsj.com]
# [Amazon.com][AS16509][54.224.0.0 - 54.239.255.255]
0.0.0.0 s.206ads.com
0.0.0.0 ib.3lift.com
0.0.0.0 optimize.adpushup.com
0.0.0.0 ads-stream.com
0.0.0.0 js.apxlv.com
0.0.0.0 www.adbooth.com
0.0.0.0 cdn.adengage.com
0.0.0.0 code.adengage.com
0.0.0.0 srv.adengage.com
0.0.0.0 ad132m.adk2.co
0.0.0.0 adbooth.adk2.co
0.0.0.0 cdn.adplxmd.com
0.0.0.0 files.adspdbl.com
0.0.0.0 js.adsrvr.org
0.0.0.0 tag.adtrendmedia.net
0.0.0.0 data.alexa.com
0.0.0.0 advice-ads.s3.amazonaws.com
0.0.0.0 ps-eu.amazon-adsystem.com
0.0.0.0 ps-us.amazon-adsystem.com
0.0.0.0 z-na.amazon-adsystem.com
0.0.0.0 cdn.installationsafe.net.s3.amazonaws.com
0.0.0.0 slate-ad-scripts.s3.amazonaws.com
0.0.0.0 znaptag-us.s3.amazonaws.com
0.0.0.0 as.eu.angsrvr.com
0.0.0.0 cdn.avmws.com #[AvantMetrics]
0.0.0.0 beachfrontio.com
0.0.0.0 t.beanstalkdata.com
0.0.0.0 ad.broadstreetads.com
0.0.0.0 cdn.broadstreetads.com
0.0.0.0 cdn.bttrack.com
0.0.0.0 adg.bzgint.com
0.0.0.0 t.channeladvisor.com
0.0.0.0 tracking2.channeladvisor.com
0.0.0.0 www.clicktripz.com
0.0.0.0 images1.cliqueclack.com
0.0.0.0 d1fc8wv8zag5ca.cloudfront.net #[Snowplow JavaScript tracker]
0.0.0.0 d1l6p2sc9645hc.cloudfront.net
0.0.0.0 d1piupybsgr6dr.cloudfront.net
0.0.0.0 d13dhn7ldhrcf6.cloudfront.net #[Win32/InstallCore.QC]
0.0.0.0 d2nq0f8d9ofdwv.cloudfront.net
0.0.0.0 d2oh4tlt9mrke9.cloudfront.net
0.0.0.0 d31qbv1cthcecs.cloudfront.net
# 0.0.0.0 d3c3cq33003psk.cloudfront.net #[affects sunglassesshop.com]
0.0.0.0 d3dcugpvnepf41.cloudfront.net
0.0.0.0 d3ujids68p6xmq.cloudfront.net
0.0.0.0 d5nxst8fruw4z.cloudfront.net
0.0.0.0 d8rk54i4mohrb.cloudfront.net
0.0.0.0 dl1d2m8ri9v3j.cloudfront.net
0.0.0.0 cdn-1.convertexperiments.com
0.0.0.0 use.convertglobal.com
0.0.0.0 p.cpx.to
0.0.0.0 admp-tc.delfi.lv
# 0.0.0.0 scripts.demandbase.com #[affects ringcentral.com]
0.0.0.0 bet.demdex.net
0.0.0.0 cbsi.demdex.net
0.0.0.0 de.demdex.net
0.0.0.0 foxnews.demdex.net
0.0.0.0 sears.demdex.net
0.0.0.0 td.demdex.net
0.0.0.0 tags-cdn.deployads.com
0.0.0.0 cdn.elasticad.net
0.0.0.0 col.eum-appdynamics.com
0.0.0.0 cdn.evergage.com
0.0.0.0 ads.evidon.com
0.0.0.0 hj.flxpxl.com
0.0.0.0 beacon.guim.co.uk
0.0.0.0 cdn.heapanalytics.com
0.0.0.0 bundle-geoip.herokuapp.com
0.0.0.0 powr-counter.herokuapp.com
0.0.0.0 beam.hlserve.com
0.0.0.0 cdn.iasrv.com
0.0.0.0 cdn.idtargeting.com
0.0.0.0 cdn.ip.inpwrd.com
0.0.0.0 cdn.libraries.inpwrd.com
0.0.0.0 load.instinctiveads.com
0.0.0.0 a.cdn.intentmedia.net
0.0.0.0 prod-services.interactiveone.com
0.0.0.0 cdn.investingchannel.com
0.0.0.0 stat.komoona.com
0.0.0.0 adserver.kontextua.com
0.0.0.0 cf.ads.kontextua.com
0.0.0.0 collector.leaddyno.com
0.0.0.0 d.liadm.com
0.0.0.0 p.liadm.com
0.0.0.0 d.lumatag.co.uk
0.0.0.0 bc.marfeel.com
0.0.0.0 edge.metroleads.com
0.0.0.0 contentz.mkt51.net
0.0.0.0 contentz.mkt912.com
0.0.0.0 content.mkt931.com
0.0.0.0 content.mkt932.com
0.0.0.0 contentz.mkt932.com
0.0.0.0 contentz.mkt941.com
0.0.0.0 track.moreniche.com
0.0.0.0 c.mtro.co #[MetroGuild Widget Tracking]
0.0.0.0 zdbb.netshelter.net
0.0.0.0 mix-test.uts.ngdata.com
0.0.0.0 meter-svc.nytimes.com
0.0.0.0 cdn.onscroll.com
0.0.0.0 vast.optimatic.com
0.0.0.0 pagefair.com
0.0.0.0 c.pebblemedia.be
0.0.0.0 jadserve.postrelease.com
0.0.0.0 static.proximic.com
0.0.0.0 di.rlcdn.com #[Marketing Evolution Tracking]
0.0.0.0 tap-secure.rubiconproject.com
0.0.0.0 savvyads.com
0.0.0.0 collector.savvyads.com
0.0.0.0 mtrx.go.sonobi.com
0.0.0.0 cdn.sail-horizon.com
0.0.0.0 shareaholic.com
0.0.0.0 clickcdn.shareaholic.com
0.0.0.0 cdn.siftscience.com
0.0.0.0 gsf-cf.softonic.com #[Win32/OpenCandy.C]
0.0.0.0 pixel.sojern.com
0.0.0.0 eventlogger.soundcloud.com
0.0.0.0 a.teads.tv
0.0.0.0 cdn.teads.tv
0.0.0.0 t.teads.tv
0.0.0.0 swrap.tradedoubler.com
0.0.0.0 ads.traffichunt.com
0.0.0.0 cdn.traffichunt.com
0.0.0.0 assets.tapad.com
0.0.0.0 analytics.userreport.com
0.0.0.0 cdn.userreport.com
0.0.0.0 sdscdn.userreport.com
# 0.0.0.0 delivery.vidible.tv #[affects aol.com]
0.0.0.0 wsc1.webspectator.com
0.0.0.0 zafiti01.webtrekk-us.net
0.0.0.0 sdk-controller.widespace.com
0.0.0.0 triggers.wfxtriggers.com
0.0.0.0 mb.zam.com
0.0.0.0 3165.tm.zedo.com
0.0.0.0 www.zergnet.com
# [Amazon.com][AS16509][54.240.0.0 - 54.255.255.255]
0.0.0.0 d.254a.com
0.0.0.0 kwserver.adhispanic.com
0.0.0.0 ads.adiply.com
0.0.0.0 srv.admailtiser.com
0.0.0.0 track.adbooth.net
0.0.0.0 app.adsbrook.com
0.0.0.0 cdn.adual.net
0.0.0.0 cdn.adquantix.com
0.0.0.0 p.adsymptotic.com
0.0.0.0 adactive-ads.aimatch.com
0.0.0.0 crtl.aimatch.com
0.0.0.0 tr-1.agilone.com
#  0.0.0.0 as.eu.angsrvr.com #[affects videos]
0.0.0.0 www.badassjv.com
0.0.0.0 blockmetrics.com
0.0.0.0 cache.btrll.com
0.0.0.0 engine.carbonads.com
0.0.0.0 ycv.clearshieldredirect.com
0.0.0.0 d2vig74li2resi.cloudfront.net
0.0.0.0 desv383oqqc0.cloudfront.net #[Popcorn Metrics]
0.0.0.0 js.convertale.com
0.0.0.0 dailymotion.demdex.net
0.0.0.0 error.demdex.net
0.0.0.0 gannett.demdex.net
0.0.0.0 links.services.disqus.com
0.0.0.0 cdn5.js.ad.dotandad.com
0.0.0.0 filecdn2.dotandad.com
0.0.0.0 s.dpmsrv.com
0.0.0.0 cf.effectivemeasure.net
0.0.0.0 us-cdn.effectivemeasure.net
0.0.0.0 ps.eyeota.net
0.0.0.0 fmsads.com
0.0.0.0 data.gosquared.com
0.0.0.0 data2.gosquared.com
0.0.0.0 ads.groupcommerce.com
0.0.0.0 ad.ipredictive.com
0.0.0.0 adserv.impactengine.com
0.0.0.0 adn.impactradius.com
0.0.0.0 scripts.kissmetrics.com
0.0.0.0 ads.lanistaads.com
0.0.0.0 content.mkt51.net
0.0.0.0 content.mkt941.com
0.0.0.0 f.monetate.net
0.0.0.0 tracker.mozo.com.au
0.0.0.0 papi.mynativeads.com
0.0.0.0 web-clients.mynativeads.com
0.0.0.0 static.nectarads.com
0.0.0.0 cl-c.netseer.com
0.0.0.0 js-agent.newrelic.com
0.0.0.0 traffic.pubexchange.com
0.0.0.0 orca.qubitproducts.com
0.0.0.0 ortc-ws2-useast1-s0005.realtime.co
0.0.0.0 a.remarketstats.com
0.0.0.0 partner.shareaholic.com
0.0.0.0 traffic.shareaholic.com
0.0.0.0 cc.simplereach.com
0.0.0.0 edge.simplereach.com
0.0.0.0 analytics.sitewit.com
0.0.0.0 st.smartredirect.de
0.0.0.0 tracking.sokrati.com
0.0.0.0 traffic-offers.com
0.0.0.0 collector-2398.tvsquared.com
0.0.0.0 konnect.videoplaza.tv
0.0.0.0 trk.vidible.tv
# 0.0.0.0 id.washingtonpost.com #[affects login]
0.0.0.0 scripts.webspectator.com
0.0.0.0 osc.optimize.webtrends.com
0.0.0.0 a.wishabi.com
0.0.0.0 track.youniversalmedia.com
0.0.0.0 axp.zedo.com
0.0.0.0 geo.ziffdavis.com
# [Amazon.com][AS16509][54.64.0.0 - 54.71.255.255]
0.0.0.0 api.proofpositivemedia.com
0.0.0.0 s.pubmine.com
# [Amazon.com][AS14618][54.72.0.0 - 54.95.255.255]
0.0.0.0 t.254a.com
0.0.0.0 r.254a.com
0.0.0.0 yieldmanager.adbooth.com
0.0.0.0 synchroscript.adswizz.com
0.0.0.0 synchroscript.deliveryengine.adswizz.com
0.0.0.0 secure.adwebster.com
0.0.0.0 pixiedust.buzzfeed.com
0.0.0.0 tracking.crobo.com
0.0.0.0 comcast.demdex.net
0.0.0.0 ecs.demdex.net
0.0.0.0 collector.githubapp.com
0.0.0.0 geobeacon.ign.com
0.0.0.0 hlok.qertewrt.com
0.0.0.0 mmtrkpy.com
0.0.0.0 tracking.olx-st.com
0.0.0.0 api.optinmonster.com
0.0.0.0 t01.proximic.com
0.0.0.0 go.redirectingat.com
0.0.0.0 katie.runtnc.net
0.0.0.0 a.rvttrack.com
0.0.0.0 b.siftscience.com
0.0.0.0 xch.smrtgs.com
0.0.0.0 ardrone.swoop.com
0.0.0.0 felix.data.tm-awx.com
0.0.0.0 collector-184.tvsquared.com #[Piwik.Analytics]
0.0.0.0 collector-428.tvsquared.com #[Piwik.Analytics]
0.0.0.0 a3.websitealive.com
0.0.0.0 zb.zeroredirect1.com
0.0.0.0 zc.zeroredirect1.com
0.0.0.0 ze1.zeroredirect1.com
0.0.0.0 zh1.zeroredirect11.com
# [Amazon.com][AS16509][67.202.0.0 - 67.202.63.255]
0.0.0.0 js.moatads.com
# [Amazon.com][AS16509][72.21.192.0 - 72.21.223.255]
0.0.0.0 aax-us-east-rtb.amazon-adsystem.com
0.0.0.0 ir-na.amazon-adsystem.com
0.0.0.0 rcm-na.amazon-adsystem.com
0.0.0.0 adtago.s3.amazonaws.com
0.0.0.0 sync.cmedia.s3.amazonaws.com
0.0.0.0 ecommstats.s3.amazonaws.com
0.0.0.0 exitsplash.s3.amazonaws.com
0.0.0.0 load.s3.amazonaws.com
0.0.0.0 ncads.s3.amazonaws.com
0.0.0.0 tracking.opencandy.com.s3.amazonaws.com
0.0.0.0 viewerstats.docstoc.com.s3.amazonaws.com
0.0.0.0 www.assoc-amazon.com
0.0.0.0 s3.buysellads.com
0.0.0.0 new.cetrk.com
0.0.0.0 trk.cetrk.com
0.0.0.0 dl.gameplaylabs.com #[Adware:Win32/GamePlayLabs]
0.0.0.0 ads.jetpackdigital.com
0.0.0.0 dl.keywordstrategy.org
0.0.0.0 asset.pagefair.com
0.0.0.0 pixel.tapad.com
0.0.0.0 beacon.tunecore.com
# [Amazon.com][AS14618][72.44.32.0 - 72.44.63.255]
0.0.0.0 p.addthis.com #[pixel.invitemedia.com]
0.0.0.0 rt3.infolinks.com
0.0.0.0 adaptv.pixel.invitemedia.com
0.0.0.0 g-pixel.invitemedia.com
0.0.0.0 segment-pixel.invitemedia.com
0.0.0.0 t.invitemedia.com
# [Amazon.com][75.101.128.0 - 75.101.255.255]
0.0.0.0 engine.adzerk.net
0.0.0.0 certify.alexametrics.com
0.0.0.0 www.bizographics.com
0.0.0.0 analytics.brightedge.com
0.0.0.0 edge.analytics.brightedge.com
0.0.0.0 fhg.digitaldesire.com
0.0.0.0 tags.extole.com
0.0.0.0 clicks11.geoads.com
0.0.0.0 tracking.hubspot.com
0.0.0.0 of.inviziads.com
0.0.0.0 ads.livepromotools.com
0.0.0.0 data.mobclix.com
0.0.0.0 a.monetate.net
0.0.0.0 click.searchnation.net
0.0.0.0 ev.yieldbuild.com
# [Amazon.com][AS39111][79.125.0.0 - 79.125.63.255]
0.0.0.0 d.adroll.com
0.0.0.0 s.adroll.com
0.0.0.0 s32.research.de.com
0.0.0.0 d.skimresources.com
0.0.0.0 t.skimresources.com #[WebBug]
0.0.0.0 www.supersonicads.com
0.0.0.0 app.ubertags.com
0.0.0.0 stats3.unrulymedia.com
# [Amazon.com][AS39111][87.238.82.0 - 87.238.83.255]
0.0.0.0 adseu.novem.pl
# [Amazon.com][16509][99.84.120.0/21]
0.0.0.0 tagan.adlightning.com
0.0.0.0 cdn-v3.conductrics.com
0.0.0.0 rules.quantcount.com
# [Anexia][AS42473][37.252.228.0 - 37.252.228.255]
0.0.0.0 cdn.qbaka.net
# [America Online][AS1668][149.174.0.0 - 149.174.255.255]
0.0.0.0 ads-us.pictela.net
0.0.0.0 pix.pulsemgr.com
# [AOL CNN / Turner][AS5662][157.166.0.0 - 157.166.255.255]
0.0.0.0 cnn.dyn.cnn.com
0.0.0.0 gdyn.cnn.com #[WebBug]
0.0.0.0 gdyn.nascar.com
0.0.0.0 gdyn.nba.com
0.0.0.0 www.ugdturner.com
0.0.0.0 gdyn.veryfunnyads.com
# [AOL / Advertising.com][209.225.4.64 - 209.225.5.95]
0.0.0.0 bf.mocda1.com
# [AOL / AD TECH][194.117.224.0 - 194.117.225.255]
0.0.0.0 ad.dc2.adtech.de
0.0.0.0 im.adtech.de
0.0.0.0 ads.aol.co.uk
0.0.0.0 img.bet-at-home.com
0.0.0.0 im.banner.t-online.de
# [AOL / AD TECH][AS8939][194.126.131.0 - 194.126.132.255]
0.0.0.0 adtech.de #[ADTECH JavaScript TAG]
0.0.0.0 ad-dc2.adtech.de
0.0.0.0 adserver.adtech.de #[affects Sky Player]
0.0.0.0 aka-cdn-ns.adtech.de
0.0.0.0 adserver.adtechus.com
0.0.0.0 aka-cdn.adtechus.com
0.0.0.0 aka-cdn-ns.adtechus.com
0.0.0.0 adserver.eyeonx.ch
0.0.0.0 hiq.fotolog.com
0.0.0.0 at.ontargetjobs.com
# [AOL / AD TECH][AS1668][195.93.64.0 - 195.93.127.255]
0.0.0.0 adsrv.adplus.co.id
0.0.0.0 adssl-dc2.adtech.de
0.0.0.0 secserv.adtech.de
0.0.0.0 ol.uk.at.atwola.com
0.0.0.0 ads.immobilienscout24.de
0.0.0.0 jt.india.com
# [America Online][AS1668][205.188.0.0 - 205.188.255.255]
0.0.0.0 free.aol.com
0.0.0.0 ar.atwola.com
# [America Online][AS1668][207.200.64.0 - 207.200.127.255]
0.0.0.0 ums.adtechus.com
0.0.0.0 adnet.affinity.com
# [America Online][AS1668][64.12.0.0 - 64.12.255.255]
0.0.0.0 dynamic.aol.com
0.0.0.0 adserver.fixionmedia.com
0.0.0.0 ads.patch.com
# [America Online][AS1668][64.236.0.0 - 64.236.255.255]
0.0.0.0 glb.adtechus.com
0.0.0.0 advertising.com
0.0.0.0 at.atwola.com
0.0.0.0 uk.at.atwola.com
0.0.0.0 helios.fvn.no
0.0.0.0 ads.intergi.com
0.0.0.0 ng3.ads.warnerbros.com
# [Applied Technologies Internet]
0.0.0.0 hit-parade.com
0.0.0.0 loga.hit-parade.com
0.0.0.0 logp.hit-parade.com
0.0.0.0 xiti.com
0.0.0.0 loga.xiti.com #[Tracking.Cookie]
0.0.0.0 logc1.xiti.com
0.0.0.0 logc2.xiti.com
0.0.0.0 logc3.xiti.com
0.0.0.0 logc8.xiti.com
0.0.0.0 logc11.xiti.com
0.0.0.0 logc13.xiti.com
0.0.0.0 logc14.xiti.com
0.0.0.0 logc22.xiti.com
0.0.0.0 logc26.xiti.com
0.0.0.0 logc31.xiti.com
0.0.0.0 logc32.xiti.com
0.0.0.0 logc35.xiti.com
0.0.0.0 logc89.xiti.com
0.0.0.0 logc142.xiti.com
0.0.0.0 logc146.xiti.com
0.0.0.0 logc149.xiti.com
0.0.0.0 logc169.xiti.com
0.0.0.0 logc173.xiti.com
0.0.0.0 logc180.xiti.com
0.0.0.0 logc181.xiti.com
0.0.0.0 logc187.xiti.com
0.0.0.0 logc189.xiti.com
0.0.0.0 logc202.xiti.com
0.0.0.0 logc205.xiti.com
0.0.0.0 logc206.xiti.com
0.0.0.0 logc209.xiti.com
0.0.0.0 logc218.xiti.com
0.0.0.0 logc238.xiti.com
0.0.0.0 logc253.xiti.com
0.0.0.0 logc279.xiti.com
0.0.0.0 logc400.xiti.com
0.0.0.0 logc407.xiti.com
0.0.0.0 logi4.xiti.com
0.0.0.0 logi5.xiti.com
0.0.0.0 logi6.xiti.com
0.0.0.0 logi7.xiti.com
0.0.0.0 logi8.xiti.com
0.0.0.0 logi9.xiti.com
0.0.0.0 logi10.xiti.com
0.0.0.0 logi11.xiti.com
0.0.0.0 logi12.xiti.com
0.0.0.0 logi13.xiti.com
0.0.0.0 logi103.xiti.com
0.0.0.0 logi104.xiti.com
0.0.0.0 logi118.xiti.com
0.0.0.0 logi125.xiti.com
0.0.0.0 logc135.xiti.com
0.0.0.0 logi141.xiti.com
0.0.0.0 logi150.xiti.com
0.0.0.0 logi151.xiti.com
0.0.0.0 logi162.xiti.com
0.0.0.0 logi163.xiti.com
0.0.0.0 logi242.xiti.com
0.0.0.0 logliberation.xiti.com
0.0.0.0 logp.xiti.com
0.0.0.0 logp2.xiti.com
0.0.0.0 logp3.xiti.com
0.0.0.0 logs1122.xiti.com
0.0.0.0 logs1125.xiti.com
0.0.0.0 logs1204.xiti.com
0.0.0.0 logs1242.xiti.com
0.0.0.0 logv1.xiti.com
0.0.0.0 logv2.xiti.com
0.0.0.0 logv3.xiti.com
0.0.0.0 logv4.xiti.com
0.0.0.0 logv5.xiti.com
0.0.0.0 logv6.xiti.com
0.0.0.0 logv7.xiti.com
0.0.0.0 logv8.xiti.com
0.0.0.0 logv9.xiti.com
0.0.0.0 logv10.xiti.com
0.0.0.0 logv11.xiti.com
0.0.0.0 logv12.xiti.com
0.0.0.0 logv13.xiti.com
0.0.0.0 logv14.xiti.com
0.0.0.0 logv16.xiti.com
0.0.0.0 logv17.xiti.com
0.0.0.0 logv18.xiti.com #[WebBug]
0.0.0.0 logv19.xiti.com
0.0.0.0 logv20.xiti.com
0.0.0.0 logv21.xiti.com
0.0.0.0 logv22.xiti.com
0.0.0.0 logv23.xiti.com
0.0.0.0 logv24.xiti.com
0.0.0.0 logv25.xiti.com
0.0.0.0 logv26.xiti.com
0.0.0.0 logv27.xiti.com
0.0.0.0 logv28.xiti.com
0.0.0.0 logv29.xiti.com
0.0.0.0 logv30.xiti.com
0.0.0.0 logv31.xiti.com
0.0.0.0 logv32.xiti.com
0.0.0.0 logv143.xiti.com
0.0.0.0 logv144.xiti.com
0.0.0.0 logv145.xiti.com
0.0.0.0 www.xiti.com
# [AppNexus][AS29990][185.33.222.0 - 185.33.223.255]
0.0.0.0 secure-ams.adnxs.com
# [AppNexus][AS29990][204.13.192.0 - 204.13.199.255]
0.0.0.0 rb.adnxs.com
0.0.0.0 ib.reachjunction.com
# [AppNexus / Bandcon][AS29990][8.12.224.0 - 8.12.239.255]
# 0.0.0.0 ib.adnxs.com #[affects Microsoft site]
0.0.0.0 photobucket.adnxs.com
0.0.0.0 secure.adnxs.com
0.0.0.0 ym.adnxs.com
0.0.0.0 ad.aquamediadirect.com
0.0.0.0 action.media6degrees.com
0.0.0.0 ag.yieldoptimizer.com
# [AppNexus / Bandcon][AS29990][8.19.16.0 - 8.19.31.255]
0.0.0.0 ads.brand.net
0.0.0.0 load.exelator.com
0.0.0.0 ad.himediadx.com
0.0.0.0 action.mathtag.com
0.0.0.0 cspix.media6degrees.com
0.0.0.0 secure.media6degrees.com
0.0.0.0 tag.yieldoptimizer.com
# [AppNexus][AS29990][64.208.0.0 - 64.209.127.255]
0.0.0.0 b.adnxs.com
0.0.0.0 nym1.b.adnxs.com
0.0.0.0 gam.adnxs.com
0.0.0.0 ad.dedicatedmedia.com
0.0.0.0 ads.matiro.com
0.0.0.0 ads.q1media.com
0.0.0.0 ads.reduxmediagroup.com
0.0.0.0 ad.retargeter.com
# [AppNexus][AS29990][68.67.128.0 - 68.67.191.255]
0.0.0.0 go.accmgr.com
0.0.0.0 advs.adgorithms.com
0.0.0.0 ad2.adnetwork.net
0.0.0.0 ib.adnxs.com
0.0.0.0 mob.adnxs.com
0.0.0.0 nym1.ib.adnxs.com
0.0.0.0 nym1-ib.adnxs.com
0.0.0.0 sin1.g.adnxs.com
0.0.0.0 go.adversal.com
0.0.0.0 rtb-ads.avazu.net
0.0.0.0 optimizedby.brealtime.com
0.0.0.0 ads.captifymedia.com
0.0.0.0 x.clickcertain.com
0.0.0.0 ads.clovenetwork.com
0.0.0.0 ads.cpxinteractive.com
0.0.0.0 ads.digitalthrottle.com
0.0.0.0 ads.exactdrive.com
0.0.0.0 ads.gamned.com
0.0.0.0 tag.gayadnetwork.com
0.0.0.0 ad.imediaaudiences.com
0.0.0.0 secure-id.impressiondesk.com
0.0.0.0 tk.ads.mmondi.com
0.0.0.0 ad.netcommunities.com
0.0.0.0 ads.networkhm.com
0.0.0.0 ads.pubsqrd.com
0.0.0.0 ads.sonital.com
0.0.0.0 ads.sonobi.com
0.0.0.0 ads.suite6ixty6ix.com
0.0.0.0 ex.banner.t-online.de
0.0.0.0 ads.up-value.de
0.0.0.0 ads.vntsm.com
0.0.0.0 an.z5x.net
# [Appserve][AS23376][64.241.102.160 - 64.241.102.191]
# [Argeweb][AS8315][193.34.150.0 - 193.34.151.255]
0.0.0.0 b.ds1.nl
0.0.0.0 k1s.nl #[Daisycon]
# [Argeweb][AS8315][91.200.48.0 - 91.200.51.255]
# [Aruba][AS31034][62.149.128.0 - 62.149.159.255]
0.0.0.0 www.infotelsrl.com
0.0.0.0 www.juiceadv.com
0.0.0.0 www.prdirectory.biz
0.0.0.0 ads.vjaffiliates.com
# [Aruba][AS31034][95.110.200.0 - 95.110.207.255]
0.0.0.0 srv.juiceadv.com
# [Asp Ltd][AS35480][193.192.48.0 - 193.192.49.255]
0.0.0.0 espresso-reklam.eu
0.0.0.0 openx.imoti.net
0.0.0.0 rot2.imoti.net
0.0.0.0 pagead.topobiavi.com
0.0.0.0 uppyads.com
# [Aufeminin.com][AS39894][185.86.136.0 - 185.86.139.255]
0.0.0.0 ww651.smartadserver.com
# [Aufeminin.com][AS39894][91.103.136.0 - 91.103.140.255]
0.0.0.0 securite.01net.com
0.0.0.0 smart.hola.com
0.0.0.0 ads.horyzon-media.com
0.0.0.0 www.meetic-partners.com
0.0.0.0 ad.prismamediadigital.com
0.0.0.0 ads.publicidad.net
# [Awknet Communications][AS17048][69.42.208.0 - 69.42.223.255]
0.0.0.0 adtegrity.com
0.0.0.0 www.adtegrity.com
# [Axill][72.3.140.224 - 72.3.140.231]
0.0.0.0 www.axill.com
# [Axill Europe][AS41813][84.45.63.0 - 84.45.70.255]
0.0.0.0 www.globe7.com
# [Bay Area / Visistat][AS7151][209.128.64.0 - 209.128.127.255]
0.0.0.0 stats.sa-as.com
0.0.0.0 stats.visistat.com
# [Bay Area / Veruta][AS7151][72.172.176.0 - 72.172.191.255]
0.0.0.0 adserver.veruta.com
# [Beanfield][AS21949][206.223.160.0 - 206.223.191.255]
0.0.0.0 ard.sexplaycam.com
0.0.0.0 flashbanners.static.ard.sexplaycam.com
0.0.0.0 ard.xxxblackbook.com
0.0.0.0 flashbanners.static.ard.xxxblackbook.com
0.0.0.0 geo.xxxblackbook.com
0.0.0.0 static.ard.xxxblackbook.com
# [Beanfield][AS21949][76.9.192.0 - 76.9.223.255]
0.0.0.0 ard.sweetdiscreet.com
# [Bell Canada][AS6539][216.18.0.0 - 216.18.127.255]
0.0.0.0 api.nrelate.com
# [Bell Globemedia Interactive][AS10808][199.246.60.0 - 199.246.71.255]
0.0.0.0 adcounter.theglobeandmail.com
0.0.0.0 adrates.theglobeandmail.com
0.0.0.0 ecestats.theglobeandmail.com
0.0.0.0 ece5stats1.theglobeandmail.com
0.0.0.0 visit.theglobeandmail.com
# [Bellona][AS3.343][193.107.164.0 - 193.107.167.255]
0.0.0.0 active.hit.stat24.com
0.0.0.0 home.hit.stat24.com
0.0.0.0 lt3.hit.stat24.com
0.0.0.0 nl4.hit.stat24.com
0.0.0.0 pro.hit.stat24.com
0.0.0.0 redefine.hit.stat24.com
0.0.0.0 redefine2.hit.stat24.com
0.0.0.0 ru2.hit.stat24.com
0.0.0.0 s1.hit.stat24.com
0.0.0.0 s2.hit.stat24.com
0.0.0.0 s3.hit.stat24.com
0.0.0.0 s4.hit.stat24.com
0.0.0.0 ua1.hit.stat24.com
0.0.0.0 ua2.hit.stat24.com
0.0.0.0 ua3.hit.stat24.com
0.0.0.0 ua4.hit.stat24.com
0.0.0.0 ua5.hit.stat24.com
0.0.0.0 uk4.hit.stat24.com
0.0.0.0 www.stat24.com
# [Beyond The Network][AS3491][205.252.0.0 - 205.252.255.255]
0.0.0.0 clicktrace.info
0.0.0.0 protect-x.com
# [Beyond The Network][AS3491][207.176.0.0 - 207.176.127.255]
0.0.0.0 www.getsearchlist.com
0.0.0.0 www.homeoffun.com
# [Beyond The Network][AS3491][207.226.0.0 - 207.226.255.255]
0.0.0.0 1directory.ru
0.0.0.0 img.royal-cash.com
0.0.0.0 adds1.trafflow.com
0.0.0.0 tds.trafflow.com
0.0.0.0 banners.truecash.com
0.0.0.0 ads.ynot.com
# [Beyond The Network][209.8.0.0 - 209.9.255.255]
0.0.0.0 ads.svnt.com
# [Beyond The Network][63.216.0.0 - 63.223.255.255]
0.0.0.0 bannersgomlm.buildreferrals.com
0.0.0.0 adds.trafflow.com
0.0.0.0 feed.trafflow.com
0.0.0.0 freeimghost.trafflow.com #[Spamdexing]
# [Bezeq][AS8551][62.219.0.0 - 62.219.21.255]
0.0.0.0 service1.predictad.com
0.0.0.0 service2.predictad.com
# [Bezeq][AS8551][81.218.31.128 - 81.218.31.255]
# [Bezeq][AS8551][82.80.204.0 - 82.80.239.255]
0.0.0.0 geo.widdit.com
# [Bigmir][AS39468][193.239.68.0 - 193.239.71.255]
0.0.0.0 ad0.bigmir.net
0.0.0.0 ad1.bigmir.net
0.0.0.0 ad4.bigmir.net
0.0.0.0 ad5.bigmir.net
0.0.0.0 ad6.bigmir.net
0.0.0.0 ad7.bigmir.net
0.0.0.0 adi.bigmir.net
0.0.0.0 c.bigmir.net #[WebBug]
0.0.0.0 i.bigmir.net
# [Big Pipe][AS6327][74.3.128.0 - 74.3.191.255]
0.0.0.0 t.nrelate.com
# [Bitgravity][AS40009][208.67.232.0 - 208.67.239.255]
0.0.0.0 bitcast-a.v1.iad1.bitgravity.com
0.0.0.0 ads.devicebondage.com
0.0.0.0 ads.fuckingmachines.com
0.0.0.0 ads.hogtied.com
0.0.0.0 ads.publicdisgrace.com
0.0.0.0 ads.sexandsubmission.com
0.0.0.0 ads.thetrainingofo.com
0.0.0.0 ads.whippedass.com
# [Blinkx][AS14743][69.25.102.0 - 69.25.102.255]
0.0.0.0 bbtv.blinkx.com #[Trojan.Win32.Agent.wif]
# [BlueConnex / Eukhost-ltd][AS29550][91.186.31.0 - 91.186.31.255]
0.0.0.0 ads.uknetguide.co.uk
# [Blue Gravity][AS15171][64.255.0.0 - 64.255.63.255]
0.0.0.0 www.bigpenisguide.com
0.0.0.0 fastwebcounter.com
0.0.0.0 stats.ozwebsites.biz
# [Bluehost][74.220.192.0 - 74.220.223.255]
0.0.0.0 www.yrals.com #[WebBug]
# [Broadband Enterprises][AS3561][64.15.238.64 - 64.15.238.127]
0.0.0.0 addirector.vindicosuite.com
0.0.0.0 web.vindicosuite.com #[WebBug]
# [Broadbandone][AS13645][64.135.0.0 - 64.135.127.255]
0.0.0.0 ads.crawler.com
0.0.0.0 ads.websearch.com
# [Broadbandone][AS13645][75.119.128.0 - 75.119.191.255]
0.0.0.0 tracking.godatafeed.com
# [BroadRiver][AS13703][208.52.128.0 - 208.52.191.255]
0.0.0.0 www.cbeckads.com
0.0.0.0 atrd.netmng.com
0.0.0.0 brnys.netmng.com
0.0.0.0 com-kia.netmng.com
0.0.0.0 com-kodak.netmng.com
0.0.0.0 com-mitsubishi.netmng.com
0.0.0.0 com-morningstar.netmng.com
0.0.0.0 com-vw.netmng.com
0.0.0.0 dms.netmng.com
0.0.0.0 nbcustr.netmng.com
0.0.0.0 vw.netmng.com
# [BroadRiver][AS13703][63.135.160.0 - 63.135.175.255]
0.0.0.0 a.netmng.com
0.0.0.0 display.digitalriver.com
# [Bso Network][AS31216][89.30.126.0 - 89.30.126.255]
0.0.0.0 tracking.tomsguide.com
0.0.0.0 tracking.tomshardware.com
0.0.0.0 www.ad.twitchguru.com
# [Bulgarian Teleco][AS8866][46.10.0.0 - 46.10.255.255]
0.0.0.0 ads.bl-consulting.net
# [Businessnet][AS13093][192.118.72.0 - 192.118.75.255]
0.0.0.0 dclk.haaretz.com
0.0.0.0 dclk.themarker.com
# [Casalemedia][AS27381][192.40.32.0 - 192.40.39.255]
0.0.0.0 a1589.casalemedia.com
0.0.0.0 a1653.casalemedia.com
0.0.0.0 a1664.casalemedia.com
0.0.0.0 a1681.casalemedia.com
# [Cash4Downloads][CidHelp Group][67.15.107.168]
0.0.0.0 c4dl.com
0.0.0.0 www.c4dl.com
0.0.0.0 www.cash4downloads.com
# [C4L][AS25577][109.104.96.0 - 109.104.127.255]
0.0.0.0 adserver.merciless.localstars.com
# [C4L][AS25577][82.197.70.0 - 82.197.70.127]
0.0.0.0 statto.plus8.net
# [C4L / Globalcharge-net][AS25577][84.45.71.0 - 84.45.71.255]
0.0.0.0 www.globalcharge.com
# [California Regional / i-Serve][AS10439][71.6.128.0 - 71.6.255.255]
0.0.0.0 pluto.adcycle.com
0.0.0.0 www.adcycle.com
0.0.0.0 www.exchange-it.com
0.0.0.0 media.exchange-it.com
0.0.0.0 metacount.com
0.0.0.0 stats.metacount.com
0.0.0.0 www.metacount.com
0.0.0.0 popunder.com
0.0.0.0 media.popunder.com
0.0.0.0 www.popunder.com
0.0.0.0 www.rkdms.com
# [Calpop.com / Airlinereservations.com][206.125.40.0 - 206.125.47.255]
0.0.0.0 engine.phn.doublepimp.com
0.0.0.0 cdn.engine.phn.doublepimp.com
0.0.0.0 rts.pgmediaserve.com
0.0.0.0 rts.revfusion.net
# [Calpop.com / Airlinereservations.com][AS7796][208.70.72.0 - 208.70.79.255]
0.0.0.0 ad.bnmla.com
# [Calpop.com / Atmlink][AS7796][216.240.128.0 - 216.240.159.255]
0.0.0.0 rts.phn.doublepimp.com
# [Calpop.com][AS7796][64.27.0.0 - 64.27.31.255]
0.0.0.0 web.adblade.com
0.0.0.0 www.adsupply.com
0.0.0.0 ad1.adtitan.net
0.0.0.0 doublepimp.com
0.0.0.0 ad1.doublepimp.com
0.0.0.0 ad2.doublepimp.com
0.0.0.0 dev.doublepimp.com
0.0.0.0 rts.doublepimp.com
0.0.0.0 ad3.linkbucks.com
0.0.0.0 www.linkbucks.com
0.0.0.0 gk.rts.sparkstudios.com
# [Caravan / Lanways-net][AS15756][217.23.132.248 - 217.23.132.255]
0.0.0.0 spytrack.tic.ru
# [Carmen Media][66.212.235.192 - 66.212.235.255]
# [Caronet][AS13618][174.34.224.0 - 174.34.255.255]
0.0.0.0 cdn.zeusclicks.com
# [Caronet / Aebn][74.81.184.0 - 74.81.185.255]
0.0.0.0 hostedbannerads.aebn.net
0.0.0.0 realtouchbannerwidget.aebn.net
0.0.0.0 ox.tossoffads.com
# [Caronet][74.81.187.56 - 74.81.187.63]
0.0.0.0 affiliate.blucigs.com
0.0.0.0 bluhostedbanners.blucigs.com
# [Caronet][76.76.4.0 - 76.76.5.255]
0.0.0.0 ads.kaktuz.net
# [Caronet][76.76.8.0 - 76.76.9.255]
0.0.0.0 ads.bnmedia.com
0.0.0.0 ieginc.com
0.0.0.0 ads.iwangmedia.com
0.0.0.0 banners.rexmag.com
# [Carpathia Hosting][AS29748][209.222.128.0 - 209.222.159.255]
# [Carpathia Hosting][AS15226][66.197.0.0 - 66.197.127.255]
0.0.0.0 webstats.oanda.com
# [Casale Media][Comspec Communications]
0.0.0.0 casalemedia.com
0.0.0.0 a407.casalemedia.com
0.0.0.0 as.casalemedia.com #[Tracking.Cookie]
0.0.0.0 b.casalemedia.com
0.0.0.0 c.casalemedia.com
0.0.0.0 i.casalemedia.com
0.0.0.0 img.casalemedia.com
0.0.0.0 js.casalemedia.com
0.0.0.0 r.casalemedia.com
0.0.0.0 ssum-sec.casalemedia.com
0.0.0.0 www.casalemedia.com
0.0.0.0 www.oofun.com
0.0.0.0 00fun.com #[Tracking.Cookie]
0.0.0.0 www.00fun.com
# [Castle Access][AS22489][69.43.160.0 - 69.43.160.255]
0.0.0.0 park.above.com
0.0.0.0 www.needmorehits.com
0.0.0.0 openx.trellian.com
# [Cat Idc2][AS9931][122.155.160.0 - 122.155.191.255]
0.0.0.0 banner.synergy-e.com
0.0.0.0 smart.synergy-e.com
0.0.0.0 stat.synergy-e.com #[Piwik.Analytics]
0.0.0.0 unitus.synergy-e.com
# [CBS Interactive / CNET Networks]
0.0.0.0 stat.fengniao.com
0.0.0.0 ads.webshots.com
# [CBS Interactive / CNET Networks][AS6623][216.239.112.0 - 216.239.127.255]
0.0.0.0 adimg.bnet.com
0.0.0.0 mads.bnet.com
0.0.0.0 ocp.bnet.com
0.0.0.0 adlog.cbsi.com
# 0.0.0.0 dw.cbsi.com #[affects CNET downloads]
0.0.0.0 mads.cbs.com
0.0.0.0 track.cbs.com #[WebBug]
0.0.0.0 mads.cbsnews.com
0.0.0.0 ocp.cbsnews.com
0.0.0.0 adimg.chow.com
0.0.0.0 mads.chow.com
0.0.0.0 adimg.cnet.com
0.0.0.0 mads.cnet.com
0.0.0.0 remotead-internal.cnet.com
0.0.0.0 remotead.cnet.com
0.0.0.0 mads.cnettv.com
0.0.0.0 adimg.download.com
0.0.0.0 mads.download.com
0.0.0.0 adimg.gamefaqs.com
0.0.0.0 mads.gamefaqs.com
0.0.0.0 adimg.theinsider.com
0.0.0.0 mads.theinsider.com
0.0.0.0 adimg.news.com
0.0.0.0 adimg.tv.com
0.0.0.0 mads.tv.com
0.0.0.0 ads.zdnet.com
0.0.0.0 adimg.zdnet.com
0.0.0.0 mads.zdnet.com
# [Cdnetworks][AS36408][14.0.32.0 - 14.0.63.255]
0.0.0.0 widget.perfectmarket.com
# [Cdnetworks][AS36408][103.4.200.0 - 103.4.203.255]
# [Cdnetworks][AS36408][151.249.93.0 - 151.249.93.255]
0.0.0.0 vht.tradedoubler.com
# [Cdnetworks][AS36408][174.35.0.0 - 174.35.127.255]
0.0.0.0 cdn.clicktale.net
0.0.0.0 d-cache.microadinc.com
0.0.0.0 media.netrefer.com
0.0.0.0 media2.netrefer.com
# [Cdnetworks][AS36408][61.110.192.0 - 61.110.255.255]
0.0.0.0 js.octopuspop.com
# [Cerfnet][AS4269][63.240.0.0 - 63.242.255.255]
0.0.0.0 activity.serving-sys.com
0.0.0.0 bs.serving-sys.com #[Tracking.Cookie]
0.0.0.0 datacapture.serving-sys.com
# [China Telecom / Chinanet][AS4812][180.152.0.0 - 180.159.255.255]
0.0.0.0 dwtracking.sdo.com
# [China Telecom / Qunying][AS4134][59.34.148.0 - 59.34.148.255]
0.0.0.0 wwv.onetad.com
# [China Telecom / Chinanet][222.64.0.0 - 222.79.255.255]
0.0.0.0 stat1.vipstat.com
# [China Telecom / Chinanet][59.52.0.0 - 61.152.255.255]
0.0.0.0 goldbye.vicp.net
# [Choopa][AS20473][108.61.3.160 - 108.61.3.167]
0.0.0.0 thetop.be
# [Choopa][AS11508][208.167.224.0 - 208.167.255.255]
0.0.0.0 www.aptrafficnetwork.com
0.0.0.0 ads.gameservers.com
0.0.0.0 as.pmates.com
0.0.0.0 banners.videosz.com
0.0.0.0 feeds.videosz.com
# [Choopa][AS20473][209.222.0.0 - 209.222.31.255]
0.0.0.0 jsg.dt07.net
0.0.0.0 imgg.dt07.net
0.0.0.0 video-pomp.com
# [Choopa][216.155.128.0 - 216.155.159.255]
0.0.0.0 ad.abum.com
0.0.0.0 www.epicgameads.com
0.0.0.0 www.freepornsubmits.com
0.0.0.0 banners.thirdmovies.com
0.0.0.0 ads.videosz.com
0.0.0.0 404.xxxymovies.com
0.0.0.0 delivery.yourfuckbook.com
0.0.0.0 ads.ztod.com
0.0.0.0 banners.ztod.com
0.0.0.0 tools.ztod.com
# [Choopa][AS20473][45.63.0.0 - 45.63.127.255]
# [Choopa][64.237.32.0 - 64.237.63.255]
0.0.0.0 ads.adgoto.com
0.0.0.0 banners.adgoto.com
0.0.0.0 v2.adgoto.com
0.0.0.0 www.mm26.com
# [Choopa][AS20473][66.55.128.0 - 66.55.159.255]
0.0.0.0 www.18access.com
0.0.0.0 www.hentaidatabase.com
0.0.0.0 longtraffic.com
0.0.0.0 adv.sexcounter.com #[Tracking.Cookie]
0.0.0.0 cs.sexcounter.com
0.0.0.0 support.sextronix.com #[Wildcard DNS]
0.0.0.0 www.sextronix.com
# [Choopa][66.55.139.0 - 66.55.139.255]
0.0.0.0 ads.asredas.com
# [Choopa][68.232.160.0 - 68.232.191.255]
# [Chunghwa Telecom][AS3462][210.242.128.0 - 210.242.255.255]
0.0.0.0 secure-yt.imrworldwide.com
# [ClaraNET][AS8426][213.221.106.192 - 213.221.106.223]
0.0.0.0 www.econda-monitor.de
# [ClaraNET][AS8426][62.80.0.0 - 62.80.63.255]
0.0.0.0 www.free-choices.com
0.0.0.0 piwik.n24.de #[Piwik.Analytics]
# [ClaraNET][AS8426][95.0.0.0 - 95.255.255.255]
0.0.0.0 ads.adnet-media.net
0.0.0.0 3amcouk.skimlinks.com
0.0.0.0 bikeforumsnet.skimlinks.com
0.0.0.0 complexcom.skimlinks.com
0.0.0.0 dirtytalk101com.skimlinks.com
0.0.0.0 freeforumsorg.skimlinks.com
0.0.0.0 handbagcom.skimlinks.com
0.0.0.0 hothardwarecom.skimlinks.com
0.0.0.0 mirrorcoukcelebs.skimlinks.com
0.0.0.0 projectw.skimlinks.com
0.0.0.0 reviewcentrecom.skimlinks.com
0.0.0.0 skimlinkscom.skimlinks.com
0.0.0.0 static.skimlinks.com
0.0.0.0 techradarcom.skimlinks.com
0.0.0.0 techspotcom.skimlinks.com
0.0.0.0 telegraphcouk.skimlinks.com
0.0.0.0 tidbitscom.skimlinks.com
0.0.0.0 toplessrobotcom.skimlinks.com
0.0.0.0 wirelessforumsorg.skimlinks.com
0.0.0.0 wordpresscom.skimlinks.com
0.0.0.0 wwwchipchickcom.skimlinks.com
0.0.0.0 wwwcultofmaccom.skimlinks.com
0.0.0.0 xmarkscom.skimlinks.com
0.0.0.0 s.skimresources.com
# [Clickability][AS14393][208.80.56.0 - 208.80.59.255]
0.0.0.0 btn.clickability.com
0.0.0.0 button.clickability.com
0.0.0.0 cas.clickability.com
0.0.0.0 imp.clickability.com
0.0.0.0 ri.clickability.com
0.0.0.0 s.clickability.com
0.0.0.0 sftp.clickability.com #[Tracking.Cookie]
0.0.0.0 stats.clickability.com
# [Cloudflare][AS13335][104.16.0.0 - 104.31.255.255]
0.0.0.0 try.abtasty.com
0.0.0.0 ads.adamoads.com
0.0.0.0 adclickservice.com
0.0.0.0 click.adpremium.org
0.0.0.0 hts2.adpremium.org
0.0.0.0 hts4.adpremium.org
0.0.0.0 js.adpremium.org
0.0.0.0 ms.adpremium.org
0.0.0.0 asmedia.adsupplyssl.com
0.0.0.0 run.adrizer.com
0.0.0.0 traffic.adxprts.com
0.0.0.0 www.appfindr.org #[Riskware/PUP]
0.0.0.0 tracker.bang.com
0.0.0.0 srv.bebi.com
0.0.0.0 banners.bghelp.co.uk
0.0.0.0 b2u-system-err.icu #[ScamFraudAlert.Antispyware]
0.0.0.0 buzzcpm.com
0.0.0.0 cdnmedia.xyz
0.0.0.0 wp1.cor-natty.com
0.0.0.0 count.im
0.0.0.0 cdn.districtm.ca
0.0.0.0 prebid.districtm.ca
0.0.0.0 downloadappguide.com
0.0.0.0 extra.eboundservices.com
0.0.0.0 www.eboundservices.com
0.0.0.0 cdn.exoticads.com
0.0.0.0 content.exoticads.com
0.0.0.0 www.fileconvertertab.com #[PUA.FileConvTab]
0.0.0.0 track.flexlinkspro.com
0.0.0.0 ox.furaffinity.net
0.0.0.0 rv.furaffinity.net
0.0.0.0 www.game-clicks.com
0.0.0.0 serve.getpopunder.com
0.0.0.0 grabtrk.com
0.0.0.0 www.hostadserver.com
0.0.0.0 tag.imonomy.com
0.0.0.0 us-tracker.inside-graph.com
0.0.0.0 embed.insticator.com
0.0.0.0 ssl.mousestats.com
0.0.0.0 multioptik.com
0.0.0.0 myfukbuddy.com
0.0.0.0 neki.org
# 0.0.0.0 onesignal.com #[blocks Push notifications]
0.0.0.0 opensharecount.com
0.0.0.0 opensoftwareupdater.com #[Riskware/PUP]
0.0.0.0 www.os-downloads.com #[Riskware/PUP]
0.0.0.0 mh.pip-pip-pop.com
0.0.0.0 cdn.www1.pip-pip-pop.com
0.0.0.0 www1.pip-pip-pop.com
0.0.0.0 code.poptm.com
0.0.0.0 ads.proboards.com
0.0.0.0 www.ps7894.com
0.0.0.0 cdn.pubexchange.com
0.0.0.0 cdn.quantummetric.com
0.0.0.0 qikdownloads.com
0.0.0.0 ads.reembed.com
0.0.0.0 a10.reflexcash.com
0.0.0.0 ads.reflexcash.com
0.0.0.0 www.retailproductzone.com
0.0.0.0 retracker.com
0.0.0.0 samvaulter.com
0.0.0.0 seaofads.com
0.0.0.0 www.searchapps.me #[Riskware/PUP]
0.0.0.0 siteimproveanalytics.com
0.0.0.0 counter.snackly.co
0.0.0.0 cdn.spoutable.com
0.0.0.0 engine.spoutable.com
0.0.0.0 www1.tec-tec-boom.com
0.0.0.0 code.theads.me
0.0.0.0 r1-t.trackedlink.net
0.0.0.0 cdn.tynt.com
0.0.0.0 cnt.tyxo.com
0.0.0.0 s.tyxo.com
0.0.0.0 pixel.yola.com
0.0.0.0 z2jakqoshx.com
0.0.0.0 s.zkcdn.net
0.0.0.0 in4.zog.link
0.0.0.0 cdn1.zopiny.com
# [Cloudflare][AS13335][108.162.192.0 - 108.162.255.255]
0.0.0.0 adfoc.us
0.0.0.0 img.avatraffic.com
0.0.0.0 bestappinstalls.com
0.0.0.0 ads.casumoaffiliates.com
0.0.0.0 cmtrading.ck-cdn.com
0.0.0.0 jque.net
0.0.0.0 mh.ogercron.com
0.0.0.0 ozertesa.com
0.0.0.0 www.pstats.com
0.0.0.0 www.xyfex.com
# [Cloudflare][AS13335][141.101.112.0 - 141.101.119.255]
0.0.0.0 adsbookie.com
0.0.0.0 ads.adsbookie.com
0.0.0.0 cs.luckyorange.net
0.0.0.0 settings.luckyorange.net
0.0.0.0 upload.luckyorange.net
# 0.0.0.0 js.maxmind.com #[affects marchon.com / directvnow.com]
0.0.0.0 ads.mylikes.com
0.0.0.0 www.mystat.pl
0.0.0.0 trafficg.com
0.0.0.0 www.trafficg.com
0.0.0.0 trw12.com
0.0.0.0 xpop.co
0.0.0.0 clicks.zwaar.org
# [Cloudflare][AS13335][162.158.0.0 - 162.159.255.255]
0.0.0.0 ads.ayads.co
0.0.0.0 click.bounceads.net
0.0.0.0 errorception.com
0.0.0.0 beacon.errorception.com
0.0.0.0 www.fulltraffic.net
0.0.0.0 static.kameleoon.com
0.0.0.0 lognormal.net
0.0.0.0 cdn.luckyorange.com #[Analytics.Tracker]
0.0.0.0 w1.luckyorange.com
0.0.0.0 www2.mousestats.com
0.0.0.0 opendownloadmanager.com
0.0.0.0 popcash.net
0.0.0.0 softwareupdaterlp.com #[Win32/DownWare.AA]
# [Cloudflare][AS13335][173.245.48.0 - 173.245.63.255]
0.0.0.0 bokotraffic.com
0.0.0.0 bororango.com
# [Cloudflare][AS13335][190.93.240/20]
0.0.0.0 0iecfobt.com
0.0.0.0 www.adhexa.com
0.0.0.0 adprovider.adlure.net
0.0.0.0 geoservice.curse.com
0.0.0.0 ems2bmen.com
0.0.0.0 m57ku6sm.com
0.0.0.0 pixxur.com
# [Cloudflare][AS13335][198.41.128.0 - 198.41.255.255]
0.0.0.0 cdn.directtrk.com
0.0.0.0 opensoftwareupdate.com #[Adware.Downware.3736]
0.0.0.0 popmyads.com
0.0.0.0 cdn.popmyads.com
0.0.0.0 assets.popmarker.com
# [Cogent / Psinet][AS174][38.0.0.0 - 38.255.255.255]
0.0.0.0 3xtraffic.com
0.0.0.0 33video.33universal.com
0.0.0.0 oasis.411affiliates.ca
0.0.0.0 acuityplatform.com
0.0.0.0 click-west.acuityplatform.com
0.0.0.0 serve-east.acuityplatform.com
0.0.0.0 c1.adform.net
0.0.0.0 a2.adform.net
0.0.0.0 server.as5000.com
0.0.0.0 server2.as5000.com
0.0.0.0 counter.bizland.com
0.0.0.0 v.bsvideos.com
0.0.0.0 hfm.checkm8.com
0.0.0.0 qlipso.checkm8.com
0.0.0.0 sagedigital.checkm8.com
0.0.0.0 creative.clicksor.com
0.0.0.0 ppc-parked.domainsite.com #[Parking Service]
0.0.0.0 vcontent.e-messenger.net
0.0.0.0 ads.financialcontent.com
0.0.0.0 id3103.com
0.0.0.0 ad.internetradioinc.com
0.0.0.0 click.linkstattrack.com
0.0.0.0 ads.lzjl.com
0.0.0.0 www.lzjl.com #[PaypopUp]
0.0.0.0 ads.newgrounds.com
0.0.0.0 www.ngads.com
0.0.0.0 adimg.ngfiles.com
0.0.0.0 ads.onemodelplace.com
0.0.0.0 www.pythonpays.com
0.0.0.0 ads.redlightcenter.com
0.0.0.0 tor.redlightcenter.com
0.0.0.0 ad.trident.net
0.0.0.0 a.xanga.com
# [Cogent][AS174][50.7.0.0 - 50.7.255.255]
0.0.0.0 cache.betweendigital.com
0.0.0.0 dispenser-rtb.sape.ru
# [Cogent / Psinet][AS174][66.28.0.0 - 66.28.255.255]
0.0.0.0 aj.600z.com
0.0.0.0 static.hatid.com
0.0.0.0 piwik.ientry.com
# [Colo4dallas][AS30496][173.237.128.0 - 173.237.191.255]
0.0.0.0 ads.smartolution.com
# [Colo4dallas][AS30496][65.99.192.0 - 65.99.255.255]
0.0.0.0 e.nspmotion.com
# [Colo4dallas][AS30496][67.222.133.86 - 67.222.133.93]
0.0.0.0 imgc.psychcentral.com
# [Coloc8][AS33536][64.128.87.0 - 64.128.87.255]
0.0.0.0 hop.clickbank.net #[Adware.Clickbank][Adware.ClickDLoader]
0.0.0.0 zzz.clickbank.net
# [Colocall][AS15497][31.28.161.16 - 31.28.161.31]
0.0.0.0 ua.adriver.ru
# [Colocall][AS15497][62.149.28.0 - 62.149.28.255]
0.0.0.0 e2.molbuk.ua
# [Colocation Clients][AS8262][85.14.6.0 - 85.14.6.255]
0.0.0.0 eadsrv.com
# [Colocation Subnet][AS30968][92.243.64.0 - 92.243.67.0]
0.0.0.0 adfun.ru
0.0.0.0 ad1.adfun.ru
# [Colo-cation][AS11110][66.244.144.0 - 66.244.159.255]
0.0.0.0 ads.juicyads.com
0.0.0.0 adserver.juicyads.com
0.0.0.0 mobile.juicyads.com
0.0.0.0 redir.juicyads.com
0.0.0.0 xapi.juicyads.com
0.0.0.0 www.juicyads.com
# [Colosseum Online][AS19842][209.47.169.0 - 209.47.169.255]
0.0.0.0 textad.eroticmatch.com
0.0.0.0 pod.manplay.com
0.0.0.0 textad.manplay.com
0.0.0.0 textad.passionsearch.com
0.0.0.0 wt.sexsearch.com
0.0.0.0 textad.sexsearchcom.com
0.0.0.0 wt.sexsearchcom.com
0.0.0.0 textad.xpress.com
0.0.0.0 textad.xxxcupid.com
0.0.0.0 textad.xxxmatch.com
# [Colosseum Online][216.105.94.64 - 216.105.94.95]
0.0.0.0 clickedyclick.com #[Tracking.Cookie]
0.0.0.0 www.clickedyclick.com
0.0.0.0 pod.infinitypersonals.com
0.0.0.0 textad.socialsex.com
# [Colt-hqs][AS8220][217.110.73.160 - 217.110.73.167]
0.0.0.0 www.ranking-links.de
0.0.0.0 api.zanox.com
# [Columbus Network Access][AS10297][173.45.111.112 - 173.45.111.127]
0.0.0.0 ads.all-free-download.com
0.0.0.0 us1.siteimprove.com
0.0.0.0 us2.siteimprove.com
# [Columbus Network Access][AS10297][207.182.128.0 - 207.182.159.255]
0.0.0.0 adv.all-free-download.com
# [Comscore / Relevant Knowledge]
0.0.0.0 siterecruit.comscore.com
0.0.0.0 oss-content.securestudies.com
0.0.0.0 b.scorecardresearch.com
0.0.0.0 beacon.scorecardresearch.com #[WebBug]
0.0.0.0 sb.scorecardresearch.com #[affects ancestry.com]
0.0.0.0 www2.survey-poll.com
# [Comscore Network][AS3561][165.193.78.128 - 165.193.78.255]
0.0.0.0 www.premieropinion.com
0.0.0.0 a.scorecardresearch.com
0.0.0.0 c.scorecardresearch.com
0.0.0.0 post.securestudies.com
0.0.0.0 www.voicefive.com
# [Comscore Network][AS3561][205.218.0.0 - 205.219.255.255]
0.0.0.0 udm.ia8.scorecardresearch.com #[Microsoft Mahjong]
0.0.0.0 udm.ia9.scorecardresearch.com
# [Comscore Network][AS3561][66.119.33.128 - 66.119.33.191]
0.0.0.0 beacon.securestudies.com
0.0.0.0 ar.voicefive.com
# [Comscore Network][66.119.34.32 - 66.119.34.63]
0.0.0.0 rules.securestudies.com
# [Comscore Network][66.119.41.0 - 66.119.41.127]
0.0.0.0 www.permissionresearch.com
0.0.0.0 relevantknowledge.com
0.0.0.0 www.relevantknowledge.com
0.0.0.0 web.survey-poll.com
0.0.0.0 www.surveysite.com
0.0.0.0 survey2.voicefive.com
# [Coremetrics][AS46589][74.121.132.0 - 74.121.135.255]
0.0.0.0 data.abebooks.com #[WebBug.eluminate]
0.0.0.0 www25.bathandbodyworks.com #[WebBug.eluminate]
0.0.0.0 testdata.coremetrics.com
# [Core Technology][AS23421][64.29.176.0 - 64.29.191.255]
0.0.0.0 www.linkshare.com
# [Cotendo][AS46281][208.93.136.0 - 208.93.143.255]
0.0.0.0 www.ad4mat.ch
0.0.0.0 www.da-ads.com
0.0.0.0 t.p.mybuys.com
0.0.0.0 w.p.mybuys.com
# [Cotendo][AS46281][98.142.96.0 - 98.142.111.255]
0.0.0.0 ads.jpost.com #[RealMedia]
# [Criteo][AS55569][182.161.73.0 - 182.161.73.255]
0.0.0.0 sslwidget.criteo.com
# [Criteo][AS19750][74.119.116.0 - 74.119.119.255]
0.0.0.0 cas.criteo.com
0.0.0.0 dis.criteo.com
0.0.0.0 dis.eu.criteo.com
0.0.0.0 dis.sv.us.criteo.com
0.0.0.0 dis.us.criteo.com
0.0.0.0 rtax.criteo.com
0.0.0.0 sapatoru.widget.criteo.com
0.0.0.0 static.criteo.net
0.0.0.0 static.eu.criteo.net
0.0.0.0 widget.criteo.com
0.0.0.0 www.criteo.com
# [Cable & Wireless][AS1273][63.130.0.0 - 63.130.255.255]
0.0.0.0 cdn.adnxs.com
0.0.0.0 search.ipromote.com
# [Cybercon][AS7393][64.37.82.96 - 64.37.82.127]
0.0.0.0 api.wundercounter.com
0.0.0.0 www.wundercounter.com
# [Cyberwebhosting][AS8893][212.72.183.0 - 212.72.183.255]
0.0.0.0 www.gratis-toplist.de
# [Cybernet Quest]
0.0.0.0 cqcounter.com #[WebBug]
0.0.0.0 img.cqcounter.com
0.0.0.0 nl.cqcounter.com
0.0.0.0 no.2.cqcounter.com
0.0.0.0 se.cqcounter.com
0.0.0.0 xxx.cqcounter.com
0.0.0.0 zz.cqcounter.com
0.0.0.0 ar.2.cqcounter.com
0.0.0.0 au.2.cqcounter.com
0.0.0.0 bg.2.cqcounter.com
0.0.0.0 ca.2.cqcounter.com
0.0.0.0 de.2.cqcounter.com
0.0.0.0 fr.2.cqcounter.com
0.0.0.0 nz.2.cqcounter.com
0.0.0.0 si.2.cqcounter.com
0.0.0.0 th.2.cqcounter.com
0.0.0.0 tr.2.cqcounter.com
0.0.0.0 uk.2.cqcounter.com
0.0.0.0 us.2.cqcounter.com #[Wildcard DNS]
0.0.0.0 us.cqcounter.com
0.0.0.0 1au.cqcounter.com
0.0.0.0 1bm.cqcounter.com
0.0.0.0 1ca.cqcounter.com
0.0.0.0 1de.cqcounter.com
0.0.0.0 1es.cqcounter.com
0.0.0.0 1fr.cqcounter.com
0.0.0.0 1in.cqcounter.com
0.0.0.0 1it.cqcounter.com
0.0.0.0 1jo.cqcounter.com
0.0.0.0 1nl.cqcounter.com
0.0.0.0 1pt.cqcounter.com
0.0.0.0 1se.cqcounter.com
0.0.0.0 1si.cqcounter.com
0.0.0.0 1th.cqcounter.com
0.0.0.0 1tr.cqcounter.com
0.0.0.0 1ua.cqcounter.com
0.0.0.0 1uk.cqcounter.com
0.0.0.0 1us.cqcounter.com
0.0.0.0 1xxx.cqcounter.com
0.0.0.0 www2.cqcounter.com
0.0.0.0 www.cqcounter.com
0.0.0.0 counter.w3open.com
0.0.0.0 ns2.w3open.com
# [Dacom / Korea Network][AS3786][117.52.0.0 - 117.52.255.255]
0.0.0.0 ad.koreadaily.com
# [Dacom / Korea Network][AS3786][211.234.96.0 - 211.234.127.255]
0.0.0.0 gtb5.acecounter.com
0.0.0.0 gtb19.acecounter.com
0.0.0.0 gtcc1.acecounter.com
0.0.0.0 gtp1.acecounter.com #[Tracking.Cookie]
0.0.0.0 gtp16.acecounter.com
0.0.0.0 wgc1.acecounter.com
# [Dacom / Korea Network][AS3786][222.231.0.0 - 222.231.63.255]
0.0.0.0 ads.fooyoh.com
# [Data Centers / AdOn Network][AS12025][69.71.57.0 - 69.71.57.255]
0.0.0.0 rmedia.adonnetwork.com
# [Data Centers / Dark Castle][AS12025][72.44.193.0 - 72.44.193.255]
0.0.0.0 banners.camdough.com
# [Datacenter D.o.o][AS41427][193.164.137.0 - 193.164.141.255]
0.0.0.0 ad.httpool.com
0.0.0.0 aurelius.httpool.com
0.0.0.0 trajan.httpool.com
# [Datagroup][AS21219][80.91.176.128 - 80.91.176.255]
0.0.0.0 nsrecord.org
# [Datapipe][AS24043][122.200.132.0 - 122.200.135.255]
0.0.0.0 sync.atomex.net
0.0.0.0 trk.atomex.net
# [DataPipe][AS22205][206.188.0.0 - 206.188.31.255]
# [DataPipe][AS14492][63.131.128.0 - 63.131.159.255]
0.0.0.0 www.xg4ken.com
# [DataPipe][AS14492][64.106.128.0 - 64.106.255.255]
0.0.0.0 www.admarketplace.net
0.0.0.0 beacon.searchlinks.com
0.0.0.0 banners.sys-con.com
# [DataPipe][AS14492]64.27.64.0 - 64.27.127.255]
0.0.0.0 pixel.adblade.com
0.0.0.0 pixel.industrybrains.com
0.0.0.0 web.industrybrains.com
0.0.0.0 image2.pubmatic.com
# [DataPipe / STANDARD INTERNET][65.17.198.120 - 65.17.198.129]
0.0.0.0 www.3dstats.com
0.0.0.0 adserv.net
# [DataPipe][66.70.0.0 - 66.70.127.255]
0.0.0.0 www.adwarespy.com #[Symantec.AdwareSpy]
0.0.0.0 affiliates.bhphotovideo.com
0.0.0.0 www.buildtraffic.com
0.0.0.0 www.buildtrafficx.com
0.0.0.0 www.eliteconcepts.com
0.0.0.0 www.loggerx.com
0.0.0.0 www.myaffiliateprogram.com
0.0.0.0 tracking.validclick.com
# [DataPipe][AS22576][69.170.128.0 - 69.170.143.255]
0.0.0.0 parking.parklogic.com #[Parking.Service]
# [Dedicated Server Range][AS5413][212.241.250.0 - 212.241.251.255]
0.0.0.0 www.almondnetworks.com
0.0.0.0 www.freedownloadzone.com #[ScamFraudAlert]
0.0.0.0 helpmedownload.com
0.0.0.0 www.helpmedownload.com
0.0.0.0 www.mp3downloadhq.com
0.0.0.0 www.mp3helpdesk.com
# [Defender Technologies][AS14383][74.200.64.0 - 74.200.95.255]
0.0.0.0 ads.cdrinfo.com
# [DemandMedia / Enom][AS21740][64.74.223.0 - 64.74.223.255]
0.0.0.0 bluehparking.com
# [DemandMedia / Enom][AS21740][69.64.144.0 - 69.64.159.255]
0.0.0.0 extended.dmtracker.com
0.0.0.0 video.dmtracker.com
0.0.0.0 vs.dmtracker.com
0.0.0.0 beacon.ehow.com
0.0.0.0 ads.i-am-bored.com
# [DemandMedia / Enom Incorporated][98.124.192.0 - 98.124.255.255]
0.0.0.0 beacon.cracked.com
0.0.0.0 external.dmtracker.com
0.0.0.0 parking.dmtracker.com
0.0.0.0 search.dmtracker.com
0.0.0.0 rte-img.nuseek.com
# [Denit / Cust-denit-id][AS25542][81.93.57.128 - 81.93.57.255]
0.0.0.0 rotator.tradetracker.net
0.0.0.0 ti.tradetracker.net
0.0.0.0 rotator.tradetracker.nl
0.0.0.0 ti.tradetracker.nl
# [Desync / Affinity][AS30217][207.36.0.0 - 207.36.255.255]
0.0.0.0 dsp.xapads.com
# [Desync / Neucom][AS30217][66.230.192.0 - 66.230.239.255]
0.0.0.0 www.linkreferral.com
0.0.0.0 mmm.vindy.com
# [Detik][AS24211][203.190.240.0 - 203.190.247.255]
0.0.0.0 adsbox.detik.com
0.0.0.0 analytic.detik.com
0.0.0.0 imagescroll.detik.com #[WebBug]
0.0.0.0 newopenx.detik.com
0.0.0.0 beta.newopenx.detik.com
0.0.0.0 o.detik.com #[WebBug]
0.0.0.0 detik.serving-sys.com
# [Deutsche Telekom][AS3320][80.156.84.0 - 80.156.87.255]
0.0.0.0 geolocation.t-online.de
# [Digital Network/ Cjsc][AS12695][213.248.36.0 - 213.248.36.255]
0.0.0.0 hit32.hotlog.ru
0.0.0.0 hit33.hotlog.ru
0.0.0.0 hit35.hotlog.ru
0.0.0.0 hit38.hotlog.ru
# [Digital Network/ Hosting and Colocation][AS12695][89.208.144.0 - 89.208.159.255]
0.0.0.0 lycosu.com
0.0.0.0 oneund.ru
0.0.0.0 go.oneund.ru
# [Digital Network/ Cjsc][AS12695][95.163.0.0 - 95.163.255.255]
0.0.0.0 hit39.hotlog.ru
0.0.0.0 hit41.hotlog.ru
0.0.0.0 js.hotlog.ru
# [Digital River][AS32081][174.46.0.0 - 174.47.255.255]
0.0.0.0 ads.glispa.com
# [Digital River][AS8182][207.250.205.0 - 207.250.205.255]
0.0.0.0 partners.mysavings.com
# [Digital River][Direct Response Technologies][AS8182][207.67.0.0 - 207.67.0.255]
0.0.0.0 network.advplace.com
0.0.0.0 cashcownetworks.com
0.0.0.0 media.cashcownetworks.com
0.0.0.0 clickauditor.net
0.0.0.0 directleads.com
0.0.0.0 tracking.fathomseo.com
0.0.0.0 keywordmax.com
0.0.0.0 www.keywordmax.com
0.0.0.0 show.onenetworkdirect.net
0.0.0.0 login.tracking101.com #[Tracking.Cookie]
# [Direct Information Group][Parking Service]
0.0.0.0 images.bmnq.com
0.0.0.0 images.cnomy.com
0.0.0.0 ads.webhosting.info
# [Disney Company][ABC News][INFOSEEK]
# 0.0.0.0 hb.disney.go.com #[affects links]
0.0.0.0 seavideo-ak.espn.go.com
0.0.0.0 adsatt.abcnews.starwave.com
0.0.0.0 adsatt.disney.starwave.com
0.0.0.0 adsatt.espn.go.com
0.0.0.0 adsatt.espn.starwave.com
0.0.0.0 adsatt.familyfun.starwave.com
0.0.0.0 adsatt.go.starwave.com
0.0.0.0 adsatt.movies.starwave.com
0.0.0.0 espn-ak.starwave.com
0.0.0.0 odc.starwave.com
# [Disney Online][AS8137][198.105.192.0 - 198.105.199.255]
0.0.0.0 dcapps.disney.go.com #[WebBug]
# [Disney Worldwide][199.181.129.0 - 199.181.135.255]
0.0.0.0 ngads.go.com
0.0.0.0 ad.infoseek.com
# [Disney Online][68.71.208.0 - 68.71.223.255]
0.0.0.0 ad.go.com
0.0.0.0 adimages.go.com
0.0.0.0 ctologger01.analytics.go.com
# [Dotster Inc][AS14744][66.11.230.0 - 66.11.230.255]
0.0.0.0 www.cyberzine.com
# [Doubleverify][AS36062][204.154.110.0 - 204.154.111.255]
0.0.0.0 rtb3.doubleverify.com
0.0.0.0 tps30.doubleverify.com
# [DreamHost][208.113.128.0 - 208.113.255.255]
0.0.0.0 oxen.hillcountrytexas.com
# [DreamHost][AS26347][64.111.96.0 - 64.111.127.255]
0.0.0.0 linkjumps.com
# [DreamHost][66.33.192.0 - 66.33.223.255]
0.0.0.0 counter.dreamhost.com
# [DreamHost][AS26347][69.163.128.0 - 69.163.191.255]
0.0.0.0 ads.dkelseymedia.com
0.0.0.0 www.superbanner.org
# [Dwd Technologies][AS46173][208.92.160.0 - 208.92.167.255]
# [e Machines / Quinstreet][AS25878][70.42.22.0 - 70.42.23.255]
0.0.0.0 bilbob.com
0.0.0.0 didtal.com
0.0.0.0 hartim.com
0.0.0.0 www.qsstats.com
0.0.0.0 quinst.com
# [EdgeCast][AS15133][117.18.232.0 - 117.18.239.255]
0.0.0.0 tags.bkrtx.com
0.0.0.0 banners.videosecrets.com
# [EdgeCast][AS15133][152.176.0.0 - 152.199.255.255]
0.0.0.0 cdn.assets.craveonline.com
# [EdgeCast Networks][AS15133][192.229.128.0 - 192.229.255.255]
0.0.0.0 cdata.carambo.la
0.0.0.0 static-bp.kameleoon.com
0.0.0.0 secure-ads.pictela.net
# [EdgeCast][AS15133][68.232.32.0 - 68.232.47.255]
0.0.0.0 cdn.engine.4dsply.com
0.0.0.0 i.blogads.com
0.0.0.0 pxl.ibpxl.com
0.0.0.0 native.sharethrough.com
0.0.0.0 cdn.tagcommander.com
# [EdgeCast][AS15133][72.21.80.0 - 72.21.95.255]
0.0.0.0 adv.0tub.com
0.0.0.0 cdn1.adadvisor.net
0.0.0.0 cdn.adgear.com
0.0.0.0 www.ad4mat.at
0.0.0.0 www.ad4mat.de
0.0.0.0 cdn.engine.adsupply.com
0.0.0.0 ads.adultfriendfinder.com
0.0.0.0 ads.adxpansion.com
0.0.0.0 media.adxpansion.com
0.0.0.0 ads.alt.com
0.0.0.0 ads.amigos.com
0.0.0.0 ads.asiafriendfinder.com
0.0.0.0 edge.ayboll.com
0.0.0.0 static.clicktripz.com
0.0.0.0 cdn.crowdtwist.com
0.0.0.0 ads.friendfinder.com
0.0.0.0 media.go2speed.org
0.0.0.0 resources.infolinks.com
0.0.0.0 e.invodo.com
0.0.0.0 ads.jewishfriendfinder.com
0.0.0.0 sec.levexis.com
0.0.0.0 mproxy.banner.linksynergy.com
0.0.0.0 media.livepromotools.com
0.0.0.0 graphics.medleyads.com
0.0.0.0 ads.millionairemate.com
0.0.0.0 cdn.orbengine.com
0.0.0.0 ads.outpersonals.com
0.0.0.0 cdn.pardot.com
0.0.0.0 ads.passion.com
0.0.0.0 content.pop6.com
0.0.0.0 media.pussycash.com
0.0.0.0 tdn.r42tag.com
0.0.0.0 cdna.runadtag.com
0.0.0.0 ads.seniorfriendfinder.com
0.0.0.0 cdn1.skinected.com
0.0.0.0 rome.specificclick.net
0.0.0.0 cdn1.steelhousemedia.com
0.0.0.0 cdn4s.steelhousemedia.com
0.0.0.0 www.synovite-scripts.com
0.0.0.0 loader.topadvert.ru
0.0.0.0 tcr.tynt.com
0.0.0.0 cts.w55c.net
0.0.0.0 images.webads.nl
0.0.0.0 images.webads.co.uk
0.0.0.0 static.woopra.com
# [EdgeCast][AS15133][93.184.216.0 - 93.184.223.255]
0.0.0.0 g.3gl.net
0.0.0.0 adcdn.33universal.com
0.0.0.0 static.cdn.adblade.com
0.0.0.0 y.cdn.adblade.com
0.0.0.0 adunit.cdn.auditude.com
0.0.0.0 ndn.cdn.auditude.com
0.0.0.0 cdn.bizible.com
0.0.0.0 cv.bsvideos.com
# 0.0.0.0 livepassdl.conviva.com #[affects videos]
0.0.0.0 banners.crakcash.com
0.0.0.0 ebocornac.com
0.0.0.0 herezera.com
0.0.0.0 pixel.indieclick.com
0.0.0.0 staticd.cdn.industrybrains.com
0.0.0.0 electosake.com
0.0.0.0 letzonke.com
0.0.0.0 engine.spotscenered.info
0.0.0.0 c.supert.ag
# 0.0.0.0 tags.tiqcdn.com #[affects Intel.com/Shaw]
0.0.0.0 tororango.com
0.0.0.0 cdn.engine.trklnks.com
0.0.0.0 ads.w55c.net
0.0.0.0 img1.zergnet.com
0.0.0.0 img2.zergnet.com
0.0.0.0 img3.zergnet.com
0.0.0.0 img4.zergnet.com
# [Elite Internet][AS36643][208.65.200.0 - 208.65.203.255]
0.0.0.0 ads.amdmb.com
0.0.0.0 dynamic1.anandtech.com
0.0.0.0 dynamic2.anandtech.com
0.0.0.0 dynamic1.dailytech.com
# [Eloqua / Oracle][AS54253][209.167.0.0 - 209.167.255.255]
0.0.0.0 now.eloqua.com #[WebBug][Tracking.Cookie]
0.0.0.0 s323.t.eloqua.com
0.0.0.0 s1184.t.eloqua.com
0.0.0.0 s1325.t.eloqua.com
0.0.0.0 s1471.t.eloqua.com
0.0.0.0 s1481.t.eloqua.com
0.0.0.0 s2150.t.eloqua.com #[WebBug]
0.0.0.0 s3015.t.eloqua.com
# [Endurance International][65.254.224.0 - 65.254.255.255]
0.0.0.0 amare.softwaregarden.com #[Win32/TrojanDownloader.Small.AWA]
# [Endurance International][AS29873][66.96.128.0 - 66.96.191.255]
0.0.0.0 hitpro.us
0.0.0.0 www.hitpro.us
0.0.0.0 iframes.us
0.0.0.0 www.iframes.us
0.0.0.0 www.targeted-banners.com
# [Equinoxe Media / EdenCast BV [AS35070]
0.0.0.0 banners.direction-x.com
0.0.0.0 599.stats.misstrends.com
0.0.0.0 602.stats.misstrends.com
0.0.0.0 604.stats.misstrends.com
0.0.0.0 606.stats.misstrends.com
0.0.0.0 654.stats.misstrends.com
0.0.0.0 671.stats.misstrends.com
0.0.0.0 680.stats.misstrends.com
0.0.0.0 699.stats.misstrends.com
0.0.0.0 726.stats.misstrends.com
0.0.0.0 750.stats.misstrends.com
0.0.0.0 803.stats.misstrends.com
0.0.0.0 879.stats.misstrends.com
0.0.0.0 986.stats.misstrends.com
0.0.0.0 1559.stats.misstrends.com
0.0.0.0 1800.stats.misstrends.com
0.0.0.0 1867.stats.misstrends.com
0.0.0.0 2278.stats.misstrends.com
0.0.0.0 4184.stats.misstrends.com
# [Ethernetix / LivePerson][AS11054][208.89.12.0 - 208.89.15.255]
0.0.0.0 www.humanclick.com
0.0.0.0 hc2.humanclick.com #[Tracking.Cookie]
# 0.0.0.0 wizard.liveperson.com
# 0.0.0.0 www.liveperson.com #[affects citi.com]
# 0.0.0.0 liveperson.net
# 0.0.0.0 lptag.liveperson.net
# 0.0.0.0 sales.liveperson.net #[affects Live Chat]
# 0.0.0.0 sec1.liveperson.net
# 0.0.0.0 server.iad.liveperson.net
# [Euroaccess][AS34305][193.138.220.0 - 193.138.231.255]
0.0.0.0 www.hostedbanners.com
0.0.0.0 landingpages.sunnytoolz.com
# [Euroaccess][AS34305][85.12.0.0 - 85.12.63.255]
0.0.0.0 ads.guru3d.com
0.0.0.0 banner1.pornhost.com
# [Eurocolo][AS35230][83.143.168.0 - 83.143.175.255]
0.0.0.0 ad3.hornymatches.com
# [Eurohost][AS48841][91.212.65.0 - 91.212.65.255]
# [Euro Web][AS35393][91.191.144.0 - 91.191.144.255]
0.0.0.0 banner.adserverpub.com
0.0.0.0 js.adserverpub.com
0.0.0.0 www2.adserverpub.com
# [Eveloz][AS27716][200.63.46.128/29]
# [Everydns][AS15135][208.76.56.0 - 208.76.63.255]
# [eXact Advertising LLC][Innovation Interactive][360i LLC]
0.0.0.0 images.brainfox.com
0.0.0.0 search.brainfox.com
0.0.0.0 www.brainfox.com
0.0.0.0 results.cafefind.net
0.0.0.0 www.exactadvertising.com
0.0.0.0 leadgenetwork.com
0.0.0.0 www.leadgenetwork.com
# [Express Technologies][AS4378][216.74.0.0 - 216.74.63.255]
0.0.0.0 gamevance.com #[Trojan-Downloader.Win32.Small.gkk]
0.0.0.0 www.gamevance.com
# [Ezzi.net][AS15149][216.150.64.0 - 216.150.95.255]
0.0.0.0 ad7.literotica.com
0.0.0.0 r1.literotica.com
# [Facebook][AS32934][31.13.71.0 - 31.13.71.255]
0.0.0.0 cx.atdmt.com
0.0.0.0 cdn.atlassbx.com
0.0.0.0 pixel.facebook.com
# [Fasthosts][AS15418][77.68.32.0 - 77.68.63.255]
0.0.0.0 ads.skupe.net
# [Fasthosts][AS15418][88.208.228.0 - 88.208.251.255]
0.0.0.0 005.free-counter.co.uk
0.0.0.0 006.free-counter.co.uk
0.0.0.0 008.free-counter.co.uk
0.0.0.0 008.free-counters.co.uk
# [Fastit-de-dus1-ADITION][AS24961][217.79.188.0 - 217.79.188.63]
0.0.0.0 ad1.adfarm1.adition.com
0.0.0.0 ad2.adfarm1.adition.com
0.0.0.0 ad3.adfarm1.adition.com
0.0.0.0 ad4.adfarm1.adition.com
0.0.0.0 static.adfarm1.adition.com
# [Fast It Colocation][AS24961][85.114.140.0 - 85.114.143.255]
0.0.0.0 ad11.adfarm1.adition.com
0.0.0.0 dsp.adfarm1.adition.com
0.0.0.0 rtb.metrigo.com
0.0.0.0 ad.traffique.net
# [Fast It Colocation][AS24961][89.163.128.0 - 89.163.255.255]
0.0.0.0 xpl.theadex.com
# [Fastly][AS54113][23.185.0.0/24]
0.0.0.0 treasuredata.com
0.0.0.0 api.treasuredata.com
# [Fastly][AS54113][151.101.0.0 - 151.101.255.255]
0.0.0.0 geoip.businessinsider.com
0.0.0.0 bh.contextweb.com
0.0.0.0 bid.contextweb.com
0.0.0.0 cdslog.contextweb.com
0.0.0.0 media.contextweb.com
0.0.0.0 tag.contextweb.com
0.0.0.0 tag-st.contextweb.com
0.0.0.0 sync-tm.everesttech.net
0.0.0.0 paid.outbrain.com
0.0.0.0 trc.taboola.com
0.0.0.0 beacon.wikia-services.com
# [Fdcservers.net][AS30058][208.53.128.0 - 208.53.191.255]
0.0.0.0 banners.virtuagirlhd.com
0.0.0.0 cbanners.virtuagirlhd.com
# [Fdcservers.net / Acceas Partners][66.90.64.0 - 66.90.127.255]
0.0.0.0 www.tostadomedia.com
# [Fdcservers.net][74.63.64.0 - 74.63.95.255]
0.0.0.0 www.1freecounter.com
# [Fdcservers.net][76.73.0.0 - 76.73.127.255]
0.0.0.0 jizzads.com
0.0.0.0 www.jizzads.com
# [Fibernet][AS5048][216.83.128.0 - 216.83.159.255]
0.0.0.0 dce.nextstat.com
0.0.0.0 hits.nextstat.com
0.0.0.0 hv3.webstat.com
0.0.0.0 hits.webstat.com #[Tracking.Cookie]
# [Firstlook][AS40634][208.87.148.0 - 208.87.151.255]
0.0.0.0 areasnap.com #[Parking.Service]
# [Fluent Ltd][AS39779][195.78.94.0 - 195.78.95.255]
0.0.0.0 uk.ads.hexus.net
0.0.0.0 adserver4.fluent.ltd.uk
0.0.0.0 hexusads.fluent.ltd.uk
# [Fox Interactive Media / News Corp]
0.0.0.0 ads.ign.com #[Tracking.Cookie]
0.0.0.0 nb.myspace.com #[WebBug]
# [Fox Interactive / MySpace][216.178.32.0 - 216.178.47.255]
0.0.0.0 fimserve.askmen.com
0.0.0.0 fimserve.ign.com #[fimserve.myspace.com]
0.0.0.0 delb.myspace.com #[ad.yieldmanager.com]
0.0.0.0 delb2.myspace.com #[media.fimnetwork.com]
0.0.0.0 demr.myspace.com #[media.fimnetwork.com]
0.0.0.0 fimserve.myspace.com
# [Fox Interactive / MySpace][AS33739][63.135.80.0 - 63.135.95.255]
0.0.0.0 mpp.specificclick.net
0.0.0.0 mpp.vindicosuite.com
# [Fox Interactive / Ign Entertainment][207.38.8.0 - 207.38.15.255]
0.0.0.0 adcontent.gamespy.com
0.0.0.0 ads.gamespyid.com
# [Fox Interactive / Ign Entertainment][69.10.16.0 - 69.10.31.255]
0.0.0.0 wrapper.fileplanet.com
0.0.0.0 wrapper.giga.de
# [Freenet Ag][AS5430][62.104.23.64 - 62.104.23.127]
0.0.0.0 ad.cashdorado.de
0.0.0.0 adview.ppro.de
0.0.0.0 cdn.stroeerdigitalmedia.de
# [Freewheel Media][AS26558][217.156.128.0 - 217.156.255.255]
0.0.0.0 5d406.v.fwmrm.net
# [Freewheel Media][AS26558][63.251.0.0 - 63.251.255.255]
0.0.0.0 2822.v.fwmrm.net
0.0.0.0 2945.v.fwmrm.net
0.0.0.0 5d4a1.v.fwmrm.net
0.0.0.0 g1.v.fwmrm.net
# [Freewheel Media][AS26558][74.217.66.0 - 74.217.66.255]
0.0.0.0 1c6e2.v.fwmrm.net
0.0.0.0 2df7e.v.fwmrm.net
0.0.0.0 5bde1.v.fwmrm.net
# 0.0.0.0 140cc.v.fwmrm.net #[affects videos]
0.0.0.0 2975c.v.fwmrm.net
0.0.0.0 29773.v.fwmrm.net
0.0.0.0 bea4.v.fwmrm.net
0.0.0.0 m.v.fwmrm.net
# [Freewheel Media][AS26558][75.98.70.0 - 75.98.70.255]
0.0.0.0 2ab7f.v.fwmrm.net
0.0.0.0 29ccd.v.fwmrm.net
# [Friendfinder Networks][AS25875][AS32527][208.88.176.0 - 208.88.183.255]
0.0.0.0 adultfriendfinder.com #[Tracking.Cookie]
0.0.0.0 adserver.adultfriendfinder.com
0.0.0.0 banners.adultfriendfinder.com
0.0.0.0 cover9.adultfriendfinder.com
0.0.0.0 geobanner.adultfriendfinder.com
0.0.0.0 guest.adultfriendfinder.com
0.0.0.0 iframe.adultfriendfinder.com #[Adware.Redalert]
0.0.0.0 option9.adultfriendfinder.com
0.0.0.0 pop6.adultfriendfinder.com
0.0.0.0 tgp.adultfriendfinder.com #[cams.com]
0.0.0.0 www.adultfriendfinder.com #[Troj/Small-AG][Adware-Adroar.dll]
0.0.0.0 adserver.alt.com
0.0.0.0 banners.alt.com
0.0.0.0 banners.amigos.com
0.0.0.0 adserver.asiafriendfinder.com
0.0.0.0 banners.asiafriendfinder.com
0.0.0.0 banners.bigchurch.com
0.0.0.0 ads.bondage.com
0.0.0.0 adserver.bondage.com
0.0.0.0 adserver.cams.com
0.0.0.0 banners.cams.com
0.0.0.0 promo.cams.com
0.0.0.0 adserver.friendfinder.com
0.0.0.0 banners.friendfinder.com
0.0.0.0 geobanner.friendfinder.com
0.0.0.0 openads.friendfinder.com
0.0.0.0 banners.fuckbookhookups.com
0.0.0.0 banners.gayfriendfinder.com
0.0.0.0 getiton.com
0.0.0.0 banners.getiton.com
0.0.0.0 geobanner.getiton.com
0.0.0.0 banners.icams.com
0.0.0.0 banners.jewishfriendfinder.com
0.0.0.0 medleyads.com
0.0.0.0 www.medleyads.com
0.0.0.0 adserver.millionairemate.com
0.0.0.0 banners.millionairemate.com
0.0.0.0 adserver.outpersonals.com
0.0.0.0 banners.outpersonals.com
0.0.0.0 adserver.passion.com
0.0.0.0 banner.passion.com
0.0.0.0 banners.passion.com
0.0.0.0 geobanner.passion.com
0.0.0.0 banners.penthouse.com
0.0.0.0 glean.pop6.com
0.0.0.0 adserver.seniorfriendfinder.com
0.0.0.0 banners.seniorfriendfinder.com
0.0.0.0 geobanner.seniorfriendfinder.com
0.0.0.0 affiliates.streamray.com
0.0.0.0 free.content.streamray.com
0.0.0.0 livecamgirls.streamray.com
0.0.0.0 banners.swapfinder.com
0.0.0.0 free.thesocialsexnetwork.com
# [Friendfinder][AS25875][69.165.96.0 - 69.165.111.255]
0.0.0.0 secure.medleyads.com
# [Fusepoint][AS16941][72.35.0.0 - 72.35.31.255]
0.0.0.0 media.foundry42.com
# [Gamma / Ifuzion][AS14720][38.80.66.0/24]
0.0.0.0 ads.pornerbros.com
# [Gamma Networking][AS14720][66.152.64.0 - 66.152.95.255]
0.0.0.0 cs.adxpansion.com
0.0.0.0 www.adxpansion.com
0.0.0.0 site.falconbucks.com
0.0.0.0 ad2.gammae.com
0.0.0.0 internalads.gammae.com
0.0.0.0 ads.givemegay.com
0.0.0.0 www.linkfame.com
0.0.0.0 1274.mediatraffic.com
0.0.0.0 www.mediatraffic.com
0.0.0.0 www.surfaccuracy.com
0.0.0.0 ads.sxx.com
0.0.0.0 ads.vipcams.com
# [GeMius]
0.0.0.0 15minadlt.hit.gemius.pl
0.0.0.0 hit.gemius.pl #[Tracking.Cookie]
0.0.0.0 activeby.hit.gemius.pl
0.0.0.0 ad.hit.gemius.pl
0.0.0.0 adactiongapl.hit.gemius.pl
0.0.0.0 adafi.hit.gemius.pl
0.0.0.0 adbg.hit.gemius.pl
0.0.0.0 adclick.hit.gemius.pl
0.0.0.0 adcz.hit.gemius.pl
0.0.0.0 adee.hit.gemius.pl
0.0.0.0 adhr.hit.gemius.pl
0.0.0.0 adlt.hit.gemius.pl
0.0.0.0 adlv.hit.gemius.pl
0.0.0.0 adnet.hit.gemius.pl
0.0.0.0 adnetgalt.hit.gemius.pl
0.0.0.0 adocean-by.hit.gemius.pl
0.0.0.0 adocean-cz.hit.gemius.pl
0.0.0.0 adocean-ee.hit.gemius.pl
0.0.0.0 adocean-hr.hit.gemius.pl
0.0.0.0 adocean-lt.hit.gemius.pl
0.0.0.0 adocean-lv.hit.gemius.pl
0.0.0.0 adocean-pl.hit.gemius.pl
0.0.0.0 adocean-ro.hit.gemius.pl
0.0.0.0 adocean-si.hit.gemius.pl
0.0.0.0 adocean-ua.hit.gemius.pl
0.0.0.0 adro.hit.gemius.pl
0.0.0.0 adrs.hit.gemius.pl
0.0.0.0 advice.hit.gemius.pl
0.0.0.0 advicead.hit.gemius.pl
0.0.0.0 aolt.hit.gemius.pl
0.0.0.0 aolv.hit.gemius.pl
0.0.0.0 apolloadlv.hit.gemius.pl
0.0.0.0 arbo.hit.gemius.pl
0.0.0.0 aripaadee.hit.gemius.pl
0.0.0.0 avt.hit.gemius.pl
0.0.0.0 allegro.hit.gemius.pl
0.0.0.0 axel.hit.gemius.pl
0.0.0.0 b92adrs.hit.gemius.pl
0.0.0.0 bestjobs.hit.gemius.pl
0.0.0.0 bg.hit.gemius.pl
0.0.0.0 blitzadbg.hit.gemius.pl
0.0.0.0 centrumcz.hit.gemius.pl
0.0.0.0 corm.hit.gemius.pl
0.0.0.0 cz.hit.gemius.pl
0.0.0.0 darikspaceadbg.hit.gemius.pl
0.0.0.0 delfiadlt.hit.gemius.pl
0.0.0.0 delfiadlv.hit.gemius.pl
0.0.0.0 delfiadee.hit.gemius.pl
0.0.0.0 delfilv.hit.gemius.pl
0.0.0.0 diginetlt.hit.gemius.pl
0.0.0.0 digital4adro.hit.gemius.pl
0.0.0.0 dirbg.hit.gemius.pl
0.0.0.0 edipresse.hit.gemius.pl
0.0.0.0 ee.hit.gemius.pl
0.0.0.0 eega.hit.gemius.pl
0.0.0.0 eniro.hit.gemius.pl
0.0.0.0 gaae.hit.gemius.pl
0.0.0.0 gaat.hit.gemius.pl
0.0.0.0 gaba.hit.gemius.pl
0.0.0.0 gabe.hit.gemius.pl
0.0.0.0 gabg.hit.gemius.pl
0.0.0.0 gaby.hit.gemius.pl
0.0.0.0 gacz.hit.gemius.pl
0.0.0.0 gadk.hit.gemius.pl
0.0.0.0 gaee.hit.gemius.pl
0.0.0.0 gadnet.hit.gemius.pl
0.0.0.0 gahu.hit.gemius.pl
0.0.0.0 gajo.hit.gemius.pl
0.0.0.0 gail.hit.gemius.pl
0.0.0.0 gakz.hit.gemius.pl
0.0.0.0 galb.hit.gemius.pl
0.0.0.0 galindia.hit.gemius.pl
0.0.0.0 galt.hit.gemius.pl
0.0.0.0 galv.hit.gemius.pl
0.0.0.0 gamd.hit.gemius.pl
0.0.0.0 gamk.hit.gemius.pl
0.0.0.0 gapl.hit.gemius.pl
0.0.0.0 gars.hit.gemius.pl
0.0.0.0 garo.hit.gemius.pl
0.0.0.0 garu.hit.gemius.pl
0.0.0.0 gask.hit.gemius.pl
0.0.0.0 gatr.hit.gemius.pl
0.0.0.0 gaua.hit.gemius.pl
0.0.0.0 gazeta.hit.gemius.pl
0.0.0.0 gdeua.hit.gemius.pl
0.0.0.0 gdebg.hit.gemius.pl
0.0.0.0 gdeil.hit.gemius.pl
0.0.0.0 gdelt.hit.gemius.pl
0.0.0.0 gdecz.hit.gemius.pl
0.0.0.0 gdelv.hit.gemius.pl
0.0.0.0 gdesk.hit.gemius.pl
0.0.0.0 gders.hit.gemius.pl
0.0.0.0 gdetr.hit.gemius.pl
0.0.0.0 gemadhu.hit.gemius.pl
0.0.0.0 generalmediaadhu.hit.gemius.pl
0.0.0.0 gg.hit.gemius.pl
0.0.0.0 gde-default.hit.gemius.pl
0.0.0.0 ghmme.hit.gemius.pl
0.0.0.0 ghmbg.hit.gemius.pl
0.0.0.0 ghmhu.hit.gemius.pl
0.0.0.0 ghmpl.hit.gemius.pl
0.0.0.0 ghmrs.hit.gemius.pl
0.0.0.0 goldbach.hit.gemius.pl
0.0.0.0 gspro.hit.gemius.pl
0.0.0.0 gtlt.hit.gemius.pl
0.0.0.0 gtlv.hit.gemius.pl
0.0.0.0 gttr.hit.gemius.pl
0.0.0.0 idg.hit.gemius.pl
0.0.0.0 hr.hit.gemius.pl
0.0.0.0 hu.hit.gemius.pl
0.0.0.0 huadn.hit.gemius.pl
0.0.0.0 icorpadro.hit.gemius.pl
0.0.0.0 idm.hit.gemius.pl
0.0.0.0 interia.hit.gemius.pl
0.0.0.0 investoradbg.hit.gemius.pl
0.0.0.0 keepaneyeadmk.hit.gemius.pl
0.0.0.0 kon.hit.gemius.pl
0.0.0.0 lrytasadlt.hit.gemius.pl
0.0.0.0 ls.hit.gemius.pl
0.0.0.0 lt.hit.gemius.pl
0.0.0.0 lv.hit.gemius.pl
0.0.0.0 mbank.hit.gemius.pl
0.0.0.0 mediaregad.hit.gemius.pl
0.0.0.0 metagaua.hit.gemius.pl
0.0.0.0 mreg.hit.gemius.pl
0.0.0.0 negadbg.hit.gemius.pl
0.0.0.0 netsprint.hit.gemius.pl
0.0.0.0 neogenadro.hit.gemius.pl
0.0.0.0 o2.hit.gemius.pl
0.0.0.0 o2adpl.hit.gemius.pl
0.0.0.0 oglasnikadhr.hit.gemius.pl
0.0.0.0 ohtulehtadee.hit.gemius.pl
0.0.0.0 olx.hit.gemius.pl
0.0.0.0 onet.hit.gemius.pl
0.0.0.0 opt.hit.gemius.pl
0.0.0.0 prefix.hit.gemius.pl
0.0.0.0 pracuj.hit.gemius.pl
0.0.0.0 pro.hit.gemius.pl
0.0.0.0 protvadmd.hit.gemius.pl
0.0.0.0 rbcgaru.hit.gemius.pl
0.0.0.0 realitateadro.hit.gemius.pl
0.0.0.0 ringieradrs.hit.gemius.pl
0.0.0.0 ringieradro.hit.gemius.pl
0.0.0.0 ro.hit.gemius.pl
0.0.0.0 ro1adro.hit.gemius.pl
0.0.0.0 rp.hit.gemius.pl
0.0.0.0 scz.hit.gemius.pl
0.0.0.0 see.hit.gemius.pl
0.0.0.0 seznam.hit.gemius.pl
0.0.0.0 si.hit.gemius.pl
0.0.0.0 sk.hit.gemius.pl
0.0.0.0 slovakia.hit.gemius.pl
0.0.0.0 slt.hit.gemius.pl
0.0.0.0 spir.hit.gemius.pl
0.0.0.0 spl.hit.gemius.pl
0.0.0.0 sportaladbg.hit.gemius.pl
0.0.0.0 st.hit.gemius.pl
0.0.0.0 st1.hit.gemius.pl
0.0.0.0 std1.hit.gemius.pl #[WebBug]
0.0.0.0 str.hit.gemius.pl
0.0.0.0 stua.hit.gemius.pl
0.0.0.0 thinkdigitaladro.hit.gemius.pl
0.0.0.0 tr.hit.gemius.pl
0.0.0.0 tvn.hit.gemius.pl
0.0.0.0 ua.hit.gemius.pl
0.0.0.0 vbadbg.hit.gemius.pl
0.0.0.0 webgroundadbg.hit.gemius.pl
0.0.0.0 wp.hit.gemius.pl
0.0.0.0 wykop.hit.gemius.pl
0.0.0.0 home.hit.stat.pl
0.0.0.0 onet.hit.stat.pl
0.0.0.0 s1.hit.stat.pl
0.0.0.0 s2.hit.stat.pl
0.0.0.0 s3.hit.stat.pl
0.0.0.0 s4.hit.stat.pl
0.0.0.0 sisco.hit.stat.pl
0.0.0.0 www.stat.pl
# [Giga-hosting][AS51167][178.238.233.0 - 178.238.233.255]
0.0.0.0 baner.energy-torrent.com
# [Gigenet][AS32181][209.212.144.0 - 209.212.159.255]
0.0.0.0 contentwidgets.net
# [Gigenet / Cloud][AS32181][66.55.80.0 - 66.55.95.255]
0.0.0.0 ads-by.madadsmedia.com
0.0.0.0 ads-by.yieldselect.com
# [Gigenet][AS32181][69.39.224.0 - 69.39.239.255]
0.0.0.0 ibmvideo.com
0.0.0.0 intermediaceli.com
# [Gigenet][AS32181][69.65.0.0 - 69.65.63.255]
0.0.0.0 c0.amazingcounters.com
0.0.0.0 c1.amazingcounters.com
0.0.0.0 c2.amazingcounters.com
0.0.0.0 c3.amazingcounters.com
0.0.0.0 c4.amazingcounters.com
0.0.0.0 c5.amazingcounters.com
0.0.0.0 c6.amazingcounters.com
0.0.0.0 c7.amazingcounters.com
0.0.0.0 c8.amazingcounters.com
0.0.0.0 c9.amazingcounters.com
0.0.0.0 cb.amazingcounters.com
0.0.0.0 www.amazingcounters.com
0.0.0.0 ads.betanews.com
0.0.0.0 m.usersonline.com #[WebBug]
# [Gigya][AS44399][74.120.148.0 - 74.120.151.255]
0.0.0.0 gscounters.gigya.com
0.0.0.0 gscounters.us1.gigya.com
# [Global Compass / Cyber Wurx][AS22653][66.154.0.0 - 66.154.95.255]
0.0.0.0 www.adultadbroker.com
0.0.0.0 www.buy404s.com
0.0.0.0 domainplayersclub.com
0.0.0.0 reviews.domainplayersclub.com
0.0.0.0 ebtmarketing.com
0.0.0.0 www.ebtmarketing.com
0.0.0.0 www.exitforcash.com
0.0.0.0 www.fpcpopunder.com
0.0.0.0 popunder.fpctraffic.com
0.0.0.0 www.fpctraffic.com
0.0.0.0 fpctraffic2.com
0.0.0.0 www.fpctraffic2.com
0.0.0.0 www.freeezinebucks.com
0.0.0.0 frontpagecash.com
0.0.0.0 www.frontpagecash.com
# [Global Crossing][AS29973][206.165.0.0 - 206.165.255.255]
0.0.0.0 www.clickaction.net
0.0.0.0 server2.discountclick.com
# 0.0.0.0 link.p0.com #[Affects email newsletters]
# [Global Crossing][AS3549][208.48.224.0 - 208.51.255.255]
0.0.0.0 a.hspvst.com
# [Global Crossing][AS3549][64.211.0.0 - 64.214.223.255]
# 0.0.0.0 secure.footprint.net #[affects nfl.com]
# [Global Crossing][AS3549][64.208.42.0 - 64.208.43.255]
0.0.0.0 van.redlightcenter.com
0.0.0.0 webmaster.utherverse.com
# [Global Net Access][AS3595][216.180.224.0 - 216.180.255.255]
0.0.0.0 www.cpx24.com
# [Global Net Access][AS3595][63.247.64.0 - 63.247.95.255]
0.0.0.0 www.edomz.com
# [Global Net Access][AS3595][64.22.64.0 - 64.22.127.255]
# [Global Net Access][AS3595][72.9.224.0 - 72.9.255.255]
0.0.0.0 flagcounter.com
0.0.0.0 spads.yamx.com
# [Global Net Access][AS27413][74.81.64.0 - 74.81.95.255]
0.0.0.0 dft.cl.dynad.net
# [Global Netoptex][AS26914][69.80.192.0 - 69.80.223.255]
0.0.0.0 stat001.mylivepage.com
0.0.0.0 stat002.mylivepage.com
0.0.0.0 stat003.mylivepage.com
0.0.0.0 stat004.mylivepage.com
0.0.0.0 stat005.mylivepage.com
0.0.0.0 stat006.mylivepage.com
0.0.0.0 stat007.mylivepage.com
0.0.0.0 stat008.mylivepage.com
0.0.0.0 stat009.mylivepage.com
0.0.0.0 stat010.mylivepage.com
# [Godaddy.com][AS26496][162.209.0.0 - 162.209.127.255]
0.0.0.0 bounceexchange.com
# [Godaddy.com][AS26496][184.168.0.0 - 184.168.255.255]
0.0.0.0 www.digiaquascr.com #[AdWare.Win32.iBryte.jda]
# [Godaddy.com Netherlands][AS26496][188.121.32.0 - 188.121.63.255]
0.0.0.0 wms-tools.com
# [Godaddy.com][208.109.0.0 - 208.109.255.255]
0.0.0.0 codeads.com
0.0.0.0 www.codeads.com
0.0.0.0 www.freehitwebcounters.com
0.0.0.0 www.milesdebanners.com
0.0.0.0 www.otherossettlement.com
0.0.0.0 redemptionengine.com
0.0.0.0 www.redemptionengine.com
# [Godaddy.com][64.202.160.0 - 64.202.191.255]
0.0.0.0 images-pw.secureserver.net #[Parking Service]
# 0.0.0.0 images.secureserver.net #[affects GoDaddy]
0.0.0.0 ms-mvp.org
0.0.0.0 www.ms-mvp.org
# [Godaddy.com][AS26496][72.167.0.0 - 72.167.255.255]
# [Godaddy.com][97.74.0.0 - 97.74.255.255]
0.0.0.0 highpro1.com
# [Google][AS15169][104.154.0.0 - 104.199.255.255]
0.0.0.0 adexchangeprediction.com
0.0.0.0 static-trackers.adtarget.me
0.0.0.0 www.buzzadnetwork.com
0.0.0.0 www.buzzonclick.com
0.0.0.0 b.codeonclick.com
0.0.0.0 c.codeonclick.com
0.0.0.0 www.maxonclick.com
0.0.0.0 pixel.meteora.us
0.0.0.0 www.nanoadexchange.com
0.0.0.0 www.onclickpredictiv.com
0.0.0.0 pureadexchange.com
0.0.0.0 www.pureadexchange.com
0.0.0.0 pwrfcia.com
0.0.0.0 www.tradeadexchange.com
# [Google][AS15169][107.178.192.0 - 107.178.255.255]
0.0.0.0 trackers.adtarget.me
0.0.0.0 t.grtyb.com
0.0.0.0 ado.pro-market.net
0.0.0.0 k.streamrail.com
# [Google][AS15169][108.170.192.0 - 108.170.255.255]
0.0.0.0 conversion-pixel.invitemedia.com
# [Google][AS15169][130.211.0.0 - 130.211.255.255]
0.0.0.0 tracker.departapp.com
0.0.0.0 e100.yt.srs.doubleverify.com
0.0.0.0 e101.yt.srs.doubleverify.com
0.0.0.0 e102.yt.srs.doubleverify.com
0.0.0.0 e103.yt.srs.doubleverify.com
0.0.0.0 e104.yt.srs.doubleverify.com
0.0.0.0 e105.yt.srs.doubleverify.com
0.0.0.0 e106.yt.srs.doubleverify.com
0.0.0.0 e107.yt.srs.doubleverify.com
0.0.0.0 e108.yt.srs.doubleverify.com
0.0.0.0 e109.yt.srs.doubleverify.com
0.0.0.0 e110.yt.srs.doubleverify.com
0.0.0.0 e111.yt.srs.doubleverify.com
0.0.0.0 e112.yt.srs.doubleverify.com
0.0.0.0 opentag-stats.qubit.com
0.0.0.0 www7.securybrowse.com
# [Google][AS15169][172.217.0.0 - 172.217.255.255]
0.0.0.0 geoapi123.appspot.com
0.0.0.0 3642305.fls.doubleclick.net
0.0.0.0 3765329.fls.doubleclick.net
0.0.0.0 4514783.fls.doubleclick.net
0.0.0.0 4923503.fls.doubleclick.net
0.0.0.0 4942839.fls.doubleclick.net
0.0.0.0 5582200.fls.doubleclick.net
0.0.0.0 8210643.fls.doubleclick.net
0.0.0.0 8482194.fls.doubleclick.net
0.0.0.0 8563004.fls.doubleclick.net
0.0.0.0 adx.g.doubleclick.net
0.0.0.0 googleads4.g.doubleclick.net
0.0.0.0 pagead.l.doubleclick.net
0.0.0.0 pagead46.l.doubleclick.net
0.0.0.0 partnerad.l.doubleclick.net
0.0.0.0 undefined.fls.doubleclick.net
0.0.0.0 adservice.google.com
0.0.0.0 pagead-googlehosted.l.google.com
# [Google][AS15169][173.194.0.0 - 173.194.255.255]
0.0.0.0 5362399.fls.doubleclick.net
0.0.0.0 video-ad-stats.googlesyndication.com
# 0.0.0.0 redirector.googlevideo.com #[affects video playback]
# [Google / DoubleClick][AS15169][173.194.0.0 - 173.194.255.255]
0.0.0.0 dp.g.doubleclick.net
0.0.0.0 service.urchin.com #[Urchin Tracking Module]
# [Google / DoubleClick][AS15169][209.85.128.0 - 209.85.255.255]
0.0.0.0 analytics-api-samples.googlecode.com
# [Google][AS15169][216.58.192.0 - 216.58.223.255]
0.0.0.0 www.adsensecustomsearchads.com
0.0.0.0 1435575.fls.doubleclick.net
0.0.0.0 2542116.fls.doubleclick.net
0.0.0.0 4053494.fls.doubleclick.net
0.0.0.0 4236808.fls.doubleclick.net
0.0.0.0 ade.googlesyndication.com
# 0.0.0.0 www.googletagmanager.com #[affects ASUS]
# [Google / DoubleClick][AS6432][216.73.80.0 - 216.73.95.255]
0.0.0.0 www3.webhostingtalk.com
# [Google][AS15169][23.236.128.0 - 23.251.159.255]
# [Google][AS15169][34.64.0.0/11]
0.0.0.0 analytics.inform.com
0.0.0.0 track.searchiq.co
# [Google][AS15169][35.184.0.0 - 35.240.255.255]
0.0.0.0 adexchangedirect.com
0.0.0.0 cleardexchange.com
0.0.0.0 stats.directexpose.com
0.0.0.0 novelty-media-us-d.openx.net
0.0.0.0 ox-delivery-prod-1-us-east1.openx.net
0.0.0.0 adoramatracksdk.optimove.net #[Piwik.Analytics]
0.0.0.0 collector-pxel3l4xih.perimeterx.net
0.0.0.0 star.pulseonclick.com
0.0.0.0 app.reflectivedata.com
0.0.0.0 track.special-promotions.online
0.0.0.0 stats.tiebreaker.com
0.0.0.0 click.udimg.com
# [Google / DoubleClick][AS15169][64.233.160.0 - 64.233.191.255]
0.0.0.0 m1.2mdn.net
0.0.0.0 n339.asp-cc.com
0.0.0.0 ads.cc-dt.com
0.0.0.0 clickserve.cc-dt.com
0.0.0.0 creative.cc-dt.com
0.0.0.0 clickserve.dartsearch.net
0.0.0.0 clickserve.eu.dartsearch.net
0.0.0.0 clickserve.uk.dartsearch.net
0.0.0.0 doubleclick.net
0.0.0.0 ad.doubleclick.net #[MVPS.Criteria]
0.0.0.0 ad-g.doubleclick.net
0.0.0.0 ad2.doubleclick.net
0.0.0.0 ad.ae.doubleclick.net
0.0.0.0 ad.ar.doubleclick.net
0.0.0.0 ad.at.doubleclick.net
0.0.0.0 ad.au.doubleclick.net
0.0.0.0 ad.be.doubleclick.net
0.0.0.0 ad.br.doubleclick.net
0.0.0.0 ad.ca.doubleclick.net
0.0.0.0 ad.ch.doubleclick.net
0.0.0.0 ad.cl.doubleclick.net
0.0.0.0 ad.cn.doubleclick.net
0.0.0.0 ad.de.doubleclick.net #[Tracking.Cookie]
0.0.0.0 ad.dk.doubleclick.net
0.0.0.0 ad.es.doubleclick.net
0.0.0.0 ad.fi.doubleclick.net
0.0.0.0 ad.fr.doubleclick.net
0.0.0.0 ad.gr.doubleclick.net
0.0.0.0 ad.hk.doubleclick.net
0.0.0.0 ad.hr.doubleclick.net
0.0.0.0 ad.hu.doubleclick.net
0.0.0.0 ad.ie.doubleclick.net
0.0.0.0 ad.in.doubleclick.net
0.0.0.0 ad.jp.doubleclick.net
0.0.0.0 ad.kr.doubleclick.net
0.0.0.0 ad.it.doubleclick.net
0.0.0.0 ad.nl.doubleclick.net
0.0.0.0 ad.no.doubleclick.net
0.0.0.0 ad.nz.doubleclick.net
0.0.0.0 ad.pl.doubleclick.net
0.0.0.0 ad.pt.doubleclick.net
0.0.0.0 ad.ro.doubleclick.net
0.0.0.0 ad.ru.doubleclick.net
0.0.0.0 ad.se.doubleclick.net
0.0.0.0 ad.sg.doubleclick.net
0.0.0.0 ad.si.doubleclick.net
0.0.0.0 ad.terra.doubleclick.net
0.0.0.0 ad.th.doubleclick.net
0.0.0.0 ad.tw.doubleclick.net
0.0.0.0 ad.uk.doubleclick.net
0.0.0.0 ad.us.doubleclick.net
0.0.0.0 ad.za.doubleclick.net
0.0.0.0 ad.n2434.doubleclick.net
0.0.0.0 ad-emea.doubleclick.net
0.0.0.0 creatives.doubleclick.net
0.0.0.0 dfp.doubleclick.net
0.0.0.0 feedads.g.doubleclick.net
0.0.0.0 fls.doubleclick.net
0.0.0.0 fls.uk.doubleclick.net
0.0.0.0 googleads.g.doubleclick.net
0.0.0.0 ir.doubleclick.net
0.0.0.0 iv.doubleclick.net
0.0.0.0 m.doubleclick.net
0.0.0.0 n4052ad.doubleclick.net
0.0.0.0 n4403ad.doubleclick.net
0.0.0.0 n479ad.doubleclick.net
0.0.0.0 paypalssl.doubleclick.net
0.0.0.0 pubads.g.doubleclick.net
0.0.0.0 s2.video.doubleclick.net
0.0.0.0 static.doubleclick.net
0.0.0.0 survey.g.doubleclick.net
0.0.0.0 www3.doubleclick.net
0.0.0.0 www.doubleclick.net
0.0.0.0 doubleclick.com
0.0.0.0 www2.doubleclick.com
0.0.0.0 www3.doubleclick.com
0.0.0.0 www.doubleclick.com
0.0.0.0 www.bt.emsecure.net
0.0.0.0 tpc.googlesyndication.com
# 0.0.0.0  www.youtube-nocookie.com #[affects various videos]
# [Google / DoubleClick][AS15169][66.249.64.0 - 66.249.95.255]
0.0.0.0 ad.rs.doubleclick.net
# [Google / DoubleClick][AS15169][72.14.192.0 - 72.14.255.255]
0.0.0.0 affiliate.2mdn.net
# 0.0.0.0  s0.2mdn.net #[affects video stream]
# 0.0.0.0  static.2mdn.net #[affects Youtube]
0.0.0.0 clickserve.us2.dartsearch.net
0.0.0.0 ad-apac.doubleclick.net
0.0.0.0 ad.mo.doubleclick.net
0.0.0.0 adclick.g.doubleclick.net
0.0.0.0 gan.doubleclick.net
0.0.0.0 googleads2.g.doubleclick.net
0.0.0.0 n4061ad.hk.doubleclick.net
0.0.0.0 securepubads.g.doubleclick.net
# [Google / DoubleClick][AS15169][74.125.0.0 - 74.125.255.255]
0.0.0.0 c.admob.com
0.0.0.0 code.adtlgc.com
0.0.0.0 ip-geo.appspot.com
0.0.0.0 nojsstats.appspot.com
0.0.0.0 ad-ace.doubleclick.net
0.0.0.0 ad.bg.doubleclick.net
0.0.0.0 bid.g.doubleclick.net
0.0.0.0 cm.g.doubleclick.net
0.0.0.0 4360661.fls.doubleclick.net
0.0.0.0 4488352.fls.doubleclick.net
0.0.0.0 4684100.fls.doubleclick.net
0.0.0.0 stats.g.doubleclick.net
0.0.0.0 fls.au.doubleclick.net
0.0.0.0 www.doubleclickbygoogle.com
0.0.0.0 video-stats.video.google.com
0.0.0.0 google-analytics.com
0.0.0.0 ssl.google-analytics.com
0.0.0.0 www.google-analytics.com #[affects Google Trends]
0.0.0.0 4.afs.googleadservices.com
0.0.0.0 pagead2.googleadservices.com
0.0.0.0 partner.googleadservices.com
0.0.0.0 www.googleadservices.com
0.0.0.0 pagead2.googlesyndication.com #[Google AdWords]
0.0.0.0 www.googletagservices.com
0.0.0.0 www.linksalpha.com
# [Gossamer][AS36483][172.255.48.0 - 172.255.63.255]
0.0.0.0 adbetnet.advertserve.com
# [Gossamer][AS36483][208.70.244.0 - 208.70.247.255]
0.0.0.0 web.acumenpi.com #[AdvertPro]
0.0.0.0 ads.bloodhorse.com
# [GTS Nextra / Etargetsh-ba][AS5578][195.168.10.128 - 195.168.10.255]
0.0.0.0 search.etargetnet.com
0.0.0.0 bg.search.etargetnet.com
0.0.0.0 cz.search.etargetnet.com
0.0.0.0 hr.search.etargetnet.com
0.0.0.0 hu.search.etargetnet.com
0.0.0.0 pl.search.etargetnet.com
0.0.0.0 ro.search.etargetnet.com
0.0.0.0 rs.search.etargetnet.com
0.0.0.0 sk.search.etargetnet.com
0.0.0.0 bg.static.etargetnet.com
0.0.0.0 cz.static.etargetnet.com
0.0.0.0 hr.static.etargetnet.com
0.0.0.0 hu.static.etargetnet.com
0.0.0.0 rs.static.etargetnet.com
# [Hetzner][AS24940][136.243.0.0 - 136.243.255.255]
0.0.0.0 ws024.coin-hive.com
# [Hetzner][AS24940][144.76.0.0 - 144.76.255.255]
0.0.0.0 www.adylalahb.ru
0.0.0.0 c.am11.ru
0.0.0.0 ws031.coin-hive.com
0.0.0.0 rtbproxy.mgid.com
0.0.0.0 splitter.ndsplitter.com
0.0.0.0 switch.rtbsystem.com
0.0.0.0 s62.research.de.com
0.0.0.0 level.turboads.de
0.0.0.0 piwik.wsws.org #[Piwik.Analytics]
# [Hetzner][AS24940][148.251.64.162 - 148.251.64.162]
0.0.0.0 t.goadservices.com
0.0.0.0 e.maxtraffic.com
0.0.0.0 track.recreativ.ru
# [Hetzner][AS24940][176.9.0.0 - 176.9.255.255]
0.0.0.0 adsfeed3.brabys.co.za
0.0.0.0 ws028.coin-hive.com
0.0.0.0 ads.people-group.net
0.0.0.0 click.plista.com
0.0.0.0 farm.plista.com
0.0.0.0 us-sonar.sociomantic.com
0.0.0.0 adserver.spritmonitor.de
0.0.0.0 xblasterads1.com
# [Hetzner][AS24940][178.63.0.0 - 178.63.255.255]
0.0.0.0 scambiobanner.altervista.org
0.0.0.0 avazudsp.net
0.0.0.0 ads2.opensubtitles.org
0.0.0.0 test.wiredminds.de
0.0.0.0 wm.wiredminds.de
# [Hetzner][AS24940][188.40.0.0 - 188.40.255.255]
0.0.0.0 eps-analyzer.de
0.0.0.0 openx.itsmassive.com
0.0.0.0 openads.motorrad-net.at
0.0.0.0 static.openads.motorrad-net.at
0.0.0.0 ads.sysmesh.com
# [Hetzner][213.133.96.0 - 213.133.111.255]
0.0.0.0 mmotraffic.com
0.0.0.0 sonar.sociomantic.com
# [Hetzner][213.239.202.128 - 213.239.202.255]
0.0.0.0 api.7segments.com
0.0.0.0 a.mobile.toboads.com
0.0.0.0 relay.mobile.toboads.com
0.0.0.0 count.yandeg.ru
# [Hetzner][AS24940][46.4.23.192 - 46.4.69.95]
0.0.0.0 adbuka.com
0.0.0.0 www.adbuka.com
0.0.0.0 www.blogads.de
0.0.0.0 ads.energy-torrent.com
0.0.0.0 hits.europuls.eu
0.0.0.0 ad.propellerads.com
0.0.0.0 block.sw1block.com
0.0.0.0 stats.warenform.de #[Piwik.Analytics]
# [Hetzner][AS24940][5.9.144.56 - 5.9.90.95]
0.0.0.0 www.adtraff.ru
0.0.0.0 advombat.ru
0.0.0.0 am15.net
0.0.0.0 ads.betweendigital.com
0.0.0.0 baypops.com
0.0.0.0 cdn.contentspread.net
0.0.0.0 js.e-generator.com
0.0.0.0 target.e-generator.com
0.0.0.0 target.net.finam.ru
0.0.0.0 track.idtargeting.com
0.0.0.0 jadcenter.com
0.0.0.0 s300.meetrics.net
0.0.0.0 wh.motorpresse-statistik.de
0.0.0.0 js.smi2.ru
0.0.0.0 target.smi2.net
0.0.0.0 stats.virtuemart.net #[Piwik.Analytics]
# [Hetzner][78.46.0.0 - 78.47.255.255]
0.0.0.0 lb.fruitflan.com
0.0.0.0 adcentre.it-advanced.com
0.0.0.0 dc61.s290.meetrics.net
0.0.0.0 partnerearning.com
0.0.0.0 eu-sonar.sociomantic.com
0.0.0.0 www.stats4free.de
0.0.0.0 ads.videofen.com
0.0.0.0 wmapp.wiredminds.de
# [Hetzner-rz-nbg-net][78.46.32.0 - 78.46.95.255]
0.0.0.0 coin-hive.com
0.0.0.0 dc56.s290.meetrics.net
0.0.0.0 ad10.play3.de
# [Hetzner][AS24940][85.10.192.0 - 85.10.207.255]
# [Hetzner][AS24940][88.198.0.0 - 88.198.255.255]
0.0.0.0 cpm.adspine.com
0.0.0.0 de1.frosmo.com
0.0.0.0 www.sitecounter.be
0.0.0.0 afx.tagcdn.com
0.0.0.0 pix.tagcdn.com
0.0.0.0 www.weitclick.de
0.0.0.0 wm-goldenclick.ru
# [Hetzner][AS24940][88.99.0.0 - 88.99.255.255]
0.0.0.0 ws023.coin-hive.com
0.0.0.0 tracking.retargeting.biz
# [Hetzner][AS24940][94.130.0.0 - 94.130.255.255]
0.0.0.0 ws017.coin-hive.com
0.0.0.0 ws022.coin-hive.com
0.0.0.0 ws025.coin-hive.com
0.0.0.0 ws026.coin-hive.com
0.0.0.0 ws027.coin-hive.com
0.0.0.0 ws032.coin-hive.com
# [Hi-media][AS45050][195.158.240.0 - 195.158.241.255]
0.0.0.0 br.comclick.com
0.0.0.0 bdx.comclick.com
0.0.0.0 ct2.comclick.com
0.0.0.0 fl01.ct2.comclick.com #[Tracking.Cookie]
0.0.0.0 ihm01.ct2.comclick.com
0.0.0.0 www.comclick.com
# [Hi-media][AS45050][46.182.41.0 - 46.182.41.255]
0.0.0.0 js.himediads.com
# [Hivelocity / Noc4hosts][AS29802][68.233.224.0 - 68.233.255.255]
0.0.0.0 c7.adforgeinc.com
# [Hizmetleri][77.92.131.0 - 77.92.131.255]
0.0.0.0 adstest.reklamstore.com
# [Hopone][AS14361][209.160.0.0 - 209.160.79.255]
0.0.0.0 ad.db3nf.com
0.0.0.0 go.jetswap.com
0.0.0.0 tracksy.com
# [Hopone][66.148.64.0 - 66.148.127.255]
0.0.0.0 findfavour.com
# [Hosteurope][AS20773][176.28.24.0 - 176.28.27.255]
0.0.0.0 get.mirando.de
# [Hosteurope][AS20773][178.77.88.0 - 178.77.91.255]
0.0.0.0 r.refinedads.com
# [Hosteurope / Centron Gmbh][AS20773][212.223.168.0 - 212.223.168.255]
0.0.0.0 limg.adspirit.de
# [Hosteurope][AS20773][46.163.120.0 - 46.163.123.255]
0.0.0.0 taz.adspirit.de
0.0.0.0 urban.adspirit.de
# [Hosteurope][AS20773][80.237.180.0 - 80.237.180.127]
0.0.0.0 admention.adspirit.de
0.0.0.0 adx.adspirit.de
0.0.0.0 lidlretargeting.adspirit.de
0.0.0.0 ruemedia.adspirit.net
0.0.0.0 sgmedia.adspirit.net
0.0.0.0 ja.revolvermaps.com
0.0.0.0 jb.revolvermaps.com
0.0.0.0 jc.revolvermaps.com
0.0.0.0 jd.revolvermaps.com
0.0.0.0 je.revolvermaps.com
0.0.0.0 jf.revolvermaps.com
0.0.0.0 jg.revolvermaps.com
0.0.0.0 jh.revolvermaps.com
0.0.0.0 ji.revolvermaps.com
0.0.0.0 jk.revolvermaps.com
0.0.0.0 rb.revolvermaps.com
0.0.0.0 rc.revolvermaps.com
0.0.0.0 rd.revolvermaps.com
0.0.0.0 re.revolvermaps.com
0.0.0.0 rg.revolvermaps.com
0.0.0.0 rh.revolvermaps.com
0.0.0.0 ri.revolvermaps.com
0.0.0.0 rk.revolvermaps.com
# [Hosteurope][AS20773][83.169.0.0 - 83.169.7.255]
0.0.0.0 folkd.put.omnimon.de
0.0.0.0 openx.omniton.net
# [Hosteurope][AS20773][87.230.55.0 - 87.230.55.255]
0.0.0.0 cdn.adspirit.de
# [Hosteurope][AS20773][92.51.184.0 - 92.51.187.255]
0.0.0.0 ad4mat.de
# [Hosting Consulting][AS30502][199.88.56.0 - 199.88.63.255]
0.0.0.0 serve.oxcluster.com
0.0.0.0 seekbang.com
0.0.0.0 www.seekbang.com
# [Hosting Consulting / RK Netmedia][AS40539][208.78.92.0 - 208.78.95.255]
0.0.0.0 adbucks.brandreachsys.com
0.0.0.0 adc.brandreachsys.com
0.0.0.0 fe.brandreachsys.com
0.0.0.0 lg1.brandreachsys.com
0.0.0.0 mad2.brandreachsys.com
0.0.0.0 media.brandreachsys.com
0.0.0.0 clicks.equantum.com
0.0.0.0 adb.fling.com
0.0.0.0 br.fling.com
0.0.0.0 track.fling.com
0.0.0.0 www.freecamdollars.com
0.0.0.0 kaizentraffic.com
0.0.0.0 br.meetlocals.com
0.0.0.0 promos.naked.com
0.0.0.0 br.naked.com
0.0.0.0 apps.nastydollars.com
0.0.0.0 clicks.nastydollars.com
0.0.0.0 graphics.nastydollars.com
0.0.0.0 webmasters.nastydollars.com
0.0.0.0 www-old.nastydollars.com
0.0.0.0 br.realitykings.com
0.0.0.0 track.realitykings.com
0.0.0.0 br.rk.com
# [Hosting Consulting / Global Personals][208.91.207.0 - 208.91.207.255]
0.0.0.0 www.camsoda1.com
0.0.0.0 promos.fling.com
0.0.0.0 promos.meetlocals.com
0.0.0.0 gallysorig.nastydollars.com
0.0.0.0 grab.nastydollars.com
0.0.0.0 hostedads.realitykings.com
0.0.0.0 promos.wealthymen.com
# [Hosting Consulting][AS30502][64.7.203.0 - 64.7.203.255]
0.0.0.0 banners.sublimedirectory.com
# [Hosting Ltd][AS13147][87.120.40.0 - 87.120.41.255]
0.0.0.0 ads.hobyto.com
0.0.0.0 ads.popfolkstars.com
# [HostDime.com][AS33182][66.7.192.0 - 66.7.223.255]
0.0.0.0 www.disable-uac.com
0.0.0.0 s2.tracemyip.org
0.0.0.0 www.tracemyip.org
# [HostDime.com][AS33182][67.23.224.0 - 67.23.255.255]
0.0.0.0 searchnigeria.net
# [Hostoffice][AS47885][195.228.74.0 - 195.228.74.255]
0.0.0.0 ads.adhall.com
# [Hosting Solutions][AS30083][50.30.32.0 - 50.30.47.255]
0.0.0.0 px.adhigh.net
# [Hosting Solutions][69.64.32.0 - 69.64.63.255]
0.0.0.0 tracker.databrain.com
0.0.0.0 www.iperbanner.com
0.0.0.0 ads.iwannawatch.to
0.0.0.0 mgjmp.com
# [Hostit][AS9166][212.113.80.0 - 212.113.95.255]
0.0.0.0 abs.proxistore.com
# [Hostway][AS7097][216.139.208.0 - 216.139.255.255]
0.0.0.0 hits.convergetrack.com
# [Hostway][AS20401][216.36.192.0 - 216.36.255.255]
0.0.0.0 ads.worddictionary.co.uk
# [Hostworks][AS9667][202.58.32.0 - 202.58.63.255]
0.0.0.0 ads.ninemsn.com.au
# [HOTLOG]
0.0.0.0 click.hotlog.ru
0.0.0.0 hit.hotlog.ru #[WebBug]
0.0.0.0 hit1.hotlog.ru
0.0.0.0 hit2.hotlog.ru
0.0.0.0 hit3.hotlog.ru
0.0.0.0 hit4.hotlog.ru
0.0.0.0 hit5.hotlog.ru
0.0.0.0 hit6.hotlog.ru
0.0.0.0 hit7.hotlog.ru
0.0.0.0 hit8.hotlog.ru #[Tracking.Cookie]
0.0.0.0 hit9.hotlog.ru
0.0.0.0 hit10.hotlog.ru
0.0.0.0 hit13.hotlog.ru
0.0.0.0 hit14.hotlog.ru
0.0.0.0 hit15.hotlog.ru
0.0.0.0 hit16.hotlog.ru
0.0.0.0 hit17.hotlog.ru
0.0.0.0 hit18.hotlog.ru
0.0.0.0 hit19.hotlog.ru
0.0.0.0 hit20.hotlog.ru
0.0.0.0 hit21.hotlog.ru
0.0.0.0 hit22.hotlog.ru
0.0.0.0 hit23.hotlog.ru
0.0.0.0 hit24.hotlog.ru
0.0.0.0 hit25.hotlog.ru
0.0.0.0 hit26.hotlog.ru
0.0.0.0 hit27.hotlog.ru
0.0.0.0 hit28.hotlog.ru
0.0.0.0 hit29.hotlog.ru
0.0.0.0 hit30.hotlog.ru
0.0.0.0 hit40.hotlog.ru
0.0.0.0 www.hotlog.ru
# [HTTPool][AS8558][91.209.18.0 - 91.209.18.255]
0.0.0.0 relay-ba.ads.httpool.com
0.0.0.0 relay-bg.ads.httpool.com
0.0.0.0 relay-cz.ads.httpool.com
0.0.0.0 relay-ks.ads.httpool.com
0.0.0.0 relay-mk.ads.httpool.com
0.0.0.0 relay-rs.ads.httpool.com
0.0.0.0 adtier.toboads.com
0.0.0.0 relay-ba.toboads.com
0.0.0.0 relay-bg.toboads.com
0.0.0.0 relay-si.toboads.com
0.0.0.0 tas2.toboads.si
0.0.0.0 tas-ba.toboads.com
0.0.0.0 tas-bg.toboads.com
0.0.0.0 tas-cz.toboads.com
0.0.0.0 tas-hr.toboads.com
0.0.0.0 tas-ks.toboads.com
0.0.0.0 tas-mk.toboads.com
0.0.0.0 tas-rs.toboads.com
0.0.0.0 tas-si.toboads.com
# [Hungarian Telecom / Invitel][AS12301][195.184.19.0 - 195.184.19.255]
0.0.0.0 stat.axelspringer.hu
# [Hunt Brothers / Parked.com][AS32592][69.46.224.0 - 69.46.239.255]
0.0.0.0 www.searchnut.com
# [Hunt Brothers / Parked.com][AS32592][74.117.112.0 - 74.117.119.255]
0.0.0.0 www.buycheapadvertising.com
# [Hurricane Electric][AS6939][173.255.192.0 - 173.255.255.255]
0.0.0.0 stats.pusher.com
0.0.0.0 vpnaffiliates.com
# [Hurricane Electric][AS6939][198.74.48.0 - 198.74.63.255]
0.0.0.0 revenue.com
# [Hurricane Electric / 800 Pound][216.218.206.32 - 216.218.206.63]
0.0.0.0 ads.artsopolis.com
0.0.0.0 www.logging.to
# [Hurricane Electric][AS32911][216.66.0.0 - 216.66.95.255]
0.0.0.0 configusa.veinteractive.com
# [Hurricane Electric][AS6939][50.116.0.0 - 50.116.63.255]
0.0.0.0 cdn.mercent.com
# [Hurricane Electric][AS6939][64.62.128.0 - 64.62.255.255]
0.0.0.0 ox-d.beforeitsnews.com
0.0.0.0 ad.epochtimes.com
0.0.0.0 www.e-traffic.com
0.0.0.0 www.etraffic.com
0.0.0.0 ads.footballmedia.com
# [Hurricane Electric][AS6939][64.71.142.0 - 64.71.142.127]
0.0.0.0 o-oe.com
# [Hurricane Electric / Clickman][64.89.16.0 - 64.89.31.255]
0.0.0.0 arsconsole.global-intermedia.com
0.0.0.0 feeds.global-intermedia.com
0.0.0.0 error.pimproll.com
0.0.0.0 promo.pimproll.com
# [Hurricane Electric][AS6939][66.220.0.0 - 66.220.31.255]
0.0.0.0 trk.in25app.com
# [Hurricane Electric][AS6939][74.82.51.0 - 74.82.51.255]
# [Icdsoft][AS8739][195.8.222.0 - 195.8.223.255]
0.0.0.0 ads.burgasinfo.com
# [ICN][AS49699][130.185.253.0 - 130.185.253.255]
# [ICN][AS49699][91.215.216.0 - 91.215.219.255]
0.0.0.0 bgbaner.com
0.0.0.0 www.bgbaner.com
0.0.0.0 ads.mixbg.net
# [ICN][AS49699][91.230.192.0 - 91.230.195.255]
# [IDG][AS13797][66.186.112.0 - 66.186.127.255]
0.0.0.0 ads.idgworldexpo.com
# [IMR Worldwide][Nielsen/NetRatings]
0.0.0.0 lycos-eu.imrworldwide.com
0.0.0.0 ninemsn.imrworldwide.com
0.0.0.0 nt-es.imrworldwide.com
0.0.0.0 safe-es.imrworldwide.com
0.0.0.0 secure-asia.imrworldwide.com
0.0.0.0 secure-au.imrworldwide.com
0.0.0.0 secure-dk.imrworldwide.com
0.0.0.0 secure-it.imrworldwide.com
0.0.0.0 secure-sg.imrworldwide.com
0.0.0.0 secure-jp.imrworldwide.com
0.0.0.0 secure-nz.imrworldwide.com
0.0.0.0 secure-uk.imrworldwide.com
0.0.0.0 secure-us.imrworldwide.com
0.0.0.0 secure-za.imrworldwide.com
0.0.0.0 server-au.imrworldwide.com
0.0.0.0 server-br.imrworldwide.com
0.0.0.0 server-by.imrworldwide.com
0.0.0.0 server-de.imrworldwide.com #[Tracking.Cookie]
0.0.0.0 server-dk.imrworldwide.com
0.0.0.0 server-ee.imrworldwide.com
0.0.0.0 server-fi.imrworldwide.com
0.0.0.0 server-it.imrworldwide.com
0.0.0.0 server-jp.imrworldwide.com
0.0.0.0 server-lv.imrworldwide.com
0.0.0.0 server-lt.imrworldwide.com
0.0.0.0 server-no.imrworldwide.com
0.0.0.0 server-nz.imrworldwide.com
0.0.0.0 server-oslo.imrworldwide.com
0.0.0.0 server-pl.imrworldwide.com
0.0.0.0 server-se.imrworldwide.com
0.0.0.0 server-sg.imrworldwide.com
0.0.0.0 server-stockh.imrworldwide.com
0.0.0.0 server-uk.imrworldwide.com
0.0.0.0 server-us.imrworldwide.com
0.0.0.0 telstra.imrworldwide.com
# [In2net / Doteasy Technology][AS26753][65.61.192.0 - 65.61.255.255]
0.0.0.0 adserve.doteasy.com
0.0.0.0 pbg2cs01.doteasy.com
0.0.0.0 hitcounter01.xspp.com
# [INET / Securenetz-de][212.162.12.0 - 212.162.15.255]
0.0.0.0 link4link.com
0.0.0.0 plus.link4link.com
0.0.0.0 ad.sexcount.de
# [INET / Securenetz][212.162.52.0 - 212.162.53.255]
0.0.0.0 www.sexcount.de
# [INET / Fliks Gmbh][AS25074][213.203.216.0 - 213.203.216.127]
0.0.0.0 adserver.trojaner-info.de
# [INET][AS25074][78.138.104.0 - 78.138.119.255]
0.0.0.0 www.down1oads.com
0.0.0.0 m.exactag.com
0.0.0.0 pxc.otto.de
# [Inflow / Coremetrics][AS19296][66.179.5.0 - 66.179.5.127]
0.0.0.0 data.coremetrics.com
0.0.0.0 jsfp.coremetrics.com
0.0.0.0 test.coremetrics.com
0.0.0.0 twci.coremetrics.com #[Tracking.Cookie]
# [Infonline][AS43407][193.46.63.0 - 193.46.63.255]
0.0.0.0 spiegel.met.vgwort.de
# [Infonline][AS43407][91.215.100.0 - 91.215.103.255]
0.0.0.0 de.ioam.de
0.0.0.0 bm.met.vgwort.de
0.0.0.0 focus.met.vgwort.de
0.0.0.0 handelsblatt.met.vgwort.de
0.0.0.0 n-tv.met.vgwort.de
0.0.0.0 rp-online.met.vgwort.de
0.0.0.0 sz.met.vgwort.de
0.0.0.0 zeit.met.vgwort.de
# [Infolink / Serverpronto][AS15083][ - 64.251.25.182]
0.0.0.0 static.dynad.net
# [Infolink / Serverpronto][AS15083][69.60.114.0 - 69.60.125.255]
0.0.0.0 www.freestats.tv
# [InfoSpace][AS22293][67.63.48.0 - 67.63.63.255]
0.0.0.0 om.metacrawler.com
0.0.0.0 om.webcrawler.com
0.0.0.0 is2.websearch.com
# [Intelenet][AS5693][207.38.96.0 - 207.38.127.255]
0.0.0.0 dp.specificclick.net
0.0.0.0 smp.specificmedia.com
0.0.0.0 specificmedia.com
0.0.0.0 www.specificmedia.com
# [Intelenet][AS5693][216.23.160.0 - 216.23.191.255]
0.0.0.0 clients.bluecava.com
# [InterActiveCorp / Focus Interactive]
0.0.0.0 ads.iwon.com
0.0.0.0 c4.iwon.com
0.0.0.0 cc.iwon.com #[iWon Progressive Counter]
0.0.0.0 docs1.iwon.com
0.0.0.0 my.iwon.com
0.0.0.0 plus.iwon.com
0.0.0.0 prizemachine.games.iwon.com
0.0.0.0 searchassistant.iwon.com
0.0.0.0 www1.iwon.com #[ADW_IWON.B]
0.0.0.0 c4.mysearch.com #[ADW_MYSEARCH.202]
0.0.0.0 cm.myway.com #[Ewido.Spyware.MyWay][ADW_MIWAY.C]
0.0.0.0 speedbar.myway.com #[ADW_MYSPEED.A][ADW_MIWAY.C]
0.0.0.0 cm.need2find.com #[Panda.adware/need2find]
# [IAC Search Media][AS16798][66.235.112.0 - 66.235.127.255]
0.0.0.0 image.i1img.com
0.0.0.0 help.mysearch.com #[Ewido.Spyware.MySearch]
0.0.0.0 www.mysearch.com #[ADW_MIWAY.B][ADWARE_BHO_MYWAY]
0.0.0.0 www.mytotalsearch.com
0.0.0.0 mywebsearch.com #[Adware.MyWebSearch]
0.0.0.0 edits.mywebsearch.com
0.0.0.0 search.mywebsearch.com #[Panda.Adware/MyWebSearch]
0.0.0.0 weatherbugbrowserbar.mywebsearch.com
0.0.0.0 www.mywebsearch.com #[Ewido.Spyware.MyWebSearch]
0.0.0.0 ka.bar.need2find.com #[Adware.Need2Find]
0.0.0.0 kc.search.need2find.com #[mwave.AdWare.MySearch.e]
0.0.0.0 kz.search.need2find.com #[altnet.com]
# 0.0.0.0  wzus1.reference.com #[affects Dictonary.com]
# [InterConnect / Viper][AS9150][213.207.92.0 - 213.207.97.255]
0.0.0.0 www.erodynamics.nl
0.0.0.0 ads.happyidiots.nl
# [Interland / Web.com][AS36476][209.237.128.0 - 209.237.191.255]
# [Internap][AS12180][199.34.124.96 - 199.34.124.103]
0.0.0.0 keisu02.eproof.com
# [Internap / Customer Acquisition][AS12180][216.52.167.64 - 216.52.167.95]
0.0.0.0 control.adap.tv
0.0.0.0 ads.shopstyle.com
# [Internap][AS10912][216.52.234.128 - 216.52.234.255]
0.0.0.0 elv3-tslogging.touchcommerce.com
# [Internap][AS10913][23.92.176.0 - 23.92.191.255]
0.0.0.0 s-adserver.cxad.cxense.com
# [Internap][AS13789][63.251.0.0 - 63.251.255.255]
0.0.0.0 ad.batanga.net
0.0.0.0 tracking.batanga.com
0.0.0.0 tracking.batanga.net
0.0.0.0 horizon.mashable.com
0.0.0.0 cdn.viglink.com
0.0.0.0 s.webtrends.com
# [Internap / Gomez][AS14742][63.251.134.0 - 63.251.134.255]
0.0.0.0 0532a9.r.axf8.net
0.0.0.0 064bdf.r.axf8.net
0.0.0.0 0d7292.r.axf8.net
0.0.0.0 0f36f3.r.axf8.net
0.0.0.0 1bb261.r.axf8.net
0.0.0.0 247590.r.axf8.net
0.0.0.0 276bf6.r.axf8.net
0.0.0.0 332645.r.axf8.net
0.0.0.0 3bb4f0.r.axf8.net
0.0.0.0 51af72.r.axf8.net
0.0.0.0 5b008e.r.axf8.net
0.0.0.0 5ebec5.r.axf8.net
0.0.0.0 72d329.r.axf8.net
0.0.0.0 8b3439.r.axf8.net
0.0.0.0 8cb8a3.r.axf8.net
0.0.0.0 8d6274.r.axf8.net
0.0.0.0 8d6274.t.axf8.net
0.0.0.0 9dacbd.r.axf8.net
0.0.0.0 9d060c.r.axf8.net
0.0.0.0 994119.r.axf8.net
0.0.0.0 1018d7.r.axf8.net
0.0.0.0 ab44aa.r.axf8.net
0.0.0.0 ac9d98.r.axf8.net
0.0.0.0 b3a70b.t.axf8.net
0.0.0.0 b5057c.r.axf8.net
0.0.0.0 c2c738.r.axf8.net
0.0.0.0 caea4e.r.axf8.net
0.0.0.0 caea4e.t.axf8.net
0.0.0.0 c6530e.r.axf8.net
0.0.0.0 d077aa.r.axf8.net
0.0.0.0 d3fd89.r.axf8.net
0.0.0.0 d9d0e0.r.axf8.net
0.0.0.0 e3f364.r.axf8.net
0.0.0.0 fdff44.r.axf8.net
0.0.0.0 fdff44.t.axf8.net
# [Internap / ClickSpring][AS14742][63.251.135.0 - 63.251.135.63]
0.0.0.0 connexity.net
# [Internap][AS12182][64.7.192.0 - 64.7.223.255]
0.0.0.0 cti.w55c.net
# [Internap][AS10912][64.74.0.0 - 64.74.255.255]
0.0.0.0 pixel.admedia.com
0.0.0.0 exit.silvercash.com
# [Internap / Sk Intertainment][AS19024][64.74.108.64 - 64.74.108.127]
0.0.0.0 ads.mrskin.com
# [Internap][AS14742][64.94.0.0 - 64.95.255.255]
0.0.0.0 p.chango.com
# [Internap / Namemedia][AS14742][64.95.64.0 - 64.95.64.255]
0.0.0.0 adserver.sitesense.com #[Parking Service]
# [Internap][AS10913][66.150.0.0 - 66.151.255.255]
0.0.0.0 ebdr2.com
0.0.0.0 p.ebdr2.com
0.0.0.0 ebdr3.com
0.0.0.0 cdn.visiblemeasures.com
# [Internap / Webhosting][AS12180][67.215.160.0 - 67.215.191.255]
0.0.0.0 affiliate.trk4.com
# [Internap / IntegraClick][AS19024][69.25.190.0 - 69.25.190.255]
0.0.0.0 clickboothlnk.com
0.0.0.0 www.clickboothlnk.com
# [Internap / Rich Relevance][AS10913][69.25.31.240 - 69.25.31.255]
0.0.0.0 recs.richrelevance.com
# [Internap / Adap.tv][AS12182][69.25.60.128 - 69.25.60.255]
0.0.0.0 u-ads.adap.tv
# [Internap / Trueffect][AS14745][69.25.86.0 - 69.25.86.31]
0.0.0.0 log.adap.tv
0.0.0.0 qlog.adap.tv
# [Internap][AS14743][70.42.0.0 - 70.42.255.255]
0.0.0.0 b.admedia.com
0.0.0.0 footerroll.admedia.com
0.0.0.0 g.admedia.com
0.0.0.0 inline.admedia.com
0.0.0.0 m.admedia.com
0.0.0.0 v.admedia.com
0.0.0.0 vslider.admedia.com
0.0.0.0 pixel.adadvisor.net
0.0.0.0 www.adadvisor.net
0.0.0.0 click.cheapstuff.com
0.0.0.0 delivery.first-impression.com
0.0.0.0 sftrack.searchforce.net
0.0.0.0 click.top10sites.com
0.0.0.0 usadserver.com
0.0.0.0 www.usadserver.com
0.0.0.0 analytics.vast.com
# [Internap / Turn][AS12182][70.42.138.0 - 70.42.138.255]
0.0.0.0 ad.turn.com #[affects megogo.net]
0.0.0.0 r.turn.com #[ad.turn.com]
# [Internap][AS19024][72.44.88.83]
0.0.0.0 adsharenetwork.com
# [Internap / Gwallet][AS12182]AS14745[72.5.64.0 - 72.5.92.127]
0.0.0.0 rs.gwallet.com
0.0.0.0 www.ojrq.net
# [Internap / Outbrain][AS13789][74.201.198.64 - 74.201.198.95]
0.0.0.0 hpr.outbrain.com
0.0.0.0 log.outbrain.com
# [Internap / Gather][AS12182][74.201.33.0 - 74.201.33.255]
0.0.0.0 tracking.skyword.com
# [Internap / Adap.tv][AS12182][74.201.86.224 - 74.201.86.255]
0.0.0.0 ads.adap.tv
0.0.0.0 t-ads.adap.tv
# [Internap / Jolokia][74.217.67.0 - 74.217.67.255]
0.0.0.0 ads.yankscash.com
# [Internap][AS13789][75.98.0.0 - 75.98.95.255]
0.0.0.0 ads.healthline.com
0.0.0.0 a.rfihub.com
0.0.0.0 ads.p.veruta.com
# [Internap][AS48910][95.172.69.0 - 95.172.69.63]
0.0.0.0 pq-direct.revsci.net
# [Internet4you][AS29014][93.92.128.0 - 93.92.135.255]
0.0.0.0 containertags.belboon.de
# [Internet Billboard][AS5588][194.213.62.32 - 194.213.62.47]
0.0.0.0 go.goldbachpoland.bbelements.com
# [Internet Billboard][AS2819][62.168.44.112 - 62.168.44.127]
0.0.0.0 go.adlt.bbelements.com
0.0.0.0 go.adlv.bbelements.com
0.0.0.0 bbcdn.go.adlv.bbelements.com
0.0.0.0 bbcdn.go.pl.bbelements.com
0.0.0.0 go.gba.bbelements.com
0.0.0.0 video-adserver.ibillboard.com
# [Internet Billboard][AS2819][62.209.227.208 - 62.209.227.223]
0.0.0.0 bbnaut.ibillboard.com
# [Internet Media][AS12008][204.69.234.0 - 204.69.234.255]
0.0.0.0 cdn.brsrvr.com
# [Interserver][AS19318][64.20.32.0 - 64.20.63.255]
0.0.0.0 gamersad.com
# [Interserver][66.45.224.0 - 66.45.255.255]
0.0.0.0 rotor6.newzfind.com
0.0.0.0 sutra.newzfind.com
0.0.0.0 php4you.biz
0.0.0.0 ads.rampidads.com #[Tracking.Cookie]
0.0.0.0 main.rampidads.com
0.0.0.0 www.rampidads.com
# [Interserver][AS19318][69.10.32.0 - 69.10.63.255]
0.0.0.0 www.classifieds1000.com
# [InterWebvertising][AS9150][213.206.254.64 - 213.206.254.127]
0.0.0.0 ads.ero-advertising.com
0.0.0.0 adspaces.ero-advertising.com
0.0.0.0 api.ero-advertising.com
0.0.0.0 apo.ero-advertising.com
0.0.0.0 banners.ero-advertising.com
0.0.0.0 data.ero-advertising.com
0.0.0.0 invideo.ero-advertising.com
0.0.0.0 layerads.ero-advertising.com
0.0.0.0 redirects.ero-advertising.com
0.0.0.0 speedclicks.ero-advertising.com
0.0.0.0 thumbs.ero-advertising.com
# [IP Exchange / Udusegbe][AS15598][62.146.117.0 - 62.146.117.127]
0.0.0.0 adc-serv.net
0.0.0.0 ad.adc-serv.net
0.0.0.0 r.adc-serv.net
0.0.0.0 ad.adserver01.de
0.0.0.0 r.adserver01.de
# [IP Exchange / Bigpoint-net][AS15598][62.146.190.0 - 62.146.191.255]
0.0.0.0 adin.bigpoint.com
# [IP Exchange / Leo Gmbh][AS15598][62.146.26.32 - 62.146.26.63]
0.0.0.0 advert.leo.org
# [IP Exchange / Pepper Media][AS15598][62.146.88.96 - 62.146.88.127]
0.0.0.0 m1.webstats4u.com
0.0.0.0 www.webstats4u.com
# [IP Exchange / Webtrekk][AS15598][80.190.151.0 - 80.190.151.127]
0.0.0.0 adx.chip.de
0.0.0.0 douglas01.webtrekk.net
0.0.0.0 handelsblatt01.webtrekk.net
0.0.0.0 jade01.webtrekk.net
0.0.0.0 lastampa01.webtrekk.net
0.0.0.0 prosieben01.webtrekk.net
0.0.0.0 sapato01.webtrekk.net
0.0.0.0 sofa01.webtrekk.net
0.0.0.0 tiscaliadv01.webtrekk.net
0.0.0.0 trendmicroeuropa01.webtrekk.net
0.0.0.0 triboo01.webtrekk.net
0.0.0.0 vnumedia01.webtrekk.net
0.0.0.0 weltonline01.webtrekk.net
0.0.0.0 zeit01.webtrekk.net
# [Ipx Server][AS24900][80.190.246.0 - 80.190.246.255]
0.0.0.0 www.counti.de
0.0.0.0 statistiq.com
0.0.0.0 www.topsites24.de
0.0.0.0 ads.webtools24.net
0.0.0.0 banner.webtools24.net
# [Isprime][AS23393][104.37.176.0 - 104.37.183.255]
0.0.0.0 ads.exdynsrv.com
# [Isprime][AS23393][199.167.64.0 - 199.167.67.255]
0.0.0.0 ads.exosrv.com
0.0.0.0 static.exosrv.com
# [Isprime][AS23393][64.111.192.0 - 64.111.223.255]
0.0.0.0 main.exoclick.com
0.0.0.0 syndication.exoclick.com
0.0.0.0 main.exosrv.com
0.0.0.0 syndication.exosrv.com
0.0.0.0 www.gbcash.com
0.0.0.0 syndication.jsadapi.com
0.0.0.0 peakclick.com
0.0.0.0 feed.peakclick.com
0.0.0.0 www.peakclick.com #[AdWare.SideSearch.g][FindFmToolbar]
0.0.0.0 www.stats.net
0.0.0.0 t2lgo.com
# [Isprime][AS23393][64.188.48.0 - 64.188.63.255]
0.0.0.0 g.promosrv.com
0.0.0.0 www.singlesadnetwork.com
# [Isprime][66.230.128.0 - 66.230.191.255]
0.0.0.0 www.ads180.com
0.0.0.0 clicksagent.com
0.0.0.0 www.clicksagent.com
0.0.0.0 easyadservice.com
0.0.0.0 www.exitmoney.com
0.0.0.0 aff.naughtyconnect.com
0.0.0.0 track.oainternetservices.com
0.0.0.0 oxcash.com
0.0.0.0 clicks2.oxcash.com
0.0.0.0 popup.oxcash.com
0.0.0.0 track.oxcash.com
0.0.0.0 exit.oxcash2.com
0.0.0.0 realbannerads.com
0.0.0.0 www.realtextads.com
0.0.0.0 www.ruclicks.com #[clicksagent.com]
0.0.0.0 banners.thiswillshockyou.com
# [ISPrime / Reality Check][64.111.216.0 - 64.111.217.255]
0.0.0.0 banners.amfibi.com
# [ISPrime][68.169.64.0 - 68.169.95.255]
0.0.0.0 promo.badoink.com
0.0.0.0 adsgen.bangbros.com
0.0.0.0 adsrv.bangbros.com
0.0.0.0 newads.bangbros.com
0.0.0.0 tck.bangbros.com
0.0.0.0 tracking.craktraffic.com
0.0.0.0 www.fuckbookdating.com
0.0.0.0 webmasters.h2porn.com
0.0.0.0 ads.nudereviews.com
0.0.0.0 www.oainternet.com
0.0.0.0 iframes.prettyincash.com
0.0.0.0 stepnation.com
0.0.0.0 ads.whaleads.com
0.0.0.0 images.ads.whaleads.com
# [ISPrime / Reality Check][AS46652][141.0.172.0 - 141.0.175.255]
0.0.0.0 banners.advidi.com
0.0.0.0 20996-1061.link.iwanttodeliver.com
0.0.0.0 243029-18685.link.iwanttodeliver.com
0.0.0.0 244657-12903.link.iwanttodeliver.com
0.0.0.0 38707-223419.link.iwanttodeliver.com #[xvideos.com]
0.0.0.0 4902-145639.link.iwanttodeliver.com
0.0.0.0 www.loading-delivery2.com
0.0.0.0 banners.meccahoo.com
0.0.0.0 cdn.banners.scubl.com
0.0.0.0 www.targetingnow.com
0.0.0.0 rpc-php.trafficfactory.biz
# [ISPrime / Reality Check / Serverstack][AS46652][185.88.180.0 - 185.88.183.255]
0.0.0.0 55995-519009.link.iwanttodeliver.com
# [ISPrime / Reality Check / Serverstack][AS23393][AS46652][69.55.48.0 - 69.55.63.255]
0.0.0.0 banners.askmecca.com
0.0.0.0 widget.supercounters.com
# [Isprime][76.9.0.0 - 76.9.31.255]
0.0.0.0 vip.adstatic.com
0.0.0.0 ads.crakmedia.com
0.0.0.0 corporate.crakmedia.com
0.0.0.0 www.crakmedia.com
0.0.0.0 ftvcash.com
0.0.0.0 404.fuckyoucash.com
0.0.0.0 bloggers.fuckyoucash.com
0.0.0.0 internal.fuckyoucash.com
0.0.0.0 affiliates.lifeselector.com
0.0.0.0 ads.program3.com
0.0.0.0 lead.program3.com
0.0.0.0 media.lead.program3.com
0.0.0.0 www.program3.com
0.0.0.0 ads2.vasmg.com
# [ISWest / Trade News][AS5033][207.178.151.0 - 207.178.151.255]
0.0.0.0 actvtrack.com
0.0.0.0 fb.cashtraffic.com
0.0.0.0 image.cecash.com
0.0.0.0 image1.cecash.com
0.0.0.0 coolwebstats.com
0.0.0.0 www.coolwebstats.com
0.0.0.0 flashmediaportal.com
0.0.0.0 flttracksecure.com
0.0.0.0 ads.ibtracking.com
0.0.0.0 sascentral.com
# [Iweb Technologies][AS32613][174.142.0.0 - 174.142.255.255]
0.0.0.0 community.adlandpro.com #[Tracking.Cookie]
0.0.0.0 ads.affbuzzads.com
0.0.0.0 www.affbuzzads.com
# [Iweb][AS32613][184.107.0.0 - 184.107.255.255]
0.0.0.0 radarurl.com
# [Iweb / Innovastreams][209.172.45.0 - 209.172.45.255]
0.0.0.0 ads.iawsnetwork.com
0.0.0.0 oreo.iawsnetwork.com
# [iWeb Dedicated HD][64.15.136.96 - 64.15.136.127]
0.0.0.0 stats.parstools.com
# [Iweb Technologies][67.205.101.32 - 67.205.75.15]
0.0.0.0 revotrack.revotas.com
# [Iweb][70.38.0.0 - 70.38.127.255]
0.0.0.0 ads.mondogames.com
# [iWeb Dedicated CL2][70.38.78.96 - 70.38.78.127]
0.0.0.0 bannerco-op.com
# [Iweb Dedicated][209.172.32.0 - 209.172.63.255]
0.0.0.0 www.regdefense.com
# [Iweb Dedicated][72.55.128.0 - 72.55.191.255]
0.0.0.0 bannersgomlm.com
0.0.0.0 www.bannersgomlm.com
0.0.0.0 ads.cinemaden.com
# [Iweb Dedicated Cl][AS32613][72.55.165.64 - 72.55.165.95]
0.0.0.0 www.freestat.ws
0.0.0.0 www.hiperstat.com
0.0.0.0 www.specialstat.com
# [Iweb Dedicated Cl][72.55.174.192 - 72.55.174.223]
0.0.0.0 www.blogrankers.com
# [Jasmin Media Group][AS34655][80.77.113.0 - 80.77.113.255]
0.0.0.0 counter.awempire.com
0.0.0.0 counter.jasmin.hu
# [Jasmin Media Group / Lalib Lda][AS34655][93.93.53.0 - 93.93.53.255]
0.0.0.0 adson.awempire.com
0.0.0.0 iframes.awempire.com
0.0.0.0 promo.awempire.com
0.0.0.0 static.awempire.com
0.0.0.0 creatives.livejasmin.com
0.0.0.0 live-cams-0.livejasmin.com
0.0.0.0 live-cams-1.livejasmin.com
0.0.0.0 www.2.livejasmin.com
# [Jupiter Hosting / ICS Entertainment][AS29814][64.255.160.0 - 64.255.191.255]
0.0.0.0 ads.gofuckyourself.com
# [Keyweb Ag][AS31103][84.19.176.0 - 84.19.191.255]
0.0.0.0 ad.adnet.de
# [Keyweb Ag][87.118.82.0 - 87.118.95.255]
0.0.0.0 exchangecash.de
# [Keyweb Ag][87.118.96.0 - 87.118.127.255]
0.0.0.0 pr-cy.ru
# [Keyweb][95.169.186.0 - 95.169.187.255]
0.0.0.0 s1.rotaban.ru
# [Korea Telecom][218.144.0.0 - 218.159.255.255]
0.0.0.0 adimg1.chosun.com
0.0.0.0 cad.chosun.com #[RealMedia]
0.0.0.0 hitlog2.chosun.com
0.0.0.0 counter.joins.com
# [LambdaNet / Ipilum.com][AS13237][80.86.167.128 - 80.86.167.255]
0.0.0.0 www.adcell.de
# [Layer42.net][AS8121][64.13.128.0 - 64.13.191.255]
# 0.0.0.0 www.luminate.com #[affects login]
# [Layered Technologies][AS22576][72.232.0.0 - 72.233.127.255]
0.0.0.0 openx.4shared.com
0.0.0.0 www.easycounter.com
0.0.0.0 www.fastusersonline.com
0.0.0.0 adsnew.gsmarena.com
0.0.0.0 pingomatic.com
0.0.0.0 ads.phonearena.com
0.0.0.0 bannerexchange.troglod.com
0.0.0.0 www.usersonlinecounter.com
0.0.0.0 botd2.wordpress.com #[WebBug]
0.0.0.0 xxx-r.com
# [Layered Technologies][AS3561][74.200.192.0 - 74.200.255.255]
0.0.0.0 www.statsforever.com
0.0.0.0 www.widebanner.com
# [Leaseweb][AS30633][108.59.0.0 - 108.59.15.255]
0.0.0.0 reactads.engine.adglare.net
# [Leaseweb][AS16265][109.237.208.0 - 109.237.219.255]
0.0.0.0 feeds.wise-click.com
# [Leaseweb][AS16265][109.69.56.0 - 109.69.59.255]
0.0.0.0 tgptraffic.biz
# [Leaseweb][AS60781][185.108.84.129 - 185.108.84.144]
0.0.0.0 x.fidelity-media.com
# [Leaseweb][AS30633][207.244.64.0 - 207.244.127.255]
0.0.0.0 static.hotjar.com
# [Leaseweb][AS394380][209.58.144.0/20]
0.0.0.0 img.sunmediaads.com
# [Leaseweb][AS28753][212.95.32.0 - 212.95.63.255]
0.0.0.0 ads.directcorp.de
0.0.0.0 adserver.directcorp.de
# [Leaseweb][AS28753][217.19.1.0 - 217.20.112.255]
0.0.0.0 exit-ad.de #[Tracking.Cookie]
0.0.0.0 www.exit-ad.de
0.0.0.0 www.little-help.com
# [Leaseweb][AS60781][37.48.64.0 - 37.48.120.255]
0.0.0.0 promo-m.bongacash.com
0.0.0.0 smartxads.com
# [Leaseweb][AS16265][46.243.0.0 - 46.243.7.255]
0.0.0.0 vktr073.net
# [Leaseweb][AS16265][5.79.64.0 - 5.79.127.255]
0.0.0.0 adservone.com
# [Leaseweb][AS16265][62.212.66.0 - 62.212.84.255]
0.0.0.0 ads.adhood.com
0.0.0.0 www.ad-skills.nl
0.0.0.0 www.hubtraffic.com
# [Leaseweb][82.192.69.0 - 82.192.88.127]
0.0.0.0 img.clicksagent.com
0.0.0.0 rubanners.com #[clicksagent.com]
0.0.0.0 2.rubanners.com
0.0.0.0 img.ruclicks.com
0.0.0.0 zhirok.com #[Spamdexing]
# [Leaseweb][83.149.112.0 - 83.149.125.191]
0.0.0.0 promo.bongacash.com
# [Leaseweb][AS16265][85.17.111.0 - 85.17.94.255]
0.0.0.0 3animalsex.com
0.0.0.0 www.3animalsex.com
0.0.0.0 www.adcode.ws
0.0.0.0 api.adlure.net
0.0.0.0 a.adorika.net
0.0.0.0 adv.adultpartnership.com
0.0.0.0 counter.cam-content.com
0.0.0.0 piwik.cam-content.com #[Piwik.Analytics]
0.0.0.0 www.crackserver.com #[StopBadware.Report]
0.0.0.0 ads2.ero-advertising.com
0.0.0.0 askjolene.ero-advertising.com
0.0.0.0 banners2.ero-advertising.com
0.0.0.0 imads.ero-advertising.com
0.0.0.0 js.ero-advertising.com
0.0.0.0 popads.ero-advertising.com
0.0.0.0 tracker.ero-advertising.com
0.0.0.0 adman.kathimerini.gr
0.0.0.0 penix.nl #[ero-advertising.com]
0.0.0.0 ads.rude.com
0.0.0.0 banners.rude.com
0.0.0.0 banners.content.rude.com
0.0.0.0 uberads.net
0.0.0.0 smartinit.webads.nl
# [Leaseweb][Euronoc Networks][85.17.161.0 - 85.17.161.255]
0.0.0.0 artwork.aim4media.com
0.0.0.0 www.aim4media.com
0.0.0.0 popupmoney.com
0.0.0.0 www.popupmoney.com
# [Leaseweb][AS16265][88.208.52.0 - 88.208.57.255]
0.0.0.0 n.adonweb.ru
0.0.0.0 pc.adonweb.ru
0.0.0.0 wu.adonweb.ru
0.0.0.0 n.pcads.ru
# [Leaseweb][AS28753][89.149.194.0 - 89.149.255.255]
0.0.0.0 www.ipcounter.de
0.0.0.0 counter.xeanon.com
# [Leaseweb][94.75.216.0 - 94.75.235.255]
0.0.0.0 a.1nimo.com
# [Nl-leaseweb][94.75.192.0 - 94.75.255.255]
0.0.0.0 www.adhood.com
0.0.0.0 amateurdevils.com
0.0.0.0 webdata.vidz.com
# [Leaseweb][95.168.163.0 - 95.168.191.255]
0.0.0.0 www.turkeyrank.com
# [Leaseweb][AS16265][AS60781][95.211.0.0 - 95.211.255.255]
0.0.0.0 ads.ad4max.com
0.0.0.0 router.adlure.net
0.0.0.0 ads.adone.com
0.0.0.0 cache.ad-serverparc.nl
0.0.0.0 cluster.ad-serverparc.nl
0.0.0.0 clickbux.ru
0.0.0.0 adserve.donanimhaber.com
0.0.0.0 ads.discreetad.com
0.0.0.0 pops.ero-advertising.com
0.0.0.0 a.heavy-r.com
0.0.0.0 openx.iamexpat.nl
0.0.0.0 inndl.com
0.0.0.0 linktarget.com
0.0.0.0 webmasters.videarn.com
0.0.0.0 ad.wingads.com
# [Legendum LLC][Tracking Service]
0.0.0.0 db0.net-filter.com #[WebtraffIQ Code]
0.0.0.0 db2.net-filter.com
0.0.0.0 db3.net-filter.com
0.0.0.0 db4.net-filter.com
0.0.0.0 db5.net-filter.com
0.0.0.0 db6.net-filter.com
0.0.0.0 db7.net-filter.com
0.0.0.0 sitestats.com #[Tracking.Cookie]
0.0.0.0 db0.sitestats.com
0.0.0.0 db1.sitestats.com
0.0.0.0 db2.sitestats.com
0.0.0.0 db3.sitestats.com
0.0.0.0 db4.sitestats.com
0.0.0.0 db5.sitestats.com
0.0.0.0 db6.sitestats.com
0.0.0.0 db7.sitestats.com
0.0.0.0 www.sitestats.com
# [Level3 / Lee][AS3356][192.104.182.0 - 192.104.231.255]
0.0.0.0 stats-newyork1.bloxcms.com
# [Level3][AS3356][198.76.0.0 - 198.79.255.255]
0.0.0.0 cdn1.traffichaus.com
# [Level3][AS3356][199.92.0.0 - 199.95.255.255]
0.0.0.0 sscdn.banners.advidi.com
# [Level3][AS3356][205.128.0.0 - 205.131.255.255]
0.0.0.0 promo.lifeselector.com
0.0.0.0 media.b.lead.program3.com
# [Level3][AS3356][207.120.0.0 - 207.123.255.255]
0.0.0.0 rcm-images.amazon.com
0.0.0.0 cdnads.cam4.com
# [Level3 / InsightExpress][AS3356][209.244.0.0 - 209.247.255.255]
0.0.0.0 ad.insightexpress.com
0.0.0.0 www.insightexpress.com #[Lavasoft.BannedSite]
0.0.0.0 ad.insightexpressai.com
0.0.0.0 icompass.insightexpressai.com
0.0.0.0 core.insightexpressai.com
0.0.0.0 insightexpresserdd.com
# [Level3][AS3356][209.41.64.0 - 209.41.95.255]
0.0.0.0 srv2trking.com
# [Level3][AS26667][213.19.162.0 - 213.19.162.255]
0.0.0.0 pixel-eu.rubiconproject.com
# [Level3 / eXTReMe][AS3356][213.244.183.192 - 213.244.183.223]
0.0.0.0 extreme-dm.com #[WebBug]
0.0.0.0 e0.extreme-dm.com
0.0.0.0 e1.extreme-dm.com
0.0.0.0 e2.extreme-dm.com
0.0.0.0 nht-2.extreme-dm.com #[eXTReMe Tracker Code]
0.0.0.0 nht-3.extreme-dm.com
0.0.0.0 reports.extreme-dm.com
0.0.0.0 t.extreme-dm.com
0.0.0.0 t0.extreme-dm.com
0.0.0.0 t1.extreme-dm.com
0.0.0.0 u.extreme-dm.com
0.0.0.0 u0.extreme-dm.com
0.0.0.0 u1.extreme-dm.com
0.0.0.0 v.extreme-dm.com
0.0.0.0 v0.extreme-dm.com
0.0.0.0 v1.extreme-dm.com
0.0.0.0 w.extreme-dm.com
0.0.0.0 w0.extreme-dm.com
0.0.0.0 w1.extreme-dm.com
0.0.0.0 x3.extreme-dm.com
0.0.0.0 y.extreme-dm.com #[Tracking.Cookie]
0.0.0.0 y0.extreme-dm.com
0.0.0.0 y1.extreme-dm.com
0.0.0.0 z.extreme-dm.com
0.0.0.0 z0.extreme-dm.com
0.0.0.0 z1.extreme-dm.com
0.0.0.0 extremetracking.com
# [Level3][4.0.0.0 - 4.255.255.255]
0.0.0.0 adsfac.us
0.0.0.0 level3.applifier.com
0.0.0.0 ads-v-darwin.hulu.com
0.0.0.0 nbc.interpolls.com
0.0.0.0 pollserver.interpolls.com
0.0.0.0 ps2.interpolls.com
0.0.0.0 ps.interpolls.com
0.0.0.0 sw.interpolls.com
0.0.0.0 wb.interpolls.com
0.0.0.0 cdn.program3.com
0.0.0.0 m.sancdn.net
0.0.0.0 udm.ri1.scorecardresearch.com #[Microsoft Mahjong]
0.0.0.0 udm.ri2.scorecardresearch.com
0.0.0.0 udm.ri3.scorecardresearch.com
0.0.0.0 udm.ri4.scorecardresearch.com
0.0.0.0 udm.ri5.scorecardresearch.com
0.0.0.0 udm.ri6.scorecardresearch.com
0.0.0.0 udm.ri7.scorecardresearch.com
0.0.0.0 udm.ri8.scorecardresearch.com
0.0.0.0 udm.ri9.scorecardresearch.com #[Microsoft Mahjong]
# [Level3][63.208.0.0 - 63.215.255.255]
0.0.0.0 www.clickmanage.com
# [Level3 / Internext Media][67.29.139.128 - 67.29.139.255]
0.0.0.0 www.abcjmp.com
0.0.0.0 3151.77152.blueseek.com
0.0.0.0 4802.170.blueseek.com
0.0.0.0 5740.4785.blueseek.com
0.0.0.0 5882.1158.blueseek.com
0.0.0.0 5990.findit.blueseek.com
0.0.0.0 7457.accessaw.blueseek.com
0.0.0.0 7457.pownit.blueseek.com
0.0.0.0 7979.nosubid.blueseek.com
0.0.0.0 itc.2081.blueseek.com
0.0.0.0 itcg3.c5369.blueseek.com
0.0.0.0 2183.jsjmlejl.clickshield.net
0.0.0.0 redirect.clickshield.net
0.0.0.0 www.icityfind.com
0.0.0.0 primosearch.com
0.0.0.0 4133.88.primosearch.com
0.0.0.0 4654.2465.primosearch.com
0.0.0.0 5490.spedads.primosearch.com
0.0.0.0 5486.winxp.primosearch.com
0.0.0.0 6266.570204.primosearch.com
0.0.0.0 www.primosearch.com
0.0.0.0 whatseek.com
# [Level 3][AS3356][67.72.0.0 - 67.75.255.255]
0.0.0.0 ads.empoweringmedia.net
# [Level3][AS3356][AS26667][AS11946][8.0.0.0 - 8.255.255.255]
0.0.0.0 ad.71i.de
0.0.0.0 www.advconversion.com
0.0.0.0 network.advertise.com
0.0.0.0 www.advertise.com
0.0.0.0 d.agkn.com #[WebBug]
0.0.0.0 cdn.alleliteads.com
0.0.0.0 adbcache.brandreachsys.com
0.0.0.0 cdn1.ads.brazzers.com
0.0.0.0 i.cdnpark.com
0.0.0.0 connect5364.com
0.0.0.0 coreclickhoo.com
0.0.0.0 ads.cracked.com
0.0.0.0 track.cracked.com
0.0.0.0 ping.crowdscience.com
0.0.0.0 click.dealshark.com
0.0.0.0 ads.deviantart.com
0.0.0.0 adsvr.deviantart.com
0.0.0.0 ads.exoclick.com
0.0.0.0 msnads-wm9.fplive.net #[MSN Video Ads]
0.0.0.0 ips-invite.iperceptions.com
0.0.0.0 ads.mediaforge.com
0.0.0.0 img.metaffiliation.com
0.0.0.0 a.global.msads.net
0.0.0.0 global.msads.net
0.0.0.0 ads.msn.com
0.0.0.0 ads1.msn.com
0.0.0.0 ads2.msn.com
0.0.0.0 a.ads1.msn.com
0.0.0.0 b.ads1.msn.com
0.0.0.0 a.ads2.msn.com
0.0.0.0 cdn.promo.pimproll.com
0.0.0.0 cdn.g.promosrv.com
0.0.0.0 rd-direct.com
0.0.0.0 cdn.redlightcenter.com
0.0.0.0 beacon-us-iad2.rubiconproject.com
0.0.0.0 fastlane.rubiconproject.com
0.0.0.0 pixel-us-west.rubiconproject.com
0.0.0.0 banners.securedataimages.com
0.0.0.0 e.sexad.net
0.0.0.0 pod.sexsearch.com
# 0.0.0.0 api.solvemedia.com #[affects captcha]
0.0.0.0 pixel.solvemedia.com
0.0.0.0 fms2.pointroll.speedera.net
0.0.0.0 ad-cdn.technoratimedia.com
0.0.0.0 demoq.use-trade.com
0.0.0.0 ads2.vortexmediagroup.com #[AdvertPro]
0.0.0.0 richmedia.yimg.com
# [Lightstorm Communications][AS42005][92.240.234.0 - 92.240.237.255]
0.0.0.0 blueadvertise.com #[Google.Diagnostic][2013-01-02]
0.0.0.0 adserver2.blueadvertise.com
0.0.0.0 cbpublishing.blueadvertise.com
0.0.0.0 cdxninteractive.blueadvertise.com
0.0.0.0 creditburner.blueadvertise.com
0.0.0.0 my.blueadvertise.com
0.0.0.0 ads.opensubtitles.org
# [Limelight][AS22822][208.111.128.0 - 208.111.191.255]
0.0.0.0 ll.atdmt.com
0.0.0.0 s.atemda.com
0.0.0.0 static.ifa.camads.net
0.0.0.0 qlipsodigital.checkm8.com
0.0.0.0 static.contentabc.com
0.0.0.0 static.cpalead.com
0.0.0.0 cache.daredorm.com
0.0.0.0 cachewww.europacasino.com
0.0.0.0 cdn.intermarkets.net
0.0.0.0 intermrkts.vo.llnwd.net
0.0.0.0 wbads.vo.llnwd.net
0.0.0.0 scripts.mofos.com
0.0.0.0 cache.realitykings.com
0.0.0.0 media.sexinyourcity.com
0.0.0.0 cdn.taboolasyndication.com
0.0.0.0 cdn.banner.thumbplay.com
0.0.0.0 media.trafficjunky.net
0.0.0.0 pl.yumenetworks.com
0.0.0.0 pl1.yumenetworks.com
# [Limelight][68.142.64.0 - 68.142.127.255]
0.0.0.0 cdn.cpmstar.com
0.0.0.0 static.ads.crakmedia.com
0.0.0.0 static.fleshlight.com
0.0.0.0 content.ipro.com #[WebBug]
0.0.0.0 cdn-01.yumenetworks.com
# [Limelight][69.164.0.0 - 69.164.63.255]
0.0.0.0 tealium.hs.llnwd.net
0.0.0.0 img100-321.xvideos.com
# [Limelight][69.28.128.0 - 69.28.191.255]
0.0.0.0 cdn.advancedmactools.com #[Riskware.Mac/PUP]
# 0.0.0.0  libs.coremetrics.com #[affects tMobile/EverBank]
0.0.0.0 cdn.content.exoticads.com
0.0.0.0 munchkin.marketo.net
# [Limestone][AS46475][69.162.64.0 - 69.162.127.255]
0.0.0.0 e.freewebhostingarea.com
# [Limestone][AS46475][74.63.224.172]
0.0.0.0 www.advancedmactools.com
# [Liquid Web][AS32244][192.138.16.0/21]
0.0.0.0 trackingclicks.xyz
# [Liquid Web][AS32244][209.59.128.0 - 209.59.191.255]
0.0.0.0 ad-rotator.com #[adspeed.com]
0.0.0.0 serv.adspeed.com
0.0.0.0 www.adspeed.com
0.0.0.0 clickthru.net
0.0.0.0 nbrtrack.com
# [Liquid Web][AS32244][50.28.0.0 - 50.28.127.255]
0.0.0.0 filter.eclickz.com
0.0.0.0 ads.localyokelmedia.com
0.0.0.0 tracki112.com
# [Liquid Web][67.225.128.0 - 67.225.255.255]
0.0.0.0 www.adimpact.com
0.0.0.0 blogadswap.com
0.0.0.0 clixtk.com
0.0.0.0 www.iwstats.com
0.0.0.0 maxtracker.net
# [Liquid Web][67.227.128.0 - 67.227.255.255]
0.0.0.0 www.adworkmedia.com
0.0.0.0 quik2link.com
0.0.0.0 uptodatecontent.net
# [Liquid Web][AS32244][69.167.128.0 - 69.167.191.255]
0.0.0.0 ctrck.com
# [Liquid Web][69.16.192.0 - 69.16.255.255]
0.0.0.0 search.eclickz.com
0.0.0.0 www.freeusersonline.com
0.0.0.0 www.linkcounter.com
# [Liquid Web][72.52.128.0 - 72.52.255.255]
0.0.0.0 www.adcash.com
0.0.0.0 adspserving.com
0.0.0.0 www.adversal.com
0.0.0.0 adv.blogupp.com
0.0.0.0 www.chrumedia.com
0.0.0.0 www.hit-counts.com
0.0.0.0 www.validview.com
0.0.0.0 ads.peoplespharmacy.com
0.0.0.0 www.yieldtraffic.com
# [Lirex][AS8262][164.138.220.0 - 164.138.221.255]
0.0.0.0 ads.3e-news.net
0.0.0.0 b.detetoigrae.com
# [Lirex][AS8262][195.191.148.0 - 195.191.149.255]
0.0.0.0 track.make-a-site.net
# [Lirex / SuperHosting.BG][AS8262][91.196.124.0 - 91.196.127.255]
0.0.0.0 www.cpmfun.com
0.0.0.0 ex-traffic.com
0.0.0.0 forexadv.eu
0.0.0.0 stat.ganbox.com
0.0.0.0 ads.ka6tata.com
0.0.0.0 adds.misiamoiatdom.com
0.0.0.0 ad.moreto.net
# [LL Limelight / Sobonito][AS31958][66.6.16.0 - 66.6.31.255]
0.0.0.0 analytic.gatewayinterface.com
0.0.0.0 analyticcdn.globalmailer.com
0.0.0.0 mediaview.globalmailer.com
0.0.0.0 rt.globalmailer.com
0.0.0.0 pcash.globalmailer5.com
0.0.0.0 pcash.imlive.com
0.0.0.0 ads.sexier.com
0.0.0.0 pcash.wildmatch.com
# [Lotame][AS40787][74.217.85.0 - 74.217.85.255]
0.0.0.0 ad.crwdcntrl.net
0.0.0.0 ag.tags.crwdcntrl.net
0.0.0.0 bb.crwdcntrl.net
0.0.0.0 bcp.crwdcntrl.net
0.0.0.0 bebo.crwdcntrl.net
0.0.0.0 blogtalkradio.crwdcntrl.net
0.0.0.0 cdn.crwdcntrl.net
0.0.0.0 celebslam.tags.crwdcntrl.net
0.0.0.0 cnnmoney.tags.crwdcntrl.net
0.0.0.0 coop.crwdcntrl.net
0.0.0.0 deviantart.crwdcntrl.net
0.0.0.0 fotolog.crwdcntrl.net
0.0.0.0 huffingtonpost.crwdcntrl.net
0.0.0.0 justjared.crwdcntrl.net
0.0.0.0 livejournal.tags.crwdcntrl.net
0.0.0.0 multiply.crwdcntrl.net
0.0.0.0 nbcu.tags.crwdcntrl.net
0.0.0.0 perfspot.crwdcntrl.net
0.0.0.0 sociallitelife.tags.crwdcntrl.net
0.0.0.0 sportsillustrated.tags.crwdcntrl.net
0.0.0.0 superficial.crwdcntrl.net
0.0.0.0 tags.crwdcntrl.net
0.0.0.0 videogum.tags.crwdcntrl.net
0.0.0.0 vidilife.crwdcntrl.net
0.0.0.0 wwtdd.tags.crwdcntrl.net
0.0.0.0 yardbarker.tags.crwdcntrl.net
# [Mail.RU][AS47764][217.69.128.0 - 217.69.135.255]
0.0.0.0 top-fwz1.mail.ru
# [Mail.RU][AS47764][94.100.176.0 - 94.100.183.255]
0.0.0.0 list.ru
0.0.0.0 top.list.ru
0.0.0.0 top1.list.ru
0.0.0.0 top3.list.ru #[WebBug]
0.0.0.0 top6.list.ru
# [Mail.RU][AS47764][94.100.184.0 - 94.100.191.255]
0.0.0.0 host4.list.ru
# [Marchex][AS40495][AS14126][174.137.112.0 - 174.137.127.255]
0.0.0.0 www.enhance.com
0.0.0.0 gflinks.industrybrains.com
0.0.0.0 ilinks.industrybrains.com
0.0.0.0 imglinks.industrybrains.com
0.0.0.0 jlinks.industrybrains.com
0.0.0.0 links.industrybrains.com
0.0.0.0 shlinks.industrybrains.com
# [Marchex][66.116.109.0 - 66.116.109.127]
0.0.0.0 mdnhinc.com
# [Marchex][66.116.125.0 - 66.116.125.255]
0.0.0.0 goclick.com
0.0.0.0 c.mdnhinc.com
0.0.0.0 cb.mdnhinc.com
0.0.0.0 title.mximg.com
# [Marchex][8.14.168.0 - 8.14.171.255]
0.0.0.0 adtrack.voicestar.com
# [Master / Fast Internet][149.62.148.0 - 149.62.148.255]
0.0.0.0 banners.yllix.com
0.0.0.0 click2.yllix.com
0.0.0.0 promo.love-money.de
# [Master / Fast Internet][AS24971][89.185.228.0  - 89.185.234.255]
0.0.0.0 www.hypercounter.com
# [Masterhost][AS25532][217.16.27.0 - 217.16.27.255]
0.0.0.0 engine.turboroller.ru
# [Masterhost][83.222.30.0 - 83.222.31.255]
0.0.0.0 mytraf.info
0.0.0.0 www.mytraf.info
0.0.0.0 mytraf.ru
0.0.0.0 www.mytraf.ru
# [Masterhost][AS25532][87.242.72.0 - 87.242.91.255]
0.0.0.0 banners.adfox.ru
0.0.0.0 rq.adfox.ru
0.0.0.0 sup.adfox.ru
0.0.0.0 sedu.adhands.ru
0.0.0.0 img.dt00.net
0.0.0.0 mg.dt00.net
0.0.0.0 nbimg.dt00.net
0.0.0.0 counter.hitmir.ru
0.0.0.0 marketgid.com
0.0.0.0 a.marketgid.com
0.0.0.0 autocounter.marketgid.com
0.0.0.0 c.marketgid.com
0.0.0.0 cdn.marketgid.com
0.0.0.0 counter.marketgid.com
0.0.0.0 mg.marketgid.com
0.0.0.0 parking.reg.ru
0.0.0.0 com.adv.vz.ru
0.0.0.0 234x120.adv.vz.ru
0.0.0.0 p2p.adv.vz.ru
0.0.0.0 txt.adv.vz.ru
0.0.0.0 tizer.adv.vz.ru
# [Masterhost][AS25532][90.156.178.0 - 90.156.179.255]
0.0.0.0 counter.aport.ru
0.0.0.0 gs.spylog.ru
0.0.0.0 spylog.com #[WebBug]
0.0.0.0 hits.spylog.com
0.0.0.0 www.spylog.com
0.0.0.0 spylog.ru
0.0.0.0 tools.spylog.ru
0.0.0.0 www.spylog.ru
# [Maxolution][AS42557][193.239.248.0 - 193.239.249.255]
0.0.0.0 promotion.partnercash.de
# [Mecuriuz][AS48172][188.127.224.0 - 188.127.231.255]
0.0.0.0 advert.rare.ru
# [Media Breakaway / OptinRealBig.com][AS32311][69.6.27.0 - 69.6.27.255]
0.0.0.0 www.cpaempire.com
0.0.0.0 ekmas.com
# [Mediametrie Estat][AS34980][194.126.156.0 - 194.126.157.255]
0.0.0.0 estat.com
0.0.0.0 prof.estat.com #[WebBug]
0.0.0.0 s.estat.com
0.0.0.0 w.estat.com
0.0.0.0 www.estat.com
# [Mediametrie Estat][AS34980][91.213.146.0 - 91.213.146.255]
# 0.0.0.0  stat3.cybermonitor.com #[affects podcasts]
# [Media Temple][AS31815][216.70.64.0 - 216.70.127.255]
0.0.0.0 www.adpeepshosted.com
# [Media Temple][AS31815][64.207.128.0 - 64.207.191.255]
0.0.0.0 ping.hellobar.com
# [Media Temple][AS31815][72.47.192.0 - 72.47.255.255]
0.0.0.0 www.adblockanalytics.com
0.0.0.0 adklip.com
0.0.0.0 topads.rrstar.com
# [Microsoft][AS8075][13.64.0.0/11]
0.0.0.0 inv-nets.admixer.net
# [Microsoft][AS8075][104.208.0.0 - 104.215.255.255]
# [Microsoft][AS8069][111.221.16.0 - 111.221.31.255]
0.0.0.0 iact.atdmt.com
# [Microsoft][AS8075][131.253.12.0 - 131.253.18.255]
0.0.0.0 c.atdmt.com
0.0.0.0 flex.msn.com
# [Microsoft][AS8075][137.116.0.0 - 137.116.255.255]
0.0.0.0 otf.msn.com
0.0.0.0 trafficgateway.research-int.se
# [Microsoft][AS8075][137.135.0.0 - 137.135.255.255]
0.0.0.0 my.trackjs.com
# [Microsoft][AS8075][157.54.0.0 - 157.60.255.255]
0.0.0.0 image.atdmt.com
0.0.0.0 img.atdmt.com
# 0.0.0.0  switch.atdmt.com #[affects Hotmail signup]
# 0.0.0.0  view.atdmt.com #[affects Microsoft / Sprint.com]
0.0.0.0 www.atdmt.com #[AveA Action Tag]
0.0.0.0 analytics.newsvine.com
# [Microsoft][AS8075][168.61.0.0 - 168.63.255.255]
0.0.0.0 tracking.bannerflow.com
# [Microsoft][AS8075][191.232/14]
0.0.0.0 analytics-eu.clickdimensions.com
# [Microsoft][AS8075][191.236/14]
0.0.0.0 universal.iperceptions.com
# [Microsoft][AS8075][207.46.0.0 - 207.46.255.255]
0.0.0.0 api.atdmt.com
0.0.0.0 bidclix.net
0.0.0.0 www.bidclix.net
0.0.0.0 collector.deepmetrix.com
0.0.0.0 www.deepmetrix.com
0.0.0.0 adsyndication.msn.com
0.0.0.0 c.no.msn.com
0.0.0.0 log.newsvine.com #[WebBug]
# [Microsoft][AS8075][23.96.0.0 - 23.103.255.255]
0.0.0.0 e3.adpushup.com
0.0.0.0 mt.adquality.ch
0.0.0.0 api.iperceptions.com
0.0.0.0 adserver.pressboard.ca
0.0.0.0 data.queryly.com
# [Microsoft][AS8075][40.64.0.0/10]
0.0.0.0 geolocation.onetrust.com
# [Microsoft][AS8075][65.52.0.0 - 65.55.255.255]
0.0.0.0 aidps.atdmt.com
0.0.0.0 analytics.atdmt.com
0.0.0.0 c1.atdmt.com
0.0.0.0 ec.atdmt.com
0.0.0.0 h.atdmt.com
0.0.0.0 bat.bing.com
0.0.0.0 c.bing.com
0.0.0.0 analytics.breakingnews.com
0.0.0.0 analytics.clickdimensions.com
0.0.0.0 analytics.live.com
0.0.0.0 digg.analytics.live.com #[WebBug]
0.0.0.0 madserver.net
0.0.0.0 ads1.msads.net
0.0.0.0 a.ads1.msads.net
0.0.0.0 a.ads2.msads.net
0.0.0.0 b.ads2.msads.net
0.0.0.0 analytics.msn.com
0.0.0.0 ads.eu.msn.com
0.0.0.0 images.adsyndication.msn.com
0.0.0.0 analytics.msnbc.msn.com
0.0.0.0 mobileads.msn.com
0.0.0.0 blu.mobileads.msn.com
0.0.0.0 col.mobileads.msn.com
0.0.0.0 popup.msn.com
0.0.0.0 analytics.r.msn.com
0.0.0.0 0.r.msn.com
# 0.0.0.0  rad.msn.com #[affects MSN Messenger]
0.0.0.0 rmads.msn.com
0.0.0.0 rmads.eu.msn.com
0.0.0.0 analytics.msnbc.com
0.0.0.0 msn.serving-sys.com
# [Microsoft][AS8075][70.37.0.0 - 70.37.191.255]
# [Microsoft][AS8075][94.245.64.0 - 94.245.127.255]
0.0.0.0 click.atdmt.com #[Tracking.Cookie]
# 0.0.0.0  clk.atdmt.com #[affects MS downloads]
0.0.0.0 jact.atdmt.com
0.0.0.0 sact.atdmt.com
# [Mirror Image][AS12168][216.38.160.0 - 216.38.175.255]
0.0.0.0 beacon.clickequations.net #[WebBug]
0.0.0.0 js.clickequations.net
0.0.0.0 servedby.o2.co.uk
0.0.0.0 i.w55c.net
# [Miva Corporation][AS14745][Starware]
0.0.0.0 v10.xmlsearch.miva.com #[Adware.Zeno]
# [Mohawk][AS14537][109.202.114.224 - 109.202.114.255]
0.0.0.0 partners.10bet.com
# [Mohawk Internet / Gaming Limited][AS14537][66.212.242.64 - 66.212.242.95]
0.0.0.0 affiliates.bet-at-home.com
0.0.0.0 sportingbeteur.adsrv.eacdn.com
0.0.0.0 partners.fanduel.com
0.0.0.0 banner.goldenpalace.com #[Tracking.Cookie]
0.0.0.0 affiliates.neteller.com
0.0.0.0 affiliates.pinnaclesports.com
0.0.0.0 partner.sbaffiliates.com
0.0.0.0 banners.victor.com
# [Mohawk Internet][AS14537][67.211.96.0 - 67.211.111.255]
0.0.0.0 ecess1.cdn.continent8.com
# [MojoHost][AS27589][199.182.106.32 - 199.182.106.47]
0.0.0.0 one.cam4ads.com
# [MojoHost / Easy Online Solutions][208.122.192.0 - 208.122.223.255]
0.0.0.0 beta.galleries.paperstreetcash.com
0.0.0.0 pepipo.com
0.0.0.0 www.pepipo.com
# [MojoHost / Easy Online Solutions][64.59.64.0 - 64.59.127.255]
0.0.0.0 a.adnium.com
0.0.0.0 popit.mediumpimpin.com
# [MojoHost / Aw Telecom][AS27589][64.59.82.128 - 64.59.82.159]
0.0.0.0 promo.sensationalcash.com
# [MojoHost / Easy Online Solutions][AS27589][74.206.160.0 - 74.206.191.255]
0.0.0.0 creative.nscash.com
0.0.0.0 www.spunkycash.com
# [MojoHost / Webquest][AS27589][99.192.140.32 - 99.192.140.47]
0.0.0.0 flashadtools.com
0.0.0.0 www.flashadtools.com
0.0.0.0 geo.gexo.com
0.0.0.0 ads.hornypharaoh.com
0.0.0.0 tools.pacinocash.com
0.0.0.0 analytics.pimproll.com
0.0.0.0 dev.trafficforce.com
0.0.0.0 ads.voyit.com
# [Momentum Solutions][AS23136][69.77.186.0 - 69.77.186.255]
0.0.0.0 board.classifieds1000.com
# [Moskvacom][AS2118][195.95.155.0 - 195.95.155.255]
0.0.0.0 edmedsnow.com
# [Mts Allstream][AS15290][64.4.64.0 - 64.4.95.255]
0.0.0.0 pk.adlandpro.com
0.0.0.0 te.adlandpro.com
0.0.0.0 trafficex.adlandpro.com
0.0.0.0 www.adlandpro.com #[Tracking.Cookie]
# [Multacom][TrekEight][AS35916][72.44.64.0 - 72.44.79.255]
0.0.0.0 www.errornuker.com
0.0.0.0 www.evidencenuker.com
0.0.0.0 spamnuker.com
0.0.0.0 www.spamnuker.com
# [Mynet][AS12858][212.101.96.0 - 212.101.127.255]
0.0.0.0 ads2.mynet.com
# [Natcoweb][AS46636][204.62.12.0 - 204.62.15.255]
0.0.0.0 getmailcounter.com
# [Natcoweb][AS46636][88.214.197.0 - 88.214.197.255]
0.0.0.0 1empiredirect.com
0.0.0.0 mysearchweb.net
# [Nationalnet][AS22384][173.0.64.0 - 173.0.79.255]
0.0.0.0 gen2server.com
# [Nationalnet][AS22384][173.45.172.0 - 173.45.172.255]
0.0.0.0 redroomnetwork.com
0.0.0.0 www.redroomnetwork.com
# [Nationalnet][216.201.80.0 - 216.201.95.255]
0.0.0.0 nats4.fetishbucks.com
0.0.0.0 www.ninjadollars.com
# [Nationalnet / Live Interactive][AS22384][66.115.128.0 - 66.115.191.255]
0.0.0.0 lo2.me
0.0.0.0 ocxxx.com
0.0.0.0 ads.oxymoronent.com
0.0.0.0 secure6.platinumbucks.com
0.0.0.0 ayboll.sgsrv.com
0.0.0.0 sureads.com
0.0.0.0 stats.xxxrewards.com
# [Nationalnet][AS22384][69.50.128.0 - 69.50.143.255]
0.0.0.0 www.adregistry.com
0.0.0.0 scrollingads.hustlermegapass.com
0.0.0.0 www.mediareps.com
0.0.0.0 tools.naughtyamerica.com
0.0.0.0 www.secretbehindporn.com #[ScamFraudAlert.Pharmacy]
0.0.0.0 vmn.net
# [NaviSite][AS14135][216.236.224.0 - 216.236.239.255]
0.0.0.0 sony.tcliveus.com
0.0.0.0 tc.zionsbank.com #[zionsbank.tcliveus.com]
# [NaviSite / Joyent][AS14135][72.2.112.0 - 72.2.127.255]
0.0.0.0 realtimeads.com
# [Net2ez][AS558][173.245.2.0 - 173.245.2.127]
0.0.0.0 ads.eqads.com
0.0.0.0 e-ads.eqads.com
# [Net2EZ / Visionaire][AS558][64.93.64.0 - 64.93.95.255]
0.0.0.0 broadspring.com
0.0.0.0 www.broadspring.com
0.0.0.0 api.content.ad
0.0.0.0 partners.content.ad
0.0.0.0 adserver.matchcraft.com
# [Net2ez][AS558][69.89.64.0 - 69.89.95.255]
0.0.0.0 engine.4dsply.com
0.0.0.0 engine.adsupply.com
0.0.0.0 tracking.1betternetwork.com
0.0.0.0 cpatrack.leadn.com
0.0.0.0 tracking.opienetwork.com
# [Net2ez][AS558][72.172.64.0 - 72.172.95.255]
0.0.0.0 www.adminder.com #[Tracking.Cookie]
0.0.0.0 analytics.atomiconline.com
0.0.0.0 widget.crowdignite.com
0.0.0.0 geo.gorillanation.com
0.0.0.0 cms.springboard.gorillanation.com
0.0.0.0 analytics.springboardvideo.com
0.0.0.0 analytics.stg.springboardvideo.com
# [Net Access][AS8001][173.255.192.0 - 173.255.255.255]
0.0.0.0 stats.thoughtcatalog.com
# [Net Access / Cdnetworks][AS8001][66.114.48.0 - 66.114.63.255]
0.0.0.0 img.linkstorm.net
# [Net Access][AS8001][66.228.32.0 - 66.228.63.255]
0.0.0.0 tracking.onespot.com
# [Netcen][AS3.535][46.245.163.1 - 46.245.163.255]
0.0.0.0 ads.dijitalvarliklar.com
0.0.0.0 banner-img.haber7.com
# [Netelligent][AS10929][205.204.64.0 - 205.204.95.255]
# [Netelligent / SearchAnyway][64.15.72.0 - 64.15.72.127]
0.0.0.0 www.coolfreehost.com
# [NetHolding][AS24730][81.173.64.0 - 81.173.64.255]
0.0.0.0 schoorsteen.geenstijl.nl
# [Netinfo][AS13147][194.153.145.0 - 194.153.145.255]
# [Netinfo][AS13147][217.174.144.0 - 217.174.159.255]
0.0.0.0 banners.alo.bg
0.0.0.0 adv.starozagorci.com
0.0.0.0 openx.vsekiden.com
# [Netinfo][AS13147][78.128.0.0 - 78.128.63.255]
# [Netinfo][AS13147][79.124.64.0 - 79.124.95.255]
0.0.0.0 adv.webvariant.com
# [Netinfo][AS13147][87.120.40.0 - 87.120.41.255]
0.0.0.0 adv.consadbg.com
# [NetNation][AS14280][64.40.96.0 - 64.40.127.255]
0.0.0.0 www.revisitors.com
0.0.0.0 affiliates.thrixxx.com
0.0.0.0 content.thrixxx.com
# [Netsaits BV]
0.0.0.0 cz2.clickzs.com
0.0.0.0 cz3.clickzs.com
0.0.0.0 cz4.clickzs.com
0.0.0.0 cz5.clickzs.com
0.0.0.0 cz6.clickzs.com
0.0.0.0 cz7.clickzs.com
0.0.0.0 cz8.clickzs.com
0.0.0.0 cz9.clickzs.com
0.0.0.0 cz11.clickzs.com
0.0.0.0 js3.clickzs.com #[Tracking.Cookie]
0.0.0.0 js4.clickzs.com
0.0.0.0 js5.clickzs.com
0.0.0.0 js6.clickzs.com
0.0.0.0 js7.clickzs.com
0.0.0.0 js8.clickzs.com
0.0.0.0 js9.clickzs.com
0.0.0.0 js11.clickzs.com
0.0.0.0 jsp.clickzs.com
0.0.0.0 jsp2.clickzs.com
0.0.0.0 vip.clickzs.com
0.0.0.0 vip2.clickzs.com
0.0.0.0 www.clickzs.com
0.0.0.0 www.hit-now.com
# [Nedstat][AS42320][212.72.32.0 - 212.72.63.255]
0.0.0.0 www.netdirect.nl
0.0.0.0 startpunt.nu.site-id.nl
0.0.0.0 www.site-id.nl
# [Net Ground][AS41445 ][87.250.141.0 - 87.250.141.255]
0.0.0.0 geoaddicted.net
0.0.0.0 promotools.islive.nl
0.0.0.0 promotools.vpscash.nl
# [Neterra][AS34224][31.13.222.80 - 31.13.222.95]
0.0.0.0 affiliate.bfashion.com
# [Neterra][AS34224][87.120.176.0 - 87.121.59.255]
# [Neterra][AS34224][94.156.102.0 - 94.156.102.255]
0.0.0.0 ads.bg-mamma.com
# [Netvertising][][84.2.34.0 - 84.2.34.63]
0.0.0.0 adedy.com
0.0.0.0 adserver.hardsextube.com
# [NetVision / Elron][AS1680][207.232.0.0 - 207.232.63.255]
0.0.0.0 dm.mlstat.com
0.0.0.0 www.mlstat.com
# [NetVision][AS1680][212.143.22.0 - 212.143.22.255]
0.0.0.0 ads.downloadaccelerator.com
0.0.0.0 ad1.speedbit.com
0.0.0.0 ad2.speedbit.com
0.0.0.0 ad3.speedbit.com
0.0.0.0 ad4.speedbit.com
0.0.0.0 ad5.speedbit.com
0.0.0.0 ad6.speedbit.com
0.0.0.0 ad7.speedbit.com
0.0.0.0 ad8.speedbit.com
0.0.0.0 ad9.speedbit.com
0.0.0.0 ad10.speedbit.com
0.0.0.0 ads1.speedbit.com
0.0.0.0 ads2.speedbit.com
0.0.0.0 ads3.speedbit.com
0.0.0.0 ads4.speedbit.com
0.0.0.0 ads5.speedbit.com
0.0.0.0 ads6.speedbit.com
0.0.0.0 ads7.speedbit.com
0.0.0.0 ads8.speedbit.com
0.0.0.0 ads9.speedbit.com
0.0.0.0 ads10.speedbit.com
0.0.0.0 mirrorsearch.speedbit.com
# [NetVision][AS8584][212.150.0.0 - 212.150.255.255]
0.0.0.0 protizer.ru
# [NetVision][AS1680][212.29.254.192 - 212.29.254.255]
# [NetVision / Adperform][AS1680][62.90.134.16 - 62.90.134.31]
0.0.0.0 www.adoptim.com
0.0.0.0 ariboo.com
0.0.0.0 www.ariboo.com
# [NetVision][AS1680][82.166.0.0 - 82.166.255.255]
0.0.0.0 ads.globescale.com
0.0.0.0 cursor.kvada.globescale.com
# [Network Data Center][AS33322][208.67.180.0 - 208.67.183.255]
0.0.0.0 cetrk.com #[Crazy Egg]
0.0.0.0 crazyegg.com
# [Network Operations][AS21788][173.212.192.0 - 173.212.255.255]
0.0.0.0 ads.kyalon.net
# [Network Solutions][AS6245][205.178.128.0 - 205.178.191.255]
0.0.0.0 ads.netsol.com
0.0.0.0 stats.netsolads.com
0.0.0.0 ads.networksolutions.com
0.0.0.0 code.superstats.com
0.0.0.0 counter.superstats.com
0.0.0.0 stats.superstats.com
# [NeverBlue Media][Vertrue Inc]
0.0.0.0 kvors.com
0.0.0.0 nbjmp.com
0.0.0.0 rotator.nbjmp.com
# [Nexica][AS24592][212.92.32.0 - 212.92.63.255]
0.0.0.0 codead.impresionesweb.com
0.0.0.0 codenew.impresionesweb.com
0.0.0.0 gad.impresionesweb.com
# [Nexica][AS24592][217.13.124.64 - 217.13.124.127]
0.0.0.0 ad.impresionesweb.com
0.0.0.0 alt.impresionesweb.com
0.0.0.0 code.impresionesweb.com
0.0.0.0 gb.impresionesweb.com
0.0.0.0 paneles.impresionesweb.com
0.0.0.0 www.impresionesweb.com
0.0.0.0 alternativos.iw-advertising.com
0.0.0.0 ad.sgdgjarfpp123.com
0.0.0.0 play.sunmediaads.com
# [MISC NEWS SITES]
0.0.0.0 ads.admaxasia.com
0.0.0.0 adnet.asahi.com
0.0.0.0 ads.bangkokpost.co.th
0.0.0.0 stats.bbc.co.uk #[may affect iPlayer app]
0.0.0.0 visualscience.external.bbc.co.uk
0.0.0.0 ads.bcnewsgroup.com
0.0.0.0 ads.bninews.com
0.0.0.0 as1.casinocity.com
0.0.0.0 adtrack.cimedia.net
0.0.0.0 realaudio.cimedia.net
0.0.0.0 fr.classic.clickintext.net
0.0.0.0 fr.64.clickintext.net
0.0.0.0 clips.coolerads.com
0.0.0.0 www.dolanadserver.com
0.0.0.0 advertising.embarcaderopublishing.com
0.0.0.0 klipmart.forbes.com
0.0.0.0 www.gcmadvertising.com
0.0.0.0 ad.hankooki.com
0.0.0.0 advertising.illinimedia.com
0.0.0.0 mouads.com
0.0.0.0 ads.nytimes.com
0.0.0.0 up.nytimes.com #[WebBug][About.com]
0.0.0.0 webtrends.randallpub.com
0.0.0.0 ads.rttnews.com
# [Misc News via Advance Publications Group][69.2.96.0 - 69.2.127.255]
0.0.0.0 ads.advance.net
0.0.0.0 ads.al.com
0.0.0.0 ads.cleveland.com
0.0.0.0 ads.gulflive.com
0.0.0.0 ads.lehighvalleylive.com
0.0.0.0 ads.masslive.com
0.0.0.0 ads.mlive.com
0.0.0.0 ads.nj.com #[RealMedia]
0.0.0.0 ads.nola.com
0.0.0.0 ads.oregonlive.com
0.0.0.0 ads.pennlive.com #[RealMedia]
0.0.0.0 ads.silive.com
0.0.0.0 ads.syracuse.com
# [Misc News via Belo Interactive]
0.0.0.0 ads.belointeractive.com #[RealMedia][Tracking.Cookie]
# [Misc News via Gannett Media]
0.0.0.0 gannett.gcion.com #[glb.adtechus.com]
# [Nforce][AS43350][77.247.177.0 - 77.247.177.127]
0.0.0.0 bestoffers.activeshopper.com
0.0.0.0 e-zshopper.activeshopper.com #[Adware.ActivShop]
0.0.0.0 mini.activeshopper.com
0.0.0.0 mobile.activeshopper.com
0.0.0.0 uk.activeshopper.com
# [Nforce][AS43350][77.247.178.0 - 77.247.178.255]
0.0.0.0 admez.com
0.0.0.0 www.admez.com
0.0.0.0 andr.net
0.0.0.0 www.andr.net
0.0.0.0 ads.identads.com
0.0.0.0 v2.urlads.net
0.0.0.0 www.urlcash.net
0.0.0.0 media.ventivmedia.com
# [Nforce][AS43350][85.159.232.0 - 85.159.232.63]
0.0.0.0 date.ventivmedia.com
0.0.0.0 stats.ventivmedia.com
# [Nforce][AS43350][85.159.233.0 - 85.159.233.255]
0.0.0.0 ads.ventivmedia.com
# [NHN][AS23576][103.6.172.0 - 103.6.175.255]
0.0.0.0 ad.naver.com
0.0.0.0 adcreative.naver.com
# [nLayer][AS4436][108.161.176.0 - 108.161.191.255]
0.0.0.0 vistabet-affiliate.host.bannerflow.com
0.0.0.0 cdn.beaconads.com
0.0.0.0 cdn.app.exitmonitor.com
0.0.0.0 cdn.ndparking.com #[Parking.Service]
0.0.0.0 cdn.popcash.net
0.0.0.0 tags.api.umbel.com
# [nLayer][AS4436][198.232.112.0 - 198.232.127.255]
0.0.0.0 backfill.ph.affinity.com
0.0.0.0 inm.affinitymatrix.com
0.0.0.0 cdn.chitika.net
0.0.0.0 adn.fusionads.net
0.0.0.0 cdn.petametrics.com
# [Noc4hosts][AS29802][206.51.224.0 - 206.51.239.255]
0.0.0.0 ad.reachppc.com
# [Noc4Hosts / Intensive][74.50.104.0 - 74.50.111.255]
0.0.0.0 pubs.hiddennetwork.com
# [Nozone Inc][AS33386][208.100.0.0 - 208.100.63.255]
0.0.0.0 pixel1097.everesttech.net
0.0.0.0 pixel1324.everesttech.net
0.0.0.0 pixel1350.everesttech.net
0.0.0.0 pixel1370.everesttech.net #[WebBug]
0.0.0.0 pixel1553.everesttech.net
0.0.0.0 pixel1739.everesttech.net
0.0.0.0 raskrutka.ucoz.com
# [Ntt America][AS2914][128.242.0.0 - 128.242.255.255]
0.0.0.0 www.ad-souk.com
# [Ntt America][AS2914][161.58.0.0 - 161.58.255.255]
0.0.0.0 ads.mediatwo.com
# [Ntt America][AS2914][165.254.0.0 - 165.254.255.255]
0.0.0.0 mads.dailymail.co.uk
0.0.0.0 in-cdn.effectivemeasure.net
# [Ntt America][168.143.0.0 - 168.143.255.255]
0.0.0.0 scripts.chitika.net
0.0.0.0 rtbcdn.doubleverify.com
# 0.0.0.0 s.marketwatch.com #[affects marketwatch]
0.0.0.0 stags.peer39.net #[PrivacyChoice.Tracker]
# [Ntt America][198.104.0.0 - 198.104.255.255]
0.0.0.0 www.secure-processingcenter.com
0.0.0.0 www.spywarebegone.com
0.0.0.0 www.zipitfast.com
# [Ntt America][198.63.0.0 - 198.66.255.255]
0.0.0.0 ads.drugs.com
0.0.0.0 www.spyarsenal.com #[Spyware.DesktopSpy][Spyware.FamilyKeylog]
# [Ntt America][199.236.0.0 - 199.239.255.255]
0.0.0.0 www.tsgonline.com
# [Ntt America][199.4.64.0 - 199.4.127.255]
0.0.0.0 nana10.checkm8.com
0.0.0.0 nana10digital.checkm8.com
0.0.0.0 nrg.checkm8.com
0.0.0.0 nrgdigital.checkm8.com
0.0.0.0 sport5.checkm8.com
0.0.0.0 sport5digital.checkm8.com
# [Ntt America][204.0.0.0 - 204.3.255.255]
0.0.0.0 affiliate.dtiserv.com
0.0.0.0 ds.eyeblaster.com
0.0.0.0 ads.lesbianpersonals.com
0.0.0.0 contextlinks.netseer.com
0.0.0.0 asd.tynt.com
# [Ntt America][AS2914][204.245.128.0 - 204.245.191.255]
0.0.0.0 c04.adsummos.net
0.0.0.0 cdn.at.atwola.com
0.0.0.0 me-cdn.effectivemeasure.net
0.0.0.0 za-cdn.effectivemeasure.net
0.0.0.0 www8.effectivemeasure.net
0.0.0.0 cdn.flashtalking.com
0.0.0.0 servedby.flashtalking.com
0.0.0.0 stat.flashtalking.com
0.0.0.0 a.huluad.com
0.0.0.0 adt.m7z.net
0.0.0.0 download.realtimegaming.com
0.0.0.0 tap-cdn.rubiconproject.com
0.0.0.0 bridgetrack.speedera.r3h.net
0.0.0.0 media-1.vpptechnologies.com
0.0.0.0 media-2.vpptechnologies.com
0.0.0.0 media-4.vpptechnologies.com
0.0.0.0 media-5.vpptechnologies.com
0.0.0.0 media-6.vpptechnologies.com
0.0.0.0 media-8.vpptechnologies.com
0.0.0.0 media-a.vpptechnologies.com
0.0.0.0 media-b.vpptechnologies.com
0.0.0.0 media-c.vpptechnologies.com
0.0.0.0 media-d.vpptechnologies.com
0.0.0.0 media-e.vpptechnologies.com
0.0.0.0 media-f.vpptechnologies.com
0.0.0.0 static.vpptechnologies.com
# [Ntt America][207.198.128.0 - 207.198.255.255]
0.0.0.0 web.checkm8.com #[CHECKM8 AD TAGS]
0.0.0.0 web2.checkm8.com
# [Ntt America][209.157.0.0 - 209.157.255.255]
0.0.0.0 stats.homestead.com
0.0.0.0 track.homestead.com
0.0.0.0 track2.homestead.com
# [Ntt America][209.207.128.0 - 209.207.255.255]
0.0.0.0 shareasale.com
0.0.0.0 www.shareasale.com
# [Ntt America][83.231.216.128 - 83.231.216.255]
0.0.0.0 ads.boursorama.com
0.0.0.0 analytics.youramigo.com
# [Nugg.ad][AS48173][80.82.201.80 - 80.82.201.95]
0.0.0.0 24m.nuggad.net
0.0.0.0 abcno.nuggad.net
0.0.0.0 asqcondenast.nuggad.net
0.0.0.0 asqrtl.nuggad.net
0.0.0.0 axdget-sync.nuggad.net
0.0.0.0 ebayit-dp.nuggad.net
0.0.0.0 lokalavisendk.nuggad.net
0.0.0.0 lpm-francetv.nuggad.net
0.0.0.0 lpm-lagardere.nuggad.net
0.0.0.0 lpm-tf1.nuggad.net
0.0.0.0 mediamond.nuggad.net
0.0.0.0 n24se.nuggad.net
0.0.0.0 naftemporiki.nuggad.net
0.0.0.0 om.nuggad.net
0.0.0.0 tuno.nuggad.net
0.0.0.0 ri.nuggad.net
0.0.0.0 tv2dk.nuggad.net
0.0.0.0 websystem24.nuggad.net
# [Nugg-ad-net][AS48173][94.198.59.128 - 94.198.59.143]
0.0.0.0 3w.nuggad.net
0.0.0.0 4wmp.nuggad.net
0.0.0.0 71i.nuggad.net
0.0.0.0 adcloud-dp.nuggad.net
0.0.0.0 adselect.nuggad.net
0.0.0.0 asqlesechos.nuggad.net
0.0.0.0 asqnext.nuggad.net
0.0.0.0 bei.nuggad.net
0.0.0.0 berldk.nuggad.net
0.0.0.0 derstandard.nuggad.net
0.0.0.0 dbadk.nuggad.net
0.0.0.0 gwp.nuggad.net
0.0.0.0 ip.nuggad.net
0.0.0.0 jpdk.nuggad.net
0.0.0.0 jobzdk.nuggad.net
0.0.0.0 krone.nuggad.net
0.0.0.0 msnad.nuggad.net
0.0.0.0 mtv.nuggad.net
0.0.0.0 nettno.nuggad.net
0.0.0.0 nuggad.nuggad.net
0.0.0.0 oms.nuggad.net
0.0.0.0 poldk.nuggad.net
0.0.0.0 rmsi.nuggad.net
0.0.0.0 si.nuggad.net
0.0.0.0 survey.nuggad.net
0.0.0.0 yahoo.nuggad.net
# [Oc3 Networks][AS29761][204.152.192.0 - 204.152.223.255]
0.0.0.0 counter.dt07.net
0.0.0.0 ads.xxxbunker.com
# [Oc3 Networks][AS29761][72.11.128.0 - 72.11.159.255]
0.0.0.0 blue.sexer.com
0.0.0.0 hello.sexer.com
0.0.0.0 white.sexer.com
# [Olm][AS19916][65.18.128.0 - 65.18.223.255]
0.0.0.0 it.bannerout.com
0.0.0.0 www.firebanner.com
0.0.0.0 www.scambiobanner.tv
# [Olm][AS19916][69.94.0.0 - 69.94.127.255]
0.0.0.0 s3.pageranktop.com
# [Omniture / Adobe][AS15224][192.243.224.0 - 192.243.255.255]
0.0.0.0 bbg.d1.sc.omtrdc.net
0.0.0.0 buzzfeed.d1.sc.omtrdc.net
0.0.0.0 idgenterprise.d1.sc.omtrdc.net
0.0.0.0 lakeshore.d1.sc.omtrdc.net
0.0.0.0 pcworldcommunication.d2.sc.omtrdc.net
# [Omniture / Adobe][AS15224][66.117.16.0 - 66.117.31.255]
0.0.0.0 foxnews.tt.omtrdc.net
0.0.0.0 lowes.tt.omtrdc.net
0.0.0.0 nautilus.tt.omtrdc.net
0.0.0.0 toysrus.tt.omtrdc.net
# [Omniture / Adobe][AS15224][66.235.128.0 - 66.235.159.255]
0.0.0.0 122.2o7.net
0.0.0.0 som.aeroplan.com
0.0.0.0 smetrics.aetn.com
0.0.0.0 tracking.everydayhealth.com
0.0.0.0 metrics.ilsole24ore.com
0.0.0.0 stats2.luckymag.com
0.0.0.0 metrics.necn.com
0.0.0.0 1und1internetag.d3.sc.omtrdc.net
0.0.0.0 cafemom.d2.sc.omtrdc.net
0.0.0.0 centricabritishgas.d3.sc.omtrdc.net
# 0.0.0.0 citicorpcreditservic.tt.omtrdc.net
0.0.0.0 comcastresidentialservices.tt.omtrdc.net
0.0.0.0 comvelgmbh.d1.sc.omtrdc.net
0.0.0.0 condenast.insight.omtrdc.net
0.0.0.0 cri.d1.sc.omtrdc.net
0.0.0.0 daimlerag.d2.sc.omtrdc.net
0.0.0.0 espndotcom.tt.omtrdc.net
0.0.0.0 fairfaxau.d1.sc.omtrdc.net
0.0.0.0 hm.d1.sc.omtrdc.net
0.0.0.0 internetretailer.d2.sc.omtrdc.net
0.0.0.0 marchofdimes.d2.sc.omtrdc.net
0.0.0.0 mashable.d2.sc.omtrdc.net
0.0.0.0 nascardigitalsap.d2.sc.omtrdc.net
0.0.0.0 nzz.d3.sc.omtrdc.net
0.0.0.0 nydailynews.d1.sc.omtrdc.net
0.0.0.0 petfooddirect.d1.sc.omtrdc.net
0.0.0.0 rtve.d1.sc.omtrdc.net
0.0.0.0 seb.d1.sc.omtrdc.net
0.0.0.0 softlayer.d1.sc.omtrdc.net
0.0.0.0 tacobell.d1.sc.omtrdc.net
0.0.0.0 metrics.td.com
0.0.0.0 tracking.whattoexpect.com
# [Omniture][AS15224][Wildcard DNS]
0.0.0.0 102.112.207.net
0.0.0.0 102.112.2o7.net #[Tracking.Cookie]
0.0.0.0 102.122.2o7.net
0.0.0.0 192.168.112.2o7.net
0.0.0.0 192.168.122.2o7.net
0.0.0.0 1105governmentinformationgroup.122.2o7.net
0.0.0.0 3gupload.112.2o7.net
0.0.0.0 10xhellometro.112.2o7.net
0.0.0.0 acckalaharinet.112.2o7.net
0.0.0.0 acpmagazines.112.2o7.net
0.0.0.0 adbrite.122.2o7.net
0.0.0.0 advertisingcom.122.2o7.net
0.0.0.0 advertisementnl.112.2o7.net
0.0.0.0 aehistory.112.2o7.net
0.0.0.0 aetv.112.2o7.net
0.0.0.0 affilcrtopcolle.112.2o7.net
0.0.0.0 agamgreetingscom.112.2o7.net
0.0.0.0 agbmcom.112.2o7.net
0.0.0.0 agegreetings.112.2o7.net
0.0.0.0 agmsnag.112.2o7.net
0.0.0.0 agwebshots.112.2o7.net
0.0.0.0 agyahooag.112.2o7.net
0.0.0.0 albanytimesunion.122.2o7.net
0.0.0.0 allbritton.122.2o7.net
0.0.0.0 amazonmerchants.122.2o7.net
0.0.0.0 amazonshopbop.122.2o7.net
0.0.0.0 amdvtest.112.2o7.net
0.0.0.0 ameritradeogilvy.112.2o7.net
0.0.0.0 ameritradeamerivest.112.2o7.net
0.0.0.0 amznshopbop.122.2o7.net
0.0.0.0 angiba.112.2o7.net
0.0.0.0 angmar.112.2o7.net
0.0.0.0 angmil.112.2o7.net
0.0.0.0 angpar.112.2o7.net
0.0.0.0 sa.aol.com.122.2o7.net
0.0.0.0 aolbks.122.2o7.net
0.0.0.0 aolcamember.122.2o7.net
0.0.0.0 aolcg.122.2o7.net
0.0.0.0 aolcmp.122.2o7.net
0.0.0.0 aolcommem.122.2o7.net
0.0.0.0 aolcommvid.122.2o7.net
0.0.0.0 aolcsmen.122.2o7.net
0.0.0.0 aoldlama.122.2o7.net
0.0.0.0 aoldrambuie.122.2o7.net
0.0.0.0 aolgam.122.2o7.net
0.0.0.0 aolgamedaily.122.2o7.net
0.0.0.0 aoljournals.122.2o7.net
0.0.0.0 aollatblog.122.2o7.net
0.0.0.0 aollove.122.2o7.net
0.0.0.0 aolmov.122.2o7.net
0.0.0.0 aolmus.122.2o7.net
0.0.0.0 aolnews.122.2o7.net
0.0.0.0 aolnssearch.122.2o7.net
0.0.0.0 aolpf.122.2o7.net
0.0.0.0 aolpolls.122.2o7.net
0.0.0.0 aolsearch.122.2o7.net
0.0.0.0 aolshred.122.2o7.net
0.0.0.0 aolsports.122.2o7.net
0.0.0.0 aolstylist.122.2o7.net
0.0.0.0 aolsvc.122.2o7.net
0.0.0.0 aolswitch.122.2o7.net
0.0.0.0 aoltruveo.122.2o7.net
0.0.0.0 aoltmz.122.2o7.net
0.0.0.0 aolturnercnnmoney.122.2o7.net
0.0.0.0 aolturnersi.122.2o7.net
0.0.0.0 aoluk.122.2o7.net
0.0.0.0 aolvideo.122.2o7.net
0.0.0.0 aolwinamp.122.2o7.net
0.0.0.0 aolwbautoblog.122.2o7.net
0.0.0.0 aolwbcinema.122.2o7.net
0.0.0.0 aolwbdnlsq.122.2o7.net
0.0.0.0 aolwbengadget.122.2o7.net
0.0.0.0 aolwbgadling.122.2o7.net
0.0.0.0 aolwbluxist.122.2o7.net
0.0.0.0 aolwbtvsq.122.2o7.net
0.0.0.0 aolwbpspfboy.122.2o7.net
0.0.0.0 aolwbwowinsd.122.2o7.net
0.0.0.0 aolwpmq.122.2o7.net
0.0.0.0 aolwpnscom.122.2o7.net
0.0.0.0 aolwpnswhatsnew.112.2o7.net
0.0.0.0 aolyedda.122.2o7.net
0.0.0.0 apdigitalorgovn.112.2o7.net
0.0.0.0 apdigitalorg.112.2o7.net
0.0.0.0 apnonline.112.2o7.net
0.0.0.0 aporg.112.2o7.net
# 0.0.0.0 appleglobal.112.2o7.net #[affects Apple site]
0.0.0.0 associatedcontent.112.2o7.net
0.0.0.0 atlanticmedia.122.2o7.net
0.0.0.0 audible.112.2o7.net
0.0.0.0 aumo123usedcarscom.112.2o7.net
0.0.0.0 aumoautomotivectl.112.2o7.net
0.0.0.0 aumoautomotivecom.112.2o7.net
0.0.0.0 aumoautomobilemagcom.112.2o7.net
0.0.0.0 aumocarsbelowinvoice.112.2o7.net
0.0.0.0 aumointernetautoguidecom.112.2o7.net
0.0.0.0 aumomotortrend.112.2o7.net
0.0.0.0 aumonewcarcom.112.2o7.net
0.0.0.0 aumotradeinvaluecom.112.2o7.net
0.0.0.0 autobytel.112.2o7.net
0.0.0.0 autobytelcorppopup.112.2o7.net
0.0.0.0 autoanythingcom.112.2o7.net
0.0.0.0 autoscout24.112.2o7.net
0.0.0.0 autoweb.112.2o7.net
0.0.0.0 avgtechnologies.112.2o7.net
0.0.0.0 avon.112.2o7.net
0.0.0.0 awarenesstech.122.2o7.net
0.0.0.0 babycentercom.112.2o7.net
0.0.0.0 bankrate.112.2o7.net
0.0.0.0 bankwest.112.2o7.net
0.0.0.0 bbc.112.2o7.net
0.0.0.0 bhgdiabeticliving.112.2o7.net
0.0.0.0 bhgdiy.112.2o7.net
0.0.0.0 bhgkitchenbath.112.2o7.net
0.0.0.0 bhgscrap.112.2o7.net
0.0.0.0 bhgremodel.112.2o7.net
0.0.0.0 bhgquilting.112.2o7.net
0.0.0.0 bnkholic.112.2o7.net
0.0.0.0 bellglobemediapublishing.122.2o7.net
0.0.0.0 belointeractive.122.2o7.net
0.0.0.0 bertelwissenprod.122.2o7.net
0.0.0.0 bet.122.2o7.net
0.0.0.0 betterhg.112.2o7.net
0.0.0.0 bigpond.122.2o7.net
0.0.0.0 bizjournals.112.2o7.net
0.0.0.0 blethenmaine.112.2o7.net
0.0.0.0 bmwmoter.122.2o7.net
0.0.0.0 bnk30livejs.112.2o7.net
0.0.0.0 bnkr8dev.112.2o7.net
0.0.0.0 bonintnewsktarcom.112.2o7.net
0.0.0.0 bonneville.112.2o7.net
0.0.0.0 bonniercorp.122.2o7.net
0.0.0.0 boostmobile.112.2o7.net
0.0.0.0 bostoncommonpress.112.2o7.net
0.0.0.0 brightcove.112.2o7.net
0.0.0.0 brighthouse.122.2o7.net
0.0.0.0 bruceclay.112.2o7.net
0.0.0.0 btcom.112.2o7.net
0.0.0.0 builderonlinecom.112.2o7.net
0.0.0.0 businessweekpoc.112.2o7.net
0.0.0.0 buycom.122.2o7.net
0.0.0.0 buzznet.112.2o7.net
0.0.0.0 byubroadcast.112.2o7.net
0.0.0.0 canadapost.112.2o7.net
0.0.0.0 cancalgary.112.2o7.net
0.0.0.0 canfinancialpost.112.2o7.net
0.0.0.0 cannationalpost.112.2o7.net
0.0.0.0 canwestglobal.112.2o7.net
0.0.0.0 canoe.112.2o7.net
0.0.0.0 canottowa.112.2o7.net
0.0.0.0 canshowcase.112.2o7.net
0.0.0.0 cantire.122.2o7.net
0.0.0.0 canwest.112.2o7.net
0.0.0.0 capcityadvcom.112.2o7.net
0.0.0.0 capecodonlinecom.112.2o7.net
0.0.0.0 care2.112.2o7.net
0.0.0.0 carlsonradisson.112.2o7.net
0.0.0.0 cartoonnetwork.122.2o7.net
0.0.0.0 cba.122.2o7.net
0.0.0.0 cbc.122.2o7.net
0.0.0.0 cbcnewmedia.112.2o7.net
0.0.0.0 cbmsn.112.2o7.net
0.0.0.0 cbglobal.112.2o7.net
0.0.0.0 cbs.112.2o7.net
0.0.0.0 cbscom.112.2o7.net
0.0.0.0 cbsdigitalmedia.112.2o7.net
0.0.0.0 cbsnfl.112.2o7.net
0.0.0.0 cbspgatour.112.2o7.net
0.0.0.0 cbsspln.112.2o7.net
0.0.0.0 cbstelevisiondistribution.112.2o7.net
0.0.0.0 ccrgaviscom.112.2o7.net
0.0.0.0 cengagecsinfosec.112.2o7.net
0.0.0.0 chacha.112.2o7.net
0.0.0.0 chchoice.112.2o7.net
0.0.0.0 chghowardjohnson.112.2o7.net
0.0.0.0 chgsupereight.112.2o7.net
0.0.0.0 ciaocom.122.2o7.net
0.0.0.0 ciscowebex.112.2o7.net
0.0.0.0 cnhicrossvillechronicle.122.2o7.net
0.0.0.0 cnhidailyindependent.122.2o7.net
0.0.0.0 cnhienid.122.2o7.net
0.0.0.0 cnnireport.122.2o7.net
0.0.0.0 cnetasiapacific.122.2o7.net
0.0.0.0 chgwyndham.112.2o7.net
0.0.0.0 chicagosuntimes.122.2o7.net
0.0.0.0 chumtv.122.2o7.net
0.0.0.0 ciaoshopcouk.122.2o7.net
0.0.0.0 ciaoshopit.122.2o7.net
0.0.0.0 classicvacations.112.2o7.net
0.0.0.0 classmatescom.112.2o7.net
0.0.0.0 clubmed.112.2o7.net
0.0.0.0 clubmom.122.2o7.net
0.0.0.0 cmp.112.2o7.net
0.0.0.0 cmpdotnetjunkiescom.112.2o7.net
0.0.0.0 cmpglobalvista.112.2o7.net
0.0.0.0 cmtvia.112.2o7.net
0.0.0.0 cnetaustralia.122.2o7.net
0.0.0.0 cneteurope.122.2o7.net
0.0.0.0 cnetjapan.122.2o7.net
0.0.0.0 cnetnews.112.2o7.net
0.0.0.0 cnettech.112.2o7.net
0.0.0.0 cnetzdnet.112.2o7.net
0.0.0.0 cnheagletribune.112.2o7.net
0.0.0.0 cnhiautovertical.122.2o7.net
0.0.0.0 cnhibatesvilleheraldtribune.122.2o7.net
0.0.0.0 cnhibdtonline.122.2o7.net
0.0.0.0 cnhieagletribune.122.2o7.net
0.0.0.0 cnhijohnstown.122.2o7.net
0.0.0.0 cnhijoplinglobe.122.2o7.net
0.0.0.0 cnhinewscourier.122.2o7.net
0.0.0.0 cnhinewsservicedev.122.2o7.net
0.0.0.0 cnhirecordeagle.122.2o7.net
0.0.0.0 cnn.122.2o7.net
0.0.0.0 cnnglobal.122.2o7.net
0.0.0.0 cnocanoecaprod.112.2o7.net
0.0.0.0 cnoompprod.112.2o7.net
0.0.0.0 computerworldcom.112.2o7.net
0.0.0.0 condeconsumermarketing.112.2o7.net
0.0.0.0 condenast.112.2o7.net
0.0.0.0 conpst.112.2o7.net
0.0.0.0 cookingcom.112.2o7.net
0.0.0.0 corelcom.112.2o7.net
0.0.0.0 coreluk.112.2o7.net
0.0.0.0 costargroup.112.2o7.net
0.0.0.0 couhome.112.2o7.net
0.0.0.0 couponchief.122.2o7.net
0.0.0.0 coxhsi.112.2o7.net
0.0.0.0 coxnet.112.2o7.net
0.0.0.0 coxnetmasterglobal.112.2o7.net
0.0.0.0 cpusall.112.2o7.net
0.0.0.0 createthegroup.122.2o7.net
0.0.0.0 creditcardscom.112.2o7.net
0.0.0.0 cruisecritic.112.2o7.net
0.0.0.0 csoonlinecom.112.2o7.net
0.0.0.0 ctvcrimelibrary.112.2o7.net
0.0.0.0 ctvmaincom.112.2o7.net
0.0.0.0 ctvsmokinggun.112.2o7.net
0.0.0.0 ctvtsgtv.112.2o7.net
0.0.0.0 cwportal.112.2o7.net
0.0.0.0 cxociocom.112.2o7.net
0.0.0.0 cxocomdev.112.2o7.net
0.0.0.0 cyberdefender.122.2o7.net
0.0.0.0 dailyheraldpaddockpublication.112.2o7.net
0.0.0.0 dardenrestaurants.112.2o7.net
0.0.0.0 dealnews.122.2o7.net
0.0.0.0 delightful.112.2o7.net
0.0.0.0 dennispublishing.112.2o7.net
0.0.0.0 daimlerag.122.2o7.net
0.0.0.0 divx.112.2o7.net
0.0.0.0 dixonscouk.112.2o7.net
0.0.0.0 dmcontactmanagement.122.2o7.net
0.0.0.0 dmvguidecom.112.2o7.net
0.0.0.0 doctorsassociatesrx.112.2o7.net
0.0.0.0 dominionenterprises.112.2o7.net
0.0.0.0 dotster.112.2o7.net
0.0.0.0 dotsterdomaincom.112.2o7.net
0.0.0.0 dotsterdotsteraug08.112.2o7.net
0.0.0.0 dreamhome.112.2o7.net
0.0.0.0 eaeacom.112.2o7.net
0.0.0.0 eagamesuk.112.2o7.net
0.0.0.0 eaglemiles.112.2o7.net
0.0.0.0 eapogocom.112.2o7.net
0.0.0.0 earthlink.122.2o7.net
0.0.0.0 earthlnkpsplive.122.2o7.net
0.0.0.0 edietsmain.112.2o7.net
0.0.0.0 edmunds.112.2o7.net
0.0.0.0 edsa.122.2o7.net
0.0.0.0 efashionsolutions.122.2o7.net
0.0.0.0 ehadvicedev.112.2o7.net
0.0.0.0 eharmony.112.2o7.net
0.0.0.0 electronicarts.112.2o7.net
0.0.0.0 eloqua.122.2o7.net
0.0.0.0 emc.122.2o7.net
0.0.0.0 enterprisemediagroup.112.2o7.net
0.0.0.0 entrepreneur.122.2o7.net
0.0.0.0 entrepreneurpoc.122.2o7.net
0.0.0.0 epebuild.112.2o7.net
0.0.0.0 eplans.112.2o7.net
0.0.0.0 eremedia.112.2o7.net
0.0.0.0 eset.122.2o7.net
0.0.0.0 eurostar.122.2o7.net
0.0.0.0 eventbrite.122.2o7.net
0.0.0.0 evepdaikencom.112.2o7.net
0.0.0.0 evepdcharleston.112.2o7.net
0.0.0.0 evepdaggiesports.112.2o7.net
0.0.0.0 evepdbrazossports.112.2o7.net
0.0.0.0 evepdeagledev.112.2o7.net
0.0.0.0 ewsabilene.112.2o7.net
0.0.0.0 ewscorpuschristi.112.2o7.net
0.0.0.0 ewscripps.112.2o7.net
0.0.0.0 ewsmemphis.112.2o7.net
0.0.0.0 ewsnaples.112.2o7.net
0.0.0.0 ewsventura.112.2o7.net
0.0.0.0 examinercom.122.2o7.net
0.0.0.0 expedia1.112.2o7.net
0.0.0.0 expedia6vt.112.2o7.net
0.0.0.0 expedia8.112.2o7.net
0.0.0.0 experianservicescorp.122.2o7.net
0.0.0.0 expertsexchange.112.2o7.net
0.0.0.0 extrovert.122.2o7.net
0.0.0.0 ezgds.112.2o7.net
0.0.0.0 f2communitynews.112.2o7.net
0.0.0.0 f2nbt.112.2o7.net
0.0.0.0 f2network.112.2o7.net
0.0.0.0 f2nmycareer.112.2o7.net
0.0.0.0 f2nsmh.112.2o7.net
0.0.0.0 f2ntheage.112.2o7.net
0.0.0.0 facebookinc.122.2o7.net
0.0.0.0 factiva.122.2o7.net
0.0.0.0 fanatics.112.2o7.net
0.0.0.0 farecastcom.122.2o7.net
0.0.0.0 fbfredericksburgcom.112.2o7.net
0.0.0.0 figlobal.112.2o7.net
0.0.0.0 fim.122.2o7.net
0.0.0.0 flyingmag.com.122.2o7.net
0.0.0.0 ford.112.2o7.net
0.0.0.0 foxamw.112.2o7.net
0.0.0.0 foxcom.112.2o7.net
0.0.0.0 foxidol.112.2o7.net
0.0.0.0 foxinteractivemedia.122.2o7.net
0.0.0.0 furnlevitz.112.2o7.net
0.0.0.0 furniturecom.112.2o7.net
0.0.0.0 fusetv.112.2o7.net
0.0.0.0 gap.112.2o7.net
0.0.0.0 gatehousemedia.122.2o7.net
0.0.0.0 gateway.122.2o7.net
0.0.0.0 genetree.112.2o7.net
0.0.0.0 geosign.112.2o7.net
0.0.0.0 gifastcompanycom.112.2o7.net
0.0.0.0 gjfastcompanycom.112.2o7.net
0.0.0.0 gjincscobleizer.112.2o7.net
0.0.0.0 giftscom.122.2o7.net
0.0.0.0 gmgmacfs.112.2o7.net
0.0.0.0 gmgmacmortgage.112.2o7.net
0.0.0.0 gmgmcom.112.2o7.net
0.0.0.0 gmgoodwrenchdmaprod.112.2o7.net
0.0.0.0 gntbcstkare.112.2o7.net
0.0.0.0 gntbcstksdk.112.2o7.net
0.0.0.0 gntbcstkthv.112.2o7.net
0.0.0.0 gntbcstkxtv.112.2o7.net
0.0.0.0 gntbcstwbir.112.2o7.net
0.0.0.0 gntbcstwfmy.112.2o7.net
0.0.0.0 gntbcstwkyc.112.2o7.net
0.0.0.0 gntbcstwlbz.112.2o7.net
0.0.0.0 gntbcstwmaz.112.2o7.net
0.0.0.0 gntbcstwcsh.112.2o7.net
0.0.0.0 gntbcstwltx.112.2o7.net
0.0.0.0 gntbcstwtlv.112.2o7.net
0.0.0.0 gntbcstwtsp.112.2o7.net
0.0.0.0 gntbcstwusa.112.2o7.net
0.0.0.0 gntbcstwxia.112.2o7.net
0.0.0.0 gntbcstwzzm.112.2o7.net
0.0.0.0 gntbcstglobal.112.2o7.net
0.0.0.0 gntbcstkusa.112.2o7.net
0.0.0.0 gourmetgiftbaskets.112.2o7.net
0.0.0.0 gpapercareer.112.2o7.net
0.0.0.0 gpapermom104.112.2o7.net
0.0.0.0 grunerandjahr.112.2o7.net
0.0.0.0 guj.122.2o7.net
0.0.0.0 hallmarkibmcom.112.2o7.net
0.0.0.0 harconsumer.112.2o7.net
0.0.0.0 harrahscom.112.2o7.net
0.0.0.0 harpo.122.2o7.net
0.0.0.0 haymarketbusinesspublications.122.2o7.net
0.0.0.0 hchrmain.112.2o7.net
0.0.0.0 healthgrades.112.2o7.net
0.0.0.0 healthination.122.2o7.net
0.0.0.0 hearstdigital.122.2o7.net
0.0.0.0 hearstugo.112.2o7.net
0.0.0.0 hearstmagazines.112.2o7.net
0.0.0.0 heavycom.122.2o7.net
0.0.0.0 hertz.122.2o7.net
0.0.0.0 hickoryfarms.112.2o7.net
0.0.0.0 highbeam.122.2o7.net
0.0.0.0 himedia.112.2o7.net
0.0.0.0 hisnakiamotors.122.2o7.net
0.0.0.0 hollywood.122.2o7.net
0.0.0.0 homepjlconline.com.112.2o7.net
0.0.0.0 homepproav.112.2o7.net
0.0.0.0 homesteadtechnologies.122.2o7.net
0.0.0.0 homestore.122.2o7.net
0.0.0.0 hotelscom.122.2o7.net
0.0.0.0 hphqglobal.112.2o7.net
0.0.0.0 hswmedia.122.2o7.net
0.0.0.0 hulu.112.2o7.net
0.0.0.0 huludev.112.2o7.net
0.0.0.0 ibibo.112.2o7.net
0.0.0.0 ice.112.2o7.net
0.0.0.0 idgenterprise.112.2o7.net
0.0.0.0 ihc.112.2o7.net
0.0.0.0 imc2.122.2o7.net
0.0.0.0 imeem.112.2o7.net
0.0.0.0 imiliving.122.2o7.net
0.0.0.0 incisivemedia.112.2o7.net
0.0.0.0 indigio.122.2o7.net
0.0.0.0 infratotalduicom.122.2o7.net
0.0.0.0 infrastrategy.122.2o7.net
0.0.0.0 infoworldmediagroup.112.2o7.net
0.0.0.0 intelcorpchan.112.2o7.net
0.0.0.0 intelcorperror.112.2o7.net
0.0.0.0 intelcorpsupp.112.2o7.net
0.0.0.0 interchangecorporation.122.2o7.net
0.0.0.0 interland.122.2o7.net
0.0.0.0 intuitinc.122.2o7.net
0.0.0.0 insiderpagescom.122.2o7.net
0.0.0.0 instadia.112.2o7.net
0.0.0.0 ipcmarieclaireprod.122.2o7.net
0.0.0.0 ipcmedia.122.2o7.net
0.0.0.0 ipcnowprod.122.2o7.net
0.0.0.0 ipcuncut.122.2o7.net
0.0.0.0 ipcwebuserprod.122.2o7.net
0.0.0.0 ipcyachtingworldprod.122.2o7.net
0.0.0.0 itmedia.122.2o7.net
0.0.0.0 itv.112.2o7.net
0.0.0.0 iusacomlive.112.2o7.net
0.0.0.0 ivillageglobal.112.2o7.net
0.0.0.0 jackpot.112.2o7.net
0.0.0.0 jennycraig.112.2o7.net
0.0.0.0 jetbluecom2.112.2o7.net
0.0.0.0 jetbluepkgcs.112.2o7.net
0.0.0.0 jijsonline.112.2o7.net
0.0.0.0 jijsonline.122.2o7.net
0.0.0.0 jiktnv.122.2o7.net
0.0.0.0 jiwire.112.2o7.net
0.0.0.0 jiwtmj.122.2o7.net
0.0.0.0 jmsyap.112.2o7.net
0.0.0.0 johnlewis.112.2o7.net
0.0.0.0 jrcdelcotimescom.122.2o7.net
0.0.0.0 jrcom.112.2o7.net
0.0.0.0 journalregistercompany.122.2o7.net
0.0.0.0 kaboose.112.2o7.net
0.0.0.0 kasperthreatpostprod.112.2o7.net
0.0.0.0 kaspersky.122.2o7.net
0.0.0.0 kbbmain.112.2o7.net
0.0.0.0 kelleybluebook.112.2o7.net
0.0.0.0 kiplinger.112.2o7.net
0.0.0.0 lab88inc.112.2o7.net
0.0.0.0 laptopmag.122.2o7.net
0.0.0.0 lastminengb.112.2o7.net
0.0.0.0 laxnws.112.2o7.net #[WebBug]
0.0.0.0 laxprs.112.2o7.net
0.0.0.0 laxpsd.112.2o7.net
0.0.0.0 laxtrb.112.2o7.net
0.0.0.0 laxwht.122.2o7.net
0.0.0.0 laxwht.112.2o7.net
0.0.0.0 ldsfch.112.2o7.net
0.0.0.0 leaitworldprod.112.2o7.net
0.0.0.0 leeenterprises.112.2o7.net
0.0.0.0 leveragemarketing.112.2o7.net
0.0.0.0 lintv.122.2o7.net
0.0.0.0 livedealcom.112.2o7.net
0.0.0.0 livenation.122.2o7.net
0.0.0.0 mailtribunecom.112.2o7.net
0.0.0.0 mapscom2.112.2o7.net
0.0.0.0 marinermarketing.112.2o7.net
0.0.0.0 marketlive.122.2o7.net
0.0.0.0 marketworksinc.122.2o7.net
0.0.0.0 marksandspencer.122.2o7.net
0.0.0.0 mattressusa.122.2o7.net
0.0.0.0 maxim.122.2o7.net
0.0.0.0 mcclatchy.112.2o7.net
0.0.0.0 mdjacksonville.112.2o7.net
0.0.0.0 mdpparents.112.2o7.net
0.0.0.0 mdwathens.112.2o7.net
0.0.0.0 mdwaugusta.112.2o7.net
0.0.0.0 mdwjuneau.112.2o7.net
0.0.0.0 mdwoakridge.112.2o7.net
0.0.0.0 mdwsavannah.112.2o7.net
0.0.0.0 mdwskirt.112.2o7.net
0.0.0.0 medhelpinternational.112.2o7.net
0.0.0.0 mediabistro.112.2o7.net
0.0.0.0 mediabistrocom.112.2o7.net
0.0.0.0 medialogic.122.2o7.net
0.0.0.0 mediamatters.112.2o7.net
0.0.0.0 meetupdev.122.2o7.net
0.0.0.0 memberservicesinc.122.2o7.net
0.0.0.0 metacafe.122.2o7.net
0.0.0.0 mgdothaneagle.112.2o7.net
0.0.0.0 mghickoryrecord.112.2o7.net
0.0.0.0 mgjournalnow.112.2o7.net
0.0.0.0 mgoanow.112.2o7.net
0.0.0.0 mngitwincities.112.2o7.net
0.0.0.0 mdstaugustine.112.2o7.net
0.0.0.0 mgstarexponent.112.2o7.net
0.0.0.0 mgtbo.112.2o7.net
0.0.0.0 mgtbopanels.112.2o7.net
0.0.0.0 mgtimesdispatch.112.2o7.net
0.0.0.0 mgwcbd.112.2o7.net
0.0.0.0 mgwjar.112.2o7.net
0.0.0.0 mgwnct.112.2o7.net
0.0.0.0 mgwsav.112.2o7.net
0.0.0.0 mgwsls.112.2o7.net
0.0.0.0 milbglobal.112.2o7.net
0.0.0.0 microsoftxbox.112.2o7.net
0.0.0.0 microsoftgamestudio.112.2o7.net
0.0.0.0 microsofteup.112.2o7.net
0.0.0.0 microsoftinternetexplorer.112.2o7.net
0.0.0.0 microsoftmachinetranslation.112.2o7.net
0.0.0.0 microsoftoffice.112.2o7.net
0.0.0.0 microsoftsto.112.2o7.net
0.0.0.0 microsoftuk.122.2o7.net
0.0.0.0 microsoftwga.112.2o7.net
0.0.0.0 microsoftwindows.112.2o7.net
0.0.0.0 microsoftwindowsmobile.122.2o7.net
0.0.0.0 microsoftwllivemkt.112.2o7.net
0.0.0.0 microsoftwlmailmkt.112.2o7.net
0.0.0.0 microsoftwlmessengermkt.112.2o7.net
0.0.0.0 microsoftwlmobilemkt.112.2o7.net
0.0.0.0 microsoftwlsearchcrm.112.2o7.net
0.0.0.0 midala.112.2o7.net
0.0.0.0 midar.112.2o7.net
0.0.0.0 midcru.112.2o7.net
0.0.0.0 midsen.112.2o7.net
0.0.0.0 mitsubishi.112.2o7.net
0.0.0.0 mkcthehomemarketplace.112.2o7.net
0.0.0.0 mkt10.122.2o7.net
0.0.0.0 mlarmani.122.2o7.net
0.0.0.0 mlbam.112.2o7.net
0.0.0.0 mlbatlanta.112.2o7.net
0.0.0.0 mlbcincinnati.112.2o7.net
0.0.0.0 mlbcom.112.2o7.net
0.0.0.0 mlbglobal.112.2o7.net
0.0.0.0 mlbglobal08.112.2o7.net
0.0.0.0 mlbsanfrancisco.112.2o7.net
0.0.0.0 mlsglobal.112.2o7.net
0.0.0.0 mmc.122.2o7.net
0.0.0.0 mngi.112.2o7.net
0.0.0.0 mngidailybreeze.112.2o7.net
0.0.0.0 mngimng.112.2o7.net
0.0.0.0 mngirockymtnnews.112.2o7.net
0.0.0.0 mngislctrib.112.2o7.net
0.0.0.0 mngisv.112.2o7.net
0.0.0.0 mngiyhnat.112.2o7.net
0.0.0.0 morningnewsonline.112.2o7.net
0.0.0.0 movitex.122.2o7.net
0.0.0.0 mpire.112.2o7.net
0.0.0.0 mngidmn.112.2o7.net
0.0.0.0 mngimercurynews.112.2o7.net
0.0.0.0 mseupwinxpfam.112.2o7.net
0.0.0.0 msna1com.112.2o7.net
0.0.0.0 msnaccountservices.112.2o7.net
0.0.0.0 msnbcom.112.2o7.net
0.0.0.0 msnbc.112.2o7.net
0.0.0.0 msnbcnewsvine.112.2o7.net
0.0.0.0 msneshopbase.112.2o7.net
0.0.0.0 msninvite.112.2o7.net
0.0.0.0 msninviteprod.112.2o7.net
0.0.0.0 msnlivefavorites.112.2o7.net
0.0.0.0 msnmercom.112.2o7.net
0.0.0.0 msnmercustacqprod.112.2o7.net
0.0.0.0 msnonecare.112.2o7.net
0.0.0.0 msnportalaffiliate.112.2o7.net
0.0.0.0 msnportalaunews.112.2o7.net
0.0.0.0 msnportalbeetoffice2007.112.2o7.net
0.0.0.0 msnportalhome.112.2o7.net
0.0.0.0 msnportalgame.112.2o7.net
0.0.0.0 msnportallatino.112.2o7.net
0.0.0.0 msnportalmsgboardsrvc.112.2o7.net
0.0.0.0 msnportalscp.112.2o7.net
0.0.0.0 msnportalvideo.112.2o7.net
0.0.0.0 msntrademarketing.112.2o7.net
0.0.0.0 msnwinonecare.112.2o7.net #[Windows OneCare]
0.0.0.0 msnportal.112.2o7.net
0.0.0.0 msnportallive.112.2o7.net
0.0.0.0 msnservices.112.2o7.net
0.0.0.0 mssbcprod.112.2o7.net
0.0.0.0 mswindowswolglobal.112.2o7.net
0.0.0.0 mswlspcmktdev.112.2o7.net
0.0.0.0 mswmwpapolloprod.122.2o7.net
0.0.0.0 mtvn.112.2o7.net
0.0.0.0 multiply.112.2o7.net
0.0.0.0 mxmacromedia.112.2o7.net
0.0.0.0 myfamilyancestry.112.2o7.net
0.0.0.0 nandomedia.112.2o7.net
0.0.0.0 nasdaq.122.2o7.net
0.0.0.0 natgeoedit.112.2o7.net
0.0.0.0 natgeoeditcom.112.2o7.net
0.0.0.0 natgeoglobal.112.2o7.net
0.0.0.0 natgeohomepage.112.2o7.net
0.0.0.0 natgeonavcom.112.2o7.net
0.0.0.0 natgeonews.112.2o7.net
0.0.0.0 natgeongkidsmagccom.112.2o7.net
0.0.0.0 natgeongmcom.112.2o7.net
0.0.0.0 natgeopeopleplaces.112.2o7.net
0.0.0.0 natgeotravelermagcom.112.2o7.net
0.0.0.0 natgeovideo.112.2o7.net
0.0.0.0 nautilus.122.2o7.net
0.0.0.0 nbcuniversal.122.2o7.net
0.0.0.0 neber.112.2o7.net
0.0.0.0 nebnr.112.2o7.net
0.0.0.0 neref.112.2o7.net
0.0.0.0 networksolutions.112.2o7.net
0.0.0.0 newcom.122.2o7.net
0.0.0.0 newlook.112.2o7.net
0.0.0.0 newsday.122.2o7.net
0.0.0.0 newsinteractive.112.2o7.net
0.0.0.0 newsinternational.122.2o7.net
0.0.0.0 newsok.112.2o7.net
0.0.0.0 newsquestdigitalmedia.122.2o7.net
0.0.0.0 newstimeslivecom.112.2o7.net
0.0.0.0 newyorkandcompany.112.2o7.net
0.0.0.0 newyorkmagazine.112.2o7.net
0.0.0.0 nhl.112.2o7.net
0.0.0.0 nielsen.112.2o7.net
0.0.0.0 nikefootball.112.2o7.net
0.0.0.0 nikefootballglobal.112.2o7.net
0.0.0.0 nikegoddess.112.2o7.net
0.0.0.0 nikehome.112.2o7.net
0.0.0.0 nikerunning.112.2o7.net
0.0.0.0 nikerunningglobal.112.2o7.net
0.0.0.0 njmvc.112.2o7.net
0.0.0.0 nmanchorage.112.2o7.net
0.0.0.0 nmbakersfieldca.112.2o7.net
0.0.0.0 nmbeaufort.112.2o7.net
0.0.0.0 nmbelleville.112.2o7.net
0.0.0.0 nmbradenton.112.2o7.net
0.0.0.0 nmcharlotte.112.2o7.net
0.0.0.0 nmcolumbia.112.2o7.net
0.0.0.0 nmcomnancomedia.112.2o7.net
0.0.0.0 nmeprod.122.2o7.net
0.0.0.0 nmfortworth.112.2o7.net
0.0.0.0 nmfresno.112.2o7.net
0.0.0.0 nmhiltonhead.112.2o7.net
0.0.0.0 nmkansascity.112.2o7.net
0.0.0.0 nmlexington.112.2o7.net
0.0.0.0 nmmclatchy.112.2o7.net
0.0.0.0 nmmerced.112.2o7.net
0.0.0.0 nmmiami.112.2o7.net
0.0.0.0 nmminneapolis.112.2o7.net
0.0.0.0 nmmodesto.112.2o7.net
0.0.0.0 nmraleigh.112.2o7.net
0.0.0.0 nmrockhill.112.2o7.net
0.0.0.0 nmsacramento.112.2o7.net
0.0.0.0 nmsanluisobispo.112.2o7.net
0.0.0.0 nmstatecollege.112.2o7.net
0.0.0.0 nmtacoma.112.2o7.net
0.0.0.0 nmthatsracin.112.2o7.net
0.0.0.0 nortelcom.112.2o7.net
0.0.0.0 northjersey.112.2o7.net
0.0.0.0 northwestairlines.112.2o7.net
0.0.0.0 novell.112.2o7.net
0.0.0.0 novellcom.112.2o7.net
0.0.0.0 nsdldlese.112.2o7.net
0.0.0.0 nttcommunications.122.2o7.net
0.0.0.0 nysun.com.112.2o7.net
0.0.0.0 nytbglobe.112.2o7.net
0.0.0.0 nytrflorence.112.2o7.net
0.0.0.0 nytrgainesville.112.2o7.net
0.0.0.0 nytrhendersonville.112.2o7.net
0.0.0.0 nytrlakeland.112.2o7.net
0.0.0.0 nytrlexington.112.2o7.net
0.0.0.0 nytrocala.112.2o7.net
0.0.0.0 nytrsantarosa.112.2o7.net
0.0.0.0 nytrsarasota.112.2o7.net
0.0.0.0 nytrthibodaux.112.2o7.net
0.0.0.0 nytrtuscaloosa.112.2o7.net
0.0.0.0 nytrwilmington.112.2o7.net
0.0.0.0 nytrworcester.112.2o7.net
0.0.0.0 nyttechnology.112.2o7.net
0.0.0.0 nytrwinterhaven.112.2o7.net
0.0.0.0 oberonincredig.112.2o7.net
0.0.0.0 oklahomadepartmentofcommerce.112.2o7.net
0.0.0.0 omniture.112.2o7.net
0.0.0.0 omniturecom.112.2o7.net
0.0.0.0 omniturebanners.112.2o7.net
0.0.0.0 omniscbt.112.2o7.net
0.0.0.0 omvisidtest1.112.2o7.net
0.0.0.0 onetoone.112.2o7.net
0.0.0.0 onlinegurupopularsitecom.112.2o7.net
0.0.0.0 oodpreprod.122.2o7.net
0.0.0.0 optimost.112.2o7.net
0.0.0.0 oraclecom.112.2o7.net
0.0.0.0 oracleglobal.112.2o7.net
0.0.0.0 osiristrading.112.2o7.net
0.0.0.0 ottdailytidingscom.112.2o7.net
0.0.0.0 ottacknet.112.2o7.net
0.0.0.0 overstockcom.112.2o7.net
0.0.0.0 overturecom.112.2o7.net
0.0.0.0 overturecomvista.112.2o7.net
0.0.0.0 pandasoftware.112.2o7.net
0.0.0.0 parade.122.2o7.net
0.0.0.0 parship.122.2o7.net
0.0.0.0 partygaming.122.2o7.net
0.0.0.0 partygamingglobal.122.2o7.net
0.0.0.0 patrickhillery.112.2o7.net
0.0.0.0 paypal.112.2o7.net
0.0.0.0 pch.122.2o7.net
0.0.0.0 pctoolscom.112.2o7.net
0.0.0.0 pcworldcommunication.122.2o7.net
0.0.0.0 pelmorexmedia.122.2o7.net
0.0.0.0 pentonmedia.122.2o7.net
0.0.0.0 pennwellcorp.112.2o7.net
0.0.0.0 petakfc.112.2o7.net
0.0.0.0 petamain.112.2o7.net
0.0.0.0 pfizer.122.2o7.net
0.0.0.0 philips.112.2o7.net
0.0.0.0 phillyburbscom.112.2o7.net
0.0.0.0 phillycom.112.2o7.net
0.0.0.0 phillymedia.112.2o7.net
0.0.0.0 pittsburghpostgazette.112.2o7.net
0.0.0.0 planetout.122.2o7.net
0.0.0.0 pldev.112.2o7.net
0.0.0.0 plsoyfoods.112.2o7.net
0.0.0.0 poacprod.122.2o7.net
0.0.0.0 poconorecordcom.112.2o7.net
0.0.0.0 popcapgames.122.2o7.net
0.0.0.0 powellsbooks.122.2o7.net
0.0.0.0 poweronemedia.122.2o7.net
0.0.0.0 premiumtv.122.2o7.net
0.0.0.0 primediabusiness.122.2o7.net
0.0.0.0 primestarmagazine.112.2o7.net
0.0.0.0 prisacom.112.2o7.net
0.0.0.0 prnewswire.122.2o7.net
0.0.0.0 primemensfitness.112.2o7.net
0.0.0.0 pulkauaiworld.112.2o7.net
0.0.0.0 pultheworldlink.112.2o7.net
0.0.0.0 questiacom.112.2o7.net
0.0.0.0 questsoftware.112.2o7.net
0.0.0.0 qwestfull.112.2o7.net
0.0.0.0 rainbowmedia.122.2o7.net
0.0.0.0 rakuten.112.2o7.net
0.0.0.0 rcci.122.2o7.net
0.0.0.0 rcntelecom.112.2o7.net
0.0.0.0 reagroup.122.2o7.net
0.0.0.0 rebtelnetworks.112.2o7.net
0.0.0.0 recordeaglecom.112.2o7.net
0.0.0.0 recordnetcom.112.2o7.net
0.0.0.0 recordonlinecom.112.2o7.net
0.0.0.0 registercom.122.2o7.net
0.0.0.0 remodelingonlinecom.112.2o7.net
0.0.0.0 rentcom.112.2o7.net
0.0.0.0 reunioncom.112.2o7.net
0.0.0.0 ringcentral.112.2o7.net
0.0.0.0 ringierag.112.2o7.net
0.0.0.0 riptownmedia.122.2o7.net
0.0.0.0 riverdeep.112.2o7.net
0.0.0.0 rmgparcelforcecom.112.2o7.net
0.0.0.0 rmgroyalmailcom.112.2o7.net
0.0.0.0 rrpartners.122.2o7.net
0.0.0.0 rtst.122.2o7.net
0.0.0.0 safaribooks.112.2o7.net
0.0.0.0 saksfifthavenue.122.2o7.net
0.0.0.0 santacruzsentinelcom.112.2o7.net
0.0.0.0 saxobutlereagle.122.2o7.net
0.0.0.0 saxoconcordmonitor.122.2o7.net
0.0.0.0 saxoeverett.122.2o7.net
0.0.0.0 saxofosters.122.2o7.net
0.0.0.0 saxogoerie.122.2o7.net
0.0.0.0 saxogreensboro.122.2o7.net
0.0.0.0 saxoorklamedia.122.2o7.net
0.0.0.0 saxopeninsuladailynews.122.2o7.net
0.0.0.0 saxorutland.122.2o7.net
0.0.0.0 saxosumteritem.122.2o7.net
0.0.0.0 saxotech.122.2o7.net
0.0.0.0 saxotechtylerpaper.122.2o7.net
0.0.0.0 saxotelegraph.122.2o7.net
0.0.0.0 saxotoledo.122.2o7.net
0.0.0.0 saxowatertowndailytimes.122.2o7.net
0.0.0.0 saxowenworld.122.2o7.net
0.0.0.0 saxowesterncommunications.122.2o7.net
0.0.0.0 sbsblukgov.112.2o7.net
0.0.0.0 sciamcom.112.2o7.net
0.0.0.0 scottrade.112.2o7.net
0.0.0.0 scrippsdiy.112.2o7.net
0.0.0.0 scrippsfineliving.112.2o7.net
0.0.0.0 scrippsfoodnet.112.2o7.net
0.0.0.0 scrippsfoodnetnew.112.2o7.net
0.0.0.0 scrippsgac.112.2o7.net
0.0.0.0 scrippshgtv.112.2o7.net
0.0.0.0 scrippshgtvpro.112.2o7.net
0.0.0.0 scrippsrecipezaar.112.2o7.net
0.0.0.0 seacoastonlinecom.112.2o7.net
0.0.0.0 sears.112.2o7.net
0.0.0.0 searscom.112.2o7.net
0.0.0.0 searskmartcom.112.2o7.net
0.0.0.0 sento.122.2o7.net
0.0.0.0 sevenoneintermedia.112.2o7.net
0.0.0.0 schaeffers.112.2o7.net
0.0.0.0 shawnewspapers.112.2o7.net
0.0.0.0 shopping.112.2o7.net
0.0.0.0 skyauction.122.2o7.net
0.0.0.0 slbbbcom.112.2o7.net
0.0.0.0 sltravelcom.112.2o7.net
0.0.0.0 smartmoney.112.2o7.net
0.0.0.0 smibs.112.2o7.net
0.0.0.0 smokingeverywhere.122.2o7.net
0.0.0.0 smokinggun.122.2o7.net
0.0.0.0 smpopmech.112.2o7.net
0.0.0.0 smwww.112.2o7.net
0.0.0.0 snagajob.122.2o7.net
0.0.0.0 snapfish.112.2o7.net
0.0.0.0 softonic.112.2o7.net
0.0.0.0 sonychina.112.2o7.net
0.0.0.0 sonycorporate.112.2o7.net
0.0.0.0 sonyscei.112.2o7.net
0.0.0.0 southcoasttodaycom.112.2o7.net
0.0.0.0 spamfighter.112.2o7.net
0.0.0.0 sparknetworks.112.2o7.net
0.0.0.0 spencergifts.112.2o7.net
0.0.0.0 sportingnews.122.2o7.net
0.0.0.0 sprintglobal.112.2o7.net
0.0.0.0 stampscom.112.2o7.net
0.0.0.0 starz.122.2o7.net
0.0.0.0 stpetersburgtimes.122.2o7.net
0.0.0.0 stubhub.122.2o7.net
0.0.0.0 stylincom.112.2o7.net
0.0.0.0 subaruofamerica.112.2o7.net
0.0.0.0 summitbusinessmedia.112.2o7.net
0.0.0.0 sunglobal.112.2o7.net
0.0.0.0 superpages.122.2o7.net
0.0.0.0 surfline.112.2o7.net
# 0.0.0.0  survey.112.2o7.net #[affect Sprint.com]
0.0.0.0 survey.122.2o7.net
0.0.0.0 svd.112.2o7.net
0.0.0.0 swsoft.122.2o7.net
0.0.0.0 sympmsnglobalen.112.2o7.net
0.0.0.0 sympmsnmusic.112.2o7.net
0.0.0.0 tangomedia.112.2o7.net
0.0.0.0 tbstv.112.2o7.net
0.0.0.0 techreview.112.2o7.net
0.0.0.0 tel3adv.112.2o7.net
0.0.0.0 tele2nl.112.2o7.net
0.0.0.0 telefloracom.112.2o7.net
0.0.0.0 tescostores.122.2o7.net
0.0.0.0 thayhoteldelcoronado.112.2o7.net
0.0.0.0 thayhiltonlongisland.112.2o7.net
0.0.0.0 thayvenetian.112.2o7.net
0.0.0.0 thedailystarcom.112.2o7.net
0.0.0.0 thegroup.112.2o7.net
0.0.0.0 thgalecom.112.2o7.net
0.0.0.0 thelibraryofcongress.122.2o7.net
0.0.0.0 thestar.122.2o7.net
0.0.0.0 thestardev.122.2o7.net
0.0.0.0 thinkgeek.112.2o7.net
0.0.0.0 thomasvillefurniture.122.2o7.net
0.0.0.0 thome.112.2o7.net
0.0.0.0 timecom.112.2o7.net
0.0.0.0 timecom.122.2o7.net
0.0.0.0 timeew.122.2o7.net
0.0.0.0 timeessence.122.2o7.net
0.0.0.0 timefoodandwine.122.2o7.net
0.0.0.0 timefortune.112.2o7.net
0.0.0.0 timehealthtips.122.2o7.net
0.0.0.0 timeinc.122.2o7.net
0.0.0.0 timelife.122.2o7.net
0.0.0.0 timeoutcommunications.122.2o7.net
0.0.0.0 timepeople.122.2o7.net
0.0.0.0 timepespanol.122.2o7.net
0.0.0.0 timespctenbest.122.2o7.net
0.0.0.0 timeteenpeople.122.2o7.net
0.0.0.0 tirerackcom.112.2o7.net
0.0.0.0 tgn.122.2o7.net
0.0.0.0 tjx.112.2o7.net
0.0.0.0 tmslexus.112.2o7.net
0.0.0.0 tmstoyota.112.2o7.net
0.0.0.0 tnttv.112.2o7.net
0.0.0.0 tomsshoes.122.2o7.net
0.0.0.0 torstardigital.122.2o7.net
0.0.0.0 toyotamotorcorporation.122.2o7.net
0.0.0.0 trailblazers.122.2o7.net
0.0.0.0 trane-ir-corp-ingersollrand.112.2o7.net
0.0.0.0 travidia.112.2o7.net
0.0.0.0 tribuneinteractive.122.2o7.net
0.0.0.0 trinitymirror.112.2o7.net
0.0.0.0 tumi.112.2o7.net
0.0.0.0 turnerclassic.112.2o7.net
0.0.0.0 turnersports.112.2o7.net
0.0.0.0 tvguide.112.2o7.net
0.0.0.0 uolfreeservers.112.2o7.net
0.0.0.0 uoljunocom2.112.2o7.net
0.0.0.0 uolnetzeronet2.112.2o7.net
0.0.0.0 uolphotosite.112.2o7.net
0.0.0.0 upi.112.2o7.net
0.0.0.0 usatoday1.112.2o7.net
0.0.0.0 usdm.122.2o7.net
0.0.0.0 usnews.122.2o7.net
0.0.0.0 ussearch.122.2o7.net
0.0.0.0 tbsveryfunnyads.112.2o7.net
0.0.0.0 vcomdeepdiscount.112.2o7.net
0.0.0.0 vcommerce.112.2o7.net
0.0.0.0 verisignwildcard.112.2o7.net #[sitefinder.verisign.com]
0.0.0.0 vermontteddybear.112.2o7.net
0.0.0.0 viaaddictingclips.112.2o7.net
0.0.0.0 viaaddictinggames.112.2o7.net
0.0.0.0 viaatom.112.2o7.net
0.0.0.0 viaatomv6.112.2o7.net
0.0.0.0 viabestweekever.112.2o7.net
0.0.0.0 viacomedycentral.112.2o7.net
0.0.0.0 viacomedycentralrl.112.2o7.net
0.0.0.0 viacomedyde.112.2o7.net
0.0.0.0 viagametrailers.112.2o7.net
0.0.0.0 vialogoonline.112.2o7.net
0.0.0.0 vialogorollup.112.2o7.net
0.0.0.0 viamtvcom.112.2o7.net
0.0.0.0 viamtvtr.112.2o7.net
0.0.0.0 vianickde.112.2o7.net
0.0.0.0 viasatsatelliteservices.112.2o7.net
0.0.0.0 viashockwave.112.2o7.net
0.0.0.0 viaspike.112.2o7.net
0.0.0.0 viamtv.112.2o7.net
0.0.0.0 viamtvukdev.112.2o7.net
0.0.0.0 viamtvnvideo.112.2o7.net
0.0.0.0 viamtvtr3s.112.2o7.net
0.0.0.0 vianewnownext.112.2o7.net
0.0.0.0 viaquiz.112.2o7.net
0.0.0.0 viaukplayer.112.2o7.net
0.0.0.0 viarnd.112.2o7.net
0.0.0.0 viavh1com.112.2o7.net
0.0.0.0 viay2m.112.2o7.net
0.0.0.0 victoriaadvocate.112.2o7.net
0.0.0.0 vintacom.112.2o7.net
0.0.0.0 vintadream.112.2o7.net
0.0.0.0 viamtvuk.112.2o7.net
0.0.0.0 viamtvromania.112.2o7.net
0.0.0.0 viavh1scandalist.112.2o7.net
0.0.0.0 viavh1video.112.2o7.net
0.0.0.0 virginmedia.112.2o7.net
0.0.0.0 virginmobile.122.2o7.net
0.0.0.0 vitacost.122.2o7.net
0.0.0.0 videotroncom.112.2o7.net
0.0.0.0 vodafonegroup.122.2o7.net
0.0.0.0 volkswagen.122.2o7.net
0.0.0.0 vpmc.122.2o7.net
0.0.0.0 walgrns.112.2o7.net
0.0.0.0 walmart.112.2o7.net
0.0.0.0 warnerbros.112.2o7.net
0.0.0.0 warnerbrothersrecords.112.2o7.net
0.0.0.0 waterfrontmedia.112.2o7.net
0.0.0.0 wbextecd.112.2o7.net
0.0.0.0 wbnews.112.2o7.net
0.0.0.0 wbprocurement.112.2o7.net
0.0.0.0 wcastrprod.122.2o7.net
0.0.0.0 webroot.112.2o7.net
0.0.0.0 westwickfarrow.122.2o7.net
0.0.0.0 whitecastle.122.2o7.net
0.0.0.0 wileypublishing.112.2o7.net
0.0.0.0 winecom.112.2o7.net
0.0.0.0 wineenthusiastcom.112.2o7.net
0.0.0.0 winmpmain.112.2o7.net #[Windows MarketPlace]
0.0.0.0 wissende.122.2o7.net
0.0.0.0 wlaptoplogic.122.2o7.net
0.0.0.0 worldnowboston.112.2o7.net
0.0.0.0 wpni.112.2o7.net
0.0.0.0 wpnipostcomjobs.112.2o7.net
0.0.0.0 wrigley.122.2o7.net
0.0.0.0 wwatchcomusa.112.2o7.net
0.0.0.0 wweconsumer.112.2o7.net
0.0.0.0 wwecorp2.112.2o7.net
0.0.0.0 xhealth.112.2o7.net
0.0.0.0 xhealthmobiltools.112.2o7.net
0.0.0.0 yamaha.122.2o7.net
0.0.0.0 yellcom.122.2o7.net
0.0.0.0 yellspain.112.2o7.net
0.0.0.0 yrkdsp.112.2o7.net
0.0.0.0 yukoyuko.112.2o7.net
0.0.0.0 zag.112.2o7.net
0.0.0.0 zango.112.2o7.net
0.0.0.0 zdau-builder.122.2o7.net
0.0.0.0 ziffdavisenterprise.112.2o7.net
0.0.0.0 ziffdavisenterpriseglobal.112.2o7.net
0.0.0.0 ziffdavisfilefront.112.2o7.net
0.0.0.0 ziffdavisglobal.112.2o7.net
0.0.0.0 ziffdavispennyarcade.112.2o7.net
0.0.0.0 ziffdaviseweek.112.2o7.net
0.0.0.0 stats.esomniture.com #[Tracking.Cookie]
0.0.0.0 www.omniture.com
0.0.0.0 www.touchclarity.com
# [Omniture via Misc Sites]
0.0.0.0 nossl.aafp.org
0.0.0.0 metrics.aarp.org
0.0.0.0 ewstv.abc15.com
0.0.0.0 metrics.accuweather.com
0.0.0.0 metrics.acehardware.com
# 0.0.0.0 stats.adobe.com #[affects MacOS updates]
0.0.0.0 stats.adultswim.com
0.0.0.0 analytic.ae.com
0.0.0.0 metrics.aetn.com
0.0.0.0 metric.allrecipes.com
0.0.0.0 stats2.allure.com
0.0.0.0 b.alot.com
0.0.0.0 analytics.amakings.com
0.0.0.0 metrics.amd.com
0.0.0.0 metrics.americancityandcounty.com
# 0.0.0.0 metrics.ancestry.co.uk #[affects login]
0.0.0.0 metric.angieslist.com
0.0.0.0 metrics.apartmentfinder.com
# 0.0.0.0 metrics.apple.com #[affects Apple site/MacOS]
# 0.0.0.0 securemetrics.apple.com #[affects Apple site/MacOS]
0.0.0.0 metrics.ariba.com
0.0.0.0 omniture.artinstitutes.edu
0.0.0.0 stats2.arstechnica.com
0.0.0.0 vs.asianave.com
0.0.0.0 stats.askmen.com
0.0.0.0 metrics.autotrader.co.uk
0.0.0.0 metrics.autobytel.com
0.0.0.0 metrics.automobilemag.com
0.0.0.0 www2.autopartswarehouse.com
0.0.0.0 metrics.azfamily.com
0.0.0.0 metrics.babycenter.com
0.0.0.0 metrics.babycentre.co.uk
0.0.0.0 stats.backcountry.com
0.0.0.0 omni.basspro.com
0.0.0.0 sa.bbc.co.uk #[may affect iPlayer app]
0.0.0.0 metrics.beachbody.com
0.0.0.0 a.beliefnet.com
0.0.0.0 metrics.bestbuy.com
0.0.0.0 metrics.bet.com
0.0.0.0 n.betus.com
0.0.0.0 metrics.bhg.com
0.0.0.0 metrics.bitdefender.com
0.0.0.0 metric.bizjournals.com
0.0.0.0 metrics.blackberry.com
0.0.0.0 vs.blackplanet.com
0.0.0.0 om.blockbuster.com
0.0.0.0 metrics.bloomberg.com
0.0.0.0 o.bluewin.ch
0.0.0.0 n.bodybuilding.com
0.0.0.0 stats.bookingbuddy.com
0.0.0.0 metrics.bose.com
0.0.0.0 metrics.boston.com
0.0.0.0 om.businessweek.com
0.0.0.0 stats.buycostumes.com
0.0.0.0 stats.cafepress.com
0.0.0.0 omni.canadiantire.ca
0.0.0.0 metrics.car.com
0.0.0.0 metrics.caranddriver.com
0.0.0.0 metrics.cars.com
0.0.0.0 metrics.carbonite.com
0.0.0.0 metrics.carphonewarehouse.com
0.0.0.0 stats.cartoonnetwork.com
0.0.0.0 omni.cash.ch
0.0.0.0 metrics.cbc.ca
0.0.0.0 om.cbsi.com
0.0.0.0 metrics.centex.com
0.0.0.0 metrics.chacha.com
0.0.0.0 webstat.channel4.com
0.0.0.0 omniture.chip.de
0.0.0.0 metrics.chron.com
# 0.0.0.0 metrics1.citibank.com #[affects login]
0.0.0.0 om.cnet.co.uk
0.0.0.0 metrics.cleveland.com
0.0.0.0 metrics.cnn.com
0.0.0.0 track.collegeboard.com
0.0.0.0 serviceo.comcast.net
0.0.0.0 metrics.compactappliance.com
0.0.0.0 stats.concierge.com
# 0.0.0.0 metrics.consumerreports.org #[affects login]
0.0.0.0 metrics.corus.ca
0.0.0.0 metrics.cosmopolitan.co.uk
0.0.0.0 omn.crackle.com
0.0.0.0 om.craftsman.com
0.0.0.0 smetrics.creditreport.com
0.0.0.0 metrics.crystalcruises.com
0.0.0.0 omni.csc.com
0.0.0.0 metrics.csmonitor.com
0.0.0.0 metrics.ctv.ca
0.0.0.0 metrics.dailystrength.org
0.0.0.0 metrics.dallasnews.com
0.0.0.0 nsm.dell.com
0.0.0.0 metrics.delta.com
0.0.0.0 metrics.dentonrc.com
0.0.0.0 stats2.details.com
0.0.0.0 metrics.dickssportinggoods.com
0.0.0.0 stats.dice.com
0.0.0.0 img.discovery.com
0.0.0.0 metrics.discovery.com
0.0.0.0 omni.dispatch.com
0.0.0.0 metrics.divinecaroline.com
0.0.0.0 metrics.diy.com
0.0.0.0 metrics.doctoroz.com
0.0.0.0 metrics.dollargeneral.com
0.0.0.0 om.dowjoneson.com
0.0.0.0 stats.drugstore.com
0.0.0.0 metrics.dunkindonuts.com
0.0.0.0 stats.economist.com
0.0.0.0 metrics.ems.com
0.0.0.0 wa.eonline.com
0.0.0.0 stats.epicurious.com
0.0.0.0 wa.essent.nl
0.0.0.0 stats.examiner.com
0.0.0.0 om.expedia.com
0.0.0.0 metrics.express.com
0.0.0.0 o.fandango.com
0.0.0.0 metrics.fedex.com
0.0.0.0 metrics.finishline.com
0.0.0.0 metrics.fitnessmagazine.com
0.0.0.0 metrics.ford.com
0.0.0.0 metrics.foreignpolicy.com
0.0.0.0 metrics.foxnews.com
0.0.0.0 smetrics.freecreditreport.com
0.0.0.0 metrics.flyingmag.com
0.0.0.0 sc-forbes.forbes.com
0.0.0.0 a.fox.com
0.0.0.0 stats.ft.com
0.0.0.0 track.futureshop.ca
0.0.0.0 metrics.gcimetrics.com
0.0.0.0 stats2.gq.com
0.0.0.0 stats2.glamour.com
0.0.0.0 metrics.gnc.com
0.0.0.0 stats2.golfdigest.com
0.0.0.0 metrics.govexec.com
# 0.0.0.0 w88.go.com #[affects espn.com]
0.0.0.0 hits.guardian.co.uk
0.0.0.0 metrics.harley-davidson.com
0.0.0.0 analytics.hayneedle.com
0.0.0.0 metrics.hbogo.com
0.0.0.0 minerva.healthcentral.com
0.0.0.0 metrics.homebase.co.uk
0.0.0.0 omt.honda.com
0.0.0.0 metrics.hoovers.com
0.0.0.0 metrics.howstuffworks.com
0.0.0.0 metrics.hrblock.com
0.0.0.0 my.iheartradio.com
0.0.0.0 sc.independent.co.uk
0.0.0.0 stats.ign.com
0.0.0.0 metrics.imvu.com
0.0.0.0 www91.intel.com
0.0.0.0 stats.investors.com
0.0.0.0 metrics.store.irobot.com
0.0.0.0 metrics.kbb.com
# 0.0.0.0 ww9.kohls.com #[affects Chrome]
0.0.0.0 metrics.lawyers.com
0.0.0.0 metrics.lehighvalleylive.com
0.0.0.0 metrics.us.levi.com
0.0.0.0 metrics.lexus.com
0.0.0.0 metrics.lhj.com
0.0.0.0 stats.libresse.no
0.0.0.0 om.lonelyplanet.com
# 0.0.0.0  omni.macworld.com #[affects Safari]
0.0.0.0 analytics.mail-corp.com
0.0.0.0 metric.makemytrip.com
0.0.0.0 metric.marthastewart.com
0.0.0.0 metrics.mcafee.com
0.0.0.0 tracking.medpagetoday.com
0.0.0.0 report.mitsubishicars.com
0.0.0.0 an.mlb.com
0.0.0.0 metrics.mlive.com
0.0.0.0 metric.modcloth.com
0.0.0.0 metrics.moneymart.ca
0.0.0.0 metrics.more.com
0.0.0.0 metrics.mysanantonio.com
0.0.0.0 metrics.nba.com
0.0.0.0 oimg.nbcuni.com
0.0.0.0 om.neimanmarcus.com
0.0.0.0 ometrics.netapp.com
0.0.0.0 metrics.newcars.com
0.0.0.0 metrics.nfl.com
0.0.0.0 metrics.nissanusa.com
0.0.0.0 metrics.nj.com
0.0.0.0 metrics.nola.com
0.0.0.0 metrics.nutrisystem.com
0.0.0.0 stats.nymag.com
0.0.0.0 om.onlineshoes.com
0.0.0.0 o.opentable.com
0.0.0.0 metrics.oregonlive.com
0.0.0.0 metrics.pagoda.com
0.0.0.0 stats.pandora.com
0.0.0.0 metrics.parents.com
0.0.0.0 metrics.pe.com
0.0.0.0 metrics.pennlive.com
0.0.0.0 metrics.penton.com
0.0.0.0 metric.petinsurance.com
0.0.0.0 metrics.petsmart.com
0.0.0.0 metrics.philly.com
0.0.0.0 metrics.us.playstation.com
0.0.0.0 metrics.politico.com
0.0.0.0 metrics.performgroup.com
0.0.0.0 metrics.ralphlauren.com
0.0.0.0 mtrcs.redhat.com
0.0.0.0 metric.rent.com
0.0.0.0 metrics.retailmenot.com
0.0.0.0 data.ritzcarlton.com
0.0.0.0 om.rogersmedia.com
0.0.0.0 metrics.seattlepi.com
0.0.0.0 metrics.seenon.com
0.0.0.0 stats2.self.com
0.0.0.0 om.sfgate.com
0.0.0.0 metrics.sharecare.com
0.0.0.0 ou.shutterfly.com
0.0.0.0 metrics.shoedazzle.com
0.0.0.0 omniture.shopstyle.com
0.0.0.0 metrics.silive.com
0.0.0.0 b.skinstore.com
0.0.0.0 metrics.sky.com
# 0.0.0.0 metrics.skype.com
0.0.0.0 metrics.slate.com
0.0.0.0 metrics.speedousa.com
0.0.0.0 omni.sportingnews.com
0.0.0.0 metrics.solarwinds.com
0.0.0.0 metrics.sony.com
0.0.0.0 omn.sonypictures.com
0.0.0.0 metrics.southwest.com
# 0.0.0.0  metrics.sprint.com #[affects login]
0.0.0.0 metrics.starwoodhotels.com
0.0.0.0 omniture.stuff.co.nz
0.0.0.0 stats.style.com
0.0.0.0 metrics.sun.com
0.0.0.0 metric.superpages.com
0.0.0.0 om.symantec.com
0.0.0.0 metrics.syracuse.com
0.0.0.0 analytics.tbs.com
0.0.0.0 metrics.teambeachbody.com
0.0.0.0 stats2.teenvogue.com
0.0.0.0 info.telstra.com
0.0.0.0 metrics.tgw.com
0.0.0.0 hits.theguardian.com
0.0.0.0 metrics.thinkgeek.com
0.0.0.0 metrics.three.co.uk
0.0.0.0 metrics.ticketmaster.com
# 0.0.0.0 metric.timewarnercable.com #[affects billing?]
0.0.0.0 metrics.tlc.com
0.0.0.0 metrics.toptenreviews.com
0.0.0.0 metrics.toyota.com
0.0.0.0 metrics.toysrus.com
0.0.0.0 metrics.traderonline.com
0.0.0.0 om.truecar.com
0.0.0.0 metric.trulia.com
0.0.0.0 metrics.tulsaworld.com
0.0.0.0 metrics.turner.com
0.0.0.0 metrics.tvguide.com
0.0.0.0 metrics.uol.com.br
0.0.0.0 stats2.vanityfair.com
0.0.0.0 sleep.vermontteddybear.com
0.0.0.0 metrics.vividseats.com
0.0.0.0 sc.vmware.com
0.0.0.0 metrics.vodafone.co.uk
0.0.0.0 metric.volkswagen.com
0.0.0.0 webstats.volvo.com
0.0.0.0 stats.voyages-sncf.com
0.0.0.0 stats.vulture.com
0.0.0.0 wa.and.co.uk #[b.scorecardresearch.com]
# 0.0.0.0 metrics.washingtonpost.com #[affects login]
0.0.0.0 webanalyticsnossl.websense.com
0.0.0.0 std.o.webmd.com #[Web Bug]
0.0.0.0 metrics.which.co.uk
0.0.0.0 metrics.windowsitpro.com
0.0.0.0 metrics.winsupersite.com
0.0.0.0 stats2.wmagazine.com
0.0.0.0 an.worldbaseballclassic.com
0.0.0.0 metric.worldcat.org
0.0.0.0 metrics.worldmarket.com
# 0.0.0.0 metric.wtop.com #[affects login]
0.0.0.0 smetrics.yellowbook.com
0.0.0.0 metric.yellowpages.com
# [Omniture / Offermatica][66.150.139.0 - 66.150.139.63]
0.0.0.0 mbox.offermatica.intuit.com
0.0.0.0 mbox12.offermatica.com
# [Omniture][AS15224][66.235.128.0 - 66.235.159.255]
0.0.0.0 metrics.iconfitness.com
0.0.0.0 crain.d1.sc.omtrdc.net
0.0.0.0 newjobs.d1.sc.omtrdc.net
0.0.0.0 rodale.d1.sc.omtrdc.net
0.0.0.0 siemens.d1.sc.omtrdc.net
0.0.0.0 truevalue.d2.sc.omtrdc.net
# [Omniture / Offermatica][70.42.13.0 - 70.42.13.255]
0.0.0.0 mbox3.offermatica.com
0.0.0.0 mbox3e.offermatica.com
0.0.0.0 mbox4.offermatica.com
0.0.0.0 mbox4e.offermatica.com
0.0.0.0 mbox5.offermatica.com
0.0.0.0 mbox9.offermatica.com
0.0.0.0 mbox9e.offermatica.com
0.0.0.0 americaneagleoutfitt.tt.omtrdc.net
0.0.0.0 angieslist.tt.omtrdc.net
0.0.0.0 carbonite.tt.omtrdc.net
0.0.0.0 comcast.tt.omtrdc.net
0.0.0.0 educationmanagementl.tt.omtrdc.net
0.0.0.0 dellinc.tt.omtrdc.net
0.0.0.0 readersdigest.tt.omtrdc.net
0.0.0.0 rentcom.tt.omtrdc.net
0.0.0.0 reunion.tt.omtrdc.net
# [Omniture / Offermatica][72.5.238.0 - 72.5.238.63]
0.0.0.0 geo.offermatica.com
# [Omniture / Offermatica]
0.0.0.0 mbox6.offermatica.com
# [Omniture / Adobe][AS10763]
0.0.0.0 a.advanstar.com
0.0.0.0 a.amd.com
0.0.0.0 a.answers.com
0.0.0.0 a.autoexpress.co.uk
0.0.0.0 a.bizarremag.com
0.0.0.0 a.cbc.ca
0.0.0.0 vendorweb.citibank.com
0.0.0.0 b.computerworlduk.com
0.0.0.0 a.custompc.co.uk
0.0.0.0 ap101.curves.com
0.0.0.0 b.digitalartsonline.co.uk
0.0.0.0 a.environmentaldefense.org
0.0.0.0 a.evo.co.uk
0.0.0.0 a.fandango.com
0.0.0.0 tracking.foxnews.com
0.0.0.0 wss.hbpl.co.uk
0.0.0.0 a.heretv.com
0.0.0.0 h.hollywood.com
0.0.0.0 a.independent.co.uk
0.0.0.0 a.itpro.co.uk
0.0.0.0 a.law.com
0.0.0.0 a.macuser.co.uk
0.0.0.0 a.modernmedicine.com
0.0.0.0 cs.montrealplus.ca
0.0.0.0 a.networkworld.com
0.0.0.0 a.pcpro.co.uk
0.0.0.0 c.realtytrac.com
0.0.0.0 a.shop.com
0.0.0.0 a.spicetv.com
0.0.0.0 h.spill.com
0.0.0.0 a.tempurpedic.com
0.0.0.0 ngd.thesun.co.uk
0.0.0.0 a.tiscali.co.uk
0.0.0.0 a.vonage.com
0.0.0.0 ws.yellowpages.ca
# [Online S.a.s][AS12876][163.172.0.0 - 163.172.255.255]
0.0.0.0 imgg.adskeeper.co.uk
0.0.0.0 servicer.adskeeper.co.uk
# [Online S.a.s][AS12876][195.154.128.0 - 195.154.255.255]
0.0.0.0 admedit.net
0.0.0.0 srv2.admedit.me
0.0.0.0 tmgr.ccmbg.com
0.0.0.0 www.freestats.ws
# [Online S.a.s][AS12876][212.129.0.0 - 212.129.21.255]
0.0.0.0 geoip.edagames.com
# [Online S.a.s][AS12876][212.83.153.103]
0.0.0.0 click.khingtracking.com
# [Online S.a.s][AS12876][62.4.27.32 - 62.4.27.63]
0.0.0.0 code.d-agency.net
0.0.0.0 switch.d-agency.net
0.0.0.0 code.rtbsystem.com
# [Openminds][AS30961][188.93.102.23 - 188.93.103.255]
0.0.0.0 ads-colruytgroup.adhese.com
0.0.0.0 ads-nrc.adhese.com
0.0.0.0 pool-nrc.adhese.com
0.0.0.0 ads.pebblemedia.adhese.com
0.0.0.0 pool.pebblemedia.adhese.com
0.0.0.0 ads.persgroep.adhese.com
0.0.0.0 pool-colruytgroup.adhese.com
0.0.0.0 pool.persgroep.adhese.com
0.0.0.0 ads.roularta.adhese.com
0.0.0.0 pool.roularta.adhese.com
0.0.0.0 pool-roularta.adhese.com
0.0.0.0 pebble-adhese.gva.be
0.0.0.0 pebble-adhese.hbvl.be
# [Openminds][AS30961][37.72.160.15]
0.0.0.0 ads-pebblemedia.adhese.com
0.0.0.0 user-sync.adhese.com
# [Openx][AS36089][173.241.240.0 - 173.241.255.255]
0.0.0.0 ox-d.cloud9-media.net
0.0.0.0 ox-d.digiday.com
0.0.0.0 ox-d.globalpost.com
0.0.0.0 ox-d.hdcmedia.nl
0.0.0.0 ox-d.iflscience.com
0.0.0.0 ox-d.johnstonpress.co.uk
0.0.0.0 ox-d.mm1x.nl
0.0.0.0 33across-d.openx.net
0.0.0.0 aa-d.openx.net
0.0.0.0 advancedigital-d.openx.net
0.0.0.0 amu-d.openx.net
0.0.0.0 anyclip-d.openx.net
0.0.0.0 bid.openx.net
0.0.0.0 bizjournals-d.openx.net
0.0.0.0 bloggernetwork-d.openx.net
0.0.0.0 boston-d.openx.net
0.0.0.0 brainfall-d.openx.net
0.0.0.0 brainyquote-d.openx.net
0.0.0.0 coed-d.openx.net
0.0.0.0 complex-media-d.openx.net
0.0.0.0 condenast-d.openx.net
0.0.0.0 dallasnews-d.openx.net
0.0.0.0 delivery-us-central-1.openx.net
0.0.0.0 digikulture-d.openx.net
0.0.0.0 digitaltrends-d.openx.net
0.0.0.0 digitalfirst-d.openx.net
0.0.0.0 distractify-d.openx.net
0.0.0.0 elitedaily-d.openx.net
0.0.0.0 eu-u.openx.net
0.0.0.0 fanserv-d.openx.net
0.0.0.0 forumcomm-d.openx.net
0.0.0.0 freestar-d.openx.net
0.0.0.0 funnyordie-d.openx.net
0.0.0.0 gatewaymedia-d.openx.net
0.0.0.0 hsw-d.openx.net
0.0.0.0 idguk1-d.openx.net
0.0.0.0 insticator-d.openx.net
0.0.0.0 jp-u.openx.net
0.0.0.0 kiosked-d.openx.net
0.0.0.0 kiplinger-d.openx.net
0.0.0.0 komoona-d.openx.net
0.0.0.0 lin-d.openx.net
0.0.0.0 mailonline-d.openx.net
0.0.0.0 mainetoday-d.openx.net
0.0.0.0 majorgeeks-d.openx.net
0.0.0.0 mediadc-d.openx.net
0.0.0.0 media122-d.openx.net
0.0.0.0 mediavine-d.openx.net
0.0.0.0 meredithlocal-d.openx.net
0.0.0.0 monkey-broker-d.openx.net
0.0.0.0 motleyfool-d.openx.net
0.0.0.0 olxro-d.openx.net
0.0.0.0 oxjapan-d.openx.net
0.0.0.0 paste-d.openx.net
0.0.0.0 philly-d.openx.net
0.0.0.0 pmc-d.openx.net
0.0.0.0 publir-d.openx.net
0.0.0.0 prod-d.openx.com
0.0.0.0 propermedia-d.openx.net
0.0.0.0 quoka-d.openx.net
0.0.0.0 reuters-d.openx.net
0.0.0.0 ruptly-d.openx.net
0.0.0.0 sbnationbidder-d.openx.net
0.0.0.0 spanishdict-d.openx.net
0.0.0.0 spinmedia-d.openx.net
0.0.0.0 stroer-d.openx.net
0.0.0.0 suntimes-d.openx.net
0.0.0.0 tango-d.openx.net
0.0.0.0 theadvocate-d.openx.net
0.0.0.0 thechive-d.openx.net
0.0.0.0 thehill-d.openx.net
0.0.0.0 titangate-d.openx.net
0.0.0.0 topix-d.openx.net
0.0.0.0 townhallmedia-d.openx.net
0.0.0.0 trinitymirror-d.openx.net
0.0.0.0 u.openx.net
0.0.0.0 uk-ads.openx.net
0.0.0.0 us-u.openx.net
0.0.0.0 universal-d.openx.net
0.0.0.0 usnews-d.openx.net
0.0.0.0 veuhub-d.openx.net
0.0.0.0 vice-d.openx.net
0.0.0.0 warnerbros-d.openx.net
0.0.0.0 wetpaint-d.openx.net
0.0.0.0 worldstarhiphop-d.openx.net
0.0.0.0 zealotnetworks-d.openx.net
0.0.0.0 ziffdavis-d.openx.net
0.0.0.0 ox-d.openxadexchange.com
0.0.0.0 ox-d.photobucket.com
0.0.0.0 ax-d.pixfuture.net
0.0.0.0 ox-d.popmatters.com
0.0.0.0 ox-d.rantsports.com
0.0.0.0 ox-d.apax.servedbyopenx.com
0.0.0.0 ox-d.bauer.servedbyopenx.com
0.0.0.0 ox-d.cheezburger.servedbyopenx.com
0.0.0.0 ox-d.concourse.servedbyopenx.com
0.0.0.0 ox-d.venturebeat.servedbyopenx.com
0.0.0.0 ox-d.sidereel.com
0.0.0.0 addelivery.thestreet.com
0.0.0.0 us-ads.openx.net
0.0.0.0 ox-d.verivox.de
0.0.0.0 ox-d.viralnova.com
0.0.0.0 ads.webcamclub.com
# [Opsource][AS19461][209.34.64.0 - 209.34.95.255]
0.0.0.0 www.avnads.com
# [Orcs Web][AS19271][206.72.112.0 - 206.72.127.255]
0.0.0.0 314.hittail.com
0.0.0.0 815.hittail.com
0.0.0.0 922.hittail.com
0.0.0.0 1262.hittail.com
0.0.0.0 30811.hittail.com
0.0.0.0 3241.hittail.com
0.0.0.0 3415.hittail.com
0.0.0.0 3463.hittail.com
0.0.0.0 3918.hittail.com
0.0.0.0 3933.hittail.com
0.0.0.0 3957.hittail.com
0.0.0.0 4134.hittail.com
0.0.0.0 4560.hittail.com
0.0.0.0 4612.hittail.com
0.0.0.0 8260.hittail.com
0.0.0.0 8959.hittail.com
0.0.0.0 9394.hittail.com
0.0.0.0 9446.hittail.com
0.0.0.0 9547.hittail.com
0.0.0.0 9563.hittail.com
0.0.0.0 9571.hittail.com
0.0.0.0 10006.hittail.com
0.0.0.0 10168.hittail.com
0.0.0.0 12877.hittail.com
0.0.0.0 13223.hittail.com
0.0.0.0 14228.hittail.com
0.0.0.0 15141.hittail.com
0.0.0.0 15628.hittail.com
0.0.0.0 15694.hittail.com
0.0.0.0 16565.hittail.com
0.0.0.0 19097.hittail.com
0.0.0.0 19500.hittail.com
0.0.0.0 19533.hittail.com
0.0.0.0 20909.hittail.com
0.0.0.0 21807.hittail.com
0.0.0.0 22537.hittail.com
0.0.0.0 23315.hittail.com
0.0.0.0 23837.hittail.com
0.0.0.0 24725.hittail.com
0.0.0.0 24809.hittail.com
0.0.0.0 25057.hittail.com
0.0.0.0 26288.hittail.com
0.0.0.0 27460.hittail.com
0.0.0.0 27891.hittail.com
0.0.0.0 28305.hittail.com
0.0.0.0 30001.hittail.com
0.0.0.0 31335.hittail.com
0.0.0.0 31870.hittail.com
0.0.0.0 34673.hittail.com
0.0.0.0 35385.hittail.com
0.0.0.0 71158.hittail.com
0.0.0.0 73091.hittail.com
0.0.0.0 77266.hittail.com
0.0.0.0 78843.hittail.com
0.0.0.0 93367.hittail.com
0.0.0.0 99400.hittail.com
0.0.0.0 100065.hittail.com
0.0.0.0 103532.hittail.com
0.0.0.0 106242.hittail.com
0.0.0.0 108411.hittail.com
0.0.0.0 tracking.hittail.com
0.0.0.0 tracking2.hittail.com
0.0.0.0 ads.neudesicmediagroup.com
# [Oversee.net][AS33626][204.13.160.0 - 204.13.163.255]
0.0.0.0 domainsponsor.com #[Tracking.Cookie][WIPO.D2006-0523]
0.0.0.0 images.domainsponsor.com
0.0.0.0 spi.domainsponsor.com
0.0.0.0 dsparking.com
# [Ovh Sas][AS16276][142.4.192.0 - 142.4.223.255]
0.0.0.0 ads.videoadex.com
# [Ovh Sas][AS16276][144.217.0.0 - 144.217.255.255]
0.0.0.0 c.us1.dyntrk.com
# [Ovh Sas][AS16276][158.69.0.0 - 158.69.255.255]
0.0.0.0 plug.plugerr.com
# [Ovh Sas][AS16276][176.31.145.136 - 176.31.145.139]
0.0.0.0 green.erne.co
0.0.0.0 geoloc4.geovisite.com
0.0.0.0 adyoulike.omnitagjs.com
# [Ovh Sas][AS16276][178.32.18.128 - 178.33.18.191]
0.0.0.0 stat.clickfrog.ru
0.0.0.0 cpm1.affiz.net
0.0.0.0 creativecdn.com
0.0.0.0 c1.onedmp.com
0.0.0.0 aff.tagcdn.com
# [Ovh Sas][AS16276][188.165.192.0 - 188.165.255.255]
0.0.0.0 hub.adlpartner.com
0.0.0.0 tracking.propellerads.com
# [Ovh Sas][AS16276][192.95.0.0 - 192.95.63.255]
0.0.0.0 www5.afsanalytics.com
0.0.0.0 ad.asntown.net
0.0.0.0 marketingenhanced.com
0.0.0.0 www2.yidsense.com
# [Ovh Sas][AS16276][192.99.0.0 - 192.99.255.255]
0.0.0.0 www8.afsanalytics.com
0.0.0.0 www.yidsense.com
# [Ovh Sas][198.27.64.0 - 198.50.255.255]
0.0.0.0 cdn.tapstream.com
# [Ovh Sas][213.186.33.0 - 213.186.33.255]
0.0.0.0 static.canalstat.com
0.0.0.0 metriweb.be
# [Ovh Sas][213.251.131.0 - 213.251.131.255]
0.0.0.0 a1.x-traceur.com
0.0.0.0 a3.x-traceur.com
0.0.0.0 a12.x-traceur.com
0.0.0.0 a18.x-traceur.com
0.0.0.0 a20.x-traceur.com
0.0.0.0 logos.x-traceur.com
0.0.0.0 services.x-traceur.com
# [Ovh Sas][217.182.0.0 - 217.182.255.255]
0.0.0.0 coinhive.com
# [Ovh Sas][AS16276][37.187.128.0 - 37.187.135.255]
0.0.0.0 oxybe.com
0.0.0.0 pubted.com
# [Ovh Sas][37.59.0.0 - 37.59.63.255]
0.0.0.0 geoloc16.geovisite.com
0.0.0.0 xed.pl
0.0.0.0 www.xed.pl
# [Ovh Sas][46.105.96.0 - 46.105.127.255]
0.0.0.0 ads.databrainz.com
0.0.0.0 geoloc2.geovisite.com
0.0.0.0 hipersushiads.com
0.0.0.0 megapopads.com
0.0.0.0 sender.megapopads.com
0.0.0.0 cdn.stickyadstv.com
0.0.0.0 tracking.veille-referencement.com
# [Ovh Sas][AS16276][5.135.203.32 - 5.135.203.47]
0.0.0.0 static.adbutter.net
0.0.0.0 j.adlooxtracking.com
0.0.0.0 sender.hipersushiads.com
0.0.0.0 fo-api.omnitagjs.com
0.0.0.0 analytics.safelinking.net
0.0.0.0 stabx.net
0.0.0.0 www.x-park.net
# [Ovh Sas][AS16276][5.39.39.136 - 5.39.50.123]
0.0.0.0 st-1.1fichier.com #[Piwik.Analytics]
0.0.0.0 adbanner.adxcore.com
0.0.0.0 l.adxcore.com
0.0.0.0 ad.adxcore.com
0.0.0.0 d.adxcore.com
# [Ovh Sas][87.98.240.0 - 87.98.247.255]
0.0.0.0 a4p.adpartner.pro
0.0.0.0 adplans.net
0.0.0.0 www.alenty.com
0.0.0.0 secure.audienceinsights.net
0.0.0.0 static.audienceinsights.net
0.0.0.0 ox2.sterta.pl
# [Ovh Sas][91.121.144.0 - 91.121.191.255]
0.0.0.0 server1.affiz.net
0.0.0.0 apicit.net
0.0.0.0 www.canalstat.com
0.0.0.0 www.diffusionpub.com
0.0.0.0 dreamad.org
0.0.0.0 ads.freecaster.tv
0.0.0.0 geoloc12.geovisite.com
0.0.0.0 geoloc13.geovisite.com
0.0.0.0 geoloc14.geovisite.com
0.0.0.0 ads1.nexdra.com
0.0.0.0 www.noowho.com
0.0.0.0 paulsnetwork.com
0.0.0.0 piwik.org
0.0.0.0 hit.reference-sexe.com
0.0.0.0 tracker.squidanalytics.com
0.0.0.0 ads.stickyadstv.com
# [Ovh Sas][AS16276][94.23.0.0 - 94.23.63.255]
0.0.0.0 adv.440network.com
0.0.0.0 fr.cim.clickintext.net
0.0.0.0 fr.slidein.clickintext.net
0.0.0.0 fr.85.clickintext.net
0.0.0.0 geoloc17.geovisite.com
0.0.0.0 adtools.matrix-cash.com
0.0.0.0 www.one-door.com
0.0.0.0 c.thestat.net
0.0.0.0 www.toptracker.ru
0.0.0.0 www.pro.webstat.pl
0.0.0.0 tracking.wisepops.com
0.0.0.0 www.xstat.pl
0.0.0.0 zbiornik.com
# [Panther Express][AS36408][66.114.48.0 - 66.114.63.255]
0.0.0.0 adbard.net
0.0.0.0 cache.adviva.net
0.0.0.0 cdn.amgdgt.com #[WebBug]
0.0.0.0 media.baventures.com
0.0.0.0 js.bizographics.com
0.0.0.0 images.ddc.com #[Parking Service]
0.0.0.0 cdn.firstlook.com
# 0.0.0.0  adm.fwmrm.net #[affects nhl.com]
0.0.0.0 m2.fwmrm.net
0.0.0.0 cache.gfrevenge.com
0.0.0.0 cache.izearanks.com
0.0.0.0 crtv.mate1.com
0.0.0.0 cdn.media6degrees.com
0.0.0.0 static.meteorsolutions.com
0.0.0.0 bannershotlink.perfectgonzo.com
0.0.0.0 iframes.perfectgonzo.com
0.0.0.0 pluginx.perfectgonzo.com
0.0.0.0 cache.specificmedia.com
0.0.0.0 cdn.undertone.com
# [Peer 1][AS13768][107.6.0.0 - 107.6.63.255]
0.0.0.0 cm.eyereturn.com
# [Peer 1][AS13768][176.74.176.160 - 176.74.176.191]
0.0.0.0 return.uk.domainnamesales.com #[Parking.Service]
0.0.0.0 internettraffic.click
# [Peer 1][AS13768][207.198.64.0 - 207.198.127.255]
0.0.0.0 pixel.sitescout.com
# [Peer 1][AS13768][209.15.0.0 - 209.15.255.255]
0.0.0.0 appie.com
0.0.0.0 adsrvr.org
0.0.0.0 use-tor.adsrvr.org
0.0.0.0 btprmnav.com
0.0.0.0 btnativedirect.com
0.0.0.0 bttrack.com
0.0.0.0 pixel-a.basis.net
0.0.0.0 pixel.crosspixel.net
0.0.0.0 pixel.programmatictrader.com
0.0.0.0 pixel-a.sitescout.com
# [Peer 1][209.25.128.0 - 209.25.255.255]
0.0.0.0 tracking.aimediagroup.com
0.0.0.0 www.maxbounty.com
0.0.0.0 www.mb01.com
# [Peer 1][216.122.0.0 - 216.122.255.255]
0.0.0.0 as1.mistupid.com
# [Peer 1][AS13768][216.151.208.0 - 216.151.223.255]
0.0.0.0 delta.rspcdn.com
# [Peer 1][216.157.0.0 - 216.157.111.255]
0.0.0.0 ads.mp.mydas.mobi
0.0.0.0 androidsdk.ads.mp.mydas.mobi
0.0.0.0 bank01.ads.dt.mydas.mobi
0.0.0.0 bank02.ads.dt.mydas.mobi
0.0.0.0 bank03.ads.dt.mydas.mobi
0.0.0.0 bank04.ads.dt.mydas.mobi
0.0.0.0 bank05.ads.dt.mydas.mobi
0.0.0.0 bank06.ads.dt.mydas.mobi
0.0.0.0 bank07.ads.dt.mydas.mobi
0.0.0.0 bank08.ads.dt.mydas.mobi
0.0.0.0 bank09.ads.dt.mydas.mobi
0.0.0.0 bank10.ads.dt.mydas.mobi
0.0.0.0 bank11.ads.dt.mydas.mobi
0.0.0.0 bank12.ads.dt.mydas.mobi
0.0.0.0 bank13.ads.dt.mydas.mobi
0.0.0.0 bank15.ads.dt.mydas.mobi #[Mobile.Advertising]
0.0.0.0 bank16.ads.dt.mydas.mobi
0.0.0.0 bank17.ads.dt.mydas.mobi
0.0.0.0 bank18.ads.dt.mydas.mobi
0.0.0.0 bank19.ads.dt.mydas.mobi
0.0.0.0 bank20.ads.dt.mydas.mobi
0.0.0.0 bank01.ads.mp.mydas.mobi
0.0.0.0 bank02.ads.mp.mydas.mobi
0.0.0.0 bank03.ads.mp.mydas.mobi
0.0.0.0 bank04.ads.mp.mydas.mobi
0.0.0.0 bank05.ads.mp.mydas.mobi
0.0.0.0 bank06.ads.mp.mydas.mobi
0.0.0.0 bank07.ads.mp.mydas.mobi
0.0.0.0 bank08.ads.mp.mydas.mobi
0.0.0.0 bank09.ads.mp.mydas.mobi
0.0.0.0 bank10.ads.mp.mydas.mobi
0.0.0.0 bank11.ads.mp.mydas.mobi
0.0.0.0 bank12.ads.mp.mydas.mobi
0.0.0.0 bank13.ads.mp.mydas.mobi
0.0.0.0 bank15.ads.mp.mydas.mobi
0.0.0.0 bank16.ads.mp.mydas.mobi
0.0.0.0 bank17.ads.mp.mydas.mobi
0.0.0.0 bank18.ads.mp.mydas.mobi
0.0.0.0 bank19.ads.mp.mydas.mobi
0.0.0.0 bank20.ads.mp.mydas.mobi
# [Peer 1][AS13768][46.20.119.247 - 46.20.119.247]
0.0.0.0 srv.buysellads.com
# [Peer 1][AS11305][64.224.0.0 - 64.227.255.255]
0.0.0.0 www.iboard.com
0.0.0.0 cg-global.maxymiser.com
0.0.0.0 www.mcsqd.com
# [Peer 1 / Canadawebhosting][64.33.132.0 - 64.34.132.255]
0.0.0.0 ab163949.adbutler-kaon.com
0.0.0.0 ads.d-msquared.com
0.0.0.0 1.ofsnetwork.com
0.0.0.0 centro.pixel.ad
0.0.0.0 ads.sportsblog.com
0.0.0.0 ab159015.adbutler-zilon.com
# [Peer 1 / Canadawebhosting][AS13768][65.39.128.0 - 65.39.255.255]
0.0.0.0 www.countmypage.com
# [Peer 1 / Serverbeach][64.34.0.0 - 64.34.255.255]
0.0.0.0 pix.lfstmedia.com
0.0.0.0 map.media6degrees.com #[WebBug]
0.0.0.0 d6y5.ads.pof.com
0.0.0.0 t.ads.pof.com
0.0.0.0 clickserv.sitescout.com
0.0.0.0 www4search.net
# [Peer 1][AS13601][66.132.128.0 - 66.132.255.255]
0.0.0.0 archive.coolerads.com
0.0.0.0 counter.co.kz
0.0.0.0 hitmodel.net
# [Peer 1 / Serverbeach][66.135.32.0 - 66.135.63.255]
0.0.0.0 openads.hiphopsite.com
# [Peer 1][AS13768][66.155.16.0 - 66.155.97.255]
0.0.0.0 connexionsafe.com
0.0.0.0 geo.crtracklink.com
0.0.0.0 www.searchnet.com
0.0.0.0 www.thepornsurvey.com
# [Peer 1][66.199.128.0 - 66.199.191.255]
0.0.0.0 banner.titanpoker.com #[Adware.Casino]
# [Peer 1][AS11388][66.40.0.0 - 66.40.255.25550]
0.0.0.0 coolinc.info
0.0.0.0 www.mb57.com
# [Peer 1][AS13768][69.90.0.0 - 69.90.255.255]
0.0.0.0 d.adgear.com
0.0.0.0 o.adgear.com
0.0.0.0 www.albiondrugs.com
0.0.0.0 banner.casinotropez.com #[Adware.Casino]
0.0.0.0 banner.europacasino.com
0.0.0.0 www.favicon.com
0.0.0.0 purefuck.com
0.0.0.0 ads.purefuck.com
0.0.0.0 adwords2.paretologic.revenuewire.net
0.0.0.0 members.sexroulette.com
# [Peer 1][70.33.192.0 - 70.33.255.255]
0.0.0.0 bb.o2.eyereturn.com
0.0.0.0 www.full-edition.info
0.0.0.0 musicmembersarea.com
0.0.0.0 www.pdf-platinum.info
# [Peer 1][AS13768][72.51.0.0 - 72.51.63.255]
0.0.0.0 www.apponic.com #[Win32/InstallCore.NR]
# [Peer 1][76.74.128.0 - 76.74.255.255]
0.0.0.0 www.adelixir.com
0.0.0.0 geo.connexionsecure.com
0.0.0.0 ertya.com
0.0.0.0 eyereact.eyereturn.com
0.0.0.0 o2.eyereturn.com
0.0.0.0 voken.eyereturn.com
0.0.0.0 frtya.com
0.0.0.0 geo.hyperlinksecure.com
0.0.0.0 stats.polldaddy.com #[stats.wordpress.com]
0.0.0.0 geo.safelinktracker.com
0.0.0.0 seethisinaction.com
0.0.0.0 topqualitylink.com
0.0.0.0 www.webmoblink.com
0.0.0.0 botd.wordpress.com #[WebBug]
0.0.0.0 stats.wordpress.com
# [Pegasus / Fortressitx][69.57.160.0 - 69.57.191.255]
0.0.0.0 www.adloader.com
0.0.0.0 ads.adtrustmedia.com
0.0.0.0 update.privdog.com
0.0.0.0 www.privdog.com #[Security.Certificate.Alert]
# [Pegasus / Fortressitx][69.72.128.0 - 69.72.255.255]
0.0.0.0 adserver.exgfnetwork.com
# [Phonera][AS21503][80.252.160.0 - 80.252.191.255]
0.0.0.0 www.hit-counter-download.com
# [Phyber / Adconion][AS7012][207.171.14.0 - 207.171.15.255]
0.0.0.0 ae.amgdgt.com
0.0.0.0 at.amgdgt.com
0.0.0.0 cdns.amgdgt.com
# [PlusServer][AS8972][188.138.0.0 - 188.138.129.255]
0.0.0.0 adv.p2pbg.com
# [PlusServer / Server4you][AS8972][217.172.182.0 - 217.172.183.255]
0.0.0.0 mouseflow.com
0.0.0.0 a.mouseflow.com
# [PlusServer][AS8972][62.75.177.0 - 62.75.219.255]
0.0.0.0 ads.adbroker.de
0.0.0.0 www.hitmaster.de
0.0.0.0 www.webanalyser.net
# [PlusServer / 24 interactive][AS8972][62.75.239.64 - 62.75.239.127]
0.0.0.0 evania.adspirit.de
# [PlusServer][AS8972][85.25.129.0 - 85.25.251.255]
0.0.0.0 ad.ad24.ru
0.0.0.0 234.adru.net
0.0.0.0 bdgadv.ru
0.0.0.0 www.klamm-counter.de
0.0.0.0 scripts.psyma.com
0.0.0.0 aff.summercart.com
0.0.0.0 banners.tempobet.com
# [PlusServer][85.25.28.128 - 85.25.28.255]
0.0.0.0 img6.adspirit.de
0.0.0.0 img7.adspirit.de
# [PlusServer][85.25.83.0 - 85.25.83.127]
# [PointRoll][Gannett]
0.0.0.0 ev.ads.pointroll.com
0.0.0.0 speed.pointroll.com
# [PointRoll][72.32.153.176 - 72.32.153.183]
0.0.0.0 pointroll.com
0.0.0.0 ads.pointroll.com #[Tracking.Cookie]
0.0.0.0 clk.pointroll.com
0.0.0.0 media.pointroll.com
0.0.0.0 t.pointroll.com
0.0.0.0 track.pointroll.com
0.0.0.0 www.pointroll.com
# [Pret En Print / Fr-carpe-diem][AS16080][193.110.146.0 - 193.110.146.255]
0.0.0.0 statsv3.gaycash.com
0.0.0.0 carpediem.sv2.biz
0.0.0.0 dvdmanager-203.sv2.biz
0.0.0.0 ktu.sv2.biz
0.0.0.0 pub.sv2.biz
0.0.0.0 media.yesmessenger.com
0.0.0.0 outils.yes-messenger.com
# [Pret En Print / Fr-carpe-diem][AS16080][193.138.90.0 - 193.138.90.255]
0.0.0.0 www.dodostats.com
# [Prime / Seekio][AS15082][216.7.87.0 - 216.7.90.255]
0.0.0.0 avalon.topbucks.com
0.0.0.0 botw.topbucks.com
0.0.0.0 clickheat.topbucks.com
0.0.0.0 cluster-03.topbucks.com
0.0.0.0 mainstream.topbucks.com
0.0.0.0 rainbow.topbucks.com
0.0.0.0 referral.topbucks.com
0.0.0.0 vod.topbucks.com
0.0.0.0 referral.vod.topbucks.com
0.0.0.0 webmaster.topbucks.com
# [Priority Colo][AS30176][204.11.48.0 - 204.11.55.255]
0.0.0.0 dynamic.fmpub.net
0.0.0.0 keywords.fmpub.net
0.0.0.0 tenzing.fmpub.net
# [Priority Colo / Enthropia][AS30176][204.11.52.64 - 204.11.52.127]
0.0.0.0 mapstats.blogflux.com
0.0.0.0 topsites.blogflux.com
0.0.0.0 www.blogtopsites.com
0.0.0.0 www.topblogs.com.ph
# [Probe Networks / Artergo][AS29686][85.197.104.0 - 85.197.104.255]
0.0.0.0 www.maxxxhits.com
# [Prolexic][AS32787][207.8.128.0 - 207.8.255.255]
0.0.0.0 hypertracker.com
# [Prolexic / Confluence][AS40034][208.91.196.0 - 208.91.199.255]
0.0.0.0 www.bnmq.com
0.0.0.0 cnomy.com
0.0.0.0 pics.cnomy.com
0.0.0.0 pics.kolmic.com #[Parking Service]
0.0.0.0 mysearch-engine.com
0.0.0.0 www.searchacross.com #[Parking.Service.kolmic]
0.0.0.0 searchdiscovered.com
0.0.0.0 searchfwding.com
0.0.0.0 searchignited.com #[Parking.Service]
0.0.0.0 searchtoexplore.com
0.0.0.0 taffr.com
0.0.0.0 tamprc.com
# [Prolexic / Crown Solution][AS32787][209.200.162.192 - 209.200.162.223]
0.0.0.0 banner.ambercoastcasino.com
0.0.0.0 banner.cdpoker.com
0.0.0.0 banner.eurogrand.com
0.0.0.0 m.friendlyduck.com
# [Prolexic / Confluence][AS40034][50.58.0.0 - 50.59.255.255]
0.0.0.0 search.keywordblocks.com
0.0.0.0 www.mnetads.com
# [Prolexic][AS32787][72.52.0.0 - 72.52.63.255]
0.0.0.0 tour.affbuzzads.com
0.0.0.0 www.friendlyduck.com
# [Proxad][AS12322][212.27.60.0 - 212.83.156.255]
0.0.0.0 cloud-observer.ip-label.net
# [Proxad][AS12322][62.210.0.0 - 62.210.255.255]
0.0.0.0 ad.caradisiac-publicite.com
# [Proxad / Dedibox Sas][AS12322][88.191.3.0 - 88.191.248.255]
0.0.0.0 ads.canalblog.com
# [Prq-net-colo][AS33837][88.80.2.0 - 88.80.7.255]
# [Q9 Networks][AS12188][216.220.32.0 - 216.220.63.255]
0.0.0.0 geo.deepmetrix.com
0.0.0.0 banners.easydns.com
0.0.0.0 www.incentaclick.com
# [Q9 Networks][AS36031][67.210.208.0 - 67.210.223.255]
0.0.0.0 chlcotrk.com
0.0.0.0 www.mlinktracker.com
0.0.0.0 www.mmtracking.com
0.0.0.0 mpmotrk.com
0.0.0.0 mprptrk.com
0.0.0.0 mpxxtrk.com
0.0.0.0 sebcotrk.com
0.0.0.0 suscotrk.com
# [Quantcast][AS27281][64.94.107.0 - 64.94.107.255]
0.0.0.0 quantserve.com
0.0.0.0 edge.quantserve.com
0.0.0.0 www.edge.quantserve.com
0.0.0.0 flash.quantserve.com
0.0.0.0 pixel.quantserve.com #[WebBug]
0.0.0.0 secure.quantserve.com
0.0.0.0 segapi.quantserve.com
# [Quantcast][AS27281][74.217.63.0 - 74.217.63.255]
0.0.0.0 cms.quantserve.com
# [Qwest][AS209][63.151.44.11]
0.0.0.0 ds-aksb-a.akamaihd.net
# [Qwest][AS209][63.236.0.0 - 63.236.127.255]
0.0.0.0 get.whitesmoke.com #[Adware.Zugo.B]
0.0.0.0 www.whitesmoke.com
0.0.0.0 www.whitesmoke.us
# [Qwest][AS209][63.144.0.0 - 63.151.255.255]
0.0.0.0 ak1.abmr.net
0.0.0.0 ads.xda-developers.com
# [Qwest][AS209][65.112.0.0 - 65.127.255.255]
0.0.0.0 ads.sidekick.condenast.com
0.0.0.0 cache.dtmpub.com
0.0.0.0 t.omkt.co
# [Qwest][AS209][67.144.0.0 - 67.148.255.255]
0.0.0.0 tiads.people.com
0.0.0.0 ads.vimg.net
# [Qwest / Conduit Ltd][Effective-i][AS209][66.77.197.0 - 66.77.197.255]
0.0.0.0 hosting.conduit.com
0.0.0.0 apps.conduit-banners.com
0.0.0.0 www.conduit-banners.com
0.0.0.0 users.effectivebrand.com
0.0.0.0 www.effectivebrand.com
0.0.0.0 search.effectivebrand.com
0.0.0.0 pcbutts1.ourtoolbar.com
# [Qwest / CMP Media][AS209][66.77.24.0 - 66.77.27.255]
0.0.0.0 cookies.cmpnet.com
# [Qwest / Opinion Lab][AS209][66.77.28.64 - 66.77.28.127]
0.0.0.0 ccc00.opinionlab.com
0.0.0.0 ccc01.opinionlab.com #[msn.com]
0.0.0.0 rate.opinionlab.com
0.0.0.0 www.opinionlab.com
# [Qwest / Akamai][AS209][67.148.147.0 - 67.148.147.255]
# 0.0.0.0  static.chartbeat.com #[affects Healthcare.gov]
0.0.0.0 csma95349.analytics.edgesuite.net
# [Qwest / Tarrob][69.8.202.0 - 69.8.202.127]
0.0.0.0 ads.tarrobads.com
# [Qwest][70.56.0.0 - 70.59.255.255]
0.0.0.0 hu.2.cqcounter.com
# [Rackco.com][AS36529][38.112.0.0 - 38.119.255.255]
0.0.0.0 c4tracking01.com
# [Rackhosting][AS31590][77.247.64.0 - 77.247.79.255]
# [Rackspace.com][AS19994][104.130.0.0 - 104.130.255.255]
0.0.0.0 adtradradservices.com
0.0.0.0 www.earnify.com
0.0.0.0 www.komodia.com #[Security.Certificate.Alert]
# [Rackspace.com][AS27357][104.239.168.117]
0.0.0.0 adswakeup.com
# [Rackspace.com][AS27357][146.20.0.0 - 146.20.255.255]
0.0.0.0 ssp.lkqd.net
0.0.0.0 v.lkqd.net
0.0.0.0 www.td583.com
# [Rackspace.com][AS15395][162.13.136.0 - 162.13.143.255]
0.0.0.0 ads2.williamhill.com
# [Rackspace.com][AS19994][162.209.0.0 - 162.209.127.255]
0.0.0.0 api.cheatsheet.me
0.0.0.0 interyield.jmp9.com
0.0.0.0 www.tr553.com
# [Rackspace.com][AS27357][162.242.128.0 - 162.242.255.255]
0.0.0.0 track.blogmeetsbrand.com
0.0.0.0 interyield.td553.com
# [Rackspace.com][AS15395][164.177.147.0 - 164.177.147.255]
0.0.0.0 admarket.entireweb.com
# [Rackspace.com][AS33070][166.78.40.0 - 166.78.41.255]
0.0.0.0 ad.download.cnet.com
0.0.0.0 ml314.com
# [Rackspace.com][AS33070][AS19994][173.203.0.0 - 173.203.255.255]
0.0.0.0 api.adsnative.com
0.0.0.0 offers.affiliatetraction.com
0.0.0.0 track.ionicmedia.com
0.0.0.0 api.mixpanel.com
0.0.0.0 live.monitus.net
0.0.0.0 log.olark.com
0.0.0.0 thesearchagency.net
# [Rackspace.com][AS33070][174.143.0.0 - 174.143.255.255]
0.0.0.0 banners.brinkin.com
0.0.0.0 stats.buysellads.com
0.0.0.0 zfhg.digitaldesire.com
0.0.0.0 adsrv.ea.com #[affects Battlefield]
0.0.0.0 adx.ibibo.com
0.0.0.0 pixel.parsely.com
0.0.0.0 www.pixeltrack66.com
0.0.0.0 px.steelhousemedia.com
# [Rackspace.com][AS19994][184.106.0.0 - 184.106.255.255]
0.0.0.0 api.bounceexchange.com
0.0.0.0 iluv.clickbooth.com
0.0.0.0 immanalytics.com
0.0.0.0 cdnt.meteorsolutions.com
0.0.0.0 naughtyadserve.com
0.0.0.0 distillery.wistia.com
# [Rackspace.com][AS19994][192.237.147.16 - 192.237.147.19]
0.0.0.0 tools.ranker.com
# [Rackspace.com][AS19994][198.254.64.0 - 198.254.79.255]
0.0.0.0 t.afftrackr.com
0.0.0.0 gmdtrk.com
0.0.0.0 tcgtrkr.com
0.0.0.0 tsmtrk.com
# [Rackspace.com][AS19994][198.61.128.0 - 198.61.255.255]
0.0.0.0 www.clear-request.com
0.0.0.0 dcs.netbiscuits.net
0.0.0.0 lb.web-stat.com
0.0.0.0 server2.web-stat.com
# [Rackspace.com][AS27357][204.232.128.0 - 204.232.255.255]
0.0.0.0 www.rewardszoneusa.com
0.0.0.0 www.webhostingcounter.com
# [Rackspace.com][AS33070][209.61.179.88 - 209.61.179.95]
0.0.0.0 www.trackingstatalytics.com
# [Rackspace.com][AS15395][212.100.244.244 - 212.100.244.245]
0.0.0.0 www.smartlinks.dianomi.com
0.0.0.0 www.dianomioffers.co.uk
# [Rackspace.com][AS19994][23.253.0.0 - 23.253.255.255]
0.0.0.0 n.ad-back.net
0.0.0.0 bcanalytics.bigcommerce.com
0.0.0.0 www.oktrk.com
0.0.0.0 pipedream.wistia.com
0.0.0.0 click.zeroclickdirect.com
# [Rackspace.com][AS15395][46.38.178.0 - 46.38.179.255]
0.0.0.0 www.ist-track.com
# [Rackspace.com][AS15395][5.79.32.232 - 5.79.32.239]
0.0.0.0 www.powerlinks.com
# [Rackspace.com][AS19994][50.56.4.216 - 50.57.4.223]
0.0.0.0 comcluster.cxense.com
0.0.0.0 lfscpttracking.com
0.0.0.0 ads.referlocal.com
0.0.0.0 interyield.td563.com
0.0.0.0 www.trkr1.com
# [Rackspace][AS10532][64.49.192.0 - 64.49.255.255]
0.0.0.0 q1mediahydraplatform.com
# [Rackspace / Solvware][AS10532][65.61.156.32 - 65.61.156.47]
0.0.0.0 123count.com
0.0.0.0 www.123count.com #[Tracking.Cookie]
0.0.0.0 www.123stat.com
0.0.0.0 www.countercentral.com
0.0.0.0 web-stat.com #[Tracking.Cookie]
0.0.0.0 server3.web-stat.com
0.0.0.0 server4.web-stat.com
0.0.0.0 www.web-stat.com
# [Rackspace.com][67.192.0.0 - 67.192.255.255]
0.0.0.0 www.adfusion.com
0.0.0.0 adreadytractions.com
0.0.0.0 www.adversalservers.com
0.0.0.0 affntwklnk.com
0.0.0.0 bigapple.contextuads.com
0.0.0.0 cowboy.contextuads.com
0.0.0.0 loadus.exelator.com
0.0.0.0 container.pointroll.com
0.0.0.0 ads.sexinyourcity.com
0.0.0.0 www.sexinyourcity.com
0.0.0.0 www1.sexinyourcity.com
0.0.0.0 swtkes.com
# [Rackspace.com / Slicehost][AS12200][67.23.0.0 - 67.23.47.255]
0.0.0.0 ads.designtaxi.com
0.0.0.0 cdn.linksmart.com
# [Rackspace.com / Acez Software][72.3.128.0 - 72.3.255.255]
0.0.0.0 cpalead.com
0.0.0.0 data.cpalead.com
0.0.0.0 www.cpalead.com
0.0.0.0 www.performics.com
# [Rackspace.com][AS33070][72.32.0.0 - 72.32.255.255]
0.0.0.0 members.commissionmonster.com
0.0.0.0 www.contextuads.com
0.0.0.0 track.dmipartners.com
0.0.0.0 ecdtrk.com
0.0.0.0 f5mtrack.com
0.0.0.0 gd.geobytes.com
0.0.0.0 ism2trk.com
0.0.0.0 ads.jiwire.com
0.0.0.0 clk.madisonlogic.com
0.0.0.0 jsc.madisonlogic.com
0.0.0.0 oamtrk.com
0.0.0.0 clients.pointroll.com
0.0.0.0 ads.queendom.com
0.0.0.0 www.text-link-ads.com
0.0.0.0 www.textlinkads.com
0.0.0.0 secure.w3track.com
# [Rackspace.com][74.205.0.0 - 74.205.127.255]
0.0.0.0 sinettrk.com
0.0.0.0 b.sli-spark.com #[affects pccasegear.com / mwave.com.au]
0.0.0.0 traktum.com
# [Rackspace.com][AS15395][78.136.16.48 - 78.136.16.55]
0.0.0.0 track.childrensalon.com #[Piwik.Analytics]
# [Rackspace.com][AS15395][83.138.128.0 - 83.138.191.255]
0.0.0.0 track.webgains.com
# [Rackspace / IP Space][AS15395][89.234.32.248 - 89.234.32.255]
0.0.0.0 ads.adhsm.adhese.com
0.0.0.0 ads.nrc.adhese.com
0.0.0.0 pool.adhsm.adhese.com
0.0.0.0 pool.nrc.adhese.com
0.0.0.0 pool.sanoma.adhese.com
# [Rackspace.com][AS15395]92.52.72.160 - 92.52.72.191]
0.0.0.0 metering.pagesuite.com
# [Rackspace / IP Space][AS15395][94.236.103.0 - 94.236.103.63]
0.0.0.0 ads.bluesq.com
0.0.0.0 ads.comeon.com
0.0.0.0 inskinad.com
0.0.0.0 ads.mrgreen.com
0.0.0.0 ads.offsidebet.com
0.0.0.0 ads.o-networkaffiliates.com
0.0.0.0 t.wowanalytics.co.uk
# [Rackspace.com][AS15395]94.236.90.16 - 94.236.90.31]
0.0.0.0 ads.betsafe.com
0.0.0.0 www.inskinad.com
# [Rackspace.com][AS15395][95.138.128.0 - 95.138.191.255]
0.0.0.0 t.svtrd.com
# [Rackspace.com][98.129.0.0 - 98.129.255.255]
0.0.0.0 adserv.adbonus.com
0.0.0.0 www.adbonus.com
0.0.0.0 ads.cc
0.0.0.0 www.metricsimage.com
0.0.0.0 p.placemypixel.com
0.0.0.0 ad.where.com
# [Rambler][AS24638][81.19.70.0 -  81.19.70.255]
0.0.0.0 ad.rambler.ru #[WebBug]
0.0.0.0 ad2.rambler.ru
0.0.0.0 counter.rambler.ru
# 0.0.0.0  id.rambler.ru #[affects Rambler email]
0.0.0.0 images.rambler.ru
0.0.0.0 scnt.rambler.ru
0.0.0.0 scounter.rambler.ru
0.0.0.0 top100.rambler.ru
0.0.0.0 top100-images.rambler.ru
0.0.0.0 st.top100.ru
# [Rapidswitch / Zenex 5ive][AS29131][78.129.244.64 - 78.129.244.127]
0.0.0.0 www.totemcash.com
0.0.0.0 banners.toteme.com
0.0.0.0 cachebanners.toteme.com
# [Rapidswitch][87.117.192.0 - 87.117.207.255]
0.0.0.0 adserving.muppetism.com
# [Reasonnet][AS25525][83.98.203.128 - 83.98.203.255]
0.0.0.0 gfx.webmasterprofitcenter.com
0.0.0.0 promo.webmasterprofitcenter.com
0.0.0.0 promo.worldprofitcenter.com
# [Reflected Networks][AS29789][208.99.64.0 - 208.99.95.255]
0.0.0.0 ads.profitsdeluxe.com
# [Reflected Networks][AS29789][209.239.160.0 - 209.239.175.255]
0.0.0.0 ads.playboy.com
0.0.0.0 delivery.trafficforce.com
0.0.0.0 ads.traffichaus.com
0.0.0.0 syndication.traffichaus.com
0.0.0.0 www.traffichaus.com
0.0.0.0 www.yvmads.com
# [Reflected Networks][AS29789][216.18.160.0 - 216.18.191.255]
0.0.0.0 aff.adsurve.com
0.0.0.0 ads.amakings.com
0.0.0.0 ads.amaland.com
0.0.0.0 ads.bigrebelads.com
0.0.0.0 adserver2.exgfnetwork.com
0.0.0.0 analytics.fuckingawesome.com
0.0.0.0 ads.jo-games.com
0.0.0.0 www.tubehits.com
0.0.0.0 ads.watchmygf.net
0.0.0.0 openx.watchmygf.net
0.0.0.0 stats.watchmygf.com
# [Reflected Networks][AS29789][64.210.128.0 - 64.210.159.255]
0.0.0.0 ab.adrecreate.com
0.0.0.0 cdn.teamskeetimages.com
# [Reflected Networks][AS29789][66.254.96.0 - 66.254.127.255]
0.0.0.0 www.etahub.com
0.0.0.0 tackthisclick.com
0.0.0.0 ctrack.trafficjunky.net
0.0.0.0 static.trafficjunky.net
# [Register.it][AS39729][81.88.48.64 - 81.88.48.127]
0.0.0.0 optimized-by.4wnetwork.com
# [ReliableHosting][AS22781][216.131.64.0 - 216.131.127.255]
0.0.0.0 www.naughty-traffic.com
# [Righthosting.com / ZMac][AS14576][67.220.139.64 - 67.220.139.127]
0.0.0.0 ads.host.camz.com
# [Righthosting.com][AS14576][67.220.140.0 - 67.220.141.255]
0.0.0.0 ads.amateurmatch.com
0.0.0.0 ads.datinggold.com
# [RTComm.ru][AS8342][81.176.236.0 - 81.176.78.255]
0.0.0.0 code.directadvert.ru
0.0.0.0 ad.oyy.ru
# [RTComm.ru][AS8342][81.177.32.0 - 81.177.37.255]
0.0.0.0 cityads.ru
0.0.0.0 promo.cityads.ru
0.0.0.0 www.cityads.ru
0.0.0.0 track.seorate.ru
# [Saferoute][AS7415][69.172.216.0 - 69.172.216.255]
0.0.0.0 5726.bapi.adsafeprotected.com
0.0.0.0 6063.bapi.adsafeprotected.com
0.0.0.0 dt.adsafeprotected.com
0.0.0.0 pm.adsafeprotected.com
0.0.0.0 static.adsafeprotected.com
0.0.0.0 spixel.adsafeprotected.com
# [Sago][207.150.160.0 - 207.150.191.255]
0.0.0.0 adlik.akavita.com
# [Sago][65.110.32.0 - 65.110.63.255]
0.0.0.0 www.hobwelt.com
# [Sago / United Colocation][AS21840][66.111.32.0 - 66.111.63.255]
# [Sago][66.118.128.0 - 66.118.191.255]
0.0.0.0 addfreestats.com #[WebBug]
0.0.0.0 top.addfreestats.com
0.0.0.0 www.addfreestats.com
0.0.0.0 www1.addfreestats.com #[Tracking.Cookie]
0.0.0.0 www2.addfreestats.com
0.0.0.0 www3.addfreestats.com
0.0.0.0 www4.addfreestats.com
0.0.0.0 www5.addfreestats.com
0.0.0.0 www6.addfreestats.com
0.0.0.0 www7.addfreestats.com
0.0.0.0 www8.addfreestats.com
0.0.0.0 www9.addfreestats.com
0.0.0.0 www.mvav.com
# [Savvis][AS3561][205.138.0.0 - 205.140.175.255]
0.0.0.0 admax.nexage.com
0.0.0.0 bbads.sx.atl.publicus.com
# [Savvis][AS3561][205.216.0.0 - 205.217.223.255]
# 0.0.0.0 d.xp1.ru4.com #[affects Battlefield]
0.0.0.0 udm.ia6.scorecardresearch.com
0.0.0.0 udm.ia7.scorecardresearch.com
# [Savvis / Comscore][AS3561][205.218.0.0 - 205.219.255.255]
0.0.0.0 sa.scorecardresearch.com
# [Savvis][AS3561][209.185.0.0 - 209.185.255.255]
0.0.0.0 click.silvercash.com
0.0.0.0 smc.silvercash.com
0.0.0.0 www.silvercash.com
0.0.0.0 banners.weboverdrive.com
# [Savvis / Lycos][209.202.192.0 - 209.202.255.255]
0.0.0.0 ads.tripod.com #[Tracking.Cookie]
0.0.0.0 ads1.tripod.com
0.0.0.0 nedstat.tripod.com
0.0.0.0 cm8.lycos.com
# [Savvis][AS3561][216.34.181.0 - 216.35.255.255]
0.0.0.0 images-aud.freshmeat.net
0.0.0.0 images-aud.slashdot.org
0.0.0.0 e89.friendfinder.com
0.0.0.0 analytics.slashdotmedia.com #[Piwik.Analytics]
0.0.0.0 images-aud.sourceforge.net
0.0.0.0 events.webflowmetrics.com
# [Savvis / Nextpoint][216.69.224.0 - 216.69.239.255]
0.0.0.0 track1.breakmedia.com
# [Savvis / Creative Media][216.74.128.0 - 216.74.191.255]
0.0.0.0 alt.webtraxs.com
0.0.0.0 www.webtraxs.com
# [Savvis / AlmondNet][64.14.90.224 - 64.14.90.239]
0.0.0.0 pbid.pro-market.net
# [Savvis][64.41.128.0 - 64.41.255.255]
0.0.0.0 spd.atdmt.speedera.net
# [Savvis][AS3561][64.79.160.0 - 64.79.175.255]
0.0.0.0 images.specificclick.net
0.0.0.0 specificpop.com
0.0.0.0 www.specificpop.com #[Tracking.Cookie]
# [SBC][AS7132][64.252.250.0 - 64.252.251.255]
# [SBC / Net Applications][AS16966][66.161.36.128 - 66.161.36.159]
0.0.0.0 hitslink.com
0.0.0.0 counter.hitslink.com #[Tracking.Cookie]
0.0.0.0 counter2.hitslink.com
0.0.0.0 profiles.hitslink.com
0.0.0.0 www2.hitslink.com
0.0.0.0 www.hitslink.com
0.0.0.0 loc1.hitsprocessor.com
# [Schibsted][AS21171][152.90.0.0 - 152.90.255.255]
0.0.0.0 click.trafikkfondet.no
# [Schibsted][AS21171][80.91.37.0 - 80.91.37.255]
0.0.0.0 aa.oasfile.aftenposten.no
0.0.0.0 ap.oasfile.aftenposten.no
0.0.0.0 adcache.aftenposten.no
0.0.0.0 webhit.aftenposten.no
# [SecurePrivateNetwork / OC3 Networks][204.152.192.0 - 204.152.223.255]
0.0.0.0 s05.flagcounter.com
# [SecurePrivateNetwork / OC3 Networks][207.150.160.110 - 207.150.160.119]
0.0.0.0 www.kickassratios.com
# [SecurePrivateNetwork / OC3 Networks][AS22298][216.45.48.0 - 216.45.63.255]
0.0.0.0 partners.badongo.com
0.0.0.0 ua.badongo.com
# [SecurePrivateNetwork / Assertivenet][AS22298][66.154.96.0 - 66.154.127.255]
0.0.0.0 www.1adult.com
0.0.0.0 11zz.com
0.0.0.0 i.11zz.com
0.0.0.0 in.11zz.com
0.0.0.0 www.11zz.com
0.0.0.0 www.acmexxx.com
0.0.0.0 adchimp.com
0.0.0.0 adultlinksco.com
0.0.0.0 www.adultlinksco.com
0.0.0.0 cashcount.com
0.0.0.0 www.cashcount.com
0.0.0.0 cecash.com
0.0.0.0 tats.cecash.com
0.0.0.0 www.cecash.com
0.0.0.0 cttracking08.com
0.0.0.0 in.cybererotica.com
0.0.0.0 in.ff5.com
0.0.0.0 in.joinourwebsite.com
0.0.0.0 www.joinourwebsite.com
0.0.0.0 tgp.pornsponsors.com
0.0.0.0 www.pornsponsors.com
0.0.0.0 bigtits.xxxallaccesspass.com
# [Secured Servers][AS20454][198.15.64.0 - 198.15.127.255]
0.0.0.0 www.ccbilleu.com
# [Secured Servers][AS20454][209.188.14.0 - 209.188.14.255]
0.0.0.0 banners.lativio.com
# [Secured Servers][AS20454][64.38.192.0 - 64.38.255.255]
0.0.0.0 serve.ads.chaturbate.com
0.0.0.0 bill.ecsuite.com
0.0.0.0 adserver.exoticads.com
0.0.0.0 promo.lonelywifehookup.com
0.0.0.0 promo.ulust.com
# [Sedo LLC Group]
0.0.0.0 www.adsedo.com
0.0.0.0 www.sedotracker.com
0.0.0.0 www.sedotracker.de
# [Sedo / Cachenetworks][AS23352][AS30081][205.234.175.0 - 205.234.175.255]
0.0.0.0 static.parkingpanel.com
0.0.0.0 img.sedoparking.com
# [Sedo][82.98.86.0 - 82.98.86.255]
0.0.0.0 traffic.revenuedirect.com
0.0.0.0 sedoparking.com
0.0.0.0 www.sedoparking.com
0.0.0.0 www1.sedoparking.com
# [ServePath][157.22.32.0 - 157.22.47.255]
0.0.0.0 www.incentivenetworks2.com
# [ServePath][173.1.0.0 - 173.1.127.255]
# [ServePath][AS26228][204.51.128.0 - 204.51.255.255]
0.0.0.0 ideoclick.com
# [ServePath][AS26228][208.96.0.0 - 208.96.63.255]
0.0.0.0 partners.realgirlsmedia.com
# [ServePath][AS26228][216.121.0.0 - 216.121.127.255]
0.0.0.0 www30a4.glam.com
0.0.0.0 ignitad.com
# [ServePath][AS26228][216.93.160.0 - 216.93.191.255]
0.0.0.0 hookedmediagroup.com
0.0.0.0 ads.hookedmediagroup.com
0.0.0.0 beacon.hookedmediagroup.com
0.0.0.0 www.hookedmediagroup.com
0.0.0.0 t4.trackalyzer.com
0.0.0.0 t6.trackalyzer.com
# [ServePath][AS26228][64.151.64.0 - 64.151.127.255]
0.0.0.0 t5.trackalyzer.com
# [ServePath][AS26228][69.59.128.0 - 69.59.191.255]
0.0.0.0 trackalyzer.com
0.0.0.0 t1.trackalyzer.com
0.0.0.0 t2.trackalyzer.com
0.0.0.0 t3.trackalyzer.com
# [Server Central Network][AS23352][204.93.128.0 - 204.93.255.255]
0.0.0.0 www.skassets.com
# [Server Central Network][AS23352][205.234.128.0 - 205.234.255.255]
0.0.0.0 www.holika.com
# [Server Central / TrackingSoft][AS23352][216.246.14.0 - 216.246.14.63]
0.0.0.0 fcds.affiliatetracking.net
0.0.0.0 our.affiliatetracking.net
0.0.0.0 www.affiliatetracking.net
0.0.0.0 www.affiliatetracking.com
0.0.0.0 ads.evtv1.com
0.0.0.0 roia.biz
0.0.0.0 ads.vidsense.com
# [Server Central Network][AS23352][66.225.192.0/18]
0.0.0.0 gamesiteads.com
# [ServerStack][AS46652][141.0.172.0 - 141.0.175.255]
0.0.0.0 118605-5437.link.iwanttodeliver.com
0.0.0.0 145639-4902.link.iwanttodeliver.com
0.0.0.0 www.iwanttodeliver.com
# [ServerStack][AS46652][192.81.208.0 - 192.81.223.255]
0.0.0.0 servads.fansshare.com
# [ServerStack][AS46652][198.199.64.0 - 198.199.127.255]
0.0.0.0 pagetracking.popmarker.com
# [ServerStack][AS46652][69.55.48.0 - 69.55.63.255]
0.0.0.0 prpops.com
0.0.0.0 prscripts.com
# [Serverstream][AS42129][91.151.208.0 - 91.151.223.255]
0.0.0.0 anm.intelli-direct.com #[IntelliTracker]
0.0.0.0 info.intelli-direct.com
0.0.0.0 oxfam.intelli-direct.com
0.0.0.0 tui.intelli-direct.com
0.0.0.0 www.intelli-direct.com #[WebBug]
# [ServInt / BackBeat Media][AS25847][207.58.150.192 - 207.58.150.223]
0.0.0.0 adserver1.backbeatmedia.com
0.0.0.0 adserver1-images.backbeatmedia.com
0.0.0.0 bullseye.backbeatmedia.com
# [ServInt / Funix][AS25847][216.38.58.0 - 216.38.58.31]
0.0.0.0 www.clickthruserver.com
# [Singlehop][AS32475][107.6.128.0 - 107.6.191.255]
0.0.0.0 advertising.bayoubuzz.com
# [Singlehop][AS32475][173.236.0.0 - 173.236.127.255]
0.0.0.0 banners.popads.net
0.0.0.0 popadscdn.net
# [Singlehop][AS32475][184.154.0.0 - 184.154.255.255]
0.0.0.0 track.justcloud.com
0.0.0.0 www.liveadclicks.com
# [Singlehop][AS32475][198.20.64.0 - 198.20.127.255]
0.0.0.0 afflow.amazonpresent.info #[ScamFraudAlert.Antispyware]
0.0.0.0 pix.impdesk.com
# [Singlehop][AS32475][216.104.32.0 - 216.104.47.255]
0.0.0.0 tally.upsideout.com #[Piwik.Analytics]
# [Singlehop][AS32475][65.60.0.0 - 65.60.63.255]
0.0.0.0 www.virtualsurfer.com
0.0.0.0 www.youho.com
# [Singlehop][AS32475][69.175.0.0 - 69.175.127.255]
0.0.0.0 a.gsmarena.com
0.0.0.0 tracksitetraffic1.com
0.0.0.0 www.universal-traffic.com
# [Singlehop][AS32475][99.198.96.0/20]
0.0.0.0 offers.cloackp.com #[ScamFraudAlert.Antispyware]
# [Shiny][AS6665][195.210.96.0 - 195.210.127.255]
0.0.0.0 codice.shinystat.com
0.0.0.0 codicebusiness.shinystat.com
0.0.0.0 codicefl.shinystat.com
0.0.0.0 codiceisp.shinystat.com
0.0.0.0 s1.shinystat.com
0.0.0.0 s2.shinystat.com
0.0.0.0 s3.shinystat.com
0.0.0.0 s4.shinystat.com
0.0.0.0 s9.shinystat.com
0.0.0.0 www.shinystat.com
# [Simpli Hosting / Rampell][208.69.176.0 - 208.69.183.255]
0.0.0.0 didtheyreadit.com
0.0.0.0 www.didtheyreadit.com
0.0.0.0 www.readnotify.com #[Email Tracker]
0.0.0.0 xpostmail.com
# [Skyline / Believe][AS22361][208.74.32.0 - 208.74.39.255]
0.0.0.0 ia.spinbox.net
0.0.0.0 netcomm.spinbox.net
0.0.0.0 vsii.spinbox.net
0.0.0.0 www.spinbox.net
# [Skyline][AS22361][65.220.52.0 - 65.220.53.255]
0.0.0.0 adtegrity.spinbox.net #[Tracking.Cookie]
# [Sky-Media / Rax.RU][AS39134][88.212.196.64 - 88.212.196.127]
0.0.0.0 ad.bannerhost.ru
0.0.0.0 ad2.bannerhost.ru
0.0.0.0 ads.photosight.ru
0.0.0.0 ad.yadro.ru #[Tracking.Cookie]
0.0.0.0 ads.yadro.ru
0.0.0.0 counter.yadro.ru
0.0.0.0 sticker.yadro.ru
0.0.0.0 upstats.yadro.ru
# [Sky-Media / Ooo Medialand][AS39134][88.212.200.0 - 88.212.200.127]
0.0.0.0 business.lbn.ru
0.0.0.0 www.business.lbn.ru
0.0.0.0 fun.lbn.ru
0.0.0.0 www.fun.lbn.ru
0.0.0.0 234.media.lbn.ru
# [Smart][AS44553][87.119.79.0 - 87.119.79.255]
0.0.0.0 www.europerank.com
0.0.0.0 ads.glasove.com
# [Smartadserver][AS201081][185.86.137.17]
0.0.0.0 diff.smartadserver.com
0.0.0.0 diff3.smartadserver.com
0.0.0.0 diff4.smartadserver.com
0.0.0.0 im2.smartadserver.com
0.0.0.0 mobile.smartadserver.com
0.0.0.0 rtb-csync.smartadserver.com
0.0.0.0 www2.smartadserver.com
0.0.0.0 www3.smartadserver.com
0.0.0.0 www4.smartadserver.com
0.0.0.0 www5.smartadserver.com
0.0.0.0 www6.smartadserver.com
0.0.0.0 ww14.smartadserver.com
0.0.0.0 ww38.smartadserver.com
0.0.0.0 ww57.smartadserver.com
0.0.0.0 ww62.smartadserver.com
0.0.0.0 ww84.smartadserver.com
0.0.0.0 ww129.smartadserver.com
0.0.0.0 ww135.smartadserver.com
0.0.0.0 ww147.smartadserver.com
0.0.0.0 ww150.smartadserver.com
0.0.0.0 ww206.smartadserver.com
0.0.0.0 ww251.smartadserver.com
0.0.0.0 ww302.smartadserver.com
0.0.0.0 ww370.smartadserver.com
0.0.0.0 ww381.smartadserver.com
0.0.0.0 ww392.smartadserver.com
0.0.0.0 ww400.smartadserver.com
0.0.0.0 ww690.smartadserver.com
0.0.0.0 ww691.smartadserver.com
0.0.0.0 ww797.smartadserver.com
0.0.0.0 ww965.smartadserver.com
0.0.0.0 ww1003.smartadserver.com
0.0.0.0 ww1097.smartadserver.com
0.0.0.0 ww1270.smartadserver.com
0.0.0.0 ww2026.smartadserver.com
0.0.0.0 ww2468.smartadserver.com
0.0.0.0 smart.styria-digital.com
0.0.0.0 www.smartadserver.com
0.0.0.0 ww881.smartadserver.com
# [Smartadserver][AS47043][199.187.192.0 - 199.187.195.255]
0.0.0.0 prg.smartadserver.com
0.0.0.0 www8.smartadserver.com
0.0.0.0 www9.smartadserver.com
# [Softlayer][AS36351][104.200.16.0 - 104.200.31.255]
0.0.0.0 delivery.thebloggernetwork.com
0.0.0.0 logs.thebloggernetwork.com
# [Softlayer][AS36351][108.167.128.0 - 108.168.255.255]
0.0.0.0 www.adforgames.com
0.0.0.0 clkrev.com
0.0.0.0 clksite.com
0.0.0.0 p128902.clksite.com
0.0.0.0 p30839.clksite.com
0.0.0.0 p69523.clksite.com
0.0.0.0 inclk.com
0.0.0.0 tag.navdmp.com
0.0.0.0 device.maxmind.com
0.0.0.0 rhtag.com
0.0.0.0 www.rightmedia.com
0.0.0.0 c.securepaths.com
0.0.0.0 www.securepaths.com
0.0.0.0 srvpub.com
0.0.0.0 dx.steelhousemedia.com
# [Softlayer][AS36351][119.81.0.0 - 119.81.255.255]
0.0.0.0 adr.adplus.co.id
# [Softlayer][AS36351][173.192.0.0 - 173.193.255.255]
0.0.0.0 d1.24counter.com
0.0.0.0 www.admixxer.com
0.0.0.0 affrh2019.com
0.0.0.0 bluekai.com
0.0.0.0 analytics.bluekai.com
0.0.0.0 stags.bluekai.com
0.0.0.0 c.chango.com
0.0.0.0 d.chango.com
0.0.0.0 dnetshelter3.d.chango.com
0.0.0.0 clkfeed.com
0.0.0.0 clkoffers.com
# 0.0.0.0 realtime.services.disqus.com #[affects politicalwire.com]
0.0.0.0 tempest.services.disqus.com
0.0.0.0 eclkmpbn.com
0.0.0.0 eclkmpsa.com
0.0.0.0 eclkspbn.com
0.0.0.0 eclkspsa.com
0.0.0.0 tags1.eclkspsa.com
0.0.0.0 s4is.histats.com
0.0.0.0 px.owneriq.net
0.0.0.0 spx.owneriq.net
0.0.0.0 28.securefinds2.com
0.0.0.0 stats.snacktools.net
0.0.0.0 tags.t.tailtarget.com
0.0.0.0 h.verticalscope.com
0.0.0.0 w55c.net
0.0.0.0 tags.w55c.net
0.0.0.0 ads.wellsmedia.com
# [Softlayer / Hosting Services][AS36351][173.244.192.0 - 173.244.223.255]
0.0.0.0 ad.looktraffic.com
# [Softlayer][174.127.0.0 - 174.37.255.255]
0.0.0.0 www.1800banners.com
0.0.0.0 ads.ad4game.com
0.0.0.0 addjump.com
0.0.0.0 aff.adventory.com
0.0.0.0 www.besthitsnow.com
0.0.0.0 www.cashlayer.com
0.0.0.0 juggler.services.disqus.com
0.0.0.0 ads.imaging-resource.com
0.0.0.0 ad.leadbolt.net
0.0.0.0 ads.right-ads.com
0.0.0.0 ad.slashgear.com
0.0.0.0 www.supremehits.net
0.0.0.0 adserver.twitpic.com
0.0.0.0 www.whalecashads.com
# [Softlayer][AS36351][184.172.0.0 - 184.173.255.255]
0.0.0.0 ad.a-ads.com
0.0.0.0 convusmp.admailtiser.com
0.0.0.0 fqtag.com
0.0.0.0 c.fqtag.com
0.0.0.0 navdmp.com
0.0.0.0 px.splittag.com
# [Softlayer][AS36351][192.200.160.0 - 192.200.191.255]
0.0.0.0 analytics.bigcommerce.com
# [Softlayer][AS36351][198.23.64.0 - 198.58.127.255]
0.0.0.0 www.freenew.net #[Win32/FreeNew.B]
# [Softlayer / Hosting Services][AS36351][206.217.192.0 - 206.217.223.255]
0.0.0.0 adultdatingtest.worlddatingforum.com
# [SoftLayer][AS36351][208.43.0.0 - 208.43.255.255]
0.0.0.0 banners.adventory.com
0.0.0.0 as.autoforums.com
0.0.0.0 as2.autoforums.com
0.0.0.0 www.counters4u.com
0.0.0.0 gostats.com
0.0.0.0 c1.gostats.com
0.0.0.0 c2.gostats.com #[Tracking.Cookie]
0.0.0.0 c3.gostats.com
0.0.0.0 c4.gostats.com
0.0.0.0 monster.gostats.com
0.0.0.0 gostats.pl
0.0.0.0 gostats.ru
0.0.0.0 c4.gostats.ru
0.0.0.0 monster.gostats.ru
0.0.0.0 s4.histats.com
0.0.0.0 s10.histats.com
0.0.0.0 s11.histats.com
0.0.0.0 s128.histats.com
0.0.0.0 s129js.histats.com
0.0.0.0 sstatic1.histats.com
0.0.0.0 in-appadvertising.com
0.0.0.0 widget6.linkwithin.com
0.0.0.0 peerfly.com
0.0.0.0 tracking.softwareprojects.com
0.0.0.0 ads.somd.com
0.0.0.0 webstats.thaindian.com
0.0.0.0 www.trafficpace.com
0.0.0.0 stats.vodpod.com
# [Softlayer][AS36351][37.58.82.248 - 37.58.82.255]
0.0.0.0 service.clicksvenue.com
0.0.0.0 eu-px.steelhousemedia.com
0.0.0.0 ww-eu.steelhousemedia.com
# [Softlayer][AS36351][5.10.68.176 - 5.10.68.183]
0.0.0.0 ads.eu.e-planning.net
# [Softlayer][50.116.64.0 - 50.97.255.255]
0.0.0.0 probes.cedexis.com
0.0.0.0 www.klixmedia.com
0.0.0.0 reseller.sexyads.com
0.0.0.0 www.sexyads.net
0.0.0.0 servedby.studads.com
0.0.0.0 a.thoughtleadr.com
0.0.0.0 wp-stats.com
# [Softlayer][66.228.112.0 - 66.228.127.255]
0.0.0.0 ad01.advertise.com
# [Softlayer][AS36351][67.228.0.0 - 67.228.255.255]
0.0.0.0 adserver.bizhat.com
0.0.0.0 cn.clickable.net
0.0.0.0 clustrmaps.com
0.0.0.0 www2.clustrmaps.com
0.0.0.0 www3.clustrmaps.com
0.0.0.0 www4.clustrmaps.com
0.0.0.0 www.clustrmaps.com
0.0.0.0 referrer.disqus.com
0.0.0.0 adv.elaana.com
0.0.0.0 hitstatus.com
0.0.0.0 hits.informer.com
0.0.0.0 my.mobfox.com
0.0.0.0 banners.mynakedweb.com
# 0.0.0.0 api.nanigans.com #[affects 2go.com]
0.0.0.0 pi.pardot.com
0.0.0.0 www.seekways.com
0.0.0.0 thesurfshield.com
0.0.0.0 www.thesurfshield.com
0.0.0.0 www.toplistim.com
# [Softlayer / Hosting Services][69.4.224.0 - 69.4.239.255]
0.0.0.0 e.dtscout.com
0.0.0.0 t.dtscout.com
# [Softlayer][74.120.236.0 - 74.120.239.255]
0.0.0.0 r.bid4keywords.com
# [Softlayer][74.86.0.0 - 74.86.255.255]
0.0.0.0 ads.abovetopsecret.com
0.0.0.0 adserverus.info
0.0.0.0 www.autosurfpro.com
0.0.0.0 tracking.fanbridge.com
0.0.0.0 www2.game-advertising-online.com
0.0.0.0 www3.game-advertising-online.com
0.0.0.0 urlstats.com
0.0.0.0 ads.verticalscope.com
# [Softlayer][75.126.0.0 - 75.126.255.255]
0.0.0.0 count.9yx.com
0.0.0.0 error.000webhost.com
0.0.0.0 arank.com
0.0.0.0 b3d.com
0.0.0.0 bde3d.com
0.0.0.0 www.b3d.com
0.0.0.0 ads.us.e-planning.net
0.0.0.0 www.game-advertising-online.com
0.0.0.0 www.mypagerank.net
0.0.0.0 obeus.com
0.0.0.0 www.sacredphoenix.com
0.0.0.0 srv.sayyac.com
0.0.0.0 srv.sayyac.net
0.0.0.0 by.uservoice.com #[WebBug]
0.0.0.0 www.vizury.com
0.0.0.0 window1.com
# [Sophus][AS29017][89.145.118.0 - 89.145.118.255]
0.0.0.0 scripts.sophus3.com
0.0.0.0 gm.touchclarity.com
# [Sovintel][AS3216][194.67.0.0 - 194.67.63.255]
0.0.0.0 adv.aport.ru
0.0.0.0 stat.aport.ru
0.0.0.0 stat.stars.ru #[WebBug]
# [Sovintel][AS3216][195.239.111.0 - 195.239.111.255]
0.0.0.0 engine.rbc.medialand.ru
# [Spectrum][AS8717][212.50.12.80 - 212.50.12.95]
0.0.0.0 ads.standartnews.com
# [Spectrum][AS8717][92.247.8.0 - 92.247.15.255]
0.0.0.0 openx.bmwpower-bg.net
# [SSERV / Adlink][AS24679][91.209.81.0 - 91.209.81.255]
0.0.0.0 js.adlink.net
0.0.0.0 tc.adlink.net #[WebBug]
# [Starhubinternet / Akamai][AS4657][125.252.192.0 - 125.252.255.255]
0.0.0.0 aka-cdn.adtech.de #[AOL Advertising]
# [Startphone][AS47344][94.100.124.0 - 94.100.127.255]
0.0.0.0 ads.dichtbij.adhese.com
0.0.0.0 pool.dichtbij.adhese.com
# [Statcounter][Aodhan Cullen]
0.0.0.0 c.statcounter.com
0.0.0.0 c1.statcounter.com #[Tracking.Cookie]
0.0.0.0 c2.statcounter.com #[WebBug]
0.0.0.0 c3.statcounter.com
0.0.0.0 c4.statcounter.com
0.0.0.0 c5.statcounter.com
0.0.0.0 c6.statcounter.com #[Analytics.Tracker]
0.0.0.0 c7.statcounter.com
0.0.0.0 c8.statcounter.com
0.0.0.0 c10.statcounter.com
0.0.0.0 c11.statcounter.com
0.0.0.0 c12.statcounter.com
0.0.0.0 c13.statcounter.com
0.0.0.0 c14.statcounter.com
0.0.0.0 c15.statcounter.com
0.0.0.0 c16.statcounter.com
0.0.0.0 c17.statcounter.com
0.0.0.0 c18.statcounter.com
0.0.0.0 c19.statcounter.com
0.0.0.0 c20.statcounter.com
0.0.0.0 c21.statcounter.com
0.0.0.0 c22.statcounter.com
0.0.0.0 c23.statcounter.com
0.0.0.0 c24.statcounter.com
0.0.0.0 c25.statcounter.com
0.0.0.0 c26.statcounter.com
0.0.0.0 c27.statcounter.com
0.0.0.0 c28.statcounter.com
0.0.0.0 c29.statcounter.com
0.0.0.0 c30.statcounter.com
0.0.0.0 c31.statcounter.com
0.0.0.0 c32.statcounter.com
0.0.0.0 c33.statcounter.com
0.0.0.0 c34.statcounter.com
0.0.0.0 c35.statcounter.com
0.0.0.0 c36.statcounter.com
0.0.0.0 c37.statcounter.com
0.0.0.0 c38.statcounter.com
0.0.0.0 c39.statcounter.com
0.0.0.0 c40.statcounter.com
0.0.0.0 c41.statcounter.com
0.0.0.0 c42.statcounter.com
0.0.0.0 c43.statcounter.com
0.0.0.0 c45.statcounter.com
0.0.0.0 c46.statcounter.com
0.0.0.0 my.statcounter.com
0.0.0.0 my8.statcounter.com
0.0.0.0 s2.statcounter.com
0.0.0.0 secure.statcounter.com
0.0.0.0 www.statcounter.com
# [Steadfast Networks][AS32748][67.202.64.0 - 67.202.127.255]
0.0.0.0 www.clixtrac.com
0.0.0.0 ic.tynt.com
# [Suavemente / IzoWeb][AS14572][66.11.113.0 - 66.11.114.255]
0.0.0.0 freakads.com
# [SuperHost.pl][AS41079][193.218.152.0 - 193.218.155.255]
0.0.0.0 poponclick.com
# [Superhosting.bg][AS201200][164.138.216.0 - 164.138.217.255]
0.0.0.0 ads.359group.com
# [SuperNetwork][AS39392][46.234.113.0 - 46.234.113.255]
0.0.0.0 cdn.exactag.com
# [SuperNetwork][AS39392][88.86.96.0 - 88.86.127.255]
0.0.0.0 toplist.eu
0.0.0.0 bannerlink.xxxtreams.com
# [Swift Ventures][AS25700][204.8.32.0 - 204.8.35.255]
0.0.0.0 clicks2.traffictrader.net
# [Swift Ventures][AS25700][204.13.164.0 - 204.13.167.255]
0.0.0.0 clicks3.traffictrader.net
0.0.0.0 weownthetraffic.com
0.0.0.0 www.weownthetraffic.com
0.0.0.0 stats.xxxkey.com
# [Swift Ventures][AS25700][204.15.224.192 - 204.15.231.255]
0.0.0.0 clicks.traffictrader.net
0.0.0.0 clicks.eutopia.traffictrader.net
# [Swiftwill][AS30361][146.82.200.0 - 146.82.207.255]
0.0.0.0 ads.contentabc.com
0.0.0.0 banners.dogfart.com
0.0.0.0 tour.brazzers.com
0.0.0.0 theshemalesurvey.com
0.0.0.0 promo.twistyscash.com
# [Swiftwill][AS30361][64.210.128.0 - 64.210.159.255]
0.0.0.0 adhealers.com
0.0.0.0 ab.advertiserurl.com
0.0.0.0 s.advertiserurl.com
0.0.0.0 promos.camsoda.com
0.0.0.0 syndication.cntrafficpro.com
0.0.0.0 syndication.trafficreps.com
# [Swiftwill][AS30361][64.88.240.0 - 64.88.255.255]
0.0.0.0 ads.brazzers.com
0.0.0.0 ads2.brazzers.com
0.0.0.0 ads2.contentabc.com
0.0.0.0 ads.genericlink.com
0.0.0.0 ads.ghettotube.com
0.0.0.0 ads.iknowthatgirl.com
0.0.0.0 ads.ireel.com
0.0.0.0 ads.mofos.com
0.0.0.0 ads.trafficjunky.net
0.0.0.0 delivery.trafficjunky.net
0.0.0.0 tracking.trafficjunky.net
0.0.0.0 ads.weownthetraffic.com
0.0.0.0 www.ypmadserver.com
# [Tata / Market Engines/Rack Engines][AS6453][63.243.188.0 - 63.243.188.255]
0.0.0.0 cashengines.com
0.0.0.0 click.cashengines.com
0.0.0.0 www.cashengines.com
0.0.0.0 qrcdownload.ibcustomerzone.com #[dware.QUADRegClean]
0.0.0.0 click.interactivebrands.com
0.0.0.0 safepay2.interactivebrands.com
0.0.0.0 www.interactivebrands.com #[SpyEraser]
0.0.0.0 download2.marketengines.com
0.0.0.0 secure.marketengines.com
0.0.0.0 secure3.marketengines.com
# [Tata][AS6453][64.86.0.0 - 64.86.255.255]
0.0.0.0 gwmtracking.com
# [TDC Data][AS3292][194.182.249.0 - 194.182.249.255]
0.0.0.0 sdc.flysas.com
# [TDC Data][AS3292][93.160.60.0 - 93.160.60.255]
0.0.0.0 dk1.siteimprove.com
0.0.0.0 ssl.siteimprove.com
# [Techie Hosting][AS13909][199.80.56.0 - 199.80.63.255]
0.0.0.0 ads.lovercash.com
0.0.0.0 media.lovercash.com
0.0.0.0 ads.singlescash.com
# [Techie Hosting][AS13909][208.90.152.0 - 208.90.155.255]
0.0.0.0 www.cashthat.com
0.0.0.0 paime.com
# [Technorati][AS16936][208.66.64.0 - 208.66.67.255]
0.0.0.0 www.adengage.com
# [TekChannel][AS36700][98.124.128.0 - 98.124.191.255]
0.0.0.0 au.effectivemeasure.net
0.0.0.0 id-cdn.effectivemeasure.net
0.0.0.0 me.effectivemeasure.net
0.0.0.0 my.effectivemeasure.net
0.0.0.0 sea.effectivemeasure.net
0.0.0.0 yahoo.effectivemeasure.net
0.0.0.0 www6.effectivemeasure.net
0.0.0.0 www8-ssl.effectivemeasure.net
0.0.0.0 www9.effectivemeasure.net
0.0.0.0 www.effectivemeasure.net
# [Telecitygroup][AS15830][109.74.200.0 - 109.74.207.255]
0.0.0.0 ads.netcommunities.com
# [Telecitygroup][AS15830][176.58.120.0 - 176.58.127.255]
0.0.0.0 adv2.expres.ua
0.0.0.0 ms.onscroll.com
# [Telecitygroup][AS15830][178.79.152.0 - 178.79.159.255]
0.0.0.0 www.cheekybanners.com
0.0.0.0 ping.onscroll.com
# [Telecitygroup][AS15830][212.71.236.0 - 212.71.239.255]
0.0.0.0 adgebra.co.in
# [Telecitygroup][AS15830][213.52.252.0 - 213.52.255.255]
0.0.0.0 marketing.888.com
# [Telecitygroup][AS15830][62.216.253.128 - 62.216.253.255]
0.0.0.0 platform.communicatorcorp.com
# [Telecitygroup][AS15830][80.252.92.0 - 80.252.92.63]
0.0.0.0 textads.sexmoney.com
# [Telecitygroup][AS15830][82.199.79.0 - 82.199.79.255]
0.0.0.0 www.cybilling.com
0.0.0.0 bannerrotation.sexmoney.com
0.0.0.0 click.sexmoney.com
0.0.0.0 imageads.sexmoney.com
0.0.0.0 pagepeels.sexmoney.com
0.0.0.0 www.sexmoney.com
0.0.0.0 counter.sexsuche.tv
# [Telecitygroup][AS15830][85.90.254.32 - 85.90.254.63]
0.0.0.0 de.hosting.adjug.com
0.0.0.0 com-cdiscount.netmng.com
# [Telemark Info-Media]
0.0.0.0 adx.hendersonvillenews.com
0.0.0.0 adx.ocala.com
0.0.0.0 adx.starbanner.com
0.0.0.0 adx.starnewsonline.com
0.0.0.0 adx.telegram.com
0.0.0.0 adx.timesdaily.com
0.0.0.0 adx.theledger.com
0.0.0.0 nyads.ny.publicus.com
0.0.0.0 bbads.sv.publicus.com
0.0.0.0 beads.sx.atl.publicus.com
0.0.0.0 cmads.sv.publicus.com
0.0.0.0 crimg.sv.publicus.com
0.0.0.0 fdads.sv.publicus.com
0.0.0.0 nsads.sv.publicus.com
0.0.0.0 ptads.sv.publicus.com
0.0.0.0 rhads.sv.publicus.com
0.0.0.0 siads.sv.publicus.com
0.0.0.0 tpads.sv.publicus.com
0.0.0.0 wdads.sx.atl.publicus.com
0.0.0.0 lladinserts.us.publicus.com
# [Telenet][AS6848][212.123.12.128 - 212.123.12.159]
0.0.0.0 ads.adhese.be
0.0.0.0 host2.adhese.be
0.0.0.0 host3.adhese.be #[ad.be.doubleclick.net]
0.0.0.0 host4.adhese.be
0.0.0.0 adhese.standaard.be
# [Telia / Emediate][AS1299][195.12.228.160 - 195.12.228.191]
0.0.0.0 eas1.emediate.eu
0.0.0.0 eas2.emediate.eu
0.0.0.0 eas3.emediate.eu
0.0.0.0 eas4.emediate.eu
# [Telia / Trade Doubler][AS1299][217.212.240.160 - 217.212.240.191]
0.0.0.0 anet.tradedoubler.com
0.0.0.0 anetch.tradedoubler.com
0.0.0.0 anetdk.tradedoubler.com
0.0.0.0 anetfi.tradedoubler.com
0.0.0.0 anetit.tradedoubler.com
0.0.0.0 anetlt.tradedoubler.com
0.0.0.0 anetse.tradedoubler.com
0.0.0.0 clk.tradedoubler.com
0.0.0.0 clkde.tradedoubler.com
0.0.0.0 clkuk.tradedoubler.com
0.0.0.0 hst.tradedoubler.com
0.0.0.0 hstde.tradedoubler.com
0.0.0.0 hstes.tradedoubler.com
0.0.0.0 hstfr.tradedoubler.com
0.0.0.0 hstgb.tradedoubler.com
0.0.0.0 hstit.tradedoubler.com
0.0.0.0 hstno.tradedoubler.com
0.0.0.0 hstpl.tradedoubler.com
0.0.0.0 hstus.tradedoubler.com
0.0.0.0 img.tradedoubler.com
0.0.0.0 imp.tradedoubler.com
0.0.0.0 impat.tradedoubler.com
0.0.0.0 impbe.tradedoubler.com
0.0.0.0 impch.tradedoubler.com
0.0.0.0 impcz.tradedoubler.com
0.0.0.0 impde.tradedoubler.com
0.0.0.0 impdk.tradedoubler.com
0.0.0.0 impes.tradedoubler.com
0.0.0.0 impfi.tradedoubler.com
0.0.0.0 impfr.tradedoubler.com
0.0.0.0 impgb.tradedoubler.com #[WebBug]
0.0.0.0 impie.tradedoubler.com
0.0.0.0 impit.tradedoubler.com
0.0.0.0 implt.tradedoubler.com
0.0.0.0 impnl.tradedoubler.com
0.0.0.0 impno.tradedoubler.com
0.0.0.0 imppl.tradedoubler.com
0.0.0.0 impru.tradedoubler.com
0.0.0.0 impse.tradedoubler.com
0.0.0.0 pf.tradedoubler.com
0.0.0.0 tbl.tradedoubler.com
0.0.0.0 tbs.tradedoubler.com
0.0.0.0 tracker.tradedoubler.com
0.0.0.0 wrap.tradedoubler.com
# [Telia][AS1299][80.239.175.32 - 80.239.175.63]
0.0.0.0 active.cache.el-mundo.net #[Omniture]
0.0.0.0 eas8.emediate.eu
# [Telia / Trade Doubler][AS25473][82.196.187.128 - 82.196.187.255]
0.0.0.0 anetno.tradedoubler.com
0.0.0.0 stardk.tradedoubler.com
0.0.0.0 tarno.tradedoubler.com
# [Theplanet.com][AS21844][173.255.192.0 - 174.123.255.255]
0.0.0.0 24counter.com
0.0.0.0 flurry.com #[Mobile Ads]
0.0.0.0 data.flurry.com
0.0.0.0 dev.flurry.com
0.0.0.0 da.newstogram.com #[WebBug]
0.0.0.0 redirectingat.com #[SkimLinks]
0.0.0.0 aff.ringtonepartner.com
0.0.0.0 the-best-track.com
0.0.0.0 advertising.thediabetesnetwork.com
0.0.0.0 w-tres.info
# [Theplanet.com][174.132.0.0 - 174.133.255.255]
0.0.0.0 adreactor.com
0.0.0.0 adserver.adreactor.com #[Tracking.Cookie]
0.0.0.0 adtactics.com
0.0.0.0 www.adtactics.com
0.0.0.0 adsvert.com
0.0.0.0 xyz.freeweblogger.com
0.0.0.0 www.persianstat.com
# [Theplanet.com][207.44.128.0 - 207.44.255.255]
0.0.0.0 as.gostats.com
0.0.0.0 ded.gostats.com
0.0.0.0 www.searchmachine.com
0.0.0.0 adopt.specificclick.net #[Tracking.Cookie]
0.0.0.0 afe.specificclick.net
0.0.0.0 bp.specificclick.net
0.0.0.0 dg.specificclick.net
# [Theplanet.com / Loseout.com][209.85.40.128 - 209.85.40.191]
0.0.0.0 ads.freeonlinegames.com
0.0.0.0 stats.freeonlinegames.com
# [Theplanet.com][216.12.192.0 - 216.12.223.255]
0.0.0.0 ads.desktopscans.com
0.0.0.0 stats.ircfast.com
# [Theplanet.com][66.98.128.0 - 66.98.255.255]
0.0.0.0 007.free-counter.co.uk
# [ThePlanet.com][67.15.0.0 - 67.15.255.255]
0.0.0.0 ads.asexstories.com
0.0.0.0 mm.chitika.net
0.0.0.0 freeonlineusers.com
0.0.0.0 ads.harpers.org
0.0.0.0 www.historykill.com
0.0.0.0 www.swanksoft.com
0.0.0.0 www.traffic4u.com
0.0.0.0 www.trustsoft.com
# [Theplanet.com / Privacy Protect][209.85.87.0 - 209.85.87.255]
0.0.0.0 cm3.bnmq.com
# [Theplanet.com / Privacy Protect][67.15.35.0 - 67.15.35.255]
0.0.0.0 images.bnmq.com
0.0.0.0 search.in #[Parking Service]
# [Theplanet.com][67.18.0.0 - 67.19.255.255]
0.0.0.0 g.adspeed.net
0.0.0.0 tags.bluekai.com
0.0.0.0 www.dating-banners.com
0.0.0.0 ad4.gueb.com
0.0.0.0 ad7.gueb.com
0.0.0.0 ext.host-tracker.com
0.0.0.0 ads.loveshack.org
0.0.0.0 www.megastats.com
0.0.0.0 meiluziai.info
0.0.0.0 search2007.info #[Spamdexing]
0.0.0.0 banner.techarp.com
0.0.0.0 webads.tradeholding.com
# [Theplanet.com][69.56.128.0 - 69.56.255.255]
0.0.0.0 counter.relmaxtop.com
0.0.0.0 www.relmaxtop.com
# [Theplanet.com][69.93.0.0 - 69.93.255.255]
0.0.0.0 advertising.entensity.net
# [Theplanet.com][70.84.0.0 - 70.87.255.255]
0.0.0.0 www.adscampaign.com
0.0.0.0 www.adultdatelink.com
0.0.0.0 www.atomictime.net
0.0.0.0 network.clickconversion.net
0.0.0.0 freelogs.com
0.0.0.0 bar.freelogs.com
0.0.0.0 goo.freelogs.com
0.0.0.0 htm.freelogs.com
0.0.0.0 ico.freelogs.com
0.0.0.0 joe.freelogs.com
0.0.0.0 mom.freelogs.com
0.0.0.0 xyz.freelogs.com
0.0.0.0 service.persianstat.com
0.0.0.0 ads.soft32.com
0.0.0.0 www.websitealive3.com
0.0.0.0 counter.yakcash.com
# [Theplanet.com][AS21844][74.52.0.0 - 74.55.255.255]
0.0.0.0 www.adgroups.net
0.0.0.0 www.adszooks.com
0.0.0.0 www.adultlinkexchange.com
0.0.0.0 www.commissionempire.com
0.0.0.0 server.cpmstar.com #[ads.shizmoo.com]
0.0.0.0 easyhitcounters.com
0.0.0.0 beta.easyhitcounters.com
0.0.0.0 fishclix.com
0.0.0.0 www.fishclix.com
0.0.0.0 www.funklicks.com
0.0.0.0 advertising.goldseek.com
0.0.0.0 ads.gravytrainproductions.com
0.0.0.0 tracking.hostgator.com
0.0.0.0 ads.infomediainc.com
0.0.0.0 kazaa.com
0.0.0.0 www.kazaa.com
0.0.0.0 www.knacads.com
0.0.0.0 ads.mindviz.com
0.0.0.0 traffic.mindviz.com
0.0.0.0 sayac.onlinewebstat.com
0.0.0.0 ads.retirementjobs.com
0.0.0.0 silveragesoftware.com
0.0.0.0 www.silveragesoftware.com
0.0.0.0 www.xclicks.net
0.0.0.0 counter.yakbucks.com
# [Theplanet.com][75.125.0.0 - 75.125.255.255]
0.0.0.0 www.3bsoftware.com #[Spyware Protection Pro]
0.0.0.0 bunny-net.com
0.0.0.0 www.cbproads.com
0.0.0.0 www.handyarchive.com
0.0.0.0 pulsix.com #[maxalbums.com]
0.0.0.0 www.pulsix.com
0.0.0.0 restore-pc.com
0.0.0.0 www.restore-pc.com
0.0.0.0 www.searchmagna.com #[Spamdexing.Parking service]
# [Thoughtconvergence.com][AS31898][209.59.195.0 - 209.59.195.255]
0.0.0.0 landing.trafficz.com
0.0.0.0 landings.trafficz.com
# [Ticketmaster][AS46318][209.104.32.0 - 209.104.63.255]
0.0.0.0 ads.livenation.com
0.0.0.0 ads.as4x.tmcs.ticketmaster.com
0.0.0.0 ads.as4x.tmcs.net
# [Tiggee][AS16552][208.94.144.0 - 208.94.151.255]
0.0.0.0 ak.sail-horizon.com
# [Tinet SpA / Akamai][AS3257][2.18.176.0 - 2.18.191.255]
0.0.0.0 fast.mtvn.demdex.net
# [Tinet SpA][AS3257][23.192.0.0 - 23.223.255.255]
0.0.0.0 ads.scorecardresearch.com
# [Tinet SpA][AS8612][213.200.36.0 - 213.205.39.255]
0.0.0.0 ma211-r.analytics.edgesuite.net
0.0.0.0 sitestats.tiscali.co.uk #[WebBug]
# [Tinet SpA][AS3257][46.33.64.0 - 46.33.77.255]
0.0.0.0 au-cdn.effectivemeasure.net
# [Tinet SpA][AS3257][77.67.102.0 - 77.67.102.255]
0.0.0.0 ma76-r.analytics.edgesuite.net
0.0.0.0 c.effectivemeasure.net
0.0.0.0 nz-cdn.effectivemeasure.net
0.0.0.0 ph-cdn.effectivemeasure.net
0.0.0.0 sg-cdn.effectivemeasure.net
0.0.0.0 fast.fairfax.demdex.net
0.0.0.0 tiads.timeinc.net
# [Todayhost / Bogal Ab][195.42.102.0 - 195.42.103.255]
0.0.0.0 petsmovies.com
0.0.0.0 zoomovies.org
0.0.0.0 www.zoomovies.org
# [Tranquil][AS13647][208.79.80.0 - 208.79.83.255]
0.0.0.0 piwik.datawrapper.de #[Piwik.Analytics]
# [Tribal Fusion][Dilip DaSilva][AS33419][204.11.108.0 - 204.11.111.255]
0.0.0.0 tags.expo9.exponential.com
0.0.0.0 tribalfusion.com #[Tracking.Cookie]
0.0.0.0 a.tribalfusion.com
0.0.0.0 cdn1.tribalfusion.com
0.0.0.0 cdn5.tribalfusion.com
0.0.0.0 cdnx.tribalfusion.com
0.0.0.0 ctxt.tribalfusion.com
0.0.0.0 m.tribalfusion.com
0.0.0.0 s.tribalfusion.com
0.0.0.0 www.tribalfusion.com
# [Trip.net][AS17393][64.8.96.0 - 64.8.127.255]
0.0.0.0 a.websponsors.com
0.0.0.0 g.websponsors.com
# [Trueserver][AS15703][87.233.13.0 - 87.233.13.255]
0.0.0.0 cz4.clickzzs.nl
0.0.0.0 cz5.clickzzs.nl
0.0.0.0 cz7.clickzzs.nl
0.0.0.0 cz8.clickzzs.nl
0.0.0.0 cz11.clickzzs.nl
0.0.0.0 jsp.clickzzs.nl
0.0.0.0 jsp2.clickzzs.nl
0.0.0.0 js7.clickzzs.nl
0.0.0.0 js11.clickzzs.nl
0.0.0.0 vip.clickzzs.nl
0.0.0.0 vip2.clickzzs.nl
# [Trueserver][87.233.141.0 - 87.233.228.255]
0.0.0.0 a3.adzs.nl
0.0.0.0 a4.adzs.nl
0.0.0.0 img.adzs.nl
0.0.0.0 www.cash4members.com
0.0.0.0 privatamateure.com #[Sagnet Group]
0.0.0.0 webmaster.privatamateure.com
0.0.0.0 www.privatamateure.com
# [TutHost / Samotlortelecom][AS44820][91.203.4.0 - 91.203.7.255]
# [Tw Telecom][AS4323][174.46.0.0 - 174.47.255.255]
0.0.0.0 servedby.ipromote.com
# [Tw Telecom][AS4323][206.80.0.0 - 206.80.31.255]
0.0.0.0 pureleads.com
# [Tw Telecom][AS4323][216.120.224.0 - 216.120.255.255]
0.0.0.0 boloz.com
# [Tw Telecom][AS4323][66.192.0.0 - 66.195.255.255]
0.0.0.0 testats.inuvo.com
0.0.0.0 tracking.inuvo.com
0.0.0.0 myap.liveperson.com
0.0.0.0 img1.ncsreporting.com
0.0.0.0 www.ncsreporting.com
0.0.0.0 ads.proz.com
# [UK2.net][AS13213][83.170.64.0 - 83.170.127.255]
0.0.0.0 err.000webhost.com
0.0.0.0 error404.000webhost.com
0.0.0.0 ad.realist.gen.tr
# [Uaonline / Real International][AS46636][88.214.192.0 - 88.214.255.255]
0.0.0.0 femeedia.com
0.0.0.0 gbscript.com
0.0.0.0 403.hqhost.net
0.0.0.0 404.hqhost.net
0.0.0.0 petrenko.biz
0.0.0.0 www.petrenko.biz
0.0.0.0 zr0.net
# [Ukrtelnet][AS6849][212.113.49.0 - 212.113.49.255]
0.0.0.0 adnet.pravda.com.ua
# [Ukrtelnet / Datacenter Networks][AS6849][213.186.114.0 - 213.186.114.255]
0.0.0.0 a.abnad.net
0.0.0.0 b.abnad.net
0.0.0.0 c.abnad.net #[Tracking.Cookie]
0.0.0.0 d.abnad.net
0.0.0.0 e.abnad.net
0.0.0.0 t.abnad.net
0.0.0.0 z.abnad.net
0.0.0.0 advert.ru.redtram.com
0.0.0.0 img2.ru.redtram.com
0.0.0.0 js.redtram.com #[RedTramCookies]
0.0.0.0 js.ru.redtram.com
0.0.0.0 n4p.ru.redtram.com
# [Unitedlayer][AS23342][207.7.128.0 - 207.7.159.255]
0.0.0.0 relestar.com
0.0.0.0 clk.relestar.com
0.0.0.0 ban.xpays.com
0.0.0.0 exit.xpays.com
0.0.0.0 www.xpays.com
# [United Online / Juno][AS13446][64.136.0.0 - 64.136.63.255]
0.0.0.0 banner.50megs.com
0.0.0.0 aboutwebservices.com
0.0.0.0 ad.aboutwebservices.com
0.0.0.0 downloadz.us #[Spamdexing]
0.0.0.0 free-stats.com
0.0.0.0 freestats.com
0.0.0.0 banner.freeservers.com
0.0.0.0 eegad.freeservers.com #[Tracking.Cookie]
0.0.0.0 abbyssh.freestats.com
0.0.0.0 insurancejournal.freestats.com
0.0.0.0 barafranca.iwarp.com #[Win32/Spy.ProAgent]
0.0.0.0 sitetracker.com
0.0.0.0 www.sitetracker.com
0.0.0.0 cyclops.prod.untd.com #[RealMedia]
0.0.0.0 nztv.prod.untd.com
0.0.0.0 track.untd.com
# [Upl-net-customers][AS43355][78.108.180.0 - 78.108.184.255]
0.0.0.0 adv.drtuber.com
0.0.0.0 links-and-traffic.com
0.0.0.0 www.links-and-traffic.com
0.0.0.0 vdhu.com #[Spamdexing.Codec]
# [Upl-net-customers][AS43355][94.198.240.0 - 94.198.243.255]
0.0.0.0 bn.premiumhdv.com
# [Uptilt][AS36699][208.66.204.0 - 208.66.207.255]
0.0.0.0 clicktracks.com
0.0.0.0 stats.clicktracks.com #[Tracking.Cookie]
0.0.0.0 stats1.clicktracks.com
0.0.0.0 stats2.clicktracks.com
0.0.0.0 stats3.clicktracks.com
0.0.0.0 stats4.clicktracks.com
0.0.0.0 www.clicktracks.com
# [US Signal][AS26554][64.186.32.0 - 64.186.63.255]
0.0.0.0 webalize.net
0.0.0.0 www.webalize.net
# [UUnet / Iperceptions][AS701][207.176.215.192 - 207.176.215.255]
0.0.0.0 group11.iperceptions.com
# [UUnet / Worldata][AS701][63.77.84.0 - 63.77.84.255]
0.0.0.0 webconnect.net
0.0.0.0 secure.webconnect.net
0.0.0.0 www.webconnect.net
0.0.0.0 www.worldata.com
# [UUnet / Microsoft.Avenue A][AS7046][65.203.229.0 - 65.203.229.255]
0.0.0.0 ads.adagent.chacha.com
0.0.0.0 adecn-w.atdmt.com
0.0.0.0 srch.atdmt.com
0.0.0.0 atlasdmt.com #[Tracking.Cookie]
0.0.0.0 www.atlasdmt.com
0.0.0.0 www.avenuea.com
0.0.0.0 ads.bidclix.com
0.0.0.0 www.bidclix.com
# [UUnet / Yesup][AS701][66.48.81.128 - 66.48.81.255]
0.0.0.0 serving.xxxwebtraffic.com
# [ValueClick / Commission Junction[216.34.209.0 - 216.34.209.31]
0.0.0.0 www.afcyhf.com #[WebBug]
0.0.0.0 www.anrdoezrs.net
0.0.0.0 mp.apmebf.com
0.0.0.0 www.apmebf.com #[Tracking.Cookie]
0.0.0.0 www.awltovhc.com #[WebBug]
0.0.0.0 www.commission-junction.com #[Tracking.Cookie]
0.0.0.0 www.dpbolvw.net
0.0.0.0 www.emjcd.com
0.0.0.0 www.ftjcfx.com #[WebBug]
0.0.0.0 www.jdoqocy.com
0.0.0.0 www.kqzyfj.com
0.0.0.0 www.lduhtrp.net #[WebBug]
0.0.0.0 qksrv.com
0.0.0.0 www.qksrv.net #[Tracking.Cookie]
0.0.0.0 www.qksz.net
0.0.0.0 www.tkqlhce.com
0.0.0.0 www.tqlkg.com #[WebBug]
# [Valueclick][AS25751][64.152.0.0 - 64.159.255.255]
0.0.0.0 csp.fastclick.net
0.0.0.0 cdn.mplxtms.com
0.0.0.0 n.mplxtms.com
0.0.0.0 t.mplxtms.com
0.0.0.0 krs.ymxpb.com
# [Valueclick / Conversant][AS25751][8.18.45.0 - 8.18.45.255]
0.0.0.0 cj.dotomi.com
0.0.0.0 adfarm.mediaplex.com
# [Vanoppen.biz / Accretive Technology][AS11404][216.243.0.0 - 216.243.63.255]
0.0.0.0 imgserv.adbutler.com #[Tracking.Cookie]
0.0.0.0 servedbyadbutler.com
0.0.0.0 adrotator.com
0.0.0.0 www.adrotator.com
0.0.0.0 counter.sparklit.com
0.0.0.0 vote.sparklit.com
0.0.0.0 webpoll.sparklit.com
# [Velcom / Rcp.net][AS30407][206.53.48.0 - 206.53.63.255]
0.0.0.0 abtracker.adultbouncer.com
# [Velocity Networks][AS8018][66.102.128.0 - 66.102.143.255]
0.0.0.0 ads.xbiz.com
0.0.0.0 exchange.xbiz.com
# [VeriCenter / Coremetrics][209.235.28.0 - 209.235.28.255]
0.0.0.0 data.cmcore.com
0.0.0.0 analytics.harpercollins.com
0.0.0.0 d1.playboy.com
# [VeriCenter / Coremetrics][66.179.0.0 - 66.179.255.255]
0.0.0.0 www2.kiehls.com
# [VeriCenter / Coremetrics][69.48.237.0 - 69.48.237.255]
0.0.0.0 log.aebn.net #[WebBug.eluminate]
# [VeriCenter][AS33502][216.205.80.0 - 216.205.95.255]
0.0.0.0 www3.bloomingdales.com
0.0.0.0 core.bluefly.com
0.0.0.0 www9.collectiblestoday.com #[WebBug.eluminate]
0.0.0.0 cmd.customink.com
0.0.0.0 rpt.footlocker.com
0.0.0.0 ww62.hsn.com
0.0.0.0 1901.nordstrom.com
0.0.0.0 www25.victoriassecret.com #[WebBug.eluminate]
# [Verizon][AS702][193.67.160.0 - 193.67.167.255]
0.0.0.0 webtrends1.britishgas.co.uk
# [Verizon][AS702][212.153.70.0 - 212.155.198.31]
0.0.0.0 secure-eu.imrworldwide.com
# [ViaWest][AS13649][204.238.82.0 - 204.238.82.255]
# 0.0.0.0 www.securitymetrics.com #[affects bank login]
# [ViaWest][AS13649][206.71.64.0 - 206.71.95.255]
0.0.0.0 mv.treehousei.com
# [ViaWest][AS13649][216.24.128.0 - 216.24.159.255]
0.0.0.0 ap.lijit.com
0.0.0.0 beacon.lijit.com
0.0.0.0 www.lijit.com
# [ViaWest][AS13649][216.38.192.0 - 216.38.223.255]
0.0.0.0 www.hugedomains.com #[Parking Service]
# [ViaWest][AS14825][67.208.128.0 - 67.208.143.255]
0.0.0.0 www.dicarlotrack.com
0.0.0.0 tracking.gajmp.com
0.0.0.0 www.leadtrackgo.com
0.0.0.0 www.rsptrack.com
0.0.0.0 www.sq2trk2.com
0.0.0.0 www.xy7track.com
0.0.0.0 affiliates.yourapprovaltracker.com
# [ViaWest][AS13649][74.63.128.0 - 74.63.191.255]
0.0.0.0 ssl.clickbank.net
0.0.0.0 www.liqwid.net
0.0.0.0 www.shopathome.com
# [Vibrant Media][AS17131]
0.0.0.0 intellitxt.com
0.0.0.0 images.intellitxt.com
0.0.0.0 www.intellitxt.com
0.0.0.0 mamamia.au.intellitxt.com
0.0.0.0 zdnet.be.intellitxt.com
0.0.0.0 ad-hoc-news.de.intellitxt.com
0.0.0.0 atspace.de.intellitxt.com
0.0.0.0 audio.de.intellitxt.com
0.0.0.0 awardspace.de.intellitxt.com
0.0.0.0 bild.de.intellitxt.com
0.0.0.0 chip.de.intellitxt.com
0.0.0.0 castingshow-news.de.intellitxt.com
0.0.0.0 computerbase.de.intellitxt.com
0.0.0.0 computerbild.de.intellitxt.com
0.0.0.0 computerhilfen.de.intellitxt.com
0.0.0.0 computerwoche.de.intellitxt.com
0.0.0.0 digital-world.de.intellitxt.com
0.0.0.0 ghacks.de.intellitxt.com
0.0.0.0 golem.de.intellitxt.com
0.0.0.0 gulli.de.intellitxt.com
0.0.0.0 inquake.de.intellitxt.com
0.0.0.0 loady.de.intellitxt.com
0.0.0.0 macwelt.de.intellitxt.com
0.0.0.0 msmobiles.de.intellitxt.com
0.0.0.0 news.de.intellitxt.com
0.0.0.0 pcwelt.de.intellitxt.com
0.0.0.0 php-mag.de.intellitxt.com
0.0.0.0 php-magnet.de.intellitxt.com
0.0.0.0 softonic.de.intellitxt.com
0.0.0.0 supernature-forum.de.intellitxt.com
0.0.0.0 supportnet.de.intellitxt.com
0.0.0.0 tecchannel.de.intellitxt.com
0.0.0.0 winfuture.de.intellitxt.com
0.0.0.0 wg-gesucht.de.intellitxt.com
0.0.0.0 womenshealth.de.intellitxt.com
0.0.0.0 actualite-de-stars.fr.intellitxt.com
0.0.0.0 telefonica.es.intellitxt.com
0.0.0.0 cowcotland.fr.intellitxt.com
0.0.0.0 froggytest.fr.intellitxt.com
0.0.0.0 generation-nt.fr.intellitxt.com
0.0.0.0 hiphopgalaxy.fr.intellitxt.com
0.0.0.0 infos-du-net.fr.intellitxt.com
0.0.0.0 memoclic.fr.intellitxt.com
0.0.0.0 neteco.fr.intellitxt.com
0.0.0.0 pcinpact.fr.intellitxt.com
0.0.0.0 pc-infopratique.fr.intellitxt.com
0.0.0.0 presence-pc.fr.intellitxt.com
0.0.0.0 programme-tv.fr.intellitxt.com
0.0.0.0 reseaux-telecoms.fr.intellitxt.com
0.0.0.0 tomshardware.fr.intellitxt.com
0.0.0.0 zataz.fr.intellitxt.com
0.0.0.0 techgadgets.in.intellitxt.com
0.0.0.0 telefonino.it.intellitxt.com
0.0.0.0 computeridee.nl.intellitxt.com
0.0.0.0 computertotaal.nl.intellitxt.com
0.0.0.0 techworld.nl.intellitxt.com
0.0.0.0 techzine.nl.intellitxt.com
0.0.0.0 topdownloads.nl.intellitxt.com
0.0.0.0 webwereld.nl.intellitxt.com
0.0.0.0 compulenta.ru.intellitxt.com
0.0.0.0 rbmods.se.intellitxt.com
0.0.0.0 tomshardware.se.intellitxt.com
0.0.0.0 4thegame.uk.intellitxt.com
0.0.0.0 amygrindhouse.uk.intellitxt.com
0.0.0.0 anorak.uk.intellitxt.com
0.0.0.0 bink.uk.intellitxt.com
0.0.0.0 bit-tech.uk.intellitxt.com
0.0.0.0 biosmagazine.uk.intellitxt.com
0.0.0.0 cbronline.uk.intellitxt.com
0.0.0.0 computeractive.uk.intellitxt.com
0.0.0.0 computing.uk.intellitxt.com
0.0.0.0 contactmusic.uk.intellitxt.com
0.0.0.0 digit-life.uk.intellitxt.com
0.0.0.0 efluxmedia.uk.intellitxt.com
0.0.0.0 express.uk.intellitxt.com
0.0.0.0 femalefirst.uk.intellitxt.com
0.0.0.0 ferrago.uk.intellitxt.com
0.0.0.0 fhm.uk.intellitxt.com
0.0.0.0 footymad.uk.intellitxt.com
0.0.0.0 freedownloadcenter.uk.intellitxt.com
0.0.0.0 freedownloadmanager.uk.intellitxt.com
0.0.0.0 freewarepalm.uk.intellitxt.com
0.0.0.0 futurepublications.uk.intellitxt.com
0.0.0.0 gamesindustry.uk.intellitxt.com
0.0.0.0 handbag.uk.intellitxt.com
0.0.0.0 hellomagazine.uk.intellitxt.com
0.0.0.0 hexus.uk.intellitxt.com
0.0.0.0 itpro.uk.intellitxt.com
0.0.0.0 itreviews.uk.intellitxt.com
0.0.0.0 knowyourmobile.uk.intellitxt.com
0.0.0.0 legitreviews-uk.intellitxt.com
0.0.0.0 letsgodigital.uk.intellitxt.com
0.0.0.0 lse.uk.intellitxt.com
0.0.0.0 mad.uk.intellitxt.com
0.0.0.0 mobilecomputermag.uk.intellitxt.com
0.0.0.0 monstersandcritics.uk.intellitxt.com
0.0.0.0 newlaunches.uk.intellitxt.com
0.0.0.0 nodevice.uk.intellitxt.com
0.0.0.0 ok.uk.intellitxt.com
0.0.0.0 pcadvisor-uk.intellitxt.com
0.0.0.0 pcgamer.uk.intellitxt.com
0.0.0.0 pcpro.uk.intellitxt.com
0.0.0.0 pcw.uk.intellitxt.com
0.0.0.0 physorg.uk.intellitxt.com
0.0.0.0 playfuls.uk.intellitxt.com
0.0.0.0 pocketlint.uk.intellitxt.com
0.0.0.0 product-reviews.uk.intellitxt.com
0.0.0.0 sharecast.uk.intellitxt.com
0.0.0.0 sofeminine.uk.intellitxt.com
0.0.0.0 softpedia.uk.intellitxt.com
0.0.0.0 squarefootball.uk.intellitxt.com
0.0.0.0 tcmagazine.uk.intellitxt.com
0.0.0.0 teamtalk.uk.intellitxt.com
0.0.0.0 techradar.uk.intellitxt.com
0.0.0.0 thehollywoodnews.uk.intellitxt.com
0.0.0.0 theinquirer.uk.intellitxt.com
0.0.0.0 theregister.uk.intellitxt.com
0.0.0.0 thetechherald.uk.intellitxt.com
0.0.0.0 videojug.uk.intellitxt.com
0.0.0.0 vitalfootball.uk.intellitxt.com
0.0.0.0 vnunet.uk.intellitxt.com
0.0.0.0 webuser.uk.intellitxt.com
0.0.0.0 westbriton.uk.intellitxt.com
0.0.0.0 wi-fitechnology.uk.intellitxt.com
0.0.0.0 windows7news.uk.intellitxt.com
0.0.0.0 worldtravelguide.uk.intellitxt.com
0.0.0.0 1up.us.intellitxt.com
0.0.0.0 247wallstreet.us.intellitxt.com
0.0.0.0 2snaps.us.intellitxt.com
0.0.0.0 2spyware.us.intellitxt.com
0.0.0.0 24wrestling.us.intellitxt.com
0.0.0.0 411mania.us.intellitxt.com
0.0.0.0 4w-wrestling.us.intellitxt.com
0.0.0.0 5starsupport.us.intellitxt.com
0.0.0.0 9down.us.intellitxt.com
0.0.0.0 10best.us.intellitxt.com
0.0.0.0 able2know.us.intellitxt.com
0.0.0.0 accuweather.us.intellitxt.com
0.0.0.0 aceshowbiz.us.intellitxt.com
0.0.0.0 aclasscelebs.us.intellitxt.com
0.0.0.0 activewin.us.intellitxt.com
0.0.0.0 actionscript.us.intellitxt.com
0.0.0.0 advancedmn.us.intellitxt.com
0.0.0.0 adwarereport.us.intellitxt.com
0.0.0.0 afterdawn.us.intellitxt.com
0.0.0.0 afraidtoask.us.intellitxt.com
0.0.0.0 ajc.us.intellitxt.com
0.0.0.0 akihabaranews.us.intellitxt.com
0.0.0.0 alive.us.intellitxt.com
0.0.0.0 allcarselectric.us.intellitxt.com
0.0.0.0 allgetaways.us.intellitxt.com
0.0.0.0 allhiphop.us.intellitxt.com
0.0.0.0 allrefer.us.intellitxt.com
0.0.0.0 allwomenstalk.us.intellitxt.com
0.0.0.0 amdzone.us.intellitxt.com
0.0.0.0 americanmedia.us.intellitxt.com
0.0.0.0 andpop.us.intellitxt.com
0.0.0.0 androidandme.us.intellitxt.com
0.0.0.0 androidcentral.us.intellitxt.com
0.0.0.0 androidcommunity.us.intellitxt.com
0.0.0.0 answerbag.us.intellitxt.com
0.0.0.0 answers.us.intellitxt.com
0.0.0.0 antimusic.us.intellitxt.com
0.0.0.0 anythinghollywood.us.intellitxt.com
0.0.0.0 appscout.us.intellitxt.com
0.0.0.0 artistdirect.us.intellitxt.com
0.0.0.0 askmen.us.intellitxt.com
0.0.0.0 askmen2.us.intellitxt.com
0.0.0.0 aquasoft.us.intellitxt.com
0.0.0.0 architecturaldesigns.us.intellitxt.com
0.0.0.0 autoforums.us.intellitxt.com
0.0.0.0 automobilemag.us.intellitxt.com
0.0.0.0 automotive.us.intellitxt.com
0.0.0.0 autospies.us.intellitxt.com
0.0.0.0 autoworldnews.us.intellitxt.com
0.0.0.0 away.us.intellitxt.com
0.0.0.0 aximsite.us.intellitxt.com
0.0.0.0 b5media.us.intellitxt.com
0.0.0.0 backseatcuddler.us.intellitxt.com
0.0.0.0 balleralert.us.intellitxt.com
0.0.0.0 baselinemag.us.intellitxt.com
0.0.0.0 bastardly.us.intellitxt.com
0.0.0.0 beautyden.us.intellitxt.com
0.0.0.0 becomegorgeous.us.intellitxt.com
0.0.0.0 beliefnet.us.intellitxt.com
0.0.0.0 betanews.us.intellitxt.com
0.0.0.0 beyondhollywood.us.intellitxt.com
0.0.0.0 bigbigforums.us.intellitxt.com
0.0.0.0 bittenandbound.us.intellitxt.com
0.0.0.0 blacksportsonline.us.intellitxt.com
0.0.0.0 blastro.us.intellitxt.com
0.0.0.0 bleepingcomputer.us.intellitxt.com
0.0.0.0 blisstree.us.intellitxt.com
0.0.0.0 boldride.us.intellitxt.com
0.0.0.0 bootdaily.us.intellitxt.com
0.0.0.0 boxingscene.us.intellitxt.com
0.0.0.0 bradpittnow.us.intellitxt.com
0.0.0.0 bricksandstonesgossip.us.intellitxt.com
0.0.0.0 brighthub.us.intellitxt.com
0.0.0.0 brothersoft.us.intellitxt.com
0.0.0.0 bukisa.us.intellitxt.com
0.0.0.0 bullz-eye.us.intellitxt.com
0.0.0.0 bumpshack.us.intellitxt.com
0.0.0.0 businessinsider.us.intellitxt.com
0.0.0.0 businessknowhow.us.intellitxt.com
0.0.0.0 bustedcoverage.us.intellitxt.com
0.0.0.0 buzzfoto.us.intellitxt.com
0.0.0.0 buzzhumor.us.intellitxt.com
0.0.0.0 bolt.us.intellitxt.com
0.0.0.0 cadillacforums.us.intellitxt.com
0.0.0.0 cafemom.us.intellitxt.com
0.0.0.0 canmag.us.intellitxt.com
0.0.0.0 car-stuff.us.intellitxt.com
0.0.0.0 cavemancircus.us.intellitxt.com
0.0.0.0 cbstv.us.intellitxt.com
0.0.0.0 newyork.cbslocal.us.intellitxt.com
0.0.0.0 cdreviews.us.intellitxt.com
0.0.0.0 cdrinfo.us.intellitxt.com
0.0.0.0 cdrom-guide.us.intellitxt.com
0.0.0.0 celebitchy.us.intellitxt.com
0.0.0.0 celebridoodle.us.intellitxt.com
0.0.0.0 celebrity-babies.us.intellitxt.com
0.0.0.0 celebritytoob.us.intellitxt.com
0.0.0.0 celebridiot.us.intellitxt.com
0.0.0.0 celebrifi.us.intellitxt.com
0.0.0.0 celebritymound.us.intellitxt.com
0.0.0.0 celebritynation.us.intellitxt.com
0.0.0.0 celebrityodor.us.intellitxt.com
0.0.0.0 celebrity-rightpundits.us.intellitxt.com
0.0.0.0 celebritysmackblog.us.intellitxt.com
0.0.0.0 celebrityviplounge.us.intellitxt.com
0.0.0.0 celebslam.us.intellitxt.com
0.0.0.0 celebrity-gossip.us.intellitxt.com
0.0.0.0 celebritypwn.us.intellitxt.com
0.0.0.0 celebritywonder.us.intellitxt.com
0.0.0.0 celebuzz.us.intellitxt.com
0.0.0.0 channelinsider.us.intellitxt.com
0.0.0.0 cheatcc.us.intellitxt.com
0.0.0.0 cheatingdome.us.intellitxt.com
0.0.0.0 chevelles.us.intellitxt.com
0.0.0.0 cmp.us.intellitxt.com
0.0.0.0 cnet.us.intellitxt.com
0.0.0.0 coedmagazine.us.intellitxt.com
0.0.0.0 collegefootballnews.us.intellitxt.com
0.0.0.0 comicbookmovie.us.intellitxt.com
0.0.0.0 comicbookresources.us.intellitxt.com
0.0.0.0 comingsoon.us.intellitxt.com
0.0.0.0 complex.us.intellitxt.com
0.0.0.0 compnet.us.intellitxt.com
0.0.0.0 consumerreview.us.intellitxt.com
0.0.0.0 contactmusic.us.intellitxt.com
0.0.0.0 cooksrecipes.us.intellitxt.com
0.0.0.0 cooltechzone.us.intellitxt.com
0.0.0.0 counselheal.us.intellitxt.com
0.0.0.0 countryweekly.us.intellitxt.com
0.0.0.0 courierpostonline.us.intellitxt.com
0.0.0.0 coxtv.us.intellitxt.com
0.0.0.0 crmbuyer.us.intellitxt.com
0.0.0.0 csharpcorner.us.intellitxt.com
0.0.0.0 csnation.us.intellitxt.com
0.0.0.0 ctv.us.intellitxt.com
0.0.0.0 dabcc.us.intellitxt.com
0.0.0.0 dailycaller.us.intellitxt.com
0.0.0.0 dailygab.us.intellitxt.com
0.0.0.0 dailystab.us.intellitxt.com
0.0.0.0 dailytech.us.intellitxt.com
0.0.0.0 damnimcute.us.intellitxt.com
0.0.0.0 danasdirt.us.intellitxt.com
0.0.0.0 daniweb.us.intellitxt.com
0.0.0.0 darkhorizons.us.intellitxt.com
0.0.0.0 darlamack.us.intellitxt.com
0.0.0.0 dbtechno.us.intellitxt.com
0.0.0.0 delawareonline.us.intellitxt.com
0.0.0.0 delconewsnetwork.us.intellitxt.com
0.0.0.0 destructoid.us.intellitxt.com
0.0.0.0 demonews.us.intellitxt.com
0.0.0.0 denguru.us.intellitxt.com
0.0.0.0 derekhail.us.intellitxt.com
0.0.0.0 dietsinreview.us.intellitxt.com
0.0.0.0 digitalhome.us.intellitxt.com
0.0.0.0 digitalmediaonline.us.intellitxt.com
0.0.0.0 digitalmediawire.us.intellitxt.com
0.0.0.0 digitaltrends.us.intellitxt.com
0.0.0.0 diyfood.us.intellitxt.com
0.0.0.0 dlmag.us.intellitxt.com
0.0.0.0 dnps.us.intellitxt.com
0.0.0.0 doubleviking.us.intellitxt.com
0.0.0.0 download32.us.intellitxt.com
0.0.0.0 drdobbs.us.intellitxt.com
0.0.0.0 driverguide.us.intellitxt.com
0.0.0.0 drugscom.us.intellitxt.com
0.0.0.0 eastsideboxing.us.intellitxt.com
0.0.0.0 eatingwell.us.intellitxt.com
0.0.0.0 ebaumsworld.us.intellitxt.com
0.0.0.0 ecanadanow.us.intellitxt.com
0.0.0.0 ecommercetimes.us.intellitxt.com
0.0.0.0 eepn.us.intellitxt.com
0.0.0.0 efanguide.us.intellitxt.com
0.0.0.0 egotastic.us.intellitxt.com
0.0.0.0 eharmony.us.intellitxt.com
0.0.0.0 ehomeupgrade.us.intellitxt.com
0.0.0.0 ehow.us.intellitxt.com
0.0.0.0 electronista.us.intellitxt.com
0.0.0.0 emaxhealth.us.intellitxt.com
0.0.0.0 encyclocentral.us.intellitxt.com
0.0.0.0 entrepreneur.us.intellitxt.com
0.0.0.0 entertainmentwise.us.intellitxt.com
0.0.0.0 eontarionow.us.intellitxt.com
0.0.0.0 estelle.us.intellitxt.com
0.0.0.0 eten-users.us.intellitxt.com
0.0.0.0 everyjoe.us.intellitxt.com
0.0.0.0 evilbeetgossip.us.intellitxt.com
0.0.0.0 eweek.us.intellitxt.com
0.0.0.0 examnotes.us.intellitxt.com
0.0.0.0 excite.us.intellitxt.com
0.0.0.0 experts.us.intellitxt.com
0.0.0.0 extntechnologies.us.intellitxt.com
0.0.0.0 extremeoverclocking.us.intellitxt.com
0.0.0.0 extremetech.us.intellitxt.com
0.0.0.0 eztracks.us.intellitxt.com
0.0.0.0 fangoria.us.intellitxt.com
0.0.0.0 faqts.us.intellitxt.com
0.0.0.0 fatbackandcollards.us.intellitxt.com
0.0.0.0 fatbackmedia.us.intellitxt.com
0.0.0.0 fatfreekitchen.us.intellitxt.com
0.0.0.0 feedsweep.us.intellitxt.com
0.0.0.0 fhmonline.us.intellitxt.com
0.0.0.0 fightline.us.intellitxt.com
0.0.0.0 filmdrunk.us.intellitxt.com
0.0.0.0 filedudes.us.intellitxt.com
0.0.0.0 filmstew.us.intellitxt.com
0.0.0.0 filmthreat.us.intellitxt.com
0.0.0.0 firingsquad.us.intellitxt.com
0.0.0.0 fixya.us.intellitxt.com
0.0.0.0 flashmagazine.us.intellitxt.com
0.0.0.0 flyingmag.us.intellitxt.com
0.0.0.0 forbes.us.intellitxt.com
0.0.0.0 fortunecity.us.intellitxt.com
0.0.0.0 forumediainc.us.intellitxt.com
0.0.0.0 foxnews.us.intellitxt.com
0.0.0.0 foxsports.us.intellitxt.com
0.0.0.0 foxtv.us.intellitxt.com
0.0.0.0 freecodecs.us.intellitxt.com
0.0.0.0 freewarehome.us.intellitxt.com
0.0.0.0 friendtest.us.intellitxt.com
0.0.0.0 gamedev.us.intellitxt.com
0.0.0.0 gamerstemple.us.intellitxt.com
0.0.0.0 gannettbroadcast.us.intellitxt.com
0.0.0.0 gannettwisconsin.us.intellitxt.com
0.0.0.0 gardenweb.us.intellitxt.com
0.0.0.0 gather.us.intellitxt.com
0.0.0.0 geek.us.intellitxt.com
0.0.0.0 geekstogo.us.intellitxt.com
0.0.0.0 genmay.us.intellitxt.com
0.0.0.0 gigwise.us.intellitxt.com
0.0.0.0 girlsaskguys.us.intellitxt.com
0.0.0.0 givememyremote.us.intellitxt.com
0.0.0.0 goal.us.intellitxt.com
0.0.0.0 gonintendo.us.intellitxt.com
0.0.0.0 gossipcenter.us.intellitxt.com
0.0.0.0 gossiponthis.us.intellitxt.com
0.0.0.0 gossipteen.us.intellitxt.com
0.0.0.0 gottabemobile.us.intellitxt.com
0.0.0.0 govpro.us.intellitxt.com
0.0.0.0 graytv.us.intellitxt.com
0.0.0.0 gsmarena.us.intellitxt.com
0.0.0.0 gtmedia.us.intellitxt.com
0.0.0.0 guardianlv.us.intellitxt.com
0.0.0.0 guru3d.us.intellitxt.com
0.0.0.0 hackedgadgets.us.intellitxt.com
0.0.0.0 hairboutique.us.intellitxt.com
0.0.0.0 hardcoreware.us.intellitxt.com
0.0.0.0 hardforum.us.intellitxt.com
0.0.0.0 hardocp.us.intellitxt.com
0.0.0.0 hardwaregeeks.us.intellitxt.com
0.0.0.0 hardwarezone.us.intellitxt.com
0.0.0.0 harmony-central.us.intellitxt.com
0.0.0.0 haveuheard.us.intellitxt.com
0.0.0.0 helium.us.intellitxt.com
0.0.0.0 hiphoprx.us.intellitxt.com
0.0.0.0 hiphopdx.us.intellitxt.com
0.0.0.0 hiphoplead.us.intellitxt.com
0.0.0.0 hngn.com.us.intellitxt.com
0.0.0.0 hollyrude.us.intellitxt.com
0.0.0.0 hollywood.us.intellitxt.com
0.0.0.0 hollywooddame.us.intellitxt.com
0.0.0.0 hollywoodbackwash.us.intellitxt.com
0.0.0.0 hollywoodchicago.us.intellitxt.com
0.0.0.0 hollywoodstreetking.us.intellitxt.com
0.0.0.0 hollywoodtuna.us.intellitxt.com
0.0.0.0 hometheaterhifi.us.intellitxt.com
0.0.0.0 hongkiat.us.intellitxt.com
0.0.0.0 hoopsworld.us.intellitxt.com
0.0.0.0 hoovers.us.intellitxt.com
0.0.0.0 horoscope.us.intellitxt.com
0.0.0.0 hostboard.us.intellitxt.com
0.0.0.0 hothardware.us.intellitxt.com
0.0.0.0 hotmommagossip.us.intellitxt.com
0.0.0.0 howardchui.us.intellitxt.com
0.0.0.0 hq-celebrity.us.intellitxt.com
0.0.0.0 huliq.us.intellitxt.com
0.0.0.0 i4u.us.intellitxt.com
0.0.0.0 iamnotageek.us.intellitxt.com
0.0.0.0 icentric.us.intellitxt.com
0.0.0.0 ichef.us.intellitxt.com
0.0.0.0 icydk.us.intellitxt.com
0.0.0.0 idontlikeyouinthatway.us.intellitxt.com
0.0.0.0 iesb.us.intellitxt.com
0.0.0.0 ign.us.intellitxt.com
0.0.0.0 india-forums.us.intellitxt.com
0.0.0.0 babes.ign.us.intellitxt.com
0.0.0.0 cars.ign.us.intellitxt.com
0.0.0.0 comics.ign.us.intellitxt.com
0.0.0.0 cube.ign.us.intellitxt.com
0.0.0.0 ds.ign.us.intellitxt.com
0.0.0.0 filmforcedvd.ign.us.intellitxt.com
0.0.0.0 gameboy.ign.us.intellitxt.com
0.0.0.0 music.ign.us.intellitxt.com
0.0.0.0 psp.ign.us.intellitxt.com
0.0.0.0 ps2.ign.us.intellitxt.com
0.0.0.0 psx.ign.us.intellitxt.com
0.0.0.0 revolution.ign.us.intellitxt.com
0.0.0.0 sports.ign.us.intellitxt.com
0.0.0.0 wireless.ign.us.intellitxt.com
0.0.0.0 xbox.ign.us.intellitxt.com
0.0.0.0 xbox360.ign.us.intellitxt.com
0.0.0.0 idm.us.intellitxt.com
0.0.0.0 i-hacked.us.intellitxt.com
0.0.0.0 imnotobsessed.us.intellitxt.com
0.0.0.0 impactwrestling.us.intellitxt.com
0.0.0.0 imreportcard.us.intellitxt.com
0.0.0.0 infopackets.us.intellitxt.com
0.0.0.0 insidemacgames.us.intellitxt.com
0.0.0.0 intermix.us.intellitxt.com
0.0.0.0 internetautoguide.us.intellitxt.com
0.0.0.0 intogossip.us.intellitxt.com
0.0.0.0 intomobile.us.intellitxt.com
0.0.0.0 investingchannel.us.intellitxt.com
0.0.0.0 investopedia.us.intellitxt.com
0.0.0.0 ittoolbox.us.intellitxt.com
0.0.0.0 itxt2.us.intellitxt.com
0.0.0.0 itxt3.us.intellitxt.com
0.0.0.0 itworld.us.intellitxt.com
0.0.0.0 ivillage.us.intellitxt.com
0.0.0.0 s.ivillage.us.intellitxt.com
0.0.0.0 iwon.us.intellitxt.com
0.0.0.0 jacksonsun.us.intellitxt.com
0.0.0.0 jakeludington.us.intellitxt.com
0.0.0.0 jkontherun.us.intellitxt.com
0.0.0.0 joblo.us.intellitxt.com
0.0.0.0 juicyceleb.us.intellitxt.com
0.0.0.0 juicy-news.blogspot.us.intellitxt.com
0.0.0.0 jupiter.us.intellitxt.com
0.0.0.0 justjared.us.intellitxt.com
0.0.0.0 justmovietrailers.us.intellitxt.com
0.0.0.0 jutiagroup.us.intellitxt.com
0.0.0.0 kaboose.us.intellitxt.com
0.0.0.0 kasterborous.us.intellitxt.com
0.0.0.0 killerstartups.us.intellitxt.com
0.0.0.0 kissingsuzykolber.us.intellitxt.com
0.0.0.0 knac.us.intellitxt.com
0.0.0.0 kpopstarz.us.intellitxt.com
0.0.0.0 laboroflove.us.intellitxt.com
0.0.0.0 laineygossip.us.intellitxt.com
0.0.0.0 laptoplogic.us.intellitxt.com
0.0.0.0 laptopmag.us.intellitxt.com
0.0.0.0 lat34.us.intellitxt.com
0.0.0.0 latinpost.us.intellitxt.com
0.0.0.0 letsrun.us.intellitxt.com
0.0.0.0 latinoreview.us.intellitxt.com
0.0.0.0 lifescript.us.intellitxt.com
0.0.0.0 linuxdevcenter.us.intellitxt.com
0.0.0.0 linuxjournal.us.intellitxt.com
0.0.0.0 livescience.us.intellitxt.com
0.0.0.0 livestrong.us.intellitxt.com
0.0.0.0 lmcd.us.intellitxt.com
0.0.0.0 lockergnome.us.intellitxt.com
0.0.0.0 lohud.us.intellitxt.com
0.0.0.0 longhornblogs.us.intellitxt.com
0.0.0.0 lxer.us.intellitxt.com
0.0.0.0 lyrics.us.intellitxt.com
0.0.0.0 macdailynews.us.intellitxt.com
0.0.0.0 macnewsworld.us.intellitxt.com
0.0.0.0 macnn.us.intellitxt.com
0.0.0.0 macgamefiles.us.intellitxt.com
0.0.0.0 macmegasite.us.intellitxt.com
0.0.0.0 macobserver.us.intellitxt.com
0.0.0.0 madamenoire.us.intellitxt.com
0.0.0.0 madpenguin.us.intellitxt.com
0.0.0.0 mainstreet.us.intellitxt.com
0.0.0.0 majorgeeks.us.intellitxt.com
0.0.0.0 makeherup.us.intellitxt.com
0.0.0.0 makemeheal.us.intellitxt.com
0.0.0.0 makeushot.us.intellitxt.com
0.0.0.0 masalatalk.us.intellitxt.com
0.0.0.0 mazdaworld.us.intellitxt.com
0.0.0.0 medicinenet.us.intellitxt.com
0.0.0.0 medindia.us.intellitxt.com
0.0.0.0 memphisrap.us.intellitxt.com
0.0.0.0 meredithtv.us.intellitxt.com
0.0.0.0 methodshop.us.intellitxt.com
0.0.0.0 military.us.intellitxt.com
0.0.0.0 missjia.us.intellitxt.com
0.0.0.0 mobile9.us.intellitxt.com
0.0.0.0 mobileburn.us.intellitxt.com
0.0.0.0 mobiletechreview.us.intellitxt.com
0.0.0.0 mobilewhack.us.intellitxt.com
0.0.0.0 mobilityguru.us.intellitxt.com
0.0.0.0 modifiedlife.us.intellitxt.com
0.0.0.0 mommyish.us.intellitxt.com
0.0.0.0 morningstar.us.intellitxt.com
0.0.0.0 motortrend.us.intellitxt.com
0.0.0.0 moviehole.us.intellitxt.com
0.0.0.0 movie-list.us.intellitxt.com
0.0.0.0 movies.us.intellitxt.com
0.0.0.0 movieweb.us.intellitxt.com
0.0.0.0 msfn.us.intellitxt.com
0.0.0.0 msnbc.us.intellitxt.com
0.0.0.0 autos.msnbc.us.intellitxt.com
0.0.0.0 business.msnbc.us.intellitxt.com
0.0.0.0 health.msnbc.us.intellitxt.com
0.0.0.0 nbcsports.us.intellitxt.com
0.0.0.0 news.msnbc.us.intellitxt.com
0.0.0.0 sports.msnbc.us.intellitxt.com
0.0.0.0 technology.msnbc.us.intellitxt.com
0.0.0.0 travel-and-weather.msnbc.us.intellitxt.com
0.0.0.0 mmafighting.us.intellitxt.com
0.0.0.0 entertainment.msn.us.intellitxt.com
0.0.0.0 muscleandfitnesshers.us.intellitxt.com
0.0.0.0 mydigitallife.us.intellitxt.com
0.0.0.0 myfavoritegames.us.intellitxt.com
0.0.0.0 mydailymoment.us.intellitxt.com
0.0.0.0 nasioc.us.intellitxt.com
0.0.0.0 nationalledger.us.intellitxt.com
0.0.0.0 nationalenquirer.us.intellitxt.com
0.0.0.0 naturalhealth.us.intellitxt.com
0.0.0.0 natureworldnews.us.intellitxt.com
0.0.0.0 nbcnewyork.us.intellitxt.com
0.0.0.0 nbcuniversaltv.us.intellitxt.com
0.0.0.0 neoseeker.us.intellitxt.com
0.0.0.0 neowin.us.intellitxt.com
0.0.0.0 nextround.us.intellitxt.com
0.0.0.0 newsoxy.us.intellitxt.com
0.0.0.0 newstoob.us.intellitxt.com
0.0.0.0 nihoncar.us.intellitxt.com
0.0.0.0 ninjadude.us.intellitxt.com
0.0.0.0 ntcompatible.us.intellitxt.com
0.0.0.0 oceanup.us.intellitxt.com
0.0.0.0 octools.us.intellitxt.com
0.0.0.0 ocworkbench.us.intellitxt.com
0.0.0.0 officer.us.intellitxt.com
0.0.0.0 okmagazine.us.intellitxt.com
0.0.0.0 onlamp.us.intellitxt.com
0.0.0.0 ontheflix.us.intellitxt.com
0.0.0.0 oocenter.us.intellitxt.com
0.0.0.0 osdir.us.intellitxt.com
0.0.0.0 ostg.us.intellitxt.com
0.0.0.0 outofsightmedia.us.intellitxt.com
0.0.0.0 overclockersonline.us.intellitxt.com
0.0.0.0 overthelimit.us.intellitxt.com
0.0.0.0 pal-item.us.intellitxt.com
0.0.0.0 pcmag.us.intellitxt.com
0.0.0.0 pcper.us.intellitxt.com
0.0.0.0 penton.us.intellitxt.com
0.0.0.0 perezhilton.us.intellitxt.com
0.0.0.0 philadelphia_cbslocal.us.intellitxt.com
0.0.0.0 phonearena.us.intellitxt.com
0.0.0.0 pickmeupnews.us.intellitxt.com
0.0.0.0 pinkisthenewblog.us.intellitxt.com
0.0.0.0 popdirt.us.intellitxt.com
0.0.0.0 popfill.us.intellitxt.com
0.0.0.0 popoholic.us.intellitxt.com
0.0.0.0 poponthepop.us.intellitxt.com
0.0.0.0 popularmechanics.us.intellitxt.com
0.0.0.0 prettyboring.us.intellitxt.com
0.0.0.0 priusonline.us.intellitxt.com
0.0.0.0 profootballweekly.us.intellitxt.com
0.0.0.0 programmerworld.us.intellitxt.com
0.0.0.0 pro-networks.us.intellitxt.com
0.0.0.0 ps3news.us.intellitxt.com
0.0.0.0 punchjump.us.intellitxt.com
0.0.0.0 puppytoob.us.intellitxt.com
0.0.0.0 pwinsider.us.intellitxt.com
0.0.0.0 quickpwn.us.intellitxt.com
0.0.0.0 quinstreet.us.intellitxt.com
0.0.0.0 rankmytattoos.us.intellitxt.com
0.0.0.0 rantsports.us.intellitxt.com
0.0.0.0 realitytea.us.intellitxt.com
0.0.0.0 realitytvmagazine.us.intellitxt.com
0.0.0.0 rickey.us.intellitxt.com
0.0.0.0 ringsurf.us.intellitxt.com
0.0.0.0 rnbdirt.us.intellitxt.com
0.0.0.0 rumorfix.us.intellitxt.com
0.0.0.0 sports.rightpundits.us.intellitxt.com
0.0.0.0 rojakpot.us.intellitxt.com
0.0.0.0 rpg.us.intellitxt.com
0.0.0.0 rx8club.us.intellitxt.com
0.0.0.0 rydium.us.intellitxt.com
0.0.0.0 scanwith.us.intellitxt.com
0.0.0.0 scienceworldreport.us.intellitxt.com
0.0.0.0 screensavers.us.intellitxt.com
0.0.0.0 sdcexecs.us.intellitxt.com
0.0.0.0 shallownation.us.intellitxt.com
0.0.0.0 shebudgets.us.intellitxt.com
0.0.0.0 sheknows.us.intellitxt.com
0.0.0.0 shoutwire.us.intellitxt.com
0.0.0.0 siliconera.us.intellitxt.com
0.0.0.0 slashfilm.us.intellitxt.com
0.0.0.0 smartabouthealth.us.intellitxt.com
0.0.0.0 smartcarfinder.us.intellitxt.com
0.0.0.0 smartdevicecentral.us.intellitxt.com
0.0.0.0 sportingnews.us.intellitxt.com
0.0.0.0 soccergaming.us.intellitxt.com
0.0.0.0 socialanxietysupport.us.intellitxt.com
0.0.0.0 socialitelife.us.intellitxt.com
0.0.0.0 soft32.us.intellitxt.com
0.0.0.0 softpedia.us.intellitxt.com
0.0.0.0 sohh.us.intellitxt.com
0.0.0.0 space.us.intellitxt.com
0.0.0.0 speedguide.us.intellitxt.com
0.0.0.0 speedtv.us.intellitxt.com
0.0.0.0 sportscarillustrated.us.intellitxt.com
0.0.0.0 sprintusers.us.intellitxt.com
0.0.0.0 sqlservercentral.us.intellitxt.com
0.0.0.0 starcasm.us.intellitxt.com
0.0.0.0 steadyhealth.us.intellitxt.com
0.0.0.0 stockgroup.us.intellitxt.com
0.0.0.0 storknet.us.intellitxt.com
0.0.0.0 stupidcelebrities.us.intellitxt.com
0.0.0.0 styleblazer.us.intellitxt.com
0.0.0.0 supercars.us.intellitxt.com
0.0.0.0 superherohype.us.intellitxt.com
0.0.0.0 surebaby.us.intellitxt.com
0.0.0.0 symbianone.us.intellitxt.com
0.0.0.0 symbian-freak.us.intellitxt.com
0.0.0.0 taletela.us.intellitxt.com
0.0.0.0 tbohiphop.us.intellitxt.com
0.0.0.0 techeblog.us.intellitxt.com
0.0.0.0 tech-faq.us.intellitxt.com
0.0.0.0 techgage.us.intellitxt.com
0.0.0.0 techguy.us.intellitxt.com
0.0.0.0 techimo.us.intellitxt.com
0.0.0.0 technobuffalo.us.intellitxt.com
0.0.0.0 technologyguide.us.intellitxt.com
0.0.0.0 techpowerup.us.intellitxt.com
0.0.0.0 techspot.us.intellitxt.com
0.0.0.0 techsupportforum.us.intellitxt.com
0.0.0.0 tenmagazines.us.intellitxt.com
0.0.0.0 tgdaily.us.intellitxt.com
0.0.0.0 thathappened.us.intellitxt.com
0.0.0.0 theadvertiser.us.intellitxt.com
0.0.0.0 theblemish.us.intellitxt.com
0.0.0.0 thebosh.us.intellitxt.com
0.0.0.0 thecarconnection.us.intellitxt.com
0.0.0.0 thecelebritycafe.us.intellitxt.com
0.0.0.0 theeldergeek.us.intellitxt.com
0.0.0.0 thefinalfantasy.us.intellitxt.com
0.0.0.0 theforce.us.intellitxt.com
0.0.0.0 thefrisky.us.intellitxt.com
0.0.0.0 thefutoncritic.us.intellitxt.com
0.0.0.0 thegauntlet.us.intellitxt.com
0.0.0.0 theglobeandmail.us.intellitxt.com
0.0.0.0 thegloss.us.intellitxt.com
0.0.0.0 thehdroom.us.intellitxt.com
0.0.0.0 thehollywoodgossip.us.intellitxt.com
0.0.0.0 themanroom.us.intellitxt.com
0.0.0.0 theonenetwork.us.intellitxt.com
0.0.0.0 thepaparazzis.us.intellitxt.com
0.0.0.0 thestreet.us.intellitxt.com
0.0.0.0 thesuperficial.us.intellitxt.com
0.0.0.0 thetechlounge.us.intellitxt.com
0.0.0.0 thetechzone.us.intellitxt.com
0.0.0.0 theunwired.us.intellitxt.com
0.0.0.0 theybf.us.intellitxt.com
0.0.0.0 thinkcomputers.us.intellitxt.com
0.0.0.0 thoughtsmedia.us.intellitxt.com
0.0.0.0 threadwatch.us.intellitxt.com
0.0.0.0 tmz.us.intellitxt.com
0.0.0.0 todayshow.us.intellitxt.com
0.0.0.0 toofab.us.intellitxt.com
0.0.0.0 toms.us.intellitxt.com
0.0.0.0 tomsforumz.us.intellitxt.com
0.0.0.0 tomshardware.us.intellitxt.com
0.0.0.0 tomsnetworking.us.intellitxt.com
0.0.0.0 topsocialite.us.intellitxt.com
0.0.0.0 topnews.us.intellitxt.com
0.0.0.0 toptechreviews.us.intellitxt.com
0.0.0.0 toptenreviews.us.intellitxt.com
0.0.0.0 topspeed.us.intellitxt.com
0.0.0.0 torquenews.us.intellitxt.com
0.0.0.0 tothecenter.us.intellitxt.com
0.0.0.0 traileraddict.us.intellitxt.com
0.0.0.0 trekweb.us.intellitxt.com
0.0.0.0 tribal.us.intellitxt.com
0.0.0.0 triumphrat.us.intellitxt.com
0.0.0.0 tsxclub.us.intellitxt.com
0.0.0.0 tutorialoutpost.us.intellitxt.com
0.0.0.0 tvfanatic.us.intellitxt.com
0.0.0.0 tv-now.us.intellitxt.com
0.0.0.0 tv-rightcelebrity.us.intellitxt.com
0.0.0.0 tvseriesfinale.us.intellitxt.com
0.0.0.0 tweaks.us.intellitxt.com
0.0.0.0 tweaktown.us.intellitxt.com
0.0.0.0 tweakvista.us.intellitxt.com
0.0.0.0 tweetsoup.us.intellitxt.com
0.0.0.0 twitchguru.us.intellitxt.com
0.0.0.0 ubergizmo.us.intellitxt.com
0.0.0.0 unathleticmag.us.intellitxt.com
0.0.0.0 universityherald.us.intellitxt.com
0.0.0.0 upi.us.intellitxt.com
0.0.0.0 vault9.us.intellitxt.com
0.0.0.0 viaarena.us.intellitxt.com
0.0.0.0 vibe.us.intellitxt.com
0.0.0.0 videocodezone.us.intellitxt.com
0.0.0.0 vidnet.us.intellitxt.com
0.0.0.0 voodoofiles.us.intellitxt.com
0.0.0.0 warcry.us.intellitxt.com
0.0.0.0 washingtontimes.us.intellitxt.com
0.0.0.0 weightlossforall.us.intellitxt.com
0.0.0.0 whatthetech.us.intellitxt.com
0.0.0.0 whoateallthepies.uk.intellitxt.com
0.0.0.0 wincert.us.intellitxt.com
0.0.0.0 windowsbbs.us.intellitxt.com
0.0.0.0 windowsitpro.us.intellitxt.com
0.0.0.0 winmatrix.us.intellitxt.com
0.0.0.0 winterrowd.us.intellitxt.com
0.0.0.0 wiregirl.us.intellitxt.com
0.0.0.0 withleather.us.intellitxt.com
0.0.0.0 wm5fixsite.us.intellitxt.com
0.0.0.0 womensforum.us.intellitxt.com
0.0.0.0 worldnetdaily.us.intellitxt.com
0.0.0.0 wowinterface.us.intellitxt.com
0.0.0.0 wrestling-edge.us.intellitxt.com
0.0.0.0 wwtdd.us.intellitxt.com
0.0.0.0 x17online.us.intellitxt.com
0.0.0.0 xmlpitstop.us.intellitxt.com
0.0.0.0 yeeeah.us.intellitxt.com
0.0.0.0 yourtango.us.intellitxt.com
0.0.0.0 zatznotfunny.us.intellitxt.com
0.0.0.0 zeldalily.us.intellitxt.com
0.0.0.0 zug.us.intellitxt.com
0.0.0.0 vibrantmedia.com
0.0.0.0 www.vibrantmedia.com
# [Virtualxs][AS15535][62.129.128.0 - 62.129.159.255]
0.0.0.0 promo.passioncams.com
0.0.0.0 banners.payserve.com
# [Visible Measures][AS14742][64.95.73.0 - 64.95.73.31]
# 0.0.0.0 cdn.visiblemeasures.com #[affects Collegehumor.com]
# [Voxel][AS29791][107.6.64.0 - 107.6.127.255]
0.0.0.0 optimize.innity.com
# [Voxel][AS29791][208.122.0.0 - 208.122.63.255]
0.0.0.0 api.adrenalads.com
# [Voxel][AS29791][208.122.0.0 - 208.122.63.255]
0.0.0.0 f.blogads.com
0.0.0.0 g.blogads.com
0.0.0.0 st.blogads.com #[WebBug]
0.0.0.0 weblog.blogads.com
0.0.0.0 t.blogreaderproject.com #[WebBug]
0.0.0.0 ads.exactseek.com
0.0.0.0 ads.pressflex.com
0.0.0.0 adserver.pressflex.com
0.0.0.0 fishadz.pressflex.net
0.0.0.0 www.projectwonderful.com
# [Voxel][AS29791][23.92.176.0 - 23.92.191.255]
0.0.0.0 mydmp.exelator.com
# [Voxel][69.9.160.0 - 69.9.191.255]
0.0.0.0 banners.absolpublisher.com
0.0.0.0 stat.blogads.com #[WebBug]
0.0.0.0 www.blogads.com
0.0.0.0 adms.physorg.com
# [Voxel][72.251.192.0 - 72.251.255.255]
0.0.0.0 loadeu.exelator.com
0.0.0.0 loadm.exelator.com
0.0.0.0 ads.imgur.com
0.0.0.0 tracking.m6r.eu
# [Voxel][AS29791][74.63.32.0 - 74.63.63.255]
0.0.0.0 network.adsmarket.com
0.0.0.0 z.blogads.com
0.0.0.0 p.raasnet.com #[WebBug]
0.0.0.0 ads.sfomedia.com
0.0.0.0 stats.twistage.com
# [W Net Isp][AS15772][217.20.160.0 - 217.20.163.255]
0.0.0.0 stat.delo.ua
# [W Net Isp][AS15772][217.20.175.0 - 217.20.175.127]
0.0.0.0 c.mystat-in.net
0.0.0.0 ___id___.c.mystat-in.net #[Wildcard DNS]
0.0.0.0 011707160008.c.mystat-in.net
0.0.0.0 121807150325.c.mystat-in.net
0.0.0.0 122907224924.c.mystat-in.net
0.0.0.0 061606084448.c.mystat-in.net
0.0.0.0 070806142521.c.mystat-in.net
0.0.0.0 090906042103.c.mystat-in.net
0.0.0.0 092706152958.c.mystat-in.net
0.0.0.0 102106151057.c.mystat-in.net
0.0.0.0 112006133326.c.mystat-in.net
# [WAN Worldcom / Live Technology][AS11486][206.65.169.128 - 206.65.169.191]
0.0.0.0 14713804a.l2m.net #[Tracking.Cookie]
0.0.0.0 30280827a.l2m.net #[WebBug]
0.0.0.0 jmm.livestat.com #[Tracking.Cookie]
0.0.0.0 www.livestat.com
# [WAN Worldcom / LinkShare][63.123.248.0 - 63.123.248.63]
0.0.0.0 analytics.clickpathmedia.com
# [Way Internet][AS13890][216.133.242.224 - 216.133.242.255]
0.0.0.0 trafficads.com
0.0.0.0 www.trafficads.com
# [Way Internet][AS13890][216.133.243.0 - 216.133.243.63]
0.0.0.0 click.zipcodez.com
# [Webair][AS27257][173.239.42.214]
0.0.0.0 dsp.adkernel.com
0.0.0.0 sync.adkernel.com
0.0.0.0 xml.ad-maven.com
0.0.0.0 filter.adxfactory.com
0.0.0.0 xml.adxfactory.com
0.0.0.0 realtime.deximedia.com
0.0.0.0 cpanel.nativeads.com
0.0.0.0 exchange.nativeads.com
0.0.0.0 xml.plusfind.net
0.0.0.0 cpv.popxml.com
0.0.0.0 xml.quiveradnet.com
0.0.0.0 app.super-links.net
0.0.0.0 cpm.super-links.net
# [Webair][AS36057][174.137.128.0 - 174.137.191.255]
0.0.0.0 xml.adfclick1.com
0.0.0.0 filter.adsparkmedia.net
0.0.0.0 xml.adsparkmedia.net
0.0.0.0 xml.adventurefeeds.com
0.0.0.0 affiliates.hookup.com
0.0.0.0 xml.mxsads.com
0.0.0.0 xml.onwardclick.com
# [Webair][AS36057][198.134.112.230]
0.0.0.0 rtb.nativeads.com
0.0.0.0 pl120422.puhtml.com
0.0.0.0 pl3087.puhtml.com
0.0.0.0 pl5102.puhtml.com
0.0.0.0 pl5318.puhtml.com
0.0.0.0 pl1978.puhtml.com
0.0.0.0 pl106067.puhtml.com
0.0.0.0 pl107977.puhtml.com
0.0.0.0 pl108062.puhtml.com #[Terriclicks]
0.0.0.0 pl109504.puhtml.com
0.0.0.0 pl137937.puhtml.com
0.0.0.0 pl176754.puhtml.com
0.0.0.0 pl3861661.puhtml.com
0.0.0.0 pl6429510.puhtml.com
# [Webair][209.200.0.0 - 209.200.63.255]
0.0.0.0 exits.adultcash.com
0.0.0.0 popfree.adultcash.com
0.0.0.0 www.adultcash.com
0.0.0.0 www.bnhtml.com
0.0.0.0 www.crazyprotocol.com
0.0.0.0 www.lonelycheatingwives.com
0.0.0.0 www.spookylinks.com
# [Webair][AS27257][216.130.160.0 - 216.130.191.255]
0.0.0.0 dn.adzerver.com
0.0.0.0 temp.adzerver.com
# [Webair][AS27257][66.207.43.232]
0.0.0.0 www.clickterra.net
# [Webair][AS27257][67.55.64.0 - 67.55.127.255]
0.0.0.0 admanage.com
0.0.0.0 xml.admanage.com
0.0.0.0 push.poptm.com
0.0.0.0 www.professionalcash.com
0.0.0.0 pl136883.puhtml.com
0.0.0.0 www.terraclicks.com
0.0.0.0 www.terrapops.com
# [Webair][AS27257][69.42.64.0 - 69.42.95.255]
0.0.0.0 www.clicksgear.com
0.0.0.0 www.cpm10.com
# [Webair][74.206.224.0 - 74.206.255.255]
0.0.0.0 webcashmaker.com
# [WebApps][AS12180][67.215.170.0 - 67.215.170.255]
0.0.0.0 affiliate.adgtracker.com
# [WebaZilla][AS35415][185.49.144.0 - 185.49.147.255]
0.0.0.0 go.ad2up.com
0.0.0.0 adsvids.com
0.0.0.0 padsdel.cdnads.com
0.0.0.0 go.padsdel.com
0.0.0.0 go.padsdelivery.com
0.0.0.0 go.padstm.com
# [WebaZilla][AS35415][188.164.249.128 - 188.164.249.255]
0.0.0.0 a2pub.com
0.0.0.0 cdn.adtrace.org
0.0.0.0 wateristian.com
# [WebaZilla][AS35415][188.72.201.34]
0.0.0.0 go.ad2upapp.com
0.0.0.0 go.deliverymodo.com
# [WebaZilla][AS35415][193.105.200.0 - 193.105.200.255]
0.0.0.0 rmbn.net
# [WebaZilla][AS35415][206.54.160.0 - 206.54.191.255]
0.0.0.0 aclickads.com
0.0.0.0 clickadu.com
0.0.0.0 go.mooncklick.com
0.0.0.0 onclkds.com
# [WebaZilla][AS35415][74.117.176.0/21]
0.0.0.0 hilltopads.net
# [WebaZilla / Nl-webazilla][AS35415][78.140.128.0 - 78.140.191.255]
0.0.0.0 1phads.com
0.0.0.0 www2.acint.net
0.0.0.0 jsc.adskeeper.co.uk
0.0.0.0 adsyst.biz
0.0.0.0 artcomix.com
0.0.0.0 top.artcomix.com
0.0.0.0 www.artcomix.com
0.0.0.0 metrics.aviasales.ru
0.0.0.0 cartoonpornguide.com
0.0.0.0 free.cartoonpornguide.com
0.0.0.0 www.cartoonpornguide.com
0.0.0.0 ads.depositfiles.com
0.0.0.0 jsn.dt00.net
0.0.0.0 dvdhentai.net
0.0.0.0 www.fhserve.com #[OpenX]
0.0.0.0 secure.fhserve.com
0.0.0.0 imgn.marketgid.com
0.0.0.0 jsn.marketgid.com
0.0.0.0 go.mobisla.com
0.0.0.0 go.mobtrks.com
0.0.0.0 go.mobytrks.com
0.0.0.0 go.oclasrv.com
0.0.0.0 go.oclaserver.com
0.0.0.0 go.onclasrv.com
0.0.0.0 onclickads.net
0.0.0.0 onlinadverts.com
0.0.0.0 otherprofit.com
0.0.0.0 t.otherprofit.com
0.0.0.0 popunder.net
0.0.0.0 www.postads24.com
0.0.0.0 propellerpops.com
0.0.0.0 go.pub2srv.com
0.0.0.0 www.reduxmediia.com
0.0.0.0 xml.seekandsee.com
0.0.0.0 ads.shorte.st
0.0.0.0 c1.smartclick.net
0.0.0.0 www.stamplive.com
0.0.0.0 toon-families.com
0.0.0.0 www.toon-families.com
0.0.0.0 toonfamilies.net
0.0.0.0 www.toonfamilies.net
0.0.0.0 traffic.ru
0.0.0.0 ad.trafficshop.com
0.0.0.0 pu.trafficshop.com
0.0.0.0 webmasters.tubealliance.com
0.0.0.0 affiliates.upforitnetworks.com
0.0.0.0 stat.upforitnetworks.com
0.0.0.0 www.yourlustmedia.com
# [Webazilla][AS35415][88.85.64.0 - 88.85.95.255]
0.0.0.0 6e2f1d2ae033.com
0.0.0.0 rotator.7x3.net
0.0.0.0 adultimate.net
0.0.0.0 ads.alphaporno.com
0.0.0.0 bestadbid.com
0.0.0.0 www.bravospots.com
0.0.0.0 ad.depositfiles.com
0.0.0.0 ad3.depositfiles.com
0.0.0.0 jsc.dt07.net
0.0.0.0 www.feyads.com
0.0.0.0 helltraffic.com
0.0.0.0 www.helltraffic.com
0.0.0.0 jsu.mgid.com
0.0.0.0 mg.mgid.com
0.0.0.0 echo.teasernet.ru
0.0.0.0 tmserver-1.com
0.0.0.0 static.traffic.ru
0.0.0.0 wonderlandads.com
0.0.0.0 xxxreactor.com
# [Web Clients][AS23045][64.8.21.0 - 64.8.21.255]
0.0.0.0 webclients.net #[Webclients Ad Network]
0.0.0.0 www.webclients.net
0.0.0.0 websponsors.com
0.0.0.0 ocs.websponsors.com
0.0.0.0 www.websponsors.com
# [Webmd][AS46244][208.93.168.0 - 208.93.175.255]
0.0.0.0 bi.medscape.com #[WebBug][affects Medscape app]
0.0.0.0 adv.medscape.com #[ads.webmd.com]
0.0.0.0 as.medscape.com
0.0.0.0 adv.webmd.com
0.0.0.0 as.webmd.com
# [Webnx][AS18450][100.42.208.0 - 100.42.223.255]
0.0.0.0 www.gameplaylabs.com #[Adware:Win32/GamePlayLabs]
# [Webnx][AS18450][173.231.0.0 - 173.231.63.255]
0.0.0.0 img.jizzads.com
# [Webnx][AS18450][50.115.32.0 - 50.115.47.255]
0.0.0.0 ads4pubs.com
# [Webnx][AS18450][64.185.224.0 - 64.185.239.255]
0.0.0.0 opt.ximad.com
# [Webnx][AS18450][67.220.192.0 - 67.220.223.255]
0.0.0.0 fttcj.com
0.0.0.0 ads.socialreach.com
# [WebTone][AS25961][204.13.8.0 - 204.13.8.255]
0.0.0.0 getclicky.com
0.0.0.0 in.getclicky.com #[WebBug]
0.0.0.0 pmetrics.getclicky.com
0.0.0.0 static.getclicky.com
0.0.0.0 pmetrics.performancing.com
0.0.0.0 stats.webleads-tracker.com
# [Webtrekk][AS60164][185.54.148.0 - 185.54.151.255]
0.0.0.0 verivox01.webtrekk.net
# [Webtrends][AS11944][216.64.169.0 - 216.64.169.255]
0.0.0.0 www.webtrends.net
# [Webtrends][AS11944][63.251.0.0 - 63.251.255.255]
0.0.0.0 scs.webtrends.com
# [Webtrends][63.88.212.0 - 63.88.213.255]
0.0.0.0 webtrendslive.com #[SmartSource Data Collector]
# [Webtrends][AS10913][66.150.117.0 - 66.150.117.127]
0.0.0.0 rd.clickshift.com
0.0.0.0 wt.o.nytimes.com #[WebBug]
0.0.0.0 dc.webtrends.com
0.0.0.0 statse.webtrendslive.com #[SDC Advanced Tracking Code]
0.0.0.0 dcs.wtlive.com #[Tracking.Cookie]
0.0.0.0 dcstest.wtlive.com
# [Webtrends via Misc Sites]
0.0.0.0 wtrs.101com.com
0.0.0.0 sdc.acc.org
0.0.0.0 sdc.caranddriver.com
0.0.0.0 sdc.ca.com
0.0.0.0 sdc.dishnetwork.com
0.0.0.0 sdc.dn.no
0.0.0.0 sdc.entertainment.com
0.0.0.0 ssdc.icelandair.com
0.0.0.0 sdc.lef.org
0.0.0.0 sdc.livingchoices.com
0.0.0.0 sdc.mcafee.com
0.0.0.0 sdc.netiq.com
0.0.0.0 sdc.radio-canada.ca
0.0.0.0 sdc.rbistats.com
0.0.0.0 sdc.roadandtrack.com
0.0.0.0 sdc.sanofi-aventis.us
0.0.0.0 sdc.traderonline.com
0.0.0.0 sdc.usps.com
0.0.0.0 sdc.vml.com
0.0.0.0 sdc.windowsmarketplace.com
0.0.0.0 wdcs.trendmicro.com
# [WireSix][AS14141][66.71.240.0 - 66.71.255.255]
0.0.0.0 adsystem.simplemachines.org
# [24/7 Real Media via various][AS36805][208.81.232.0 - 208.81.235.255]
0.0.0.0 ads.ctvdigital.net
0.0.0.0 b3-uk.mookie1.com
0.0.0.0 oas.offremedia.com
0.0.0.0 ads.pennnet.com
0.0.0.0 oas.stv.tv
# [Wz Communications][AS40824][199.80.52.0 - 199.80.55.255]
0.0.0.0 jsn.dt07.net
0.0.0.0 jsc.mgid.com
0.0.0.0 jsn.mgid.com
# [Wz Communications][AS40824][204.155.144.0 - 204.155.159.255]
0.0.0.0 track.ad4mmo.com
0.0.0.0 cdn.mgid.com
0.0.0.0 cdn.trafficstars.com
# [Wz Communications][AS40824][206.54.177.0 - 206.54.177.255]
0.0.0.0 id.get35.com
# [Wz Communications][208.88.224.0 - 208.88.227.255]
0.0.0.0 aka-root.com
0.0.0.0 ads.h2porn.com
0.0.0.0 adv.h2porn.com
# [Wz Communications / Soft-Com.biz][AS40824][208.94.235.0 - 208.94.235.255]
0.0.0.0 c.mgid.com
0.0.0.0 www.mgid.com
# [Wz Communications][AS40824][74.117.176.0 - 74.117.183.255]
0.0.0.0 www.4shared.com #[Adware.4SharedDesktop]
0.0.0.0 adv.freepornvs.com
# [XO Communications][AS40935][208.36.0.0 - 208.37.255.255]
# [XO Communications][209.116.0.0 - 209.119.255.255]
0.0.0.0 33universal.adprimemedia.com
0.0.0.0 video1.adprimemedia.com
# [XO Communications][64.244.0.0 - 64.245.255.255]
0.0.0.0 advert.funimation.com
0.0.0.0 webiq005.webiqonline.com
# [Xs4all Internet][AS3265][82.161.231.0 - 82.161.231.255]
0.0.0.0 www.netpoll.nl
# [Xs4all Internet][AS3265][83.68.16.0 - 83.68.16.255]
0.0.0.0 ntkrnlpa.info
# [Xtraordinary][AS30827][82.113.144.0 - 82.113.151.255]
0.0.0.0 banners.delivery.addynamo.com
0.0.0.0 s01.delivery.addynamo.com
0.0.0.0 s01-delivery.addynamo.net
0.0.0.0 static.addynamo.net
0.0.0.0 static-uk.addynamo.net
# [Yahoo Taiwan][AS24506][116.214.0.0 - 116.214.15.255]
0.0.0.0 ad.wretch.cc
# [Yahoo SG1][124.108.112.0 - 124.108.127.255]
0.0.0.0 nz.adserver.yahoo.com
0.0.0.0 sg.adserver.yahoo.com
# [Yahoo Brasil][200.152.160/20]
0.0.0.0 br.adserver.yahoo.com
# [Yahoo China][202.43.192.0 - 202.43.223.255]
0.0.0.0 cn.adserver.yahoo.com
# [Yahoo TPC][203.84.192.0 - 203.84.223.255]
0.0.0.0 tw.adserver.yahoo.com
# [Yahoo][AS36129][206.190.32.0 - 206.190.63.255]
0.0.0.0 mi.adinterax.com
0.0.0.0 e.yieldmanager.net
0.0.0.0 l.yieldmanager.net
0.0.0.0 ads.yimg.com
# [Yahoo Europe][AS15635][217.12.3.0 - 217.12.4.255]
0.0.0.0 be.adserver.yahoo.com
0.0.0.0 dk.adserver.yahoo.com
0.0.0.0 eu-pn4.adserver.yahoo.com
0.0.0.0 fr.adserver.yahoo.com
0.0.0.0 nl.adserver.yahoo.com
0.0.0.0 se.adserver.yahoo.com
0.0.0.0 uk.adserver.yahoo.com
# [Yahoo Europe][217.146.184.0 - 217.146.191.47]
0.0.0.0 de.adserver.yahoo.com
0.0.0.0 es.adserver.yahoo.com
0.0.0.0 gr.adserver.yahoo.com
0.0.0.0 it.adserver.yahoo.com
0.0.0.0 no.adserver.yahoo.com
# [Yahoo / BlueLithium]
0.0.0.0 gambling911.adrevolver.com
0.0.0.0 aps.media.adrevolver.com
0.0.0.0 media.adrevolver.com #[Tracking.Cookie]
0.0.0.0 track.adrevolver.com
# [Yahoo][AS14779][66.196.64.0 - 66.196.127.255]
0.0.0.0 hostingprod.com #[WebBug]
0.0.0.0 geo.yahoo.com
0.0.0.0 nol.yahoo.com
# [Yahoo][AS26101][68.142.192.0 - 68.142.255.255]
0.0.0.0 partnerads.ysm.yahoo.com
# [Yahoo][AS36752][68.180.128.0 - 68.180.255.255]
0.0.0.0 ts.richmedia.yahoo.com
0.0.0.0 visit.webhosting.yahoo.com #[WebBug]
# [Yahoo][AS14778][76.13.0.0 - 76.13.255.255]
0.0.0.0 ad.foxnetworks.com
0.0.0.0 ad.hi5.com
0.0.0.0 adserver.yahoo.com
0.0.0.0 ae.adserver.yahoo.com
0.0.0.0 ar.adserver.yahoo.com
0.0.0.0 au.adserver.yahoo.com
0.0.0.0 ca.adserver.yahoo.com
0.0.0.0 cn2.adserver.yahoo.com
0.0.0.0 eu-pn2.adserver.yahoo.com
0.0.0.0 hk.adserver.yahoo.com
0.0.0.0 in.adserver.yahoo.com
0.0.0.0 us.adserver.yahoo.com
0.0.0.0 pn1.adserver.yahoo.com
0.0.0.0 pn2.adserver.yahoo.com
0.0.0.0 tw2.adserver.yahoo.com
0.0.0.0 launch.adserver.yahoo.com
0.0.0.0 mx.adserver.yahoo.com
0.0.0.0 sp.analytics.yahoo.com
# [Yahoo][AS26101][98.136.0.0 - 98.139.255.255]
0.0.0.0 adinterax.com #[Tracking.Cookie]
0.0.0.0 www.adinterax.com
0.0.0.0 np.lexity.com
# 0.0.0.0 beap.adss.yahoo.com #[affects Yahoo video]
0.0.0.0 beap.adx.yahoo.com #[WebBug]
0.0.0.0 analytics.query.yahoo.com
0.0.0.0 geo.query.yahoo.com
0.0.0.0 ac.ybinst0.ec.yimg.com
0.0.0.0 ac.ybinst1.ec.yimg.com
0.0.0.0 ac.ybinst2.ec.yimg.com
0.0.0.0 ac.ybinst3.ec.yimg.com
0.0.0.0 ac.ybinst4.ec.yimg.com
0.0.0.0 ac.ybinst5.ec.yimg.com
0.0.0.0 ac.ybinst6.ec.yimg.com #[WebBug]
0.0.0.0 ac.ybinst7.ec.yimg.com
0.0.0.0 ac.ybinst8.ec.yimg.com
0.0.0.0 ac.ybinst9.ec.yimg.com
0.0.0.0 ybinst0.ec.yimg.com
0.0.0.0 ybinst1.ec.yimg.com
0.0.0.0 ybinst2.ec.yimg.com
0.0.0.0 ybinst3.ec.yimg.com #[Bing.WebBug]
0.0.0.0 ybinst4.ec.yimg.com
0.0.0.0 ybinst5.ec.yimg.com
0.0.0.0 ybinst6.ec.yimg.com
0.0.0.0 ybinst7.ec.yimg.com
0.0.0.0 ybinst8.ec.yimg.com
0.0.0.0 ybinst9.ec.yimg.com
# [Yandex][AS13238][178.154.131.0 - 178.154.131.255]
# 0.0.0.0 yastatic.net #[affects Yandex Mail]
# [Yandex][AS13238][213.180.193.0 - 213.180.193.255]
0.0.0.0 an.yandex.ru
# [Yandex][AS13238][87.250.250.0 - 87.250.250.255]
0.0.0.0 advertising.yandex.ru
0.0.0.0 bs.yandex.ru
0.0.0.0 bs-meta.yandex.ru
# 0.0.0.0 clck.yandex.ru
# 0.0.0.0 grade.market.yandex.ru
0.0.0.0 informer.yandex.ru
0.0.0.0 mc.yandex.ru
0.0.0.0 yandexadexchange.net
# [Yesup][AS22923][199.21.148.0 - 199.21.151.255]
0.0.0.0 serv.clicksor.net
0.0.0.0 serw.myroitracking.com
0.0.0.0 tr1.myroitracking.com
0.0.0.0 track.visitorpath.com
# [Yesup Ecommerce Solutions][66.48.78.192 - 66.48.78.255]
0.0.0.0 mp.clicksor.net
0.0.0.0 myad.clicksor.net
0.0.0.0 pub.clicksor.net
0.0.0.0 www.infinityads.com
0.0.0.0 multipops.com
0.0.0.0 service.multi-pops.com
0.0.0.0 www1.multipops.com
0.0.0.0 www2.multipops.com
0.0.0.0 www.multipops.com
0.0.0.0 www.xxxwebtraffic.com
# [Yesup Ecommerce Solutions][AS701][66.48.81.128 - 66.48.81.255]
0.0.0.0 ads.adonion.com
0.0.0.0 serving.adsrevenue.clicksor.net
0.0.0.0 www.myroitracking.com
0.0.0.0 yourstats.net
0.0.0.0 www.yourstats.net
# [ZEDO][AS26914][64.127.125.112 - 64.127.125.127]
0.0.0.0 l7.zedo.com
# [ZEDO]
0.0.0.0 zedo.com #[WebBug]
0.0.0.0 3650.tm.zedo.com
0.0.0.0 ads.zedo.com
0.0.0.0 c1.zedo.com
0.0.0.0 c2.zedo.com #[Tracking.Cookie]
0.0.0.0 c3.zedo.com
0.0.0.0 c4.zedo.com
0.0.0.0 c5.zedo.com
0.0.0.0 c6.zedo.com
0.0.0.0 c7.zedo.com
0.0.0.0 c8.zedo.com
0.0.0.0 d2.zedo.com
0.0.0.0 d3.zedo.com
0.0.0.0 d7.zedo.com
0.0.0.0 d8.zedo.com
0.0.0.0 g.zedo.com
0.0.0.0 gw.zedo.com
0.0.0.0 h.zedo.com
0.0.0.0 l1.zedo.com
0.0.0.0 l2.zedo.com
0.0.0.0 l3.zedo.com
0.0.0.0 l4.zedo.com
0.0.0.0 l5.zedo.com
0.0.0.0 l6.zedo.com
0.0.0.0 l8.zedo.com
0.0.0.0 r1.zedo.com
0.0.0.0 simg.zedo.com
0.0.0.0 ss1.zedo.com
0.0.0.0 ss2.zedo.com
0.0.0.0 ss7.zedo.com
0.0.0.0 xads.zedo.com
0.0.0.0 yads.zedo.com
0.0.0.0 www.zedo.com #[Adware.RaxSearch]
# [Zero Lag][AS20093][68.71.240.0 - 68.71.255.255]
0.0.0.0 rt.udmserve.net
# [Zero Lag][AS20093][72.37.216.0 - 72.37.217.255]
0.0.0.0 www.stickylogic.com
0.0.0.0 www.winaproduct.com
# [end of entries generated by MVPS HOSTS]
`;
